
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aME7P", function(module, exports) {

$parcel$export(module.exports, "UniformWrapper", function () { return $f1ccbec1e07eee42$export$227673ab846fab74; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");

var $lHB9W = parcelRequire("lHB9W");

var $3A0Kj = parcelRequire("3A0Kj");

var $9Dbz6 = parcelRequire("9Dbz6");

var $2ki5H = parcelRequire("2ki5H");

var $4sbR8 = parcelRequire("4sbR8");
const $f1ccbec1e07eee42$var$resolveRenderer = ({ type: type })=>{
    const MissingComponent = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $4sbR8.UniformMissingComponent), {
            componentName: type
        });
    var _UNIFORM_DEFINITIONS_type;
    return (_UNIFORM_DEFINITIONS_type = (0, $2ki5H.default)[type]) !== null && _UNIFORM_DEFINITIONS_type !== void 0 ? _UNIFORM_DEFINITIONS_type : MissingComponent;
};
const $f1ccbec1e07eee42$export$227673ab846fab74 = ({ composition: composition, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const preloadedComposition = typeof window !== "undefined" ? window._uniformPreloadedComposition : null;
    const initialData = preloadedComposition || composition;
    const [data, setData] = (0, $iSvIT.useState)(initialData);
    const [isFetched, setIsFetched] = (0, $iSvIT.useState)(!!initialData);
    // Listen for postMessage events to update composition dynamically
    // Only enabled if allowPostMessage flag is set and in non-production environments
    (0, $iSvIT.useEffect)(()=>{
        if (typeof window === "undefined") return;
        // Only enable if allowPostMessage flag is set
        if (!isAllowPostMessage) return;
        const handleMessage = async (event)=>{
            var _event_data, _event_data1;
            // Check if message is for updating Uniform composition
            if (((_event_data = event.data) === null || _event_data === void 0 ? void 0 : _event_data.type) === "UNIFORM_COMPOSITION_UPDATE" && ((_event_data1 = event.data) === null || _event_data1 === void 0 ? void 0 : _event_data1.composition)) try {
                var _compositionData_compositionApiResponse;
                const compositionData = event.data.composition;
                // If composition is wrapped in compositionApiResponse, extract it
                const rawComposition = ((_compositionData_compositionApiResponse = compositionData.compositionApiResponse) === null || _compositionData_compositionApiResponse === void 0 ? void 0 : _compositionData_compositionApiResponse.composition) || compositionData;
                // Enhance the composition
                const enhancedComp = await (0, $3A0Kj.enhanceComposition)(rawComposition);
                // Update state to trigger re-render
                setData(enhancedComp);
                setIsFetched(true);
                console.log("Uniform composition updated via postMessage");
            } catch (error) {
                console.error("Error processing composition from postMessage:", error);
            }
        };
        window.addEventListener("message", handleMessage);
        return ()=>{
            window.removeEventListener("message", handleMessage);
        };
    }, [
        isAllowPostMessage
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (initialData) return;
        const fetchComposition = async ()=>{
            if (typeof window === "undefined") return;
            const { path: path, locale: locale } = (0, $9Dbz6.parseRoute)(window.location);
            if (path === "uniform-preview" && isAllowPostMessage === true) {
                console.log("uniform-preview with allowPostMessage - waiting for postMessage");
                return;
            }
            const slug = path.startsWith("/") ? path.substring(1) : path;
            const cdn = "https://wac-uniform-promotion--production.us-east-1.prod.public.atl-paas.net/";
            const cdn_path = `${cdn}release/${locale}/${slug}/composition.json`;
            try {
                const req = await fetch(cdn_path);
                const file = await req.json();
                const enhancedComp = await (0, $3A0Kj.enhanceComposition)(file.compositionApiResponse.composition);
                setData(enhancedComp);
            } catch (error) {
                console.error("Error fetching composition from CDN:", error);
                if (composition) setData(composition);
            }
            setIsFetched(true);
        };
        fetchComposition();
    }, [
        initialData,
        composition
    ]);
    if (isUniformPlayground) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformPlayground), {
        resolveRenderer: $f1ccbec1e07eee42$var$resolveRenderer,
        contextualEditingEnhancer: ({ composition: composition })=>(0, $3A0Kj.enhanceComposition)(composition)
    });
    return isFetched && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformComposition), {
            data: (0, $lHB9W.expectContent)(data),
            behaviorTracking: "onLoad",
            resolveRenderer: $f1ccbec1e07eee42$var$resolveRenderer,
            contextualEditingEnhancer: ({ composition: composition })=>(0, $3A0Kj.enhanceComposition)(composition)
        })
    });
};

});
parcelRegister("2ki5H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3c70305862de902$export$2e2bcd8739ae039; });
parcelRequire("g7YDa");
var $iBtwn = parcelRequire("iBtwn");

var $dtOL9 = parcelRequire("dtOL9");
parcelRequire("8tetE");
var $hKdux = parcelRequire("hKdux");

var $cGo4B = parcelRequire("cGo4B");

var $65qTS = parcelRequire("65qTS");
parcelRequire("5DXmX");
var $6PX7I = parcelRequire("6PX7I");
parcelRequire("1419P");
var $5tOAJ = parcelRequire("5tOAJ");
parcelRequire("13r6t");
var $3DJF0 = parcelRequire("3DJF0");
parcelRequire("46UAu");
var $gZtXi = parcelRequire("gZtXi");
parcelRequire("54jXi");
var $fHStO = parcelRequire("fHStO");
parcelRequire("aDgKf");
var $kjD5h = parcelRequire("kjD5h");
parcelRequire("7vkxP");
var $6q68w = parcelRequire("6q68w");
parcelRequire("fNs39");
var $fgHWA = parcelRequire("fgHWA");
parcelRequire("haYnf");
var $gVN7C = parcelRequire("gVN7C");
parcelRequire("jMHQc");
var $jiwkx = parcelRequire("jiwkx");
parcelRequire("kuzIk");
var $gGkrX = parcelRequire("gGkrX");
parcelRequire("hQud5");
var $jgBDg = parcelRequire("jgBDg");
parcelRequire("bvk3D");
var $j5qkq = parcelRequire("j5qkq");
parcelRequire("dX6Xs");
var $jgCjv = parcelRequire("jgCjv");
parcelRequire("JGvCj");
var $6Y74j = parcelRequire("6Y74j");
parcelRequire("dUTg3");
var $dPZ0n = parcelRequire("dPZ0n");
parcelRequire("4hRws");
var $jezov = parcelRequire("jezov");
parcelRequire("7w1de");
var $kIPoi = parcelRequire("kIPoi");
parcelRequire("2RHFR");
var $kW4qU = parcelRequire("kW4qU");

var $3MlHp = parcelRequire("3MlHp");
parcelRequire("9WxMx");
var $ipijV = parcelRequire("ipijV");
parcelRequire("gp86Z");
var $hhL3A = parcelRequire("hhL3A");
parcelRequire("lwXlz");
var $bVuUk = parcelRequire("bVuUk");
parcelRequire("gMNh2");
var $8TUqr = parcelRequire("8TUqr");
parcelRequire("l0zDw");
var $3qApo = parcelRequire("3qApo");
parcelRequire("19QOl");
var $das6y = parcelRequire("das6y");
parcelRequire("lrMw1");
var $25N89 = parcelRequire("25N89");
parcelRequire("hS2Tl");
var $bEbxJ = parcelRequire("bEbxJ");
parcelRequire("7JHqD");
var $3IgE4 = parcelRequire("3IgE4");
parcelRequire("e6r6l");
var $l8rpb = parcelRequire("l8rpb");
parcelRequire("c81IA");
var $2wBma = parcelRequire("2wBma");
parcelRequire("db1CJ");
var $jnZNE = parcelRequire("jnZNE");
parcelRequire("8X3P4");
var $gnm3L = parcelRequire("gnm3L");
parcelRequire("4x11f");
var $6wjLX = parcelRequire("6wjLX");
parcelRequire("dFD1n");
var $9KNdd = parcelRequire("9KNdd");
parcelRequire("hykE5");
var $dWM7f = parcelRequire("dWM7f");
parcelRequire("ee1EE");
var $1Yaob = parcelRequire("1Yaob");
parcelRequire("cmgz2");
var $y6XPA = parcelRequire("y6XPA");
parcelRequire("kgmR5");
var $fq2e7 = parcelRequire("fq2e7");
parcelRequire("kh16D");
var $3HmCN = parcelRequire("3HmCN");
parcelRequire("liGDD");
var $9ScPv = parcelRequire("9ScPv");
parcelRequire("ixWw7");
var $cJj5V = parcelRequire("cJj5V");
parcelRequire("bMQWw");
var $k3kI6 = parcelRequire("k3kI6");
parcelRequire("4DwX2");
var $a35tB = parcelRequire("a35tB");
parcelRequire("5TIC4");
var $6Lfpq = parcelRequire("6Lfpq");
parcelRequire("1fx7M");
var $hCb7M = parcelRequire("hCb7M");
parcelRequire("9nWUO");
var $3OzIV = parcelRequire("3OzIV");

var $cceBl = parcelRequire("cceBl");
parcelRequire("eLOkc");
var $9WCsH = parcelRequire("9WCsH");

var $7D1nQ = parcelRequire("7D1nQ");
parcelRequire("jp1CX");
var $gUjud = parcelRequire("gUjud");
parcelRequire("k4P0o");
var $8Pgz8 = parcelRequire("8Pgz8");
parcelRequire("ebG1P");
var $kklDD = parcelRequire("kklDD");
parcelRequire("gcnH1");
var $4d1KE = parcelRequire("4d1KE");
parcelRequire("dj3LQ");
var $1BNhI = parcelRequire("1BNhI");

var $f7sBJ = parcelRequire("f7sBJ");
parcelRequire("borry");
var $impgo = parcelRequire("impgo");
parcelRequire("5yXyq");
var $aogEX = parcelRequire("aogEX");
parcelRequire("enK00");
var $iDXPJ = parcelRequire("iDXPJ");
parcelRequire("adl56");
var $koVMZ = parcelRequire("koVMZ");
parcelRequire("5znlu");
var $gmi9U = parcelRequire("gmi9U");

var $a1e48 = parcelRequire("a1e48");
parcelRequire("qpVJw");
var $cn8o7 = parcelRequire("cn8o7");
parcelRequire("2UtIB");
var $5QIwB = parcelRequire("5QIwB");
parcelRequire("1kxv4");
var $gRQBn = parcelRequire("gRQBn");
parcelRequire("5wZPk");
var $k6qJQ = parcelRequire("k6qJQ");
parcelRequire("diZQT");
var $h3wk5 = parcelRequire("h3wk5");
parcelRequire("5hZGW");
var $c7WmW = parcelRequire("c7WmW");
parcelRequire("6NpvY");
var $1GDqm = parcelRequire("1GDqm");
parcelRequire("85qcB");
var $9SZQE = parcelRequire("9SZQE");

var $lOAhp = parcelRequire("lOAhp");

var $aDVDR = parcelRequire("aDVDR");
parcelRequire("jzDAp");
var $4d4f5 = parcelRequire("4d4f5");
parcelRequire("3Z0Az");
var $bR2Mn = parcelRequire("bR2Mn");
parcelRequire("d6DCu");
var $3gOU8 = parcelRequire("3gOU8");
parcelRequire("fWJHK");
var $ci6CH = parcelRequire("ci6CH");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e3c70305862de902$var$UNIFORM_DEFINITIONS = {
    accordion: (0, $iBtwn.default),
    agileArticleBodyContent: (0, $dtOL9.default),
    agileHubSidebarNav: (0, $hKdux.default),
    agileTutorialBodyContent: (0, $cGo4B.default),
    articleIntroductionContent: (0, $65qTS.default),
    backgroundVideoContainer: (0, $6PX7I.default),
    bannerAlert: (0, $5tOAJ.default),
    blockContainer: (0, $jgBDg.default),
    bodyContent: (0, $3DJF0.default),
    button: (0, $fHStO.default),
    card: (0, $6q68w.default),
    collectionPricingHero: (0, $fgHWA.default),
    columnLayout: (0, $gVN7C.UniformColumnLayout),
    confluenceAnimatedHero: (0, $jiwkx.default),
    connector: (0, $gGkrX.default),
    contentBlock: (0, $j5qkq.default),
    ctaWithPolygonBackground: (0, $kjD5h.default),
    customerBodyContent: (0, $gZtXi.default),
    customerStat: (0, $jgCjv.default),
    customerStoriesDetailsHero: (0, $6Y74j.default),
    customerTestimonials: (0, $dPZ0n.default),
    enhancedBanner: (0, $kW4qU.default),
    downloadRow: (0, $jezov.default),
    downloadTable: (0, $kIPoi.default),
    expand: (0, $3MlHp.default),
    featuresHighlight: (0, $bVuUk.default),
    globalFooter: (0, $8TUqr.default),
    globalNav: (0, $3qApo.default),
    heading: (0, $das6y.default),
    heroCarouselSection: (0, $25N89.default),
    heroSection: (0, $bEbxJ.default),
    horizontalDivider: (0, $3IgE4.default),
    image: (0, $l8rpb.default),
    imageV2: (0, $2wBma.default),
    integration: (0, $jnZNE.default),
    invisibleContent: (0, $gnm3L.default),
    productCardBlock: (0, $9WCsH.default),
    rovoChatContainer: (0, $8Pgz8.default),
    rovoChatBox: (0, $gUjud.default),
    rovoChatHeader: (0, $kklDD.default),
    scrollableHeroCards: (0, $1BNhI.default),
    jiraTemplatesTabContentSubgridLayout: (0, $6wjLX.default),
    link: (0, $9KNdd.default),
    list: (0, $dWM7f.default),
    listv2: (0, $1Yaob.default),
    logos: (0, $y6XPA.default),
    lozenge: (0, $fq2e7.default),
    mobileApp: (0, $3HmCN.default),
    modal: (0, $9ScPv.default),
    page: (0, $cJj5V.default),
    pagination: (0, $k3kI6.default),
    panel: (0, $a35tB.default),
    personalizationContainer: (0, $6Lfpq.default),
    pricingCalculator: (0, $hCb7M.default),
    pricingTable: (0, $3OzIV.default),
    productCard: (0, $cceBl.default),
    rovoHero: (0, $4d1KE.default),
    sideNav: (0, $f7sBJ.default),
    sideNavCollection: (0, $impgo.default),
    sideNavLink: (0, $aogEX.default),
    signUpForm: (0, $iDXPJ.default),
    subProduct: (0, $cn8o7.default),
    templateCta: (0, $k6qJQ.default),
    pullQuote: (0, $7D1nQ.default),
    singleTab: (0, $koVMZ.default),
    splitBackgroundContainer: (0, $gmi9U.default),
    statsSection: (0, $a1e48.default),
    statsigExperimentContainer: (0, $ipijV.default),
    statsigFeatureGateContainer: (0, $hhL3A.default),
    subColumnLayout: (0, $gVN7C.UniformSubColumnLayout),
    tabs12Col: (0, $5QIwB.default),
    tabs8Col: (0, $gRQBn.default),
    templateModalButton: (0, $h3wk5.default),
    templatePreview: (0, $c7WmW.default),
    text: (0, $1GDqm.default),
    textWithIcon: (0, $9SZQE.default),
    topicIntroductionContent: (0, $lOAhp.default),
    tutorialIntroductionContent: (0, $aDVDR.default),
    variant: (0, $4d4f5.default),
    variantContainer: (0, $bR2Mn.default),
    video: (0, $3gOU8.default),
    videoCarousel: (0, $ci6CH.default)
};
var $e3c70305862de902$export$2e2bcd8739ae039 = $e3c70305862de902$var$UNIFORM_DEFINITIONS;

});
parcelRegister("g7YDa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("iBtwn")).default; });

var $iBtwn = parcelRequire("iBtwn");

});
parcelRegister("iBtwn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f73576dbd586feaf$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $40KoW = parcelRequire("40KoW");

var $hRjh0 = parcelRequire("hRjh0");

var $8lB1y = parcelRequire("8lB1y");
const $f73576dbd586feaf$var$UniformAccordion = (props)=>{
    const { id: id, header: header, textBody: textBody, richText: richText } = props;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hRjh0.Accordion), {
        id: id,
        header: header,
        content: richText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            text: richText
        }) : !(0, $40KoW.isRichTextValueConsideredEmpty)(props.uniformRichText) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            uniformParameter: "uniformRichText"
        }) : textBody
    });
};
var $f73576dbd586feaf$export$2e2bcd8739ae039 = $f73576dbd586feaf$var$UniformAccordion;

});
parcelRegister("40KoW", function(module, exports) {

$parcel$export(module.exports, "isRichTextValueConsideredEmpty", function () { return $2ebb27d3fd99ac6b$export$3113f85f4f2c043b; });
$parcel$export(module.exports, "getRichTextTagsFromTextFormat", function () { return $2ebb27d3fd99ac6b$export$5a89a4161bd9ebd2; });
$parcel$export(module.exports, "walkRichTextTree", function () { return $2ebb27d3fd99ac6b$export$5a4dbd7b3859d56e; });
// src/elements.ts

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");
var $2ebb27d3fd99ac6b$var$rendererTypeTagMap = /* @__PURE__ */ new Map([
    [
        "linebreak",
        [
            "br"
        ]
    ],
    [
        "quote",
        [
            "blockquote"
        ]
    ],
    [
        "code",
        [
            "pre",
            "code"
        ]
    ]
]);
function $2ebb27d3fd99ac6b$export$a4ec677d66b3eef3(text) {
    return text.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $2ebb27d3fd99ac6b$export$8553002765ef8155(format) {
    return Boolean(format && [
        "center",
        "end",
        "justify",
        "left",
        "right",
        "start"
    ].includes(format));
}
function $2ebb27d3fd99ac6b$export$2d8458e4858dd6bc(direction) {
    return Boolean(direction && [
        "ltr",
        "rtl"
    ].includes(direction));
}
var $2ebb27d3fd99ac6b$var$voidElements = /* @__PURE__ */ new Set([
    "area",
    "base",
    "br",
    "col",
    "embed",
    "hr",
    "img",
    "input",
    "link",
    "meta",
    "source",
    "track",
    "wbr"
]);
function $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb(tag, attributes, children) {
    const attributesString = attributes && attributes.size > 0 ? " " + Array.from(attributes).reduce((result, [key, value])=>[
            ...result,
            `${key}="${value}"`
        ], []).join(" ") : "";
    return $2ebb27d3fd99ac6b$var$voidElements.has(tag) ? `<${tag}${attributesString}>` : `<${tag}${attributesString}>${children != null ? children : ""}</${tag}>`;
}
// src/guards.ts
function $2ebb27d3fd99ac6b$export$70f15e3e004ad6dd(arr) {
    return Array.isArray(arr) && arr.length > 0;
}
function $2ebb27d3fd99ac6b$export$5397ae48e85521ee(node) {
    return !!node && typeof node === "object" && "type" in node;
}
function $2ebb27d3fd99ac6b$export$bce37bf8275274bb(value) {
    return typeof value === "object" && value !== null && "root" in value && $2ebb27d3fd99ac6b$export$5397ae48e85521ee(value.root);
}
function $2ebb27d3fd99ac6b$export$76356ac770fe566f(node, type) {
    return $2ebb27d3fd99ac6b$export$5397ae48e85521ee(node) && node.type === type;
}
function $2ebb27d3fd99ac6b$export$3113f85f4f2c043b(value) {
    if (!value) return true;
    if (value.root.children.length === 0) return true;
    if (value.root.children.length > 1) return false;
    const child = value.root.children[0];
    if (!$2ebb27d3fd99ac6b$export$76356ac770fe566f(child, "paragraph")) return false;
    return child.children === void 0 || child.children.length === 0;
}
function $2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(node) {
    return "children" in node && $2ebb27d3fd99ac6b$export$70f15e3e004ad6dd(node.children);
}
// src/nodes/asset.ts
var $2ebb27d3fd99ac6b$export$7b8470edeb266d2d = ({ context: context })=>{
    var _a, _b;
    const node = context.currentNode;
    if (node.__asset === void 0) return "";
    if (node.__asset.type !== "image") return "";
    const imgAttributes = /* @__PURE__ */ new Map();
    imgAttributes.set("src", node.__asset.fields.url.value);
    if ((_a = node.__asset.fields.title) == null ? void 0 : _a.value) imgAttributes.set("alt", node.__asset.fields.title.value);
    const img = $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb("img", imgAttributes);
    const figcaption = ((_b = node.__asset.fields.description) == null ? void 0 : _b.value) ? $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb("figcaption", null, node.__asset.fields.description.value) : "";
    return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb("figure", null, `${img}${figcaption}`);
};
// src/nodes/heading.ts
var $2ebb27d3fd99ac6b$export$bf6388ba992fa09c = ({ context: context, renderChildren: renderChildren })=>{
    var _a;
    const node = context.currentNode;
    return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb((_a = node.tag) != null ? _a : "h1", null, renderChildren(context.currentNode.children));
};
var $2ebb27d3fd99ac6b$var$headingTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
// src/nodes/link.ts
var $2ebb27d3fd99ac6b$export$936fe693edb52ead = ({ context: context, renderChildren: renderChildren })=>{
    const node = context.currentNode;
    const attributes = /* @__PURE__ */ new Map();
    const href = $2ebb27d3fd99ac6b$export$14401f8b485975ea(node.link);
    if (href) attributes.set("href", href);
    return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb("a", attributes, renderChildren(context.currentNode.children));
};
function $2ebb27d3fd99ac6b$export$14401f8b485975ea(link) {
    switch(link == null ? void 0 : link.type){
        case "email":
            return `mailto:${link.path}`;
        case "tel":
            return `tel:${link.path}`;
        case "url":
            return link.path;
        case "projectMapNode":
            return link.path;
    }
}
// src/nodes/list.ts
var $2ebb27d3fd99ac6b$export$7d9d55832c255604 = ({ context: context, renderChildren: renderChildren })=>{
    var _a;
    const node = context.currentNode;
    const attributes = /* @__PURE__ */ new Map();
    if (node.start > 1) attributes.set("start", node.start.toString());
    return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb((_a = node.tag) != null ? _a : "ul", attributes, renderChildren(context.currentNode.children));
};
// src/nodes/listitem.ts
var $2ebb27d3fd99ac6b$export$7db814f6895f686a = ({ context: context, renderChildren: renderChildren })=>{
    const node = context.currentNode;
    const attributes = /* @__PURE__ */ new Map();
    if (Number.isFinite(node.value) && node.value > 0) attributes.set("value", node.value.toString());
    return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb("li", attributes, renderChildren(context.currentNode.children));
};
var $2ebb27d3fd99ac6b$var$listitemTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    if (!$2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(context.currentNode)) return "";
    const childrenRendered = renderChildren(context.currentNode.children);
    if (childrenRendered.endsWith(" ")) return childrenRendered;
    return `${childrenRendered} `;
};
// src/nodes/paragraph.ts
var $2ebb27d3fd99ac6b$export$8bcf4977d6029c8 = ({ context: context, renderChildren: renderChildren })=>{
    const node = context.currentNode;
    const attributes = /* @__PURE__ */ new Map();
    if ($2ebb27d3fd99ac6b$export$8553002765ef8155(node.format)) attributes.set("style", `text-align: ${node.format};`);
    if ($2ebb27d3fd99ac6b$export$2d8458e4858dd6bc(node.direction)) attributes.set("dir", node.direction);
    return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb("p", attributes, $2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(context.currentNode) ? renderChildren(context.currentNode.children) : "<br>");
};
var $2ebb27d3fd99ac6b$var$paragraphTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
// src/nodes/root.ts
var $2ebb27d3fd99ac6b$export$1a6e4df79d5098f8 = ({ context: context, renderChildren: renderChildren })=>{
    return $2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(context.currentNode) ? renderChildren(context.currentNode.children) : "";
};
// src/nodes/table.ts
var $2ebb27d3fd99ac6b$export$29b37b9cb24833f8 = ({ context: context, renderChildren: renderChildren })=>{
    return [
        "table",
        "tbody"
    ].reduceRight((children, tag)=>{
        return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb(tag, null, children);
    }, renderChildren(context.currentNode.children));
};
var $2ebb27d3fd99ac6b$var$tableTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
// src/nodes/tablecell.ts
var $2ebb27d3fd99ac6b$export$5bdbd5436df1f109 = ({ context: context, renderChildren: renderChildren })=>{
    const node = context.currentNode;
    const tag = $2ebb27d3fd99ac6b$export$37fd5c6d3c00d303(node.headerState);
    return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb(tag, null, renderChildren(context.currentNode.children));
};
var $2ebb27d3fd99ac6b$var$tablecellTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
function $2ebb27d3fd99ac6b$export$37fd5c6d3c00d303(headerState) {
    if (headerState === 0) return "td";
    return "th";
}
// src/nodes/tablerow.ts
var $2ebb27d3fd99ac6b$export$28c41253e2c9901a = ({ context: context, renderChildren: renderChildren })=>{
    return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb("tr", null, renderChildren(context.currentNode.children));
};
var $2ebb27d3fd99ac6b$var$tablerowTextRenderer = ({ context: context, renderChildren: renderChildren })=>{
    return $2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(context.currentNode) ? `${renderChildren(context.currentNode.children)} ` : "";
};
// src/nodes/text.ts
var $2ebb27d3fd99ac6b$export$56ed6376d093860 = ({ context: context })=>{
    const node = context.currentNode;
    const tags = $2ebb27d3fd99ac6b$export$5a89a4161bd9ebd2(node.format);
    const pureText = $2ebb27d3fd99ac6b$export$a4ec677d66b3eef3(node.text);
    return tags.length === 0 ? pureText : tags.reduceRight((children, tag)=>{
        return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb(tag, null, children);
    }, pureText);
};
var $2ebb27d3fd99ac6b$var$textTextRenderer = ({ context: context })=>{
    const node = context.currentNode;
    return node.text;
};
function $2ebb27d3fd99ac6b$export$5a89a4161bd9ebd2(format) {
    const tags = [];
    if (format & 1) tags.push("strong");
    if (format & 2) tags.push("em");
    if (format & 4) tags.push("s");
    if (format & 8) tags.push("u");
    if (format & 16) tags.push("code");
    if (format & 32) tags.push("sub");
    if (format & 64) tags.push("sup");
    return tags;
}
// src/nodes/tab.ts
var $2ebb27d3fd99ac6b$var$tabHtmlRenderer = ()=>{
    return "	";
};
var $2ebb27d3fd99ac6b$var$tabTextRenderer = ()=>{
    return "	";
};
// src/renderToHtml.ts
var $2ebb27d3fd99ac6b$var$rendererTypeMap = /* @__PURE__ */ new Map([
    [
        "heading",
        $2ebb27d3fd99ac6b$export$bf6388ba992fa09c
    ],
    [
        "link",
        $2ebb27d3fd99ac6b$export$936fe693edb52ead
    ],
    [
        "list",
        $2ebb27d3fd99ac6b$export$7d9d55832c255604
    ],
    [
        "listitem",
        $2ebb27d3fd99ac6b$export$7db814f6895f686a
    ],
    [
        "paragraph",
        $2ebb27d3fd99ac6b$export$8bcf4977d6029c8
    ],
    [
        "root",
        $2ebb27d3fd99ac6b$export$1a6e4df79d5098f8
    ],
    [
        "text",
        $2ebb27d3fd99ac6b$export$56ed6376d093860
    ],
    [
        "tab",
        $2ebb27d3fd99ac6b$var$tabHtmlRenderer
    ],
    [
        "table",
        $2ebb27d3fd99ac6b$export$29b37b9cb24833f8
    ],
    [
        "tablecell",
        $2ebb27d3fd99ac6b$export$5bdbd5436df1f109
    ],
    [
        "tablerow",
        $2ebb27d3fd99ac6b$export$28c41253e2c9901a
    ],
    [
        "asset",
        $2ebb27d3fd99ac6b$export$7b8470edeb266d2d
    ]
]);
var $2ebb27d3fd99ac6b$export$28174e313edd87cd = (context)=>{
    const renderer = $2ebb27d3fd99ac6b$var$rendererTypeMap.get(context.currentNode.type);
    if (renderer) return renderer;
    const tags = $2ebb27d3fd99ac6b$var$rendererTypeTagMap.get(context.currentNode.type);
    if (tags) return ({ renderChildren: renderChildren })=>{
        var _a;
        return (_a = tags.reduceRight((children, tag)=>{
            return $2ebb27d3fd99ac6b$export$1b1ba35a6df515eb(tag, null, children);
        }, $2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(context.currentNode) ? renderChildren(context.currentNode.children) : void 0)) != null ? _a : "";
    };
    return ()=>`<!-- WARNING: No renderer for type ${context.currentNode.type} -->`;
};
function $2ebb27d3fd99ac6b$var$initializeRenderContext(node, parentContext) {
    let ancestorNodes = [];
    if (parentContext == null ? void 0 : parentContext.ancestorNodes) ancestorNodes = ancestorNodes.concat(parentContext.ancestorNodes);
    if (parentContext == null ? void 0 : parentContext.currentNode) ancestorNodes.unshift(parentContext.currentNode);
    return (0, $6iHNw._)((0, $7Knp0._)({}, parentContext != null ? parentContext : {}), {
        currentNode: node,
        ancestorNodes: ancestorNodes
    });
}
function $2ebb27d3fd99ac6b$export$32f1246b4326e182(node, parentContext) {
    var _a;
    if (!$2ebb27d3fd99ac6b$export$5397ae48e85521ee(node)) return "";
    const context = $2ebb27d3fd99ac6b$var$initializeRenderContext(node, parentContext);
    let renderer = (_a = context.resolveRenderer) == null ? void 0 : _a.call(context, context);
    if (typeof renderer === "undefined") renderer = $2ebb27d3fd99ac6b$export$28174e313edd87cd(context);
    else if (renderer === null) return "";
    const renderChildren = (children)=>$2ebb27d3fd99ac6b$export$e4421ac256b62cb6(children, context);
    if (renderer) return renderer({
        context: context,
        renderChildren: renderChildren
    });
    else throw new Error(`There is no renderer for node type: ${context.currentNode.type}`);
}
function $2ebb27d3fd99ac6b$export$e4421ac256b62cb6(children, context) {
    return Array.isArray(children) ? children.map((node)=>$2ebb27d3fd99ac6b$export$32f1246b4326e182(node, context)).join("") : "";
}
// src/nodes/linebreak.ts
var $2ebb27d3fd99ac6b$var$linebreakTextRenderer = ()=>{
    return " ";
};
// src/renderToText.ts
var $2ebb27d3fd99ac6b$var$rendererTypeMap2 = /* @__PURE__ */ new Map([
    [
        "text",
        $2ebb27d3fd99ac6b$var$textTextRenderer
    ],
    [
        "tab",
        $2ebb27d3fd99ac6b$var$tabTextRenderer
    ],
    [
        "linebreak",
        $2ebb27d3fd99ac6b$var$linebreakTextRenderer
    ],
    [
        "paragraph",
        $2ebb27d3fd99ac6b$var$paragraphTextRenderer
    ],
    [
        "listitem",
        $2ebb27d3fd99ac6b$var$listitemTextRenderer
    ],
    [
        "heading",
        $2ebb27d3fd99ac6b$var$headingTextRenderer
    ],
    [
        "table",
        $2ebb27d3fd99ac6b$var$tableTextRenderer
    ],
    [
        "tablecell",
        $2ebb27d3fd99ac6b$var$tablecellTextRenderer
    ],
    [
        "tablerow",
        $2ebb27d3fd99ac6b$var$tablerowTextRenderer
    ]
]);
var $2ebb27d3fd99ac6b$export$dd531e7b53a0cbec = (context)=>{
    const renderer = $2ebb27d3fd99ac6b$var$rendererTypeMap2.get(context.currentNode.type);
    if (renderer) return renderer;
    return ({ context: context2, renderChildren: renderChildren })=>{
        return $2ebb27d3fd99ac6b$export$bd5ff50f0e53d41c(context2.currentNode) ? renderChildren(context2.currentNode.children) : "";
    };
};
function $2ebb27d3fd99ac6b$var$initializeRenderContext2(node, parentContext) {
    let ancestorNodes = [];
    if (parentContext == null ? void 0 : parentContext.ancestorNodes) ancestorNodes = ancestorNodes.concat(parentContext.ancestorNodes);
    if (parentContext == null ? void 0 : parentContext.currentNode) ancestorNodes.unshift(parentContext.currentNode);
    return (0, $6iHNw._)((0, $7Knp0._)({}, parentContext != null ? parentContext : {}), {
        currentNode: node,
        ancestorNodes: ancestorNodes
    });
}
function $2ebb27d3fd99ac6b$export$f21c5276b1e9847a(node, parentContext) {
    var _a;
    if (!$2ebb27d3fd99ac6b$export$5397ae48e85521ee(node)) return "";
    const context = $2ebb27d3fd99ac6b$var$initializeRenderContext2(node, parentContext);
    let renderer = (_a = context.resolveRenderer) == null ? void 0 : _a.call(context, context);
    if (typeof renderer === "undefined") renderer = $2ebb27d3fd99ac6b$export$dd531e7b53a0cbec(context);
    else if (renderer === null) return "";
    const renderChildren = (children)=>$2ebb27d3fd99ac6b$export$6ba9468a0a4c5ffc(children, context);
    if (renderer) {
        const rendered = renderer({
            context: context,
            renderChildren: renderChildren
        });
        return context.ancestorNodes.length > 0 ? rendered : rendered.trim();
    } else throw new Error(`There is no renderer for node type: ${context.currentNode.type}`);
}
function $2ebb27d3fd99ac6b$export$6ba9468a0a4c5ffc(children, context) {
    return Array.isArray(children) ? children.map((node)=>$2ebb27d3fd99ac6b$export$f21c5276b1e9847a(node, context)).join("") : "";
}
// src/utils.ts
var $2ebb27d3fd99ac6b$export$5a4dbd7b3859d56e = (node, callback, parent)=>{
    if (!$2ebb27d3fd99ac6b$export$5397ae48e85521ee(node)) return;
    callback(node, parent);
    if (Array.isArray(node.children)) {
        let i = 0;
        while(node.children.length > i){
            $2ebb27d3fd99ac6b$export$5a4dbd7b3859d56e(node.children[i], callback, node);
            i += 1;
        }
    }
};
var $2ebb27d3fd99ac6b$export$4593e5e0513f0a70 = [
    {
        label: "Heading 1",
        type: "h1"
    },
    {
        label: "Heading 2",
        type: "h2"
    },
    {
        label: "Heading 3",
        type: "h3"
    },
    {
        label: "Heading 4",
        type: "h4"
    },
    {
        label: "Heading 5",
        type: "h5"
    },
    {
        label: "Heading 6",
        type: "h6"
    },
    {
        label: "Bullet List",
        type: "unorderedList"
    },
    {
        label: "Ordered List",
        type: "orderedList"
    },
    {
        label: "Link",
        type: "link"
    },
    {
        label: "Blockquote",
        type: "quote"
    },
    {
        label: "Code Block",
        type: "code"
    },
    {
        label: "Table",
        type: "table"
    },
    {
        label: "Asset",
        type: "asset"
    },
    {
        label: "Dynamic Token",
        type: "variable"
    }
];
var $2ebb27d3fd99ac6b$export$1c57de179d11d54c = [
    {
        label: "Bold",
        type: "bold"
    },
    {
        label: "Italic",
        type: "italic"
    },
    {
        label: "Underline",
        type: "underline"
    },
    {
        label: "Strikethrough",
        type: "strikethrough"
    },
    {
        label: "Code",
        type: "code"
    },
    {
        label: "Superscript",
        type: "superscript"
    },
    {
        label: "Subscript",
        type: "subscript"
    }
];
var $2ebb27d3fd99ac6b$export$401e495ff5af005a = (type)=>{
    var _a;
    if (type === "paragraph") return "Normal";
    const element = $2ebb27d3fd99ac6b$export$4593e5e0513f0a70.find((element2)=>element2.type === type);
    return (_a = element == null ? void 0 : element.label) != null ? _a : type;
};
var $2ebb27d3fd99ac6b$export$419f7a872c5c801f = (type)=>{
    var _a;
    const format = $2ebb27d3fd99ac6b$export$1c57de179d11d54c.find((element)=>element.type === type);
    return (_a = format == null ? void 0 : format.label) != null ? _a : type;
};
var $2ebb27d3fd99ac6b$export$ea67c934009c1e06 = {
    root: {
        type: "root",
        version: 1,
        direction: null,
        format: "",
        indent: 0,
        children: [
            {
                type: "paragraph",
                version: 1,
                format: "start",
                indent: 0,
                direction: null,
                children: [],
                textFormat: 0,
                textStyle: ""
            }
        ]
    }
};

});



parcelRegister("dtOL9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19629cedb73f1c61$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $iii3u = parcelRequire("iii3u");
const $19629cedb73f1c61$export$d9468344d3651243 = (body)=>{
    if (!body) return {
        name: "",
        contentComponents: []
    };
    const { bodyTextContainer: bodyTextContainer } = body;
    var _bodyTextContainer_supportingConceptNameExternal, _bodyTextContainer_contentComponents;
    const formattedBody = {
        name: (_bodyTextContainer_supportingConceptNameExternal = bodyTextContainer === null || bodyTextContainer === void 0 ? void 0 : bodyTextContainer.supportingConceptNameExternal) !== null && _bodyTextContainer_supportingConceptNameExternal !== void 0 ? _bodyTextContainer_supportingConceptNameExternal : "",
        contentComponents: $19629cedb73f1c61$var$formatContentComponent((_bodyTextContainer_contentComponents = bodyTextContainer === null || bodyTextContainer === void 0 ? void 0 : bodyTextContainer.contentComponents) !== null && _bodyTextContainer_contentComponents !== void 0 ? _bodyTextContainer_contentComponents : [])
    };
    return formattedBody;
};
const $19629cedb73f1c61$var$formatContentComponent = (contentComponents)=>{
    if (!contentComponents) return [];
    const formattedContentComponents = contentComponents.map(// eslint-disable-next-line complexity
    (contentComponent)=>{
        var _contentComponent_fields, _contentComponent_fields1, _contentComponent_fields2, _contentComponent_fields3, _contentComponent_fields4, _contentComponent_fields5, _contentComponent_fields6, _contentComponent_fields7, _contentComponent_fields8, _contentComponent_fields9, _contentComponent_fields10, _contentComponent_fields11, _contentComponent_fields12, _contentComponent_fields13, _contentComponent_fields14, _contentComponent_fields15, _contentComponent_fields16, _contentComponent_fields17, _contentComponent_fields18, _contentComponent_fields19, _contentComponent_fields20, _contentComponent_fields21, _contentComponent_fields22, _contentComponent_fields23;
        if (contentComponent.sys.contentType.sys.id === "textComponent") return {
            __typename: "TextComponent",
            name: (_contentComponent_fields = contentComponent.fields) === null || _contentComponent_fields === void 0 ? void 0 : _contentComponent_fields.textComponentNameExternal,
            text: (_contentComponent_fields1 = contentComponent.fields) === null || _contentComponent_fields1 === void 0 ? void 0 : _contentComponent_fields1.text
        };
        else if (contentComponent.sys.contentType.sys.id === "assetComponent") return {
            __typename: "AssetComponent",
            asset: $19629cedb73f1c61$var$formatAsset((_contentComponent_fields2 = contentComponent.fields) === null || _contentComponent_fields2 === void 0 ? void 0 : _contentComponent_fields2.asset),
            caption: (_contentComponent_fields3 = contentComponent.fields) === null || _contentComponent_fields3 === void 0 ? void 0 : _contentComponent_fields3.assetCaption,
            assetRelatedText: (_contentComponent_fields4 = contentComponent.fields) === null || _contentComponent_fields4 === void 0 ? void 0 : _contentComponent_fields4.assetRelatedText
        };
        else if (contentComponent.sys.contentType.sys.id === "proTipComponent") {
            var _contentComponent_fields24, _contentComponent_fields25, _contentComponent_fields26, _contentComponent_fields27, _contentComponent_fields28, _contentComponent_fields29, _contentComponent_fields30;
            let proTipText = "";
            if ((_contentComponent_fields24 = contentComponent.fields) === null || _contentComponent_fields24 === void 0 ? void 0 : _contentComponent_fields24.proTipRichText) proTipText = (_contentComponent_fields25 = contentComponent.fields) === null || _contentComponent_fields25 === void 0 ? void 0 : _contentComponent_fields25.proTipRichText;
            else if ((_contentComponent_fields26 = contentComponent.fields) === null || _contentComponent_fields26 === void 0 ? void 0 : _contentComponent_fields26.proTipText) proTipText = (_contentComponent_fields27 = contentComponent.fields) === null || _contentComponent_fields27 === void 0 ? void 0 : _contentComponent_fields27.proTipText;
            else if ((_contentComponent_fields28 = contentComponent.fields) === null || _contentComponent_fields28 === void 0 ? void 0 : _contentComponent_fields28.proTipTextShort) proTipText = (_contentComponent_fields29 = contentComponent.fields) === null || _contentComponent_fields29 === void 0 ? void 0 : _contentComponent_fields29.proTipTextShort;
            return {
                __typename: "ProTipComponent",
                name: (_contentComponent_fields30 = contentComponent.fields) === null || _contentComponent_fields30 === void 0 ? void 0 : _contentComponent_fields30.proTipNameExternal,
                proTipText: proTipText
            };
        } else if (contentComponent.sys.contentType.sys.id === "embeddedVideoAsset") return {
            __typename: "EmbeddedVideoAsset",
            embeddedVideoAssetName: (_contentComponent_fields5 = contentComponent.fields) === null || _contentComponent_fields5 === void 0 ? void 0 : _contentComponent_fields5.embeddedVideoAssetNameExternal,
            embedded: (_contentComponent_fields6 = contentComponent.fields) === null || _contentComponent_fields6 === void 0 ? void 0 : _contentComponent_fields6.embedded,
            embedAssetOverlay: $19629cedb73f1c61$var$formatAsset((_contentComponent_fields7 = contentComponent.fields) === null || _contentComponent_fields7 === void 0 ? void 0 : _contentComponent_fields7.embedAssetOverlay)
        };
        else if (contentComponent.sys.contentType.sys.id === "twitterComponent") return {
            __typename: "TwitterComponent",
            twitterComponentName: (_contentComponent_fields8 = contentComponent.fields) === null || _contentComponent_fields8 === void 0 ? void 0 : _contentComponent_fields8.twitterComponentExternalName,
            tweetText: (_contentComponent_fields9 = contentComponent.fields) === null || _contentComponent_fields9 === void 0 ? void 0 : _contentComponent_fields9.tweetText,
            twitterUrl: (_contentComponent_fields10 = contentComponent.fields) === null || _contentComponent_fields10 === void 0 ? void 0 : _contentComponent_fields10.twitterUrl
        };
        else if (contentComponent.sys.contentType.sys.id === "callToAction") return {
            __typename: "CallToAction",
            title: (_contentComponent_fields11 = contentComponent.fields) === null || _contentComponent_fields11 === void 0 ? void 0 : _contentComponent_fields11.ctaTitleExternal,
            valueProposition: (_contentComponent_fields12 = contentComponent.fields) === null || _contentComponent_fields12 === void 0 ? void 0 : _contentComponent_fields12.valueProposition,
            ctaText: (_contentComponent_fields13 = contentComponent.fields) === null || _contentComponent_fields13 === void 0 ? void 0 : _contentComponent_fields13.ctaText,
            url: (_contentComponent_fields14 = contentComponent.fields) === null || _contentComponent_fields14 === void 0 ? void 0 : _contentComponent_fields14.ctaUrl,
            asset: $19629cedb73f1c61$var$formatAsset((_contentComponent_fields15 = contentComponent.fields) === null || _contentComponent_fields15 === void 0 ? void 0 : _contentComponent_fields15.ctaAsset),
            product: (_contentComponent_fields16 = contentComponent.fields) === null || _contentComponent_fields16 === void 0 ? void 0 : _contentComponent_fields16.product,
            dataBlueprintModule: (_contentComponent_fields17 = contentComponent.fields) === null || _contentComponent_fields17 === void 0 ? void 0 : _contentComponent_fields17.dataBlueprintModule
        };
        else if (contentComponent.sys.contentType.sys.id === "questionComponent") return {
            __typename: "QuestionComponent",
            questionTitle: (_contentComponent_fields18 = contentComponent.fields) === null || _contentComponent_fields18 === void 0 ? void 0 : _contentComponent_fields18.questionTitleExternal,
            answer: (_contentComponent_fields19 = contentComponent.fields) === null || _contentComponent_fields19 === void 0 ? void 0 : _contentComponent_fields19.answer,
            answerAsset: $19629cedb73f1c61$var$formatAsset((_contentComponent_fields20 = contentComponent.fields) === null || _contentComponent_fields20 === void 0 ? void 0 : _contentComponent_fields20.answerAsset)
        };
        else if (contentComponent.sys.contentType.sys.id === "callOutComponent") return {
            __typename: "CallOutComponent",
            title: (_contentComponent_fields21 = contentComponent.fields) === null || _contentComponent_fields21 === void 0 ? void 0 : _contentComponent_fields21.callOutComponentTitleExternal,
            callOutText: (_contentComponent_fields22 = contentComponent.fields) === null || _contentComponent_fields22 === void 0 ? void 0 : _contentComponent_fields22.callOutText,
            icon: $19629cedb73f1c61$var$formatAsset((_contentComponent_fields23 = contentComponent.fields) === null || _contentComponent_fields23 === void 0 ? void 0 : _contentComponent_fields23.callOutComponentIcon)
        };
        else // Default case for unknown component types
        return (0, $7Knp0._)({
            __typename: "UnknownComponent"
        }, contentComponent);
    });
    // Filter out unknown component types
    return formattedContentComponents.filter((component)=>component.__typename !== "UnknownComponent");
};
// eslint-disable-next-line complexity
const $19629cedb73f1c61$var$formatAsset = (asset)=>{
    var _fields_file_details, _fields_file, _fields_file1, _fields_file_image, _fields_file2, _fields_image, _fields_file3, _fields_file4;
    if (!(asset === null || asset === void 0 ? void 0 : asset.fields)) return undefined;
    const { fields: fields } = asset;
    var _fields_file_fileName, _fields_file_image_height, _fields_image_width, _fields_description, _fields_file_contentType;
    return {
        name: fields.title,
        size: (_fields_file = fields.file) === null || _fields_file === void 0 ? void 0 : (_fields_file_details = _fields_file.details) === null || _fields_file_details === void 0 ? void 0 : _fields_file_details.size,
        fileName: (_fields_file_fileName = (_fields_file1 = fields.file) === null || _fields_file1 === void 0 ? void 0 : _fields_file1.fileName) !== null && _fields_file_fileName !== void 0 ? _fields_file_fileName : null,
        height: (_fields_file_image_height = (_fields_file2 = fields.file) === null || _fields_file2 === void 0 ? void 0 : (_fields_file_image = _fields_file2.image) === null || _fields_file_image === void 0 ? void 0 : _fields_file_image.height) !== null && _fields_file_image_height !== void 0 ? _fields_file_image_height : null,
        width: (_fields_image_width = (_fields_image = fields.image) === null || _fields_image === void 0 ? void 0 : _fields_image.width) !== null && _fields_image_width !== void 0 ? _fields_image_width : null,
        url: (_fields_file3 = fields.file) === null || _fields_file3 === void 0 ? void 0 : _fields_file3.url,
        description: (_fields_description = fields.description) !== null && _fields_description !== void 0 ? _fields_description : null,
        contentType: (_fields_file_contentType = (_fields_file4 = fields.file) === null || _fields_file4 === void 0 ? void 0 : _fields_file4.contentType) !== null && _fields_file_contentType !== void 0 ? _fields_file_contentType : null
    };
};
const $19629cedb73f1c61$var$UniformAgileArticleBodyContent = (props)=>{
    const bodyComponent = (0, $iSvIT.useMemo)(()=>$19629cedb73f1c61$export$d9468344d3651243(props), [
        props
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iii3u.AgileArticleBodyContent), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        bodyTextContainer: bodyComponent
    }));
};
var $19629cedb73f1c61$export$2e2bcd8739ae039 = $19629cedb73f1c61$var$UniformAgileArticleBodyContent;

});
parcelRegister("iii3u", function(module, exports) {

$parcel$export(module.exports, "AgileArticleBodyContent", function () { return $3be587fb1a9c4d8d$export$5ccbc19baa270323; });
/* agile-article-body-content.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable react/jsx-key */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $h2e6B = parcelRequire("h2e6B");

var $6O6jV = parcelRequire("6O6jV");

var $1UUq1 = parcelRequire("1UUq1");

var $7eZEV = parcelRequire("7eZEV");

var $krNyQ = parcelRequire("krNyQ");

var $ZQ88u = parcelRequire("ZQ88u");
function $3be587fb1a9c4d8d$var$getRichText(richText) {
    if (typeof richText === "string") return richText;
    return (0, $h2e6B.documentToHtmlString)(richText);
}
const $3be587fb1a9c4d8d$export$5ccbc19baa270323 = ({ bodyTextContainer: bodyTextContainer })=>{
    var _bodyTextContainer_contentComponents;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "agile-hub-article-content",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulpv47k"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_6rthze3t"
                ]),
                children: bodyTextContainer === null || bodyTextContainer === void 0 ? void 0 : bodyTextContainer.name
            }),
            bodyTextContainer === null || bodyTextContainer === void 0 ? void 0 : (_bodyTextContainer_contentComponents = bodyTextContainer.contentComponents) === null || _bodyTextContainer_contentComponents === void 0 ? void 0 : _bodyTextContainer_contentComponents.map((component)=>{
                var _component_asset, _component_asset1, _component_asset2;
                var _component_name, _component_text, _component_asset_url, _component_asset_description, _component_asset_contentType, _component_embeddedVideoAssetName, _component_name1, _component_name2, _component_proTipText, _component_title, _component_title1, _component_callOutText, _component_questionTitle, _component_questionTitle1, _component_answer;
                if ((0, $ZQ88u.isTextComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_rrz6idpf _1cobidpf _7exwv47k _1o6vv47k"
                    ]),
                    children: [
                        (component === null || component === void 0 ? void 0 : component.name) && /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                            children: component === null || component === void 0 ? void 0 : component.name
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                            name: (_component_name = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name !== void 0 ? _component_name : "",
                            text: $3be587fb1a9c4d8d$var$getRichText((_component_text = component === null || component === void 0 ? void 0 : component.text) !== null && _component_text !== void 0 ? _component_text : "")
                        })
                    ]
                });
                else if ((0, $ZQ88u.isAssetComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                            src: (_component_asset_url = component === null || component === void 0 ? void 0 : (_component_asset = component.asset) === null || _component_asset === void 0 ? void 0 : _component_asset.url) !== null && _component_asset_url !== void 0 ? _component_asset_url : "",
                            alt: (_component_asset_description = component === null || component === void 0 ? void 0 : (_component_asset1 = component.asset) === null || _component_asset1 === void 0 ? void 0 : _component_asset1.description) !== null && _component_asset_description !== void 0 ? _component_asset_description : "",
                            contentType: (_component_asset_contentType = component === null || component === void 0 ? void 0 : (_component_asset2 = component.asset) === null || _component_asset2 === void 0 ? void 0 : _component_asset2.contentType) !== null && _component_asset_contentType !== void 0 ? _component_asset_contentType : "",
                            className: (0, $esG4f.default)([
                                "_p12f1osq"
                            ])
                        }),
                        (component === null || component === void 0 ? void 0 : component.caption) && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                "fine-print"
                            ]),
                            children: component === null || component === void 0 ? void 0 : component.caption
                        })
                    ]
                });
                else if ((0, $ZQ88u.isEmbedComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6O6jV.AgileVideo), {
                    embedLink: (component === null || component === void 0 ? void 0 : component.embedded) || "",
                    thumbnail: component === null || component === void 0 ? void 0 : component.embedAssetOverlay,
                    title: (_component_embeddedVideoAssetName = component === null || component === void 0 ? void 0 : component.embeddedVideoAssetName) !== null && _component_embeddedVideoAssetName !== void 0 ? _component_embeddedVideoAssetName : ""
                });
                else if ((0, $ZQ88u.isProTipText)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eZEV.Panel), {
                    panelType: "pro-tip",
                    label: (_component_name1 = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name1 !== void 0 ? _component_name1 : "",
                    description: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_name2 = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name2 !== void 0 ? _component_name2 : "",
                        text: $3be587fb1a9c4d8d$var$getRichText((_component_proTipText = component === null || component === void 0 ? void 0 : component.proTipText) !== null && _component_proTipText !== void 0 ? _component_proTipText : "")
                    })
                });
                else if ((0, $ZQ88u.isCallOutComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eZEV.Panel), {
                    panelType: "highlight",
                    label: (_component_title = component === null || component === void 0 ? void 0 : component.title) !== null && _component_title !== void 0 ? _component_title : "",
                    description: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_title1 = component === null || component === void 0 ? void 0 : component.title) !== null && _component_title1 !== void 0 ? _component_title1 : "",
                        text: $3be587fb1a9c4d8d$var$getRichText((_component_callOutText = component === null || component === void 0 ? void 0 : component.callOutText) !== null && _component_callOutText !== void 0 ? _component_callOutText : "")
                    })
                });
                else if ((0, $ZQ88u.isQuestionComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eZEV.Panel), {
                    panelType: "highlight",
                    label: (_component_questionTitle = component === null || component === void 0 ? void 0 : component.questionTitle) !== null && _component_questionTitle !== void 0 ? _component_questionTitle : "",
                    description: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_questionTitle1 = component === null || component === void 0 ? void 0 : component.questionTitle) !== null && _component_questionTitle1 !== void 0 ? _component_questionTitle1 : "",
                        text: $3be587fb1a9c4d8d$var$getRichText((_component_answer = component === null || component === void 0 ? void 0 : component.answer) !== null && _component_answer !== void 0 ? _component_answer : "")
                    })
                });
                return null;
            })
        ]
    });
};

});


parcelRegister("8tetE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("hKdux")).default; });

var $hKdux = parcelRequire("hKdux");

});
parcelRegister("hKdux", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea5e0364749fd1f4$export$2e2bcd8739ae039; });
/* agile-hub-sidebar-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $ayjUl = parcelRequire("ayjUl");

var $2wO91 = parcelRequire("2wO91");

var $hP07d = parcelRequire("hP07d");

var $lK5pR = parcelRequire("lK5pR");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $gHHDz = parcelRequire("gHHDz");
const $ea5e0364749fd1f4$var$desktopCss = null;
const $ea5e0364749fd1f4$var$tabletMobileCss = null;
const $ea5e0364749fd1f4$var$navContainerCss = null;
const $ea5e0364749fd1f4$var$listCss = null;
const $ea5e0364749fd1f4$var$navHeaderCss = null;
const $ea5e0364749fd1f4$var$mobileExpandableButtonCss = null;
const $ea5e0364749fd1f4$var$mobileNavContentCss = null;
const $ea5e0364749fd1f4$var$mobileNavContentCollapsedCss = null;
const $ea5e0364749fd1f4$var$firstLevelNavItemCss = null;
const $ea5e0364749fd1f4$var$dividerCss = null;
const $ea5e0364749fd1f4$var$topicNameCss = null;
const $ea5e0364749fd1f4$var$topicLinkCss = null;
const $ea5e0364749fd1f4$var$topicNoNestedCss = null;
const $ea5e0364749fd1f4$var$secondLevelLinkCss = null;
const $ea5e0364749fd1f4$var$dotContainerCss = null;
const $ea5e0364749fd1f4$var$getCurrRoute = ()=>{
    let currRoute = window.location.pathname;
    if (currRoute === "/uniform-preview") {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        var _urlParams_get;
        currRoute = (_urlParams_get = urlParams.get("path")) !== null && _urlParams_get !== void 0 ? _urlParams_get : "";
    }
    return currRoute;
};
const $ea5e0364749fd1f4$var$NavList = ()=>{
    const navData = (0, $gHHDz.getAgileHubSidebarNavData)();
    const localizedHref = (0, $3FBn4.useLocalizedHref);
    const getExpandedTopic = (route)=>{
        return navData.findIndex((topic)=>"nestedLinks" in topic && topic.nestedLinks.some((link)=>link.url === route));
    };
    const route = $ea5e0364749fd1f4$var$getCurrRoute();
    const expandedTopicIndex = getExpandedTopic(route);
    const lastIndex = navData.length - 1;
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
        className: (0, $esG4f.default)([
            "_qtt8glyw _1yt4ze3t _18s8ze3t"
        ]),
        children: navData.map((topic, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                className: (0, $esG4f.default)([
                    "_1rjcpxbi",
                    index !== lastIndex && "_179ryzqy"
                ]),
                style: {
                    "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
                },
                children: "url" in topic ? /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                    href: localizedHref(topic.url),
                    "aria-current": route === topic.url ? "page" : undefined,
                    className: (0, $esG4f.default)([
                        "_v564h5h4 _30l317la"
                    ]),
                    style: {
                        "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: (0, $esG4f.default)([
                            "_1e0c1ule _y3gn1e5h",
                            "_bozg1f4h",
                            "h6"
                        ]),
                        children: intl.formatMessage(topic.name)
                    })
                }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $lK5pR.Expand), {
                    label: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: "h6",
                        children: intl.formatMessage(topic.name)
                    }),
                    isExpanded: index === expandedTopicIndex,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                        id: `section-${index}`,
                        className: (0, $esG4f.default)([
                            "_qtt8glyw _1yt4ze3t _18s8ze3t"
                        ]),
                        children: topic.nestedLinks.map((link)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                                children: /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
                                    href: localizedHref(link.url),
                                    "aria-current": route === link.url ? "page" : undefined,
                                    className: (0, $esG4f.default)([
                                        "_1e0c1txw _zulpu2gc _1rjcu2gc _v564h5h4 _30l317la"
                                    ]),
                                    style: {
                                        "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o"
                                            ]),
                                            children: route === link.url && /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hP07d))), {
                                                label: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                            className: (0, $esG4f.default)([
                                                route === link.url && "_k48p1fw0",
                                                "p"
                                            ]),
                                            children: intl.formatMessage(link.name)
                                        })
                                    ]
                                })
                            }, intl.formatMessage(link.name)))
                    })
                })
            }, intl.formatMessage(topic.name)))
    });
};
const $ea5e0364749fd1f4$var$MobileExpandableNav = ({ children: children })=>{
    const intl = (0, $f6qj2.default)();
    const [isExpanded, setIsExpanded] = (0, $iSvIT.useState)(false);
    const [buttonBottom, setButtonBottom] = (0, $iSvIT.useState)(0);
    const navRef = (0, $iSvIT.useRef)(null);
    const buttonRef = (0, $iSvIT.useRef)(null);
    const contentRef = (0, $iSvIT.useRef)(null);
    const handleToggle = ()=>{
        setIsExpanded(!isExpanded);
    }; // Calculate button position for nav positioning
    (0, $iSvIT.useEffect)(()=>{
        const updateButtonPosition = ()=>{
            if (buttonRef.current) {
                const rect = buttonRef.current.getBoundingClientRect();
                setButtonBottom(rect.bottom);
            }
        };
        updateButtonPosition();
        window.addEventListener("resize", updateButtonPosition);
        window.addEventListener("scroll", updateButtonPosition);
        return ()=>{
            window.removeEventListener("resize", updateButtonPosition);
            window.removeEventListener("scroll", updateButtonPosition);
        };
    }, []); // Prevent body scroll when nav is open
    (0, $iSvIT.useEffect)(()=>{
        if (isExpanded) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "unset";
         // Cleanup on unmount
        return ()=>{
            document.body.style.overflow = "unset";
        };
    }, [
        isExpanded
    ]); // Scroll to top when nav expands
    (0, $iSvIT.useEffect)(()=>{
        if (isExpanded && contentRef.current) contentRef.current.scrollTop = 0;
    }, [
        isExpanded
    ]); // Handle click outside to close nav
    (0, $iSvIT.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (isExpanded && navRef.current && !navRef.current.contains(event.target)) setIsExpanded(false);
        };
        if (isExpanded) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isExpanded
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        ref: navRef,
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("button", {
                ref: buttonRef,
                onClick: handleToggle,
                "aria-expanded": isExpanded,
                "aria-controls": "mobile-nav-content",
                className: (0, $esG4f.default)([
                    "_1bsb1osq _bfhk150w _19itglyw _1yt41hnt _1e0c1txw _4cvr1h6o _zulpu2gc _80omtlke _v564mfn2 _irr3u4vp _v736zwfg _chtuzwfg"
                ]),
                style: {
                    "--_8nj8hf": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light200")),
                    "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: (0, $esG4f.default)([
                            "_4t3i1ejb _1bsb1ejb _1e0c1txw _4cvr1h6o _1bah1h6o _1wybf6fq _k48p8n31 _syaz17la"
                        ]),
                        style: {
                            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                        },
                        children: isExpanded ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2wO91))), {
                            label: ""
                        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ayjUl))), {
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: "eyebrow-md",
                        children: intl.formatMessage({
                            id: "agile-hub.sidenav.agile-hub-topics",
                            defaultMessage: "Agile hub topics"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                ref: contentRef,
                id: "mobile-nav-content",
                className: (0, $esG4f.default)([
                    "_bfhkcd5j _1bsb1osq _bozg1wqb _y4ti1wqb _v5641pfq _1reo1wug _18m91wug _v736zwfg _chtuzwfg",
                    isExpanded ? "_kqsw1n9t _152t1um1 _1e02idpf _rjxpidpf _u7coidpf _1bsbauwl _4t3iqi8f _c71lqi8f _tzy4kb7n _1pbyzo7u _1reo15vq _18m915vq _bfhkcd5j _1q51v47k _85i51ejb _bozg1wqb _y4ti1wqb _v736xy5q _chtuxy5q" : "_c71lidpf _tzy4idpf"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                    "--_ab93rs": (0, $43MIc.default)(buttonBottom, "px")
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_4t3i1osq _1reo1wug _18m91wug _85i51ejb"
                    ]),
                    children: children
                })
            })
        ]
    });
};
const $ea5e0364749fd1f4$var$UniformAgileHubSidebarNav = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "aria-label": "Sidebar Navigation",
        className: (0, $esG4f.default)([
            "_19ityzqy _2rkovwyg _1yt4v47k _tnv2150w _tl28idpf _axwiidpf _1hwcidpf _sp8tidpf _13jeglyw _1l9uidpf"
        ]),
        style: {
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400")),
            "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
            "--_8nj8hf": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light200"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1mjbglyw",
                    "tablet-desktop-nav"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: (0, $esG4f.default)([
                            "_1e0c1ule _1yt41dg4",
                            "eyebrow-md"
                        ]),
                        children: intl.formatMessage({
                            id: "agile-hub.sidenav.browse-topics",
                            defaultMessage: "Browse topics"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_c71l1pse _1reo1wug _18m91wug"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)($ea5e0364749fd1f4$var$NavList, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_dm25glyw _kqsw1n9t _1pbykb7n _1bsb1osq",
                    "mobile-nav"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($ea5e0364749fd1f4$var$MobileExpandableNav, {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)($ea5e0364749fd1f4$var$NavList, {})
                })
            })
        ]
    });
};
var $ea5e0364749fd1f4$export$2e2bcd8739ae039 = $ea5e0364749fd1f4$var$UniformAgileHubSidebarNav;

});
parcelRegister("2wO91", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e2df2c0b677df1945f42cd8e58b7f64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1d75779a6f475134$var$_react = $1d75779a6f475134$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $1d75779a6f475134$var$_baseNew = $1d75779a6f475134$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $1d75779a6f475134$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minus".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1d75779a6f475134$var$MinusIcon = (props)=>/*#__PURE__*/ $1d75779a6f475134$var$_react.default.createElement($1d75779a6f475134$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 8.75H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$1d75779a6f475134$var$MinusIcon.displayName = "MinusIcon";
var $1d75779a6f475134$var$_default = module.exports.default = $1d75779a6f475134$var$MinusIcon;

});

parcelRegister("gHHDz", function(module, exports) {

$parcel$export(module.exports, "getAgileHubSidebarNavData", function () { return $80cb4bf9ad6af9e6$export$8fb0a717eaa8070d; });

var $6x1qA = parcelRequire("6x1qA");
const $80cb4bf9ad6af9e6$export$8fb0a717eaa8070d = ()=>{
    return [
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.agile-coach",
                defaultMessage: "What is Agile?"
            }),
            url: "/agile"
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.agile-manifesto",
                defaultMessage: "Agile Manifesto"
            }),
            url: "/agile/manifesto"
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.scrum",
                defaultMessage: "Scrum"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/scrum"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.sprints",
                        defaultMessage: "Sprints"
                    }),
                    url: "/agile/scrum/sprints"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.sprint-planning",
                        defaultMessage: "Sprint planning"
                    }),
                    url: "/agile/scrum/sprint-planning"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.ceremonies",
                        defaultMessage: "Ceremonies"
                    }),
                    url: "/agile/scrum/ceremonies"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.backlogs",
                        defaultMessage: "Backlogs"
                    }),
                    url: "/agile/scrum/backlogs"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.sprint-reviews",
                        defaultMessage: "Sprint reviews"
                    }),
                    url: "/agile/scrum/sprint-reviews"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.standups",
                        defaultMessage: "Standups"
                    }),
                    url: "/agile/scrum/standups"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.scrum-master",
                        defaultMessage: "Scrum master"
                    }),
                    url: "/agile/scrum/scrum-master"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.retrospectives",
                        defaultMessage: "Retrospectives"
                    }),
                    url: "/agile/scrum/retrospectives"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.distributed-scrum",
                        defaultMessage: "Distributed scrum"
                    }),
                    url: "/agile/scrum/distributed-scrum"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.roles",
                        defaultMessage: "Roles"
                    }),
                    url: "/agile/scrum/roles"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.scrum-of-scrums",
                        defaultMessage: "Scrum of scrums"
                    }),
                    url: "/agile/scrum/scrum-of-scrums"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.artifacts",
                        defaultMessage: "Agile scrum artifacts"
                    }),
                    url: "/agile/scrum/artifacts"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.scrum-metrics",
                        defaultMessage: "Scrum metrics"
                    }),
                    url: "/agile/scrum/scrum-metrics"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.jira-confluence-scrum",
                        defaultMessage: "Jira Confluence scrum"
                    }),
                    url: "/agile/scrum/jira-confluence-scrum"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.agile-vs-scrum",
                        defaultMessage: "Agile vs Scrum"
                    }),
                    url: "/agile/scrum/agile-vs-scrum"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.backlog-refinement",
                        defaultMessage: "Backlog Refinement Guide"
                    }),
                    url: "/agile/scrum/backlog-refinement"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.scrum-master-project-manager",
                        defaultMessage: "Scrum master vs. project manager"
                    }),
                    url: "/agile/scrum/scrum-master-project-manager"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.kanban",
                defaultMessage: "Kanban"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.kanban-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/kanban"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.kanban.boards",
                        defaultMessage: "Boards"
                    }),
                    url: "/agile/kanban/boards"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.kanban.wip-limits",
                        defaultMessage: "WIP limits"
                    }),
                    url: "/agile/kanban/wip-limits"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.kanban.kanban-vs-scrum",
                        defaultMessage: "Kanban vs Scrum"
                    }),
                    url: "/agile/kanban/kanban-vs-scrum"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.kanban.kanplan",
                        defaultMessage: "Kanplan"
                    }),
                    url: "/agile/kanban/kanplan"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.kanban.cards",
                        defaultMessage: "Kanban cards"
                    }),
                    url: "/agile/kanban/cards"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.project-management",
                defaultMessage: "Agile project management"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/project-management"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.project-management-intro",
                        defaultMessage: "Project management intro"
                    }),
                    url: "/agile/project-management/project-management-intro"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workflow",
                        defaultMessage: "Workflow"
                    }),
                    url: "/agile/project-management/workflow"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.ai-workflow-automation",
                        defaultMessage: "AI workflow automation"
                    }),
                    url: "/agile/project-management/ai-workflow-automation"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.epics-stories-themes",
                        defaultMessage: "Epics, stories, themes"
                    }),
                    url: "/agile/project-management/epics-stories-themes"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.epics",
                        defaultMessage: "Epics"
                    }),
                    url: "/agile/project-management/epics"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.user-stories",
                        defaultMessage: "User Stories"
                    }),
                    url: "/agile/project-management/user-stories"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.estimation",
                        defaultMessage: "Estimation"
                    }),
                    url: "/agile/project-management/estimation"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.task-management-tools",
                        defaultMessage: "Task management tools"
                    }),
                    url: "/agile/project-management/task-management-tools"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.metrics",
                        defaultMessage: "Metrics"
                    }),
                    url: "/agile/project-management/metrics"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.gantt-chart",
                        defaultMessage: "Gantt chart"
                    }),
                    url: "/agile/project-management/gantt-chart"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.best-free-project-management-software",
                        defaultMessage: "Best free project management software"
                    }),
                    url: "/agile/project-management/free-project-management-software"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.program-management",
                        defaultMessage: "Program management vs. project management"
                    }),
                    url: "/agile/project-management/program-management"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.project-baseline",
                        defaultMessage: "Project baseline"
                    }),
                    url: "/agile/project-management/project-baseline"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.continuous-improvement",
                        defaultMessage: "Continuous improvement"
                    }),
                    url: "/agile/project-management/continuous-improvement"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.lean-principles",
                        defaultMessage: "Lean principles"
                    }),
                    url: "/agile/project-management/lean-principles"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.3-pillars-scrum",
                        defaultMessage: "3 pillars of Scrum"
                    }),
                    url: "/agile/project-management/3-pillars-scrum"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.scrum-board",
                        defaultMessage: "Scrum Board"
                    }),
                    url: "/agile/project-management/scrum-board"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.waterfall-methodology",
                        defaultMessage: "Waterfall Methodology"
                    }),
                    url: "/agile/project-management/waterfall-methodology"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.velocity-scrum",
                        defaultMessage: "Velocity in Scrum"
                    }),
                    url: "/agile/project-management/velocity-scrum"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.definition-of-ready",
                        defaultMessage: "What is Definition of Ready"
                    }),
                    url: "/agile/project-management/definition-of-ready"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.lean-vs-agile",
                        defaultMessage: "Lean vs. agile"
                    }),
                    url: "/agile/project-management/lean-vs-agile"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.scrumban",
                        defaultMessage: "Scrumban"
                    }),
                    url: "/agile/project-management/scrumban"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.lean-methodology",
                        defaultMessage: "Lean Methodology"
                    }),
                    url: "/agile/project-management/lean-methodology"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.sprint-backlog",
                        defaultMessage: "Sprint backlog"
                    }),
                    url: "/agile/project-management/sprint-backlog"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.burn-up-chart",
                        defaultMessage: "Burn up chart"
                    }),
                    url: "/agile/project-management/burn-up-chart"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.kanban-principles",
                        defaultMessage: "4 kanban principles"
                    }),
                    url: "/agile/project-management/kanban-principles"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.kanban-metrics",
                        defaultMessage: "4 kanban metrics"
                    }),
                    url: "/agile/project-management/kanban-metrics"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.program-vs-project-manager",
                        defaultMessage: "Program vs. Project Manager"
                    }),
                    url: "/agile/project-management/program-vs-project-manager"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.gantt-chart-examples",
                        defaultMessage: "Gantt chart examples"
                    }),
                    url: "/agile/project-management/gantt-chart-examples"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.definition-of-done",
                        defaultMessage: "Definition of done"
                    }),
                    url: "/agile/project-management/definition-of-done"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.backlog-grooming",
                        defaultMessage: "Backlog grooming"
                    }),
                    url: "/agile/project-management/backlog-grooming"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.lean-process-improvement",
                        defaultMessage: "Lean process improvement"
                    }),
                    url: "/agile/project-management/lean-process-improvement"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.backlog-refinement-meeting",
                        defaultMessage: "Backlog refinement meetings"
                    }),
                    url: "/agile/project-management/backlog-refinement-meeting"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.scrum-values",
                        defaultMessage: "Scrum values"
                    }),
                    url: "/agile/project-management/scrum-values"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.scope-of-work",
                        defaultMessage: "Scope of work"
                    }),
                    url: "/agile/project-management/scope-of-work"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.scrum-tools",
                        defaultMessage: "Scrum tools"
                    }),
                    url: "/agile/project-management/scrum-tools"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.tools",
                        defaultMessage: "Tools"
                    }),
                    url: "/agile/project-management/tools"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workflow-automation-software",
                        defaultMessage: "Workflow automation software"
                    }),
                    url: "/agile/project-management/workflow-automation-software"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.templates",
                        defaultMessage: "Templates"
                    }),
                    url: "/agile/project-management/templates"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.task-tracker",
                        defaultMessage: "Task tracker"
                    }),
                    url: "/agile/project-management/task-tracker"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workflow-automation",
                        defaultMessage: "Workflow automation"
                    }),
                    url: "/agile/project-management/workflow-automation"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.status-report",
                        defaultMessage: "Status report"
                    }),
                    url: "/agile/project-management/status-report"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workflow-chart",
                        defaultMessage: "Workflow chart"
                    }),
                    url: "/agile/project-management/workflow-chart"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.project-roadmap",
                        defaultMessage: "Project roadmap"
                    }),
                    url: "/agile/project-management/project-roadmap"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.project-schedule",
                        defaultMessage: "Project schedule"
                    }),
                    url: "/agile/project-management/project-schedule"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.issue-tracking-software",
                        defaultMessage: "Tracking software"
                    }),
                    url: "/agile/project-management/issue-tracking-software"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.roadmap-tools",
                        defaultMessage: "Roadmap tools"
                    }),
                    url: "/agile/project-management/roadmap-tools"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.technology-roadmap",
                        defaultMessage: "Technology roadmap"
                    }),
                    url: "/agile/project-management/technology-roadmap"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.project-scheduling-software",
                        defaultMessage: "Project scheduling software"
                    }),
                    url: "/agile/project-management/project-scheduling-software"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.backlog-management-tools",
                        defaultMessage: "Backlog management tools"
                    }),
                    url: "/agile/project-management/backlog-management-tools"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workflow-management",
                        defaultMessage: "Understanding workflow management strategies"
                    }),
                    url: "/agile/project-management/workflow-management"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workflow-examples",
                        defaultMessage: "Workflow examples"
                    }),
                    url: "/agile/project-management/workflow-examples"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.create-project-roadmap",
                        defaultMessage: "Create project roadmap"
                    }),
                    url: "/agile/project-management/create-project-roadmap"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.sprint-planning-tools",
                        defaultMessage: "Sprint planning tools"
                    }),
                    url: "/agile/project-management/sprint-planning-tools"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.sprint-demo",
                        defaultMessage: "Sprint demo"
                    }),
                    url: "/agile/project-management/sprint-demo"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.project-timeline-software",
                        defaultMessage: "Project Timeline Software"
                    }),
                    url: "/agile/project-management/project-timeline-software"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.task-management-tools",
                        defaultMessage: "Top task management tools"
                    }),
                    url: "/agile/project-management/task-management-tools"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.sprint-backlog-product-backlog",
                        defaultMessage: "Product backlog vs. sprint backlog"
                    }),
                    url: "/agile/project-management/sprint-backlog-product-backlog"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workflow-management-tools",
                        defaultMessage: "Top workflow management tools"
                    }),
                    url: "/agile/project-management/workflow-management-tools"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.project-management-dependencies",
                        defaultMessage: "Project dependencies"
                    }),
                    url: "/agile/project-management/project-management-dependencies"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.task-management-dashboard",
                        defaultMessage: "Task dashboard guide"
                    }),
                    url: "/agile/project-management/task-management-dashboard"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.sprint-cadence",
                        defaultMessage: "Sprint cadence"
                    }),
                    url: "/agile/project-management/sprint-cadence"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.fast-tracking",
                        defaultMessage: "Fast tracking"
                    }),
                    url: "/agile/project-management/fast-tracking"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.fibonacci-story-points",
                        defaultMessage: "Fibonacci story points"
                    }),
                    url: "/agile/project-management/fibonacci-story-points"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.product-vs-project-management",
                        defaultMessage: "Product vs. Project Management"
                    }),
                    url: "/agile/project-management/product-vs-project-management"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.deadline-management",
                        defaultMessage: "Deadline management"
                    }),
                    url: "/agile/project-management/deadline-management"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.skills",
                        defaultMessage: "10 must-have skills"
                    }),
                    url: "/agile/project-management/skills"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.product-management",
                defaultMessage: "Product Management"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/product-management"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-roadmaps",
                        defaultMessage: "Product Roadmaps"
                    }),
                    url: "/agile/product-management/product-roadmaps"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-manager",
                        defaultMessage: "Product Manager"
                    }),
                    url: "/agile/product-management/product-manager"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.tips-for-new-product-manager",
                        defaultMessage: "Tips for new product managers"
                    }),
                    url: "/agile/product-management/tips-for-new-product-manager"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.roadmaps",
                        defaultMessage: "Roadmaps"
                    }),
                    url: "/agile/product-management/roadmaps"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.tips-for-presenting-product-roadmaps",
                        defaultMessage: "Tips for presenting product roadmaps"
                    }),
                    url: "/agile/product-management/tips-for-presenting-product-roadmaps"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.requirements",
                        defaultMessage: "Requirements"
                    }),
                    url: "/agile/product-management/requirements"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-analytics",
                        defaultMessage: "Product analytics"
                    }),
                    url: "/agile/product-management/product-analytics"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-development",
                        defaultMessage: "Product development"
                    }),
                    url: "/agile/product-management/product-development"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.remote-product-management",
                        defaultMessage: "Remote product management"
                    }),
                    url: "/agile/product-management/remote-product-management"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.minimum-viable-product",
                        defaultMessage: "Minimal viable product"
                    }),
                    url: "/agile/product-management/minimum-viable-product"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.discovery",
                        defaultMessage: "Product discovery"
                    }),
                    url: "/agile/product-management/discovery"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-specification",
                        defaultMessage: "Product specification"
                    }),
                    url: "/agile/product-management/product-specification"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-development-strategy",
                        defaultMessage: "Product development strategy"
                    }),
                    url: "/agile/product-management/product-development-strategy"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-development-software",
                        defaultMessage: "Product development software"
                    }),
                    url: "/agile/product-management/product-development-software"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.new-product-development-process",
                        defaultMessage: "New product development process"
                    }),
                    url: "/agile/product-management/new-product-development-process"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-management-kpis",
                        defaultMessage: "Product management KPIs"
                    }),
                    url: "/agile/product-management/product-management-kpis"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.nps-score",
                        defaultMessage: "Net Promoter Score (NPS)"
                    }),
                    url: "/agile/product-management/nps-score"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-critique",
                        defaultMessage: "Product critique"
                    }),
                    url: "/agile/product-management/product-critique"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.prioritization-framework",
                        defaultMessage: "Prioritization frameworks"
                    }),
                    url: "/agile/product-management/prioritization-framework"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-features",
                        defaultMessage: "Product features"
                    }),
                    url: "/agile/product-management/product-features"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-management-tools",
                        defaultMessage: "Product management tools"
                    }),
                    url: "/agile/product-management/product-management-tools"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.plm",
                        defaultMessage: "Product Lifecycle Management"
                    }),
                    url: "/agile/product-management/plm"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.roadmap-software",
                        defaultMessage: "9 best roadmap software for teams"
                    }),
                    url: "/agile/product-management/roadmap-software"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-launch-checklist",
                        defaultMessage: "Product launch checklist"
                    }),
                    url: "/agile/product-management/product-launch-checklist"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-strategy",
                        defaultMessage: "Product strategy"
                    }),
                    url: "/agile/product-management/product-strategy"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-engineering",
                        defaultMessage: "Product engineering"
                    }),
                    url: "/agile/product-management/product-engineering"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-operations",
                        defaultMessage: "Product operations"
                    }),
                    url: "/agile/product-management/product-operations"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.portfolio-management",
                        defaultMessage: "Portfolio management"
                    }),
                    url: "/agile/product-management/portfolio-management"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.pm-and-ai",
                        defaultMessage: "AI and product management"
                    }),
                    url: "/agile/product-management/pm-and-ai"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.growth-product-management",
                        defaultMessage: "Growth product management"
                    }),
                    url: "/agile/product-management/growth-product-management"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-metrics",
                        defaultMessage: "Product metrics"
                    }),
                    url: "/agile/product-management/product-metrics"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-release",
                        defaultMessage: "Product release"
                    }),
                    url: "/agile/product-management/product-release"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.feature-request",
                        defaultMessage: "Feature request"
                    }),
                    url: "/agile/product-management/feature-request"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-launch",
                        defaultMessage: "Product launch"
                    }),
                    url: "/agile/product-management/product-launch"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-planning",
                        defaultMessage: "Product planning"
                    }),
                    url: "/agile/product-management/product-planning"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-launch-event",
                        defaultMessage: "Product launch event"
                    }),
                    url: "/agile/product-management/product-launch-event"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-operating-model",
                        defaultMessage: "Product operating model"
                    }),
                    url: "/agile/product-management/product-operating-model"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-design",
                        defaultMessage: "Product design"
                    }),
                    url: "/agile/product-management/product-design"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.value-stream-management",
                defaultMessage: "Value Stream Management"
            }),
            url: "/agile/value-stream-management"
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.advantage",
                defaultMessage: "The agile advantage"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.advantage-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/advantage"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.advantage.connect-business-strategy-to-development-reality",
                        defaultMessage: "Connecting business strategy to development reality"
                    }),
                    url: "/agile/advantage/connect-business-strategy-to-development-reality"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.advantage.agile-is-a-competitive-advantage",
                        defaultMessage: "Agile is a competitive advantage"
                    }),
                    url: "/agile/advantage/agile-is-a-competitive-advantage"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.advantage.agile-mindset",
                        defaultMessage: "Cultivating an agile mindset"
                    }),
                    url: "/agile/advantage/agile-mindset"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.advantage.going-agile",
                        defaultMessage: "Going agile"
                    }),
                    url: "/agile/advantage/going-agile"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.agile-at-scale",
                defaultMessage: "Agile at scale"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/agile-at-scale"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.managing-an-agile-portfolio",
                        defaultMessage: "Managing an agile portfolio"
                    }),
                    url: "/agile/agile-at-scale/managing-an-agile-portfolio"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.lean-portfolio-management",
                        defaultMessage: "Lean portfolio management"
                    }),
                    url: "/agile/agile-at-scale/lean-portfolio-management"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.okr",
                        defaultMessage: "Okrs"
                    }),
                    url: "/agile/agile-at-scale/okr"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.long-term-agile-planning",
                        defaultMessage: "Long-term agile planning"
                    }),
                    url: "/agile/agile-at-scale/long-term-agile-planning"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.what-is-safe",
                        defaultMessage: "What is SAFe?"
                    }),
                    url: "/agile/agile-at-scale/what-is-safe"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.spotify",
                        defaultMessage: "Spotify model"
                    }),
                    url: "/agile/agile-at-scale/spotify"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.scrum-at-scale",
                        defaultMessage: "Organizational agility with Scrum@Scale"
                    }),
                    url: "/agile/agile-at-scale/scrum-at-scale"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.agile-iron-triangle",
                        defaultMessage: "Agile iron triangle"
                    }),
                    url: "/agile/agile-at-scale/agile-iron-triangle"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.less",
                        defaultMessage: "The Large-Scale Scrum (LeSS) framework"
                    }),
                    url: "/agile/agile-at-scale/less"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.using-improvement-kata-to-support-lean",
                        defaultMessage: "Using Improvement Kata to support lean"
                    }),
                    url: "/agile/agile-at-scale/using-improvement-kata-to-support-lean"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.beyond-the-basics-whitepaper",
                        defaultMessage: "Beyond the basics whitepaper"
                    }),
                    url: "/agile/agile-at-scale/beyond-the-basics-whitepaper"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.software-development",
                defaultMessage: "Software development"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/software-development"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.developer",
                        defaultMessage: "Developer"
                    }),
                    url: "/agile/software-development/developer"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.dev-managers-vs-scrum-masters",
                        defaultMessage: "Dev managers vs scrum masters"
                    }),
                    url: "/agile/software-development/dev-managers-vs-scrum-masters"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.git",
                        defaultMessage: "Git"
                    }),
                    url: "/agile/software-development/git"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.branching",
                        defaultMessage: "Branching"
                    }),
                    url: "/agile/software-development/branching"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.git-branching-video",
                        defaultMessage: "Git branching video"
                    }),
                    url: "/agile/software-development/git-branching-video"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.code-reviews",
                        defaultMessage: "Code reviews"
                    }),
                    url: "/agile/software-development/code-reviews"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.release",
                        defaultMessage: "Release"
                    }),
                    url: "/agile/software-development/release"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.technical-debt",
                        defaultMessage: "Technical debt"
                    }),
                    url: "/agile/software-development/technical-debt"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.testing",
                        defaultMessage: "Testing"
                    }),
                    url: "/agile/software-development/testing"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.incident-response",
                        defaultMessage: "Incident response"
                    }),
                    url: "/agile/software-development/incident-response"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.continuous-integration",
                        defaultMessage: "Continuous integration"
                    }),
                    url: "/agile/software-development/continuous-integration"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.sdlc",
                        defaultMessage: "Sdlc"
                    }),
                    url: "/agile/software-development/sdlc"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.bug-triage",
                        defaultMessage: "Bug triage: definition, examples, and best practices"
                    }),
                    url: "/agile/software-development/bug-triage"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.software-deployment",
                        defaultMessage: "Software deployment"
                    }),
                    url: "/agile/software-development/software-deployment"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.design",
                defaultMessage: "Design"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.design-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/design"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-design",
                        defaultMessage: "Agile design"
                    }),
                    url: "/agile/design/design-process"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.design.product-design-process-customer-interview",
                        defaultMessage: "Product design process customer interview"
                    }),
                    url: "/agile/design/product-design-process-customer-interview"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.design.collaborative-design-in-agile-teams-video",
                        defaultMessage: "Collaborative design in agile teams video"
                    }),
                    url: "/agile/design/collaborative-design-in-agile-teams-video"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.agile-marketing",
                defaultMessage: "Agile marketing"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-marketing-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/agile-marketing"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-marketing.what-is-agile-marketing",
                        defaultMessage: "What is Agile Marketing?"
                    }),
                    url: "/agile/agile-marketing/what-is-agile-marketing"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-marketing.what-is-a-marketing-project-manager",
                        defaultMessage: "What is a marketing project manager?"
                    }),
                    url: "/agile/agile-marketing/marketing-project-manager"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-marketing.agile-marketing-team",
                        defaultMessage: "How to create an agile marketing team"
                    }),
                    url: "/agile/agile-marketing/agile-marketing-team"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-marketing.ai-marketing-automation",
                        defaultMessage: "AI marketing automation"
                    }),
                    url: "/agile/agile-marketing/ai-marketing-automation"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.devops",
                defaultMessage: "DevOps"
            }),
            url: "/agile/devops"
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.teams",
                defaultMessage: "Agile Teams"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.teams-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/teams"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.teams.remote-teams",
                        defaultMessage: "Remote teams"
                    }),
                    url: "/agile/teams/remote-teams"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.teams.working-with-specialists",
                        defaultMessage: "Working with specialists"
                    }),
                    url: "/agile/teams/working-with-specialists"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.teams.release-ready-teams",
                        defaultMessage: "Release ready teams"
                    }),
                    url: "/agile/teams/release-ready-teams"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.teams.agilents-agile-transformation-journey",
                        defaultMessage: "Agilent's agile transformation journey"
                    }),
                    url: "/agile/teams/agilents-agile-transformation-journey"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.teams.advanced-roadmaps-teams",
                        defaultMessage: "Advanced Roadmaps"
                    }),
                    url: "/agile/teams/advanced-roadmaps-teams"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.teams.jira-twitter-unified-projects-teamwork",
                        defaultMessage: "How Twitter uses Jira"
                    }),
                    url: "/agile/teams/jira-twitter-unified-projects-teamwork"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.teams.scrum-kanban-agile",
                        defaultMessage: "How we chose our agile"
                    }),
                    url: "/agile/teams/scrum-kanban-agile"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.tutorials",
                defaultMessage: "Agile tutorials"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/tutorials"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.jira-confluence-sprint-refinement",
                        defaultMessage: "Jira and Confluence sprint refinement"
                    }),
                    url: "/agile/tutorials/jira-confluence-sprint-refinement"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.how-to-do-scrum-with-jira-software",
                        defaultMessage: "How to do scrum with Jira"
                    }),
                    url: "/agile/tutorials/how-to-do-scrum-with-jira"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.how-to-do-kanban-with-jira-software",
                        defaultMessage: "Learn kanban with Jira"
                    }),
                    url: "/agile/tutorials/how-to-do-kanban-with-jira"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.epics",
                        defaultMessage: "Learn how to use Epics in Jira"
                    }),
                    url: "/agile/tutorials/epics"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.creating-your-agile-board",
                        defaultMessage: "Learn how to create an agile board in Jira"
                    }),
                    url: "/agile/tutorials/creating-your-agile-board"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.sprints",
                        defaultMessage: "Learn how to use sprints in Jira"
                    }),
                    url: "/agile/tutorials/sprints"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.versions",
                        defaultMessage: "Learn Versions with Jira"
                    }),
                    url: "/agile/tutorials/versions"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.issues",
                        defaultMessage: "Learn Issues with Jira"
                    }),
                    url: "/agile/tutorials/issues"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.burndown-charts",
                        defaultMessage: "Learn burndown charts with Jira"
                    }),
                    url: "/agile/tutorials/burndown-charts"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.how-to-auto-create-subtasks-with-jira-software-automation",
                        defaultMessage: "Auto-create sub-tasks and update fields in Jira"
                    }),
                    url: "/agile/tutorials/how-to-auto-create-subtasks-with-jira-automation"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.how-to-automatically-assign-issues-with-jira-software-automation",
                        defaultMessage: "How to automatically assign issues with Jira Automation"
                    }),
                    url: "/agile/tutorials/how-to-automatically-assign-issues-with-jira-software-automation"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.how-to-sync-epics-stories-with-jira-software-automation",
                        defaultMessage: "How to sync epics stories with Jira Automation"
                    }),
                    url: "/agile/tutorials/how-to-sync-epics-stories-with-jira-software-automation"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.how-to-escalate-overdue-issues-with-jira-software-automation",
                        defaultMessage: "Automatically escalate overdue issues in Jira"
                    }),
                    url: "/agile/tutorials/how-to-escalate-overdue-issues-with-jira-software-automation"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.agile-conversations",
                defaultMessage: "Agile conversations"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-conversations-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/agile-conversations"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-conversations.marketing-agility",
                        defaultMessage: "Unlocking marketing agility"
                    }),
                    url: "/agile/agile-conversations/marketing-agility"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-conversations.customer-research-tips",
                        defaultMessage: "The power of agile and customer insights"
                    }),
                    url: "/agile/agile-conversations/customer-research-tips"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-conversations.think-big-work-small",
                        defaultMessage: "Think big, work small"
                    }),
                    url: "/agile/agile-conversations/think-big-work-small"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.about",
                defaultMessage: "About the Agile Coach"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.about-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/about"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.all-articles",
                defaultMessage: "All articles"
            }),
            url: "/agile/articles"
        }
    ];
};

});



parcelRegister("cGo4B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $600c8041298aec96$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $6z0RS = parcelRequire("6z0RS");
const $600c8041298aec96$export$d9468344d3651243 = (body)=>{
    if (!body) return {
        tutorialUseStepTitle: null,
        tutorialBodyTextContainer: null
    };
    const { tutorialInstructionSteps: tutorialInstructionSteps } = body;
    var _tutorialInstructionSteps_tutorialUseStepTitleExternal, _formatContentComponent;
    const formattedBody = {
        tutorialUseStepTitle: (_tutorialInstructionSteps_tutorialUseStepTitleExternal = tutorialInstructionSteps === null || tutorialInstructionSteps === void 0 ? void 0 : tutorialInstructionSteps.tutorialUseStepTitleExternal) !== null && _tutorialInstructionSteps_tutorialUseStepTitleExternal !== void 0 ? _tutorialInstructionSteps_tutorialUseStepTitleExternal : null,
        tutorialBodyTextContainer: (_formatContentComponent = $600c8041298aec96$var$formatContentComponent(tutorialInstructionSteps === null || tutorialInstructionSteps === void 0 ? void 0 : tutorialInstructionSteps.tutorialBodyTextContainer)) !== null && _formatContentComponent !== void 0 ? _formatContentComponent : null
    };
    return formattedBody;
};
const $600c8041298aec96$var$formatContentComponent = (contentComponents)=>{
    if (!contentComponents) return [];
    const formattedContentComponents = contentComponents.map(// eslint-disable-next-line complexity
    (contentComponent)=>{
        var _contentComponent_fields, _contentComponent_fields1, _contentComponent_fields2, _contentComponent_fields3, _contentComponent_fields4, _contentComponent_fields5, _contentComponent_fields6, _contentComponent_fields7, _contentComponent_fields8, _contentComponent_fields9, _contentComponent_fields10, _contentComponent_fields11, _contentComponent_fields12, _contentComponent_fields13, _contentComponent_fields14, _contentComponent_fields15, _contentComponent_fields16, _contentComponent_fields17, _contentComponent_fields18, _contentComponent_fields19, _contentComponent_fields20, _contentComponent_fields21, _contentComponent_fields22, _contentComponent_fields23;
        if (contentComponent.sys.contentType.sys.id === "textComponent") return {
            __typename: "TextComponent",
            name: (_contentComponent_fields = contentComponent.fields) === null || _contentComponent_fields === void 0 ? void 0 : _contentComponent_fields.textComponentNameExternal,
            text: (_contentComponent_fields1 = contentComponent.fields) === null || _contentComponent_fields1 === void 0 ? void 0 : _contentComponent_fields1.text
        };
        else if (contentComponent.sys.contentType.sys.id === "assetComponent") return {
            __typename: "AssetComponent",
            asset: $600c8041298aec96$var$formatAsset((_contentComponent_fields2 = contentComponent.fields) === null || _contentComponent_fields2 === void 0 ? void 0 : _contentComponent_fields2.asset),
            caption: (_contentComponent_fields3 = contentComponent.fields) === null || _contentComponent_fields3 === void 0 ? void 0 : _contentComponent_fields3.assetCaption,
            assetRelatedText: (_contentComponent_fields4 = contentComponent.fields) === null || _contentComponent_fields4 === void 0 ? void 0 : _contentComponent_fields4.assetRelatedText
        };
        else if (contentComponent.sys.contentType.sys.id === "proTipComponent") {
            var _contentComponent_fields24, _contentComponent_fields25, _contentComponent_fields26, _contentComponent_fields27, _contentComponent_fields28, _contentComponent_fields29, _contentComponent_fields30;
            let proTipText = "";
            if ((_contentComponent_fields24 = contentComponent.fields) === null || _contentComponent_fields24 === void 0 ? void 0 : _contentComponent_fields24.proTipRichText) proTipText = (_contentComponent_fields25 = contentComponent.fields) === null || _contentComponent_fields25 === void 0 ? void 0 : _contentComponent_fields25.proTipRichText;
            else if ((_contentComponent_fields26 = contentComponent.fields) === null || _contentComponent_fields26 === void 0 ? void 0 : _contentComponent_fields26.proTipText) proTipText = (_contentComponent_fields27 = contentComponent.fields) === null || _contentComponent_fields27 === void 0 ? void 0 : _contentComponent_fields27.proTipText;
            else if ((_contentComponent_fields28 = contentComponent.fields) === null || _contentComponent_fields28 === void 0 ? void 0 : _contentComponent_fields28.proTipTextShort) proTipText = (_contentComponent_fields29 = contentComponent.fields) === null || _contentComponent_fields29 === void 0 ? void 0 : _contentComponent_fields29.proTipTextShort;
            return {
                __typename: "ProTipComponent",
                name: (_contentComponent_fields30 = contentComponent.fields) === null || _contentComponent_fields30 === void 0 ? void 0 : _contentComponent_fields30.proTipNameExternal,
                proTipText: proTipText
            };
        } else if (contentComponent.sys.contentType.sys.id === "embeddedVideoAsset") return {
            __typename: "EmbeddedVideoAsset",
            embeddedVideoAssetName: (_contentComponent_fields5 = contentComponent.fields) === null || _contentComponent_fields5 === void 0 ? void 0 : _contentComponent_fields5.embeddedVideoAssetNameExternal,
            embedded: (_contentComponent_fields6 = contentComponent.fields) === null || _contentComponent_fields6 === void 0 ? void 0 : _contentComponent_fields6.embedded,
            embedAssetOverlay: $600c8041298aec96$var$formatAsset((_contentComponent_fields7 = contentComponent.fields) === null || _contentComponent_fields7 === void 0 ? void 0 : _contentComponent_fields7.embedAssetOverlay)
        };
        else if (contentComponent.sys.contentType.sys.id === "twitterComponent") return {
            __typename: "TwitterComponent",
            twitterComponentName: (_contentComponent_fields8 = contentComponent.fields) === null || _contentComponent_fields8 === void 0 ? void 0 : _contentComponent_fields8.twitterComponentExternalName,
            tweetText: (_contentComponent_fields9 = contentComponent.fields) === null || _contentComponent_fields9 === void 0 ? void 0 : _contentComponent_fields9.tweetText,
            twitterUrl: (_contentComponent_fields10 = contentComponent.fields) === null || _contentComponent_fields10 === void 0 ? void 0 : _contentComponent_fields10.twitterUrl
        };
        else if (contentComponent.sys.contentType.sys.id === "callToAction") return {
            __typename: "CallToAction",
            title: (_contentComponent_fields11 = contentComponent.fields) === null || _contentComponent_fields11 === void 0 ? void 0 : _contentComponent_fields11.ctaTitleExternal,
            valueProposition: (_contentComponent_fields12 = contentComponent.fields) === null || _contentComponent_fields12 === void 0 ? void 0 : _contentComponent_fields12.valueProposition,
            ctaText: (_contentComponent_fields13 = contentComponent.fields) === null || _contentComponent_fields13 === void 0 ? void 0 : _contentComponent_fields13.ctaText,
            url: (_contentComponent_fields14 = contentComponent.fields) === null || _contentComponent_fields14 === void 0 ? void 0 : _contentComponent_fields14.ctaUrl,
            asset: $600c8041298aec96$var$formatAsset((_contentComponent_fields15 = contentComponent.fields) === null || _contentComponent_fields15 === void 0 ? void 0 : _contentComponent_fields15.ctaAsset),
            product: (_contentComponent_fields16 = contentComponent.fields) === null || _contentComponent_fields16 === void 0 ? void 0 : _contentComponent_fields16.product,
            dataBlueprintModule: (_contentComponent_fields17 = contentComponent.fields) === null || _contentComponent_fields17 === void 0 ? void 0 : _contentComponent_fields17.dataBlueprintModule
        };
        else if (contentComponent.sys.contentType.sys.id === "questionComponent") return {
            __typename: "QuestionComponent",
            questionTitle: (_contentComponent_fields18 = contentComponent.fields) === null || _contentComponent_fields18 === void 0 ? void 0 : _contentComponent_fields18.questionTitleExternal,
            answer: (_contentComponent_fields19 = contentComponent.fields) === null || _contentComponent_fields19 === void 0 ? void 0 : _contentComponent_fields19.answer,
            answerAsset: $600c8041298aec96$var$formatAsset((_contentComponent_fields20 = contentComponent.fields) === null || _contentComponent_fields20 === void 0 ? void 0 : _contentComponent_fields20.answerAsset)
        };
        else if (contentComponent.sys.contentType.sys.id === "callOutComponent") return {
            __typename: "CallOutComponent",
            title: (_contentComponent_fields21 = contentComponent.fields) === null || _contentComponent_fields21 === void 0 ? void 0 : _contentComponent_fields21.callOutComponentTitleExternal,
            callOutText: (_contentComponent_fields22 = contentComponent.fields) === null || _contentComponent_fields22 === void 0 ? void 0 : _contentComponent_fields22.callOutText,
            icon: $600c8041298aec96$var$formatAsset((_contentComponent_fields23 = contentComponent.fields) === null || _contentComponent_fields23 === void 0 ? void 0 : _contentComponent_fields23.callOutComponentIcon)
        };
        else // Default case for unknown component types
        return (0, $7Knp0._)({
            __typename: "UnknownComponent"
        }, contentComponent);
    });
    // Filter out unknown component types
    return formattedContentComponents.filter((component)=>component.__typename !== "UnknownComponent");
};
// eslint-disable-next-line complexity
const $600c8041298aec96$var$formatAsset = (asset)=>{
    var _fields_file_details, _fields_file, _fields_file1, _fields_file_image, _fields_file2, _fields_image, _fields_file3, _fields_file4;
    if (!(asset === null || asset === void 0 ? void 0 : asset.fields)) return undefined;
    const { fields: fields } = asset;
    var _fields_file_fileName, _fields_file_image_height, _fields_image_width, _fields_description, _fields_file_contentType;
    return {
        name: fields.title,
        size: (_fields_file = fields.file) === null || _fields_file === void 0 ? void 0 : (_fields_file_details = _fields_file.details) === null || _fields_file_details === void 0 ? void 0 : _fields_file_details.size,
        fileName: (_fields_file_fileName = (_fields_file1 = fields.file) === null || _fields_file1 === void 0 ? void 0 : _fields_file1.fileName) !== null && _fields_file_fileName !== void 0 ? _fields_file_fileName : null,
        height: (_fields_file_image_height = (_fields_file2 = fields.file) === null || _fields_file2 === void 0 ? void 0 : (_fields_file_image = _fields_file2.image) === null || _fields_file_image === void 0 ? void 0 : _fields_file_image.height) !== null && _fields_file_image_height !== void 0 ? _fields_file_image_height : null,
        width: (_fields_image_width = (_fields_image = fields.image) === null || _fields_image === void 0 ? void 0 : _fields_image.width) !== null && _fields_image_width !== void 0 ? _fields_image_width : null,
        url: (_fields_file3 = fields.file) === null || _fields_file3 === void 0 ? void 0 : _fields_file3.url,
        description: (_fields_description = fields.description) !== null && _fields_description !== void 0 ? _fields_description : null,
        contentType: (_fields_file_contentType = (_fields_file4 = fields.file) === null || _fields_file4 === void 0 ? void 0 : _fields_file4.contentType) !== null && _fields_file_contentType !== void 0 ? _fields_file_contentType : null
    };
};
const $600c8041298aec96$var$UniformAgileTutorialBodyContent = (props)=>{
    const tutorialInstructionSteps = (0, $iSvIT.useMemo)(()=>$600c8041298aec96$export$d9468344d3651243(props), [
        props
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6z0RS.AgileTutorialBodyContent), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        tutorialInstructionSteps: tutorialInstructionSteps
    }));
};
var $600c8041298aec96$export$2e2bcd8739ae039 = $600c8041298aec96$var$UniformAgileTutorialBodyContent;

});
parcelRegister("6z0RS", function(module, exports) {

$parcel$export(module.exports, "AgileTutorialBodyContent", function () { return $4438a4bc31146ac4$export$4b3aacc978c972ad; });
/* agile-tutorial-body-content.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable react/jsx-key */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $h2e6B = parcelRequire("h2e6B");

var $6O6jV = parcelRequire("6O6jV");

var $1UUq1 = parcelRequire("1UUq1");

var $7eZEV = parcelRequire("7eZEV");

var $krNyQ = parcelRequire("krNyQ");

var $ZQ88u = parcelRequire("ZQ88u");
function $4438a4bc31146ac4$var$getRichText(richText) {
    if (typeof richText === "string") return richText;
    return (0, $h2e6B.documentToHtmlString)(richText);
}
const $4438a4bc31146ac4$export$4b3aacc978c972ad = ({ tutorialInstructionSteps: tutorialInstructionSteps })=>{
    var _tutorialInstructionSteps_tutorialBodyTextContainer;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "agile-hub-tutorial-content",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulpv47k"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_6rthze3t"
                ]),
                children: tutorialInstructionSteps === null || tutorialInstructionSteps === void 0 ? void 0 : tutorialInstructionSteps.tutorialUseStepTitle
            }),
            tutorialInstructionSteps === null || tutorialInstructionSteps === void 0 ? void 0 : (_tutorialInstructionSteps_tutorialBodyTextContainer = tutorialInstructionSteps.tutorialBodyTextContainer) === null || _tutorialInstructionSteps_tutorialBodyTextContainer === void 0 ? void 0 : _tutorialInstructionSteps_tutorialBodyTextContainer.map(// eslint-disable-next-line complexity
            (component)=>{
                var _component_asset, _component_asset1, _component_asset2;
                var _component_name, _component_text, _component_asset_url, _component_asset_description, _component_asset_contentType, _component_embeddedVideoAssetName, _component_name1, _component_name2, _component_proTipText, _component_title, _component_title1, _component_callOutText, _component_questionTitle, _component_questionTitle1, _component_answer;
                if ((0, $ZQ88u.isTextComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_rrz6idpf _1cobidpf _7exwv47k _1o6vv47k"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_name = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name !== void 0 ? _component_name : "",
                        text: $4438a4bc31146ac4$var$getRichText((_component_text = component === null || component === void 0 ? void 0 : component.text) !== null && _component_text !== void 0 ? _component_text : "")
                    })
                });
                else if ((0, $ZQ88u.isAssetComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                            src: (_component_asset_url = component === null || component === void 0 ? void 0 : (_component_asset = component.asset) === null || _component_asset === void 0 ? void 0 : _component_asset.url) !== null && _component_asset_url !== void 0 ? _component_asset_url : "",
                            alt: (_component_asset_description = component === null || component === void 0 ? void 0 : (_component_asset1 = component.asset) === null || _component_asset1 === void 0 ? void 0 : _component_asset1.description) !== null && _component_asset_description !== void 0 ? _component_asset_description : "",
                            contentType: (_component_asset_contentType = component === null || component === void 0 ? void 0 : (_component_asset2 = component.asset) === null || _component_asset2 === void 0 ? void 0 : _component_asset2.contentType) !== null && _component_asset_contentType !== void 0 ? _component_asset_contentType : "",
                            className: (0, $esG4f.default)([
                                "_p12f1osq"
                            ])
                        }),
                        (component === null || component === void 0 ? void 0 : component.caption) && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                "fine-print"
                            ]),
                            children: component === null || component === void 0 ? void 0 : component.caption
                        })
                    ]
                });
                else if ((0, $ZQ88u.isEmbedComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6O6jV.AgileVideo), {
                    embedLink: (component === null || component === void 0 ? void 0 : component.embedded) || "",
                    thumbnail: component === null || component === void 0 ? void 0 : component.embedAssetOverlay,
                    title: (_component_embeddedVideoAssetName = component === null || component === void 0 ? void 0 : component.embeddedVideoAssetName) !== null && _component_embeddedVideoAssetName !== void 0 ? _component_embeddedVideoAssetName : ""
                });
                else if ((0, $ZQ88u.isProTipText)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eZEV.Panel), {
                    panelType: "pro-tip",
                    label: (_component_name1 = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name1 !== void 0 ? _component_name1 : "",
                    description: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_name2 = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name2 !== void 0 ? _component_name2 : "",
                        text: $4438a4bc31146ac4$var$getRichText((_component_proTipText = component === null || component === void 0 ? void 0 : component.proTipText) !== null && _component_proTipText !== void 0 ? _component_proTipText : "")
                    })
                });
                else if ((0, $ZQ88u.isCallOutComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eZEV.Panel), {
                    panelType: "highlight",
                    label: (_component_title = component === null || component === void 0 ? void 0 : component.title) !== null && _component_title !== void 0 ? _component_title : "",
                    description: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_title1 = component === null || component === void 0 ? void 0 : component.title) !== null && _component_title1 !== void 0 ? _component_title1 : "",
                        text: $4438a4bc31146ac4$var$getRichText((_component_callOutText = component === null || component === void 0 ? void 0 : component.callOutText) !== null && _component_callOutText !== void 0 ? _component_callOutText : "")
                    })
                });
                else if ((0, $ZQ88u.isQuestionComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eZEV.Panel), {
                    panelType: "highlight",
                    label: (_component_questionTitle = component === null || component === void 0 ? void 0 : component.questionTitle) !== null && _component_questionTitle !== void 0 ? _component_questionTitle : "",
                    description: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_questionTitle1 = component === null || component === void 0 ? void 0 : component.questionTitle) !== null && _component_questionTitle1 !== void 0 ? _component_questionTitle1 : "",
                        text: $4438a4bc31146ac4$var$getRichText((_component_answer = component === null || component === void 0 ? void 0 : component.answer) !== null && _component_answer !== void 0 ? _component_answer : "")
                    })
                });
                return null;
            })
        ]
    });
};

});


parcelRegister("65qTS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12eae32653535cfa$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $h2e6B = parcelRequire("h2e6B");

var $e6ztu = parcelRequire("e6ztu");
const $12eae32653535cfa$export$d9468344d3651243 = (body)=>{
    if (!body) return {
        articleIntroductionName: null,
        articleIntroductionDetails: null,
        articleIntroductionAsset: null,
        embedLink: null,
        componentizedIntroduction: null
    };
    const { articleintroduction: articleintroduction } = body;
    function getRichText(richText) {
        if (typeof richText === "string") return richText;
        return (0, $h2e6B.documentToHtmlString)(richText);
    }
    var _articleintroduction_articleIntroductionTitleExternal, _getRichText, _formatAsset, _articleintroduction_embedLink, _formatContentComponent;
    const formattedBody = {
        articleIntroductionName: (_articleintroduction_articleIntroductionTitleExternal = articleintroduction === null || articleintroduction === void 0 ? void 0 : articleintroduction.articleIntroductionTitleExternal) !== null && _articleintroduction_articleIntroductionTitleExternal !== void 0 ? _articleintroduction_articleIntroductionTitleExternal : null,
        articleIntroductionDetails: (_getRichText = getRichText(articleintroduction === null || articleintroduction === void 0 ? void 0 : articleintroduction.articleIntroductionDetails)) !== null && _getRichText !== void 0 ? _getRichText : null,
        articleIntroductionAsset: (_formatAsset = $12eae32653535cfa$var$formatAsset(articleintroduction === null || articleintroduction === void 0 ? void 0 : articleintroduction.articleIntroductionAsset)) !== null && _formatAsset !== void 0 ? _formatAsset : null,
        embedLink: (_articleintroduction_embedLink = articleintroduction === null || articleintroduction === void 0 ? void 0 : articleintroduction.embedLink) !== null && _articleintroduction_embedLink !== void 0 ? _articleintroduction_embedLink : null,
        componentizedIntroduction: (_formatContentComponent = $12eae32653535cfa$var$formatContentComponent(articleintroduction === null || articleintroduction === void 0 ? void 0 : articleintroduction.componentizedIntroduction)) !== null && _formatContentComponent !== void 0 ? _formatContentComponent : null
    };
    return formattedBody;
};
const $12eae32653535cfa$var$formatContentComponent = (contentComponents)=>{
    if (!contentComponents) return null;
    const formattedContentComponents = contentComponents.map(// eslint-disable-next-line complexity
    (contentComponent)=>{
        var _contentComponent_fields, _contentComponent_fields1, _contentComponent_fields2, _contentComponent_fields3, _contentComponent_fields4, _contentComponent_fields5, _contentComponent_fields6, _contentComponent_fields7, _contentComponent_fields8, _contentComponent_fields9, _contentComponent_fields10, _contentComponent_fields11, _contentComponent_fields12, _contentComponent_fields13, _contentComponent_fields14, _contentComponent_fields15, _contentComponent_fields16, _contentComponent_fields17, _contentComponent_fields18, _contentComponent_fields19, _contentComponent_fields20, _contentComponent_fields21, _contentComponent_fields22, _contentComponent_fields23;
        if (contentComponent.sys.contentType.sys.id === "textComponent") return {
            __typename: "TextComponent",
            name: (_contentComponent_fields = contentComponent.fields) === null || _contentComponent_fields === void 0 ? void 0 : _contentComponent_fields.textComponentNameExternal,
            text: (_contentComponent_fields1 = contentComponent.fields) === null || _contentComponent_fields1 === void 0 ? void 0 : _contentComponent_fields1.text
        };
        else if (contentComponent.sys.contentType.sys.id === "assetComponent") return {
            __typename: "AssetComponent",
            asset: $12eae32653535cfa$var$formatAsset((_contentComponent_fields2 = contentComponent.fields) === null || _contentComponent_fields2 === void 0 ? void 0 : _contentComponent_fields2.asset),
            caption: (_contentComponent_fields3 = contentComponent.fields) === null || _contentComponent_fields3 === void 0 ? void 0 : _contentComponent_fields3.assetCaption,
            assetRelatedText: (_contentComponent_fields4 = contentComponent.fields) === null || _contentComponent_fields4 === void 0 ? void 0 : _contentComponent_fields4.assetRelatedText
        };
        else if (contentComponent.sys.contentType.sys.id === "proTipComponent") {
            var _contentComponent_fields24, _contentComponent_fields25, _contentComponent_fields26, _contentComponent_fields27, _contentComponent_fields28, _contentComponent_fields29, _contentComponent_fields30;
            let proTipText = "";
            if ((_contentComponent_fields24 = contentComponent.fields) === null || _contentComponent_fields24 === void 0 ? void 0 : _contentComponent_fields24.proTipRichText) proTipText = (_contentComponent_fields25 = contentComponent.fields) === null || _contentComponent_fields25 === void 0 ? void 0 : _contentComponent_fields25.proTipRichText;
            else if ((_contentComponent_fields26 = contentComponent.fields) === null || _contentComponent_fields26 === void 0 ? void 0 : _contentComponent_fields26.proTipText) proTipText = (_contentComponent_fields27 = contentComponent.fields) === null || _contentComponent_fields27 === void 0 ? void 0 : _contentComponent_fields27.proTipText;
            else if ((_contentComponent_fields28 = contentComponent.fields) === null || _contentComponent_fields28 === void 0 ? void 0 : _contentComponent_fields28.proTipTextShort) proTipText = (_contentComponent_fields29 = contentComponent.fields) === null || _contentComponent_fields29 === void 0 ? void 0 : _contentComponent_fields29.proTipTextShort;
            return {
                __typename: "ProTipComponent",
                name: (_contentComponent_fields30 = contentComponent.fields) === null || _contentComponent_fields30 === void 0 ? void 0 : _contentComponent_fields30.proTipNameExternal,
                proTipText: proTipText
            };
        } else if (contentComponent.sys.contentType.sys.id === "embeddedVideoAsset") return {
            __typename: "EmbeddedVideoAsset",
            embeddedVideoAssetName: (_contentComponent_fields5 = contentComponent.fields) === null || _contentComponent_fields5 === void 0 ? void 0 : _contentComponent_fields5.embeddedVideoAssetNameExternal,
            embedded: (_contentComponent_fields6 = contentComponent.fields) === null || _contentComponent_fields6 === void 0 ? void 0 : _contentComponent_fields6.embedded,
            embedAssetOverlay: $12eae32653535cfa$var$formatAsset((_contentComponent_fields7 = contentComponent.fields) === null || _contentComponent_fields7 === void 0 ? void 0 : _contentComponent_fields7.embedAssetOverlay)
        };
        else if (contentComponent.sys.contentType.sys.id === "twitterComponent") return {
            __typename: "TwitterComponent",
            twitterComponentName: (_contentComponent_fields8 = contentComponent.fields) === null || _contentComponent_fields8 === void 0 ? void 0 : _contentComponent_fields8.twitterComponentExternalName,
            tweetText: (_contentComponent_fields9 = contentComponent.fields) === null || _contentComponent_fields9 === void 0 ? void 0 : _contentComponent_fields9.tweetText,
            twitterUrl: (_contentComponent_fields10 = contentComponent.fields) === null || _contentComponent_fields10 === void 0 ? void 0 : _contentComponent_fields10.twitterUrl
        };
        else if (contentComponent.sys.contentType.sys.id === "callToAction") return {
            __typename: "CallToAction",
            title: (_contentComponent_fields11 = contentComponent.fields) === null || _contentComponent_fields11 === void 0 ? void 0 : _contentComponent_fields11.ctaTitleExternal,
            valueProposition: (_contentComponent_fields12 = contentComponent.fields) === null || _contentComponent_fields12 === void 0 ? void 0 : _contentComponent_fields12.valueProposition,
            ctaText: (_contentComponent_fields13 = contentComponent.fields) === null || _contentComponent_fields13 === void 0 ? void 0 : _contentComponent_fields13.ctaText,
            url: (_contentComponent_fields14 = contentComponent.fields) === null || _contentComponent_fields14 === void 0 ? void 0 : _contentComponent_fields14.ctaUrl,
            asset: $12eae32653535cfa$var$formatAsset((_contentComponent_fields15 = contentComponent.fields) === null || _contentComponent_fields15 === void 0 ? void 0 : _contentComponent_fields15.ctaAsset),
            product: (_contentComponent_fields16 = contentComponent.fields) === null || _contentComponent_fields16 === void 0 ? void 0 : _contentComponent_fields16.product,
            dataBlueprintModule: (_contentComponent_fields17 = contentComponent.fields) === null || _contentComponent_fields17 === void 0 ? void 0 : _contentComponent_fields17.dataBlueprintModule
        };
        else if (contentComponent.sys.contentType.sys.id === "questionComponent") return {
            __typename: "QuestionComponent",
            questionTitle: (_contentComponent_fields18 = contentComponent.fields) === null || _contentComponent_fields18 === void 0 ? void 0 : _contentComponent_fields18.questionTitleExternal,
            answer: (_contentComponent_fields19 = contentComponent.fields) === null || _contentComponent_fields19 === void 0 ? void 0 : _contentComponent_fields19.answer,
            answerAsset: $12eae32653535cfa$var$formatAsset((_contentComponent_fields20 = contentComponent.fields) === null || _contentComponent_fields20 === void 0 ? void 0 : _contentComponent_fields20.answerAsset)
        };
        else if (contentComponent.sys.contentType.sys.id === "callOutComponent") return {
            __typename: "CallOutComponent",
            title: (_contentComponent_fields21 = contentComponent.fields) === null || _contentComponent_fields21 === void 0 ? void 0 : _contentComponent_fields21.callOutComponentTitleExternal,
            callOutText: (_contentComponent_fields22 = contentComponent.fields) === null || _contentComponent_fields22 === void 0 ? void 0 : _contentComponent_fields22.callOutText,
            icon: $12eae32653535cfa$var$formatAsset((_contentComponent_fields23 = contentComponent.fields) === null || _contentComponent_fields23 === void 0 ? void 0 : _contentComponent_fields23.callOutComponentIcon)
        };
        else // Default case for unknown component types
        return (0, $7Knp0._)({
            __typename: "UnknownComponent"
        }, contentComponent);
    });
    // Filter out unknown component types
    return formattedContentComponents.filter((component)=>component.__typename !== "UnknownComponent");
};
// eslint-disable-next-line complexity
const $12eae32653535cfa$var$formatAsset = (asset)=>{
    var _fields_file_details, _fields_file, _fields_file1, _fields_file_image, _fields_file2, _fields_image, _fields_file3, _fields_file4;
    if (!(asset === null || asset === void 0 ? void 0 : asset.fields)) return undefined;
    const { fields: fields } = asset;
    var _fields_file_fileName, _fields_file_image_height, _fields_image_width, _fields_description, _fields_file_contentType;
    return {
        name: fields.title,
        size: (_fields_file = fields.file) === null || _fields_file === void 0 ? void 0 : (_fields_file_details = _fields_file.details) === null || _fields_file_details === void 0 ? void 0 : _fields_file_details.size,
        fileName: (_fields_file_fileName = (_fields_file1 = fields.file) === null || _fields_file1 === void 0 ? void 0 : _fields_file1.fileName) !== null && _fields_file_fileName !== void 0 ? _fields_file_fileName : null,
        height: (_fields_file_image_height = (_fields_file2 = fields.file) === null || _fields_file2 === void 0 ? void 0 : (_fields_file_image = _fields_file2.image) === null || _fields_file_image === void 0 ? void 0 : _fields_file_image.height) !== null && _fields_file_image_height !== void 0 ? _fields_file_image_height : null,
        width: (_fields_image_width = (_fields_image = fields.image) === null || _fields_image === void 0 ? void 0 : _fields_image.width) !== null && _fields_image_width !== void 0 ? _fields_image_width : null,
        url: (_fields_file3 = fields.file) === null || _fields_file3 === void 0 ? void 0 : _fields_file3.url,
        description: (_fields_description = fields.description) !== null && _fields_description !== void 0 ? _fields_description : null,
        contentType: (_fields_file_contentType = (_fields_file4 = fields.file) === null || _fields_file4 === void 0 ? void 0 : _fields_file4.contentType) !== null && _fields_file_contentType !== void 0 ? _fields_file_contentType : null
    };
};
const $12eae32653535cfa$var$UniformArticleIntroductionContent = (props)=>{
    const articleIntroduction = (0, $iSvIT.useMemo)(()=>$12eae32653535cfa$export$d9468344d3651243(props), [
        props
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $e6ztu.ArticleIntroductionContent), {
        articleIntroduction: articleIntroduction
    });
};
var $12eae32653535cfa$export$2e2bcd8739ae039 = $12eae32653535cfa$var$UniformArticleIntroductionContent;

});
parcelRegister("e6ztu", function(module, exports) {

$parcel$export(module.exports, "ArticleIntroductionContent", function () { return $079c0c2aa7b1ac7e$export$6ccfc3df312e7dbb; });
/* article-introduction-content.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable react/jsx-key */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $h2e6B = parcelRequire("h2e6B");

var $6O6jV = parcelRequire("6O6jV");

var $1UUq1 = parcelRequire("1UUq1");

var $7eZEV = parcelRequire("7eZEV");

var $krNyQ = parcelRequire("krNyQ");

var $ZQ88u = parcelRequire("ZQ88u");
function $079c0c2aa7b1ac7e$var$getRichText(richText) {
    if (typeof richText === "string") return richText;
    return (0, $h2e6B.documentToHtmlString)(richText);
} // eslint-disable-next-line complexity
const $079c0c2aa7b1ac7e$export$6ccfc3df312e7dbb = ({ articleIntroduction: articleIntroduction })=>{
    var _articleIntroduction_componentizedIntroduction;
    var _articleIntroduction_articleIntroductionName, _articleIntroduction_articleIntroductionDetails, _articleIntroduction_embedLink, _articleIntroduction_articleIntroductionName1;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "agile-hub-introduction-content",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulpv47k"
        ]),
        children: [
            (articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.articleIntroductionName) && /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_6rthze3t"
                ]),
                children: articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.articleIntroductionName
            }),
            (articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.articleIntroductionDetails) && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rthv47k"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                    name: (_articleIntroduction_articleIntroductionName = articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.articleIntroductionName) !== null && _articleIntroduction_articleIntroductionName !== void 0 ? _articleIntroduction_articleIntroductionName : "",
                    text: $079c0c2aa7b1ac7e$var$getRichText((_articleIntroduction_articleIntroductionDetails = articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.articleIntroductionDetails) !== null && _articleIntroduction_articleIntroductionDetails !== void 0 ? _articleIntroduction_articleIntroductionDetails : "")
                })
            }),
            (articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.embedLink) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $6O6jV.AgileVideo), {
                embedLink: (_articleIntroduction_embedLink = articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.embedLink) !== null && _articleIntroduction_embedLink !== void 0 ? _articleIntroduction_embedLink : "",
                title: (_articleIntroduction_articleIntroductionName1 = articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.articleIntroductionName) !== null && _articleIntroduction_articleIntroductionName1 !== void 0 ? _articleIntroduction_articleIntroductionName1 : "",
                thumbnail: articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.articleIntroductionAsset
            }),
            articleIntroduction === null || articleIntroduction === void 0 ? void 0 : (_articleIntroduction_componentizedIntroduction = articleIntroduction.componentizedIntroduction) === null || _articleIntroduction_componentizedIntroduction === void 0 ? void 0 : _articleIntroduction_componentizedIntroduction.map(// eslint-disable-next-line complexity
            (component)=>{
                var _component_asset, _component_asset1, _component_asset2;
                var _component_name, _component_text, _component_asset_url, _component_asset_description, _component_asset_contentType, _component_embeddedVideoAssetName, _component_name1, _component_name2, _component_proTipText, _component_title, _component_title1, _component_callOutText, _component_questionTitle, _component_questionTitle1, _component_answer;
                if ((0, $ZQ88u.isTextComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_rrz6idpf _1cobidpf _7exwv47k _1o6vv47k"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_name = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name !== void 0 ? _component_name : "",
                        text: $079c0c2aa7b1ac7e$var$getRichText((_component_text = component === null || component === void 0 ? void 0 : component.text) !== null && _component_text !== void 0 ? _component_text : "")
                    })
                });
                else if ((0, $ZQ88u.isAssetComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                            src: (_component_asset_url = component === null || component === void 0 ? void 0 : (_component_asset = component.asset) === null || _component_asset === void 0 ? void 0 : _component_asset.url) !== null && _component_asset_url !== void 0 ? _component_asset_url : "",
                            alt: (_component_asset_description = component === null || component === void 0 ? void 0 : (_component_asset1 = component.asset) === null || _component_asset1 === void 0 ? void 0 : _component_asset1.description) !== null && _component_asset_description !== void 0 ? _component_asset_description : "",
                            contentType: (_component_asset_contentType = component === null || component === void 0 ? void 0 : (_component_asset2 = component.asset) === null || _component_asset2 === void 0 ? void 0 : _component_asset2.contentType) !== null && _component_asset_contentType !== void 0 ? _component_asset_contentType : "",
                            className: (0, $esG4f.default)([
                                "_p12f1osq"
                            ])
                        }),
                        (component === null || component === void 0 ? void 0 : component.caption) && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                "fine-print"
                            ]),
                            children: component === null || component === void 0 ? void 0 : component.caption
                        })
                    ]
                });
                else if ((0, $ZQ88u.isEmbedComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6O6jV.AgileVideo), {
                    embedLink: (component === null || component === void 0 ? void 0 : component.embedded) || "",
                    thumbnail: component === null || component === void 0 ? void 0 : component.embedAssetOverlay,
                    title: (_component_embeddedVideoAssetName = component === null || component === void 0 ? void 0 : component.embeddedVideoAssetName) !== null && _component_embeddedVideoAssetName !== void 0 ? _component_embeddedVideoAssetName : ""
                });
                else if ((0, $ZQ88u.isProTipText)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eZEV.Panel), {
                    panelType: "pro-tip",
                    label: (_component_name1 = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name1 !== void 0 ? _component_name1 : "",
                    description: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_name2 = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name2 !== void 0 ? _component_name2 : "",
                        text: $079c0c2aa7b1ac7e$var$getRichText((_component_proTipText = component === null || component === void 0 ? void 0 : component.proTipText) !== null && _component_proTipText !== void 0 ? _component_proTipText : "")
                    })
                });
                else if ((0, $ZQ88u.isCallOutComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eZEV.Panel), {
                    panelType: "highlight",
                    label: (_component_title = component === null || component === void 0 ? void 0 : component.title) !== null && _component_title !== void 0 ? _component_title : "",
                    description: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_title1 = component === null || component === void 0 ? void 0 : component.title) !== null && _component_title1 !== void 0 ? _component_title1 : "",
                        text: $079c0c2aa7b1ac7e$var$getRichText((_component_callOutText = component === null || component === void 0 ? void 0 : component.callOutText) !== null && _component_callOutText !== void 0 ? _component_callOutText : "")
                    })
                });
                else if ((0, $ZQ88u.isQuestionComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eZEV.Panel), {
                    panelType: "highlight",
                    label: (_component_questionTitle = component === null || component === void 0 ? void 0 : component.questionTitle) !== null && _component_questionTitle !== void 0 ? _component_questionTitle : "",
                    description: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_questionTitle1 = component === null || component === void 0 ? void 0 : component.questionTitle) !== null && _component_questionTitle1 !== void 0 ? _component_questionTitle1 : "",
                        text: $079c0c2aa7b1ac7e$var$getRichText((_component_answer = component === null || component === void 0 ? void 0 : component.answer) !== null && _component_answer !== void 0 ? _component_answer : "")
                    })
                });
                return null;
            })
        ]
    });
};

});


parcelRegister("5DXmX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("6PX7I")).default; });

var $6PX7I = parcelRequire("6PX7I");

});
parcelRegister("6PX7I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28396434fb3285f3$export$2e2bcd8739ae039; });
/* background-video-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $gF60T = parcelRequire("gF60T");

var $7ShLR = parcelRequire("7ShLR");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $gAJUc = parcelRequire("gAJUc");
const $28396434fb3285f3$var$containerStyles = null;
const $28396434fb3285f3$var$contentStyles = null;
const $28396434fb3285f3$var$svgOverlayStyles = null;
const $28396434fb3285f3$var$backgroundVideoStyles = null;
const $28396434fb3285f3$var$headingStyles = null;
const $28396434fb3285f3$var$descriptionStyles = null;
const $28396434fb3285f3$var$controlButtonStyles = null; // eslint-disable-next-line complexity
const $28396434fb3285f3$var$UniformBackgroundVideoContainer = (props)=>{
    const containerRef = (0, $iSvIT.useRef)(null);
    const [isVisible, setIsVisible] = (0, $iSvIT.useState)(false);
    const videoRef = (0, $iSvIT.useRef)(null);
    const [isPlaying, setPlaying] = (0, $iSvIT.useState)(false);
    const [hasEnded, setHasEnded] = (0, $iSvIT.useState)(false);
    const [currentVideoSource, setCurrentVideoSource] = (0, $iSvIT.useState)("");
    const [windowWidth, setWindowWidth] = (0, $iSvIT.useState)(typeof globalThis.window !== "undefined" ? globalThis.window.innerWidth : 1200);
    const [holeWidth, setHoleWidth] = (0, $iSvIT.useState)(1); // Separate width for rectangle
    const [holeHeight, setHoleHeight] = (0, $iSvIT.useState)(1); // Separate height for rectangle
    const [holeRadius, setHoleRadius] = (0, $iSvIT.useState)(300);
    const [containerDimensions, setContainerDimensions] = (0, $iSvIT.useState)({
        width: 0,
        height: 0
    });
    const intl = (0, $f6qj2.default)();
    const prefersReducedMotion = typeof globalThis.window !== "undefined" ? globalThis.window.matchMedia("(prefers-reduced-motion: reduce)").matches : false; // can turn the feature flag on to disable the overlay if it's glitchy
    const isAnimationOverlayEnabled = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7823AnimationOverlayOption);
    const computedWidth = containerDimensions.width || 1200;
    const computedHeight = containerDimensions.height || 700;
    const getVideoSource = (0, $iSvIT.useCallback)((width)=>{
        if (width >= 1024) return props.videoSourceDesktop;
        if (width >= 768) return props.videoSourceTablet;
        return props.videoSourceMobile;
    }, [
        props.videoSourceDesktop,
        props.videoSourceTablet,
        props.videoSourceMobile
    ]);
    (0, $iSvIT.useEffect)(()=>{
        const handleResize = ()=>{
            if (typeof globalThis.window !== "undefined") setWindowWidth(globalThis.window.innerWidth);
        };
        const updateVideoSource = (newSource)=>{
            if (newSource === currentVideoSource) return;
            setCurrentVideoSource(newSource);
            if (!videoRef.current) return;
            if (isPlaying) {
                const currentTime = videoRef.current.currentTime;
                videoRef.current.src = newSource;
                videoRef.current.load();
                videoRef.current.currentTime = currentTime;
                videoRef.current.play().catch(()=>{});
            } else {
                videoRef.current.src = newSource;
                videoRef.current.load();
            }
        };
        const initialSource = getVideoSource(windowWidth);
        updateVideoSource(initialSource);
        if (typeof globalThis.window !== "undefined") {
            globalThis.window.addEventListener("resize", handleResize);
            return ()=>globalThis.window.removeEventListener("resize", handleResize);
        }
        return undefined;
    }, [
        windowWidth,
        currentVideoSource,
        isPlaying,
        getVideoSource
    ]);
    const togglePlay = ()=>{
        if (videoRef.current) {
            if (isPlaying) videoRef.current.pause();
            else videoRef.current.play().catch(()=>{});
        }
    };
    const handleVideoPlay = ()=>{
        setPlaying(true);
        setHasEnded(false);
    };
    const handleVideoPause = ()=>setPlaying(false);
    const handleVideoEnded = ()=>{
        setPlaying(false);
        setHasEnded(true);
    };
    const startHoleAnimation = (0, $iSvIT.useCallback)((containerElement)=>{
        const containerWidth = containerElement.offsetWidth;
        const containerHeight = containerElement.offsetHeight;
        setContainerDimensions({
            width: containerWidth,
            height: containerHeight
        });
        setTimeout(()=>{
            const startTime = Date.now();
            const duration = 800;
            const startSize = 1;
            const animationInterval = setInterval(()=>{
                const elapsed = Date.now() - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const easedProgress = 1 - Math.pow(1 - progress, 3); // ease-out cubic
                const currentHoleWidth = startSize + (containerWidth - startSize) * easedProgress;
                const currentHoleHeight = startSize + (containerHeight - startSize) * easedProgress;
                const currentRadius = 300 * (1 - Math.min(progress * 1.5, 1));
                setHoleWidth(currentHoleWidth);
                setHoleHeight(currentHoleHeight);
                setHoleRadius(currentRadius);
                if (progress >= 1) clearInterval(animationInterval);
            }, 16);
        }, 800);
    }, []);
    (0, $iSvIT.useEffect)(()=>{
        const observer = new IntersectionObserver(([entry])=>{
            if (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) {
                setIsVisible(true);
                if (videoRef.current && !prefersReducedMotion) videoRef.current.play().catch(()=>{});
                if (!prefersReducedMotion && containerRef.current && isAnimationOverlayEnabled) startHoleAnimation(containerRef.current);
                else if (containerRef.current && isAnimationOverlayEnabled) {
                    const containerWidth = containerRef.current.offsetWidth;
                    const containerHeight = containerRef.current.offsetHeight;
                    setContainerDimensions({
                        width: containerWidth,
                        height: containerHeight
                    });
                    setHoleWidth(containerWidth);
                    setHoleHeight(containerHeight);
                    setHoleRadius(0);
                }
            }
        }, {
            threshold: 0.3
        });
        if (containerRef.current) observer.observe(containerRef.current);
        return ()=>observer.disconnect();
    }, [
        prefersReducedMotion,
        startHoleAnimation,
        isAnimationOverlayEnabled
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        ref: containerRef,
        className: (0, $esG4f.default)([
            "_bfhkmt5y _kqswh2mm _1reo15vq _18m915vq _4t3i1j7z _1gdlbcwg _1knekdgb"
        ]),
        style: {
            "--video-width-mobile": props.videoWidthMobile ? `${props.videoWidthMobile}px` : "500px",
            "--video-height-mobile": props.videoHeightMobile ? `${props.videoHeightMobile}px` : "700px",
            "--video-width-tablet": props.videoWidthTablet ? `${props.videoWidthTablet}px` : "800px",
            "--video-height-tablet": props.videoHeightTablet ? `${props.videoHeightTablet}px` : "1000px",
            "--video-width-desktop": props.videoWidthDesktop ? `${props.videoWidthDesktop}px` : "1200px",
            "--video-height-desktop": props.videoHeightDesktop ? `${props.videoHeightDesktop}px` : "700px",
            "--_1ex89o1": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark0"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("video", {
                ref: videoRef,
                src: currentVideoSource,
                muted: true,
                loop: props.videoLoop || false,
                playsInline: true,
                onPlay: handleVideoPlay,
                onPause: handleVideoPause,
                onEnded: handleVideoEnded,
                className: (0, $esG4f.default)([
                    "_kqswstnw _19pk1wug _2hwx1wug _otyr1wug _18u01wug _152tidpf _u7coidpf _1pbykb7n _1e021l2x _rjxp1l2x _4t3i1j7z _1j7jwqo7 _19tlwqo7 _1gdlbcwg _nqop1vnc _1a5h1vnc _1knekdgb"
                ])
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_tzy4idpf _kqswh2mm _1pbycs5v _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _y3gn1h6o _19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _p12f1osq _4t3i1osq _1bsbbxu3 _w19jrnt7 _v5641v33 _1s4p1erl _14u4kb7n _22qt1amc",
                    isVisible ? "animate-reveal" : ""
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        className: (0, $esG4f.default)([
                            "_18s812pl _16cqcd5j",
                            "video-heading"
                        ]),
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                        },
                        children: props.videoHeading
                    }),
                    props.videoDescription && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_163ycd5j",
                            "video-description"
                        ]),
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                        },
                        children: props.videoDescription
                    }),
                    props.videoCta && props.videoCtaLink && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        href: props.videoCtaLink,
                        text: props.videoCta,
                        type: "primary",
                        bgColor: "bgBlackBlue"
                    })
                ]
            }),
            !hasEnded && /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                onClick: togglePlay,
                className: (0, $esG4f.default)([
                    "_80omtlke _tzy41ou4 _bfhk1j28 _syazcd5j _19it1axk _2rko17td _4t3i1ul9 _1bsb1ul9 _1e0c1txw _4cvr1h6o _1bah1h6o _kqswstnw _1pbyegat _rjxppxbi _u7copxbi _16l4kb7n _w8l5dlk8"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                    "--_514je1": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.pill"))
                },
                children: isPlaying ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gF60T))), {
                    label: intl.formatMessage({
                        id: "uniform-video.pause",
                        defaultMessage: "Pause"
                    })
                }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7ShLR))), {
                    label: intl.formatMessage({
                        id: "uniform-video.play",
                        defaultMessage: "Play"
                    })
                })
            }),
            isAnimationOverlayEnabled && /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                viewBox: `0 0 ${computedWidth} ${computedHeight}`,
                preserveAspectRatio: "none",
                className: (0, $esG4f.default)([
                    "_kqswstnw _1pby11wp _lcxvglyw _1r04idpf _1bsb1osq _4t3i1osq _1lmqglyw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("mask", {
                            id: "hole-mask",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                    width: computedWidth,
                                    height: computedHeight,
                                    fill: "white"
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                    x: computedWidth / 2 - holeWidth / 2,
                                    y: computedHeight / 2 - holeHeight / 2,
                                    width: holeWidth,
                                    height: holeHeight,
                                    rx: holeRadius,
                                    ry: holeRadius,
                                    fill: "black"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: computedWidth,
                        height: computedHeight,
                        fill: (0, $5ohHq.wacToken)("color.neutral.light0"),
                        mask: "url(#hole-mask)"
                    })
                ]
            })
        ]
    });
};
var $28396434fb3285f3$export$2e2bcd8739ae039 = $28396434fb3285f3$var$UniformBackgroundVideoContainer;

});
parcelRegister("gF60T", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73df1d388ecc854df8671cdf3cc68b05>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c21523d4c5898645$var$_react = $c21523d4c5898645$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $c21523d4c5898645$var$_baseNew = $c21523d4c5898645$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $c21523d4c5898645$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPauseOverlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pause video when icon is overlayed on Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c21523d4c5898645$var$VideoPauseOverlayIcon = (props)=>/*#__PURE__*/ $c21523d4c5898645$var$_react.default.createElement($c21523d4c5898645$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm7 0a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$c21523d4c5898645$var$VideoPauseOverlayIcon.displayName = "VideoPauseOverlayIcon";
var $c21523d4c5898645$var$_default = module.exports.default = $c21523d4c5898645$var$VideoPauseOverlayIcon;

});

parcelRegister("7ShLR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d2e3c8fcba4e62054ef71c09ada81e61>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5bbb5c804e3fea2a$var$_react = $5bbb5c804e3fea2a$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $5bbb5c804e3fea2a$var$_baseNew = $5bbb5c804e3fea2a$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $5bbb5c804e3fea2a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlayOverlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for play video when icon is overlayed on Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5bbb5c804e3fea2a$var$VideoPlayOverlayIcon = (props)=>/*#__PURE__*/ $5bbb5c804e3fea2a$var$_react.default.createElement($5bbb5c804e3fea2a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.112C2 1.592 3.63.627 4.963 1.36l8.902 4.888c1.383.76 1.383 2.747 0 3.506l-8.902 4.888C3.63 15.373 2 14.408 2 12.888z" clip-rule="evenodd"/>`
    }, props));
$5bbb5c804e3fea2a$var$VideoPlayOverlayIcon.displayName = "VideoPlayOverlayIcon";
var $5bbb5c804e3fea2a$var$_default = module.exports.default = $5bbb5c804e3fea2a$var$VideoPlayOverlayIcon;

});



parcelRegister("1419P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("5tOAJ")).default; });

var $5tOAJ = parcelRequire("5tOAJ");

});
parcelRegister("5tOAJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51ad7e783341a3f6$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $6N99x = parcelRequire("6N99x");
const $51ad7e783341a3f6$var$UniformBannerAlert = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6N99x.BannerAlert), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        dataEventProps: {
            "data-product-key": "uniform",
            "data-event-component": "linkButton",
            "data-event-container": "bannerAlert",
            "data-event": "clicked"
        }
    }));
};
var $51ad7e783341a3f6$export$2e2bcd8739ae039 = $51ad7e783341a3f6$var$UniformBannerAlert;

});


parcelRegister("13r6t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("3DJF0")).default; });

var $3DJF0 = parcelRequire("3DJF0");

});
parcelRegister("3DJF0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0ae596e2684c3fb$export$2e2bcd8739ae039; });
/* body-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $h2e6B = parcelRequire("h2e6B");

var $8M1Bj = parcelRequire("8M1Bj");

var $1UUq1 = parcelRequire("1UUq1");

var $8lB1y = parcelRequire("8lB1y");
const $a0ae596e2684c3fb$var$UniformBodyContent = ({ body: body })=>{
    const customComponentRenderer = (node)=>{
        switch(node.data.target.sys.contentType.sys.id){
            case "embeddedVideoAsset":
                {
                    const embeddedVideoAssetData = node.data.target.fields;
                    let embeddedVideoThumbnail = undefined;
                    if (embeddedVideoAssetData.embedAssetOverlayOl) {
                        const orangeLogicThumbnail = embeddedVideoAssetData.embedAssetOverlayOl.fields;
                        var _orangeLogicThumbnail_assetUrl;
                        const imageUrl = orangeLogicThumbnail.assetJson ? orangeLogicThumbnail.assetJson.imageUrl : (_orangeLogicThumbnail_assetUrl = orangeLogicThumbnail.assetUrl) !== null && _orangeLogicThumbnail_assetUrl !== void 0 ? _orangeLogicThumbnail_assetUrl : "";
                        var _orangeLogicThumbnail_alt;
                        embeddedVideoThumbnail = {
                            src: imageUrl,
                            alt: (_orangeLogicThumbnail_alt = orangeLogicThumbnail.alt) !== null && _orangeLogicThumbnail_alt !== void 0 ? _orangeLogicThumbnail_alt : ""
                        };
                    } else if (embeddedVideoAssetData.embedAssetOverlay) embeddedVideoThumbnail = {
                        src: embeddedVideoAssetData.embedAssetOverlay.fields.file.url,
                        alt: embeddedVideoAssetData.embedAssetOverlay.fields.description,
                        contentType: embeddedVideoAssetData.embedAssetOverlay.fields.file.contentType
                    };
                    if (!embeddedVideoAssetData.embedded) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {});
                    var _embeddedVideoAssetData_embeddedVideoAssetNameExternal;
                    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.EmbeddedVideo), {
                            embedUrl: embeddedVideoAssetData.embedded,
                            thumbnail: embeddedVideoThumbnail,
                            title: (_embeddedVideoAssetData_embeddedVideoAssetNameExternal = embeddedVideoAssetData.embeddedVideoAssetNameExternal) !== null && _embeddedVideoAssetData_embeddedVideoAssetNameExternal !== void 0 ? _embeddedVideoAssetData_embeddedVideoAssetNameExternal : ""
                        })
                    });
                }
            case "proTipComponent":
                {
                    const proTipComponentData = node.data.target.fields;
                    var _proTipComponentData_proTipText;
                    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Panel), {
                            panelType: "pro-tip",
                            label: proTipComponentData.proTipNameExternal,
                            description: proTipComponentData.proTipRichText ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: (0, $h2e6B.documentToHtmlString)(proTipComponentData.proTipRichText)
                                }
                            }) : (_proTipComponentData_proTipText = proTipComponentData.proTipText) !== null && _proTipComponentData_proTipText !== void 0 ? _proTipComponentData_proTipText : ""
                        })
                    });
                }
            case "orangeLogicAsset":
                {
                    const orangeLogicAssetData = node.data.target.fields;
                    var _orangeLogicAssetData_assetUrl;
                    const imageUrl = orangeLogicAssetData.assetJson ? orangeLogicAssetData.assetJson.imageUrl : (_orangeLogicAssetData_assetUrl = orangeLogicAssetData.assetUrl) !== null && _orangeLogicAssetData_assetUrl !== void 0 ? _orangeLogicAssetData_assetUrl : undefined;
                    if (imageUrl === undefined) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {});
                    var _orangeLogicAssetData_alt;
                    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1bsb1osq _1e0c1txw _1bah1h6o",
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                            src: imageUrl,
                            alt: (_orangeLogicAssetData_alt = orangeLogicAssetData.alt) !== null && _orangeLogicAssetData_alt !== void 0 ? _orangeLogicAssetData_alt : "",
                            style: orangeLogicAssetData.width ? {
                                width: orangeLogicAssetData.width
                            } : undefined
                        })
                    });
                }
            case "callToActionMicrocopy":
                {
                    const callToActionMicrocopyData = node.data.target.fields;
                    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
                            href: callToActionMicrocopyData.ctaUrl,
                            dataEventProps: {
                                "data-product-key": "uniform",
                                "data-event-component": "linkButton",
                                "data-event-container": "bodyContentInline",
                                "data-event": "clicked"
                            },
                            children: callToActionMicrocopyData.ctaButtonText
                        })
                    });
                }
            case "codeBlock":
                {
                    const codeBlockData = node.data.target.fields;
                    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
                        text: `<pre><code>${codeBlockData.code}</code></pre>`
                    });
                }
            default:
                return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {});
        }
    };
    const renderContentfulRichTextNodes = (nodes)=>{
        return nodes.map((node)=>{
            switch(node.nodeType){
                case "embedded-entry-block":
                    return customComponentRenderer(node);
                case "embedded-asset-block":
                    {
                        const embeddedAssetBlockData = node.data.target;
                        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                            src: embeddedAssetBlockData.fields.file.url,
                            alt: embeddedAssetBlockData.fields.description,
                            style: $a0ae596e2684c3fb$var$embeddedItemStyles
                        });
                    }
                case "blockquote":
                    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.PullQuote), {
                        quote: "",
                        quoteRichTextString: $a0ae596e2684c3fb$var$parseRichTextStringForOnlyContentInsideParagraphs((0, $h2e6B.documentToHtmlString)({
                            nodeType: (0, $8M1Bj.BLOCKS).DOCUMENT,
                            content: node.content,
                            data: {}
                        }))
                    });
                default:
                    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
                        text: (0, $h2e6B.documentToHtmlString)({
                            nodeType: (0, $8M1Bj.BLOCKS).DOCUMENT,
                            content: [
                                node
                            ],
                            data: {}
                        })
                    });
            }
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        id: "body-content",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _gy1pu2gc _1srcpxbi"
        ]),
        children: renderContentfulRichTextNodes(body.content)
    });
};
const $a0ae596e2684c3fb$var$embeddedItemStyles = {
    maxWidth: "100%",
    marginBlock: "var(--ds-space-200, 16px)"
};
const $a0ae596e2684c3fb$var$bodyContainerCss = null;
const $a0ae596e2684c3fb$var$parseRichTextStringForOnlyContentInsideParagraphs = (richTextString)=>{
    const paragraphRegex = /<p\b[^>]*>(.*?)<\/p>/gi;
    const matches = Array.from(richTextString.matchAll(paragraphRegex));
    return matches ? matches.map((m)=>m[1]).join() : richTextString;
};
var $a0ae596e2684c3fb$export$2e2bcd8739ae039 = $a0ae596e2684c3fb$var$UniformBodyContent;

});
parcelRegister("8M1Bj", function(module, exports) {
"use strict";
var $66340c49c763593e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $66340c49c763593e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $66340c49c763593e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $66340c49c763593e$var$__createBinding(exports1, m, p);
};
var $66340c49c763593e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $66340c49c763593e$var$__createBinding(result, mod, k);
    }
    $66340c49c763593e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSchemaWithNodeType = module.exports.helpers = module.exports.EMPTY_DOCUMENT = module.exports.MARKS = module.exports.INLINES = module.exports.BLOCKS = void 0;

var $1tzW7 = parcelRequire("1tzW7");
Object.defineProperty(module.exports, "BLOCKS", {
    enumerable: true,
    get: function() {
        return $1tzW7.BLOCKS;
    }
});

var $7M716 = parcelRequire("7M716");
Object.defineProperty(module.exports, "INLINES", {
    enumerable: true,
    get: function() {
        return $7M716.INLINES;
    }
});

var $h1Tit = parcelRequire("h1Tit");
Object.defineProperty(module.exports, "MARKS", {
    enumerable: true,
    get: function() {
        return $h1Tit.MARKS;
    }
});

$66340c49c763593e$var$__exportStar((parcelRequire("2HY3w")), module.exports);

$66340c49c763593e$var$__exportStar((parcelRequire("69oZm")), module.exports);

$66340c49c763593e$var$__exportStar((parcelRequire("2KBrn")), module.exports);

var $4VZh4 = parcelRequire("4VZh4");
Object.defineProperty(module.exports, "EMPTY_DOCUMENT", {
    enumerable: true,
    get: function() {
        return $4VZh4.EMPTY_DOCUMENT;
    }
});

var $66340c49c763593e$var$helpers = $66340c49c763593e$var$__importStar((parcelRequire("kcFSF")));
module.exports.helpers = $66340c49c763593e$var$helpers;

var $jT4hL = parcelRequire("jT4hL");
Object.defineProperty(module.exports, "getSchemaWithNodeType", {
    enumerable: true,
    get: function() {
        return $jT4hL.getSchemaWithNodeType;
    }
});

});
parcelRegister("1tzW7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BLOCKS = void 0;
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */ var $1134601884ba055b$var$BLOCKS;
(function(BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["EMBEDDED_RESOURCE"] = "embedded-resource-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})($1134601884ba055b$var$BLOCKS || (module.exports.BLOCKS = $1134601884ba055b$var$BLOCKS = {}));

});

parcelRegister("7M716", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.INLINES = void 0;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 *
 * @note This should be kept in alphabetical order since the
 * [validation package](https://github.com/contentful/content-stack/tree/master/packages/validation)
 *  relies on the values being in a predictable order.
 */ var $5a92757fe39538a5$var$INLINES;
(function(INLINES) {
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
    INLINES["EMBEDDED_RESOURCE"] = "embedded-resource-inline";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["RESOURCE_HYPERLINK"] = "resource-hyperlink";
})($5a92757fe39538a5$var$INLINES || (module.exports.INLINES = $5a92757fe39538a5$var$INLINES = {}));

});

parcelRegister("h1Tit", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MARKS = void 0;
/**
 * Map of all Contentful marks.
 */ var $c65d6c7b23d33ecb$var$MARKS;
(function(MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
    MARKS["STRIKETHROUGH"] = "strikethrough";
})($c65d6c7b23d33ecb$var$MARKS || (module.exports.MARKS = $c65d6c7b23d33ecb$var$MARKS = {}));

});

parcelRegister("2HY3w", function(module, exports) {
"use strict";
var $1f8e2ec2e0d9f56b$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $1f8e2ec2e0d9f56b$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1_MARKS = module.exports.V1_NODE_TYPES = module.exports.TEXT_CONTAINERS = module.exports.HEADINGS = module.exports.CONTAINERS = module.exports.VOID_BLOCKS = module.exports.TABLE_BLOCKS = module.exports.LIST_ITEM_BLOCKS = module.exports.TOP_LEVEL_BLOCKS = void 0;

var $1tzW7 = parcelRequire("1tzW7");

var $7M716 = parcelRequire("7M716");

var $h1Tit = parcelRequire("h1Tit");
/**
 * Array of all top level block types.
 * Only these block types can be the direct children of the document.
 */ module.exports.TOP_LEVEL_BLOCKS = [
    $1tzW7.BLOCKS.PARAGRAPH,
    $1tzW7.BLOCKS.HEADING_1,
    $1tzW7.BLOCKS.HEADING_2,
    $1tzW7.BLOCKS.HEADING_3,
    $1tzW7.BLOCKS.HEADING_4,
    $1tzW7.BLOCKS.HEADING_5,
    $1tzW7.BLOCKS.HEADING_6,
    $1tzW7.BLOCKS.OL_LIST,
    $1tzW7.BLOCKS.UL_LIST,
    $1tzW7.BLOCKS.HR,
    $1tzW7.BLOCKS.QUOTE,
    $1tzW7.BLOCKS.EMBEDDED_ENTRY,
    $1tzW7.BLOCKS.EMBEDDED_ASSET,
    $1tzW7.BLOCKS.EMBEDDED_RESOURCE,
    $1tzW7.BLOCKS.TABLE
];
/**
 * Array of all allowed block types inside list items
 */ module.exports.LIST_ITEM_BLOCKS = [
    $1tzW7.BLOCKS.PARAGRAPH,
    $1tzW7.BLOCKS.HEADING_1,
    $1tzW7.BLOCKS.HEADING_2,
    $1tzW7.BLOCKS.HEADING_3,
    $1tzW7.BLOCKS.HEADING_4,
    $1tzW7.BLOCKS.HEADING_5,
    $1tzW7.BLOCKS.HEADING_6,
    $1tzW7.BLOCKS.OL_LIST,
    $1tzW7.BLOCKS.UL_LIST,
    $1tzW7.BLOCKS.HR,
    $1tzW7.BLOCKS.QUOTE,
    $1tzW7.BLOCKS.EMBEDDED_ENTRY,
    $1tzW7.BLOCKS.EMBEDDED_ASSET,
    $1tzW7.BLOCKS.EMBEDDED_RESOURCE
];
module.exports.TABLE_BLOCKS = [
    $1tzW7.BLOCKS.TABLE,
    $1tzW7.BLOCKS.TABLE_ROW,
    $1tzW7.BLOCKS.TABLE_CELL,
    $1tzW7.BLOCKS.TABLE_HEADER_CELL
];
/**
 * Array of all void block types
 */ module.exports.VOID_BLOCKS = [
    $1tzW7.BLOCKS.HR,
    $1tzW7.BLOCKS.EMBEDDED_ENTRY,
    $1tzW7.BLOCKS.EMBEDDED_ASSET,
    $1tzW7.BLOCKS.EMBEDDED_RESOURCE
];
/**
 * Dictionary of all container block types, and the set block types they accept as children.
 *
 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
 */ module.exports.CONTAINERS = ($1f8e2ec2e0d9f56b$var$_a = {}, $1f8e2ec2e0d9f56b$var$_a[$1tzW7.BLOCKS.OL_LIST] = [
    $1tzW7.BLOCKS.LIST_ITEM
], $1f8e2ec2e0d9f56b$var$_a[$1tzW7.BLOCKS.UL_LIST] = [
    $1tzW7.BLOCKS.LIST_ITEM
], $1f8e2ec2e0d9f56b$var$_a[$1tzW7.BLOCKS.LIST_ITEM] = module.exports.LIST_ITEM_BLOCKS, $1f8e2ec2e0d9f56b$var$_a[$1tzW7.BLOCKS.QUOTE] = [
    $1tzW7.BLOCKS.PARAGRAPH
], $1f8e2ec2e0d9f56b$var$_a[$1tzW7.BLOCKS.TABLE] = [
    $1tzW7.BLOCKS.TABLE_ROW
], $1f8e2ec2e0d9f56b$var$_a[$1tzW7.BLOCKS.TABLE_ROW] = [
    $1tzW7.BLOCKS.TABLE_CELL,
    $1tzW7.BLOCKS.TABLE_HEADER_CELL
], $1f8e2ec2e0d9f56b$var$_a[$1tzW7.BLOCKS.TABLE_CELL] = [
    $1tzW7.BLOCKS.PARAGRAPH,
    $1tzW7.BLOCKS.UL_LIST,
    $1tzW7.BLOCKS.OL_LIST
], $1f8e2ec2e0d9f56b$var$_a[$1tzW7.BLOCKS.TABLE_HEADER_CELL] = [
    $1tzW7.BLOCKS.PARAGRAPH
], $1f8e2ec2e0d9f56b$var$_a);
/**
 * Array of all heading levels
 */ module.exports.HEADINGS = [
    $1tzW7.BLOCKS.HEADING_1,
    $1tzW7.BLOCKS.HEADING_2,
    $1tzW7.BLOCKS.HEADING_3,
    $1tzW7.BLOCKS.HEADING_4,
    $1tzW7.BLOCKS.HEADING_5,
    $1tzW7.BLOCKS.HEADING_6
];
/**
 * Array of all block types that may contain text and inline nodes.
 */ module.exports.TEXT_CONTAINERS = $1f8e2ec2e0d9f56b$var$__spreadArray([
    $1tzW7.BLOCKS.PARAGRAPH
], module.exports.HEADINGS, true);
/**
 * Node types before `tables` release.
 */ module.exports.V1_NODE_TYPES = [
    $1tzW7.BLOCKS.DOCUMENT,
    $1tzW7.BLOCKS.PARAGRAPH,
    $1tzW7.BLOCKS.HEADING_1,
    $1tzW7.BLOCKS.HEADING_2,
    $1tzW7.BLOCKS.HEADING_3,
    $1tzW7.BLOCKS.HEADING_4,
    $1tzW7.BLOCKS.HEADING_5,
    $1tzW7.BLOCKS.HEADING_6,
    $1tzW7.BLOCKS.OL_LIST,
    $1tzW7.BLOCKS.UL_LIST,
    $1tzW7.BLOCKS.LIST_ITEM,
    $1tzW7.BLOCKS.HR,
    $1tzW7.BLOCKS.QUOTE,
    $1tzW7.BLOCKS.EMBEDDED_ENTRY,
    $1tzW7.BLOCKS.EMBEDDED_ASSET,
    $7M716.INLINES.HYPERLINK,
    $7M716.INLINES.ENTRY_HYPERLINK,
    $7M716.INLINES.ASSET_HYPERLINK,
    $7M716.INLINES.EMBEDDED_ENTRY,
    "text"
];
/**
 * Marks before `superscript` & `subscript` release.
 */ module.exports.V1_MARKS = [
    $h1Tit.MARKS.BOLD,
    $h1Tit.MARKS.CODE,
    $h1Tit.MARKS.ITALIC,
    $h1Tit.MARKS.UNDERLINE
];

});

parcelRegister("69oZm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2KBrn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4VZh4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EMPTY_DOCUMENT = void 0;

var $1tzW7 = parcelRequire("1tzW7");
/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */ module.exports.EMPTY_DOCUMENT = {
    nodeType: $1tzW7.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: $1tzW7.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: "text",
                    value: "",
                    marks: [],
                    data: {}
                }
            ]
        }
    ]
};

});

parcelRegister("kcFSF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isInline = $eb556a49f6e32746$var$isInline;
module.exports.isBlock = $eb556a49f6e32746$var$isBlock;
module.exports.isText = $eb556a49f6e32746$var$isText;

var $1tzW7 = parcelRequire("1tzW7");

var $7M716 = parcelRequire("7M716");
/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */ function $eb556a49f6e32746$var$hasValue(obj, value) {
    for(var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++){
        var key = _a[_i];
        if (value === obj[key]) return true;
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */ function $eb556a49f6e32746$var$isInline(node) {
    return $eb556a49f6e32746$var$hasValue($7M716.INLINES, node.nodeType);
}
/**
 * Checks if the node is an instance of Block.
 */ function $eb556a49f6e32746$var$isBlock(node) {
    return $eb556a49f6e32746$var$hasValue($1tzW7.BLOCKS, node.nodeType);
}
/**
 * Checks if the node is an instance of Text.
 */ function $eb556a49f6e32746$var$isText(node) {
    return node.nodeType === "text";
}

});

parcelRegister("jT4hL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSchemaWithNodeType = $e7a67a5f8e434497$var$getSchemaWithNodeType;
function $e7a67a5f8e434497$var$getSchemaWithNodeType(nodeType) {
    try {
        return require("./generated/".concat(nodeType, ".json"));
    } catch (error) {
        throw new Error('Schema for nodeType "'.concat(nodeType, '" was not found.'));
    }
}

});




parcelRegister("46UAu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("gZtXi")).default; });

var $gZtXi = parcelRequire("gZtXi");

});
parcelRegister("gZtXi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cbc8431dc4c5f2f$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $lyjMi = parcelRequire("lyjMi");
const $4cbc8431dc4c5f2f$export$d9468344d3651243 = (body)=>{
    if (!body) return {};
    const { story: story, richText: richText, image: image, embeddedVideoLink: embeddedVideoLink, imageCaption: imageCaption } = body;
    var _story_storyText, _ref, _story_bodyAsset, _story_embeddedVideoLink, _ref1, _story_bodyAssetCaption, _ref2;
    const formattedBody = {
        storyText: (_ref = (_story_storyText = story === null || story === void 0 ? void 0 : story.storyText) !== null && _story_storyText !== void 0 ? _story_storyText : richText) !== null && _ref !== void 0 ? _ref : undefined,
        bodyAsset: $4cbc8431dc4c5f2f$var$formatBodyAsset((_story_bodyAsset = story === null || story === void 0 ? void 0 : story.bodyAsset) !== null && _story_bodyAsset !== void 0 ? _story_bodyAsset : image),
        embeddedVideoLink: (_ref1 = (_story_embeddedVideoLink = story === null || story === void 0 ? void 0 : story.embeddedVideoLink) !== null && _story_embeddedVideoLink !== void 0 ? _story_embeddedVideoLink : embeddedVideoLink) !== null && _ref1 !== void 0 ? _ref1 : undefined,
        bodyAssetCaption: (_ref2 = (_story_bodyAssetCaption = story === null || story === void 0 ? void 0 : story.bodyAssetCaption) !== null && _story_bodyAssetCaption !== void 0 ? _story_bodyAssetCaption : imageCaption) !== null && _ref2 !== void 0 ? _ref2 : undefined,
        quote: $4cbc8431dc4c5f2f$var$formatQuote(story === null || story === void 0 ? void 0 : story.quote)
    };
    // Remove undefined properties
    return Object.fromEntries(Object.entries(formattedBody).filter(([_, value])=>value !== undefined));
};
// eslint-disable-next-line complexity
const $4cbc8431dc4c5f2f$var$formatBodyAsset = (bodyAsset)=>{
    var _fields_file_details, _fields_file, _fields_file1, _fields_file_details_image, _fields_file_details1, _fields_file2, _fields_file_details_image1, _fields_file_details2, _fields_file3, _fields_file4, _fields_file5;
    if (!(bodyAsset === null || bodyAsset === void 0 ? void 0 : bodyAsset.fields)) return undefined;
    const { fields: fields } = bodyAsset;
    var _fields_file_fileName, _fields_file_details_image_height, _fields_file_details_image_width, _fields_description, _fields_file_contentType;
    return {
        name: fields.title,
        size: (_fields_file = fields.file) === null || _fields_file === void 0 ? void 0 : (_fields_file_details = _fields_file.details) === null || _fields_file_details === void 0 ? void 0 : _fields_file_details.size,
        fileName: (_fields_file_fileName = (_fields_file1 = fields.file) === null || _fields_file1 === void 0 ? void 0 : _fields_file1.fileName) !== null && _fields_file_fileName !== void 0 ? _fields_file_fileName : null,
        height: (_fields_file_details_image_height = (_fields_file2 = fields.file) === null || _fields_file2 === void 0 ? void 0 : (_fields_file_details1 = _fields_file2.details) === null || _fields_file_details1 === void 0 ? void 0 : (_fields_file_details_image = _fields_file_details1.image) === null || _fields_file_details_image === void 0 ? void 0 : _fields_file_details_image.height) !== null && _fields_file_details_image_height !== void 0 ? _fields_file_details_image_height : null,
        width: (_fields_file_details_image_width = (_fields_file3 = fields.file) === null || _fields_file3 === void 0 ? void 0 : (_fields_file_details2 = _fields_file3.details) === null || _fields_file_details2 === void 0 ? void 0 : (_fields_file_details_image1 = _fields_file_details2.image) === null || _fields_file_details_image1 === void 0 ? void 0 : _fields_file_details_image1.width) !== null && _fields_file_details_image_width !== void 0 ? _fields_file_details_image_width : null,
        url: (_fields_file4 = fields.file) === null || _fields_file4 === void 0 ? void 0 : _fields_file4.url,
        description: (_fields_description = fields.description) !== null && _fields_description !== void 0 ? _fields_description : null,
        contentType: (_fields_file_contentType = (_fields_file5 = fields.file) === null || _fields_file5 === void 0 ? void 0 : _fields_file5.contentType) !== null && _fields_file_contentType !== void 0 ? _fields_file_contentType : null
    };
};
const $4cbc8431dc4c5f2f$var$formatQuote = (quote)=>{
    if (!(quote === null || quote === void 0 ? void 0 : quote.fields)) return undefined;
    const { fields: fields } = quote;
    return {
        quote: fields.advocateQuote,
        authorName: fields.advocateName,
        authorDetails: fields.advocateJobTitle
    };
};
/**
 * @deprecated - Please use UniformBodyContent at /uniform/components/body-content instead
 */ const $4cbc8431dc4c5f2f$var$UniformBodyContent = (props)=>{
    const bodyComponent = (0, $iSvIT.useMemo)(()=>$4cbc8431dc4c5f2f$export$d9468344d3651243(props), [
        props
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lyjMi.BodyContent), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        story: bodyComponent
    }));
};
var $4cbc8431dc4c5f2f$export$2e2bcd8739ae039 = $4cbc8431dc4c5f2f$var$UniformBodyContent;

});
parcelRegister("lyjMi", function(module, exports) {

$parcel$export(module.exports, "BodyContent", function () { return $e5b766fe34aeec9b$export$36cf6d64005c1ddf; });
/* body-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $h2e6B = parcelRequire("h2e6B");

var $6O6jV = parcelRequire("6O6jV");

var $dyrzP = parcelRequire("dyrzP");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");

var $krNyQ = parcelRequire("krNyQ");
function $e5b766fe34aeec9b$var$getRichText(richText) {
    if (typeof richText === "string") return richText;
    return (0, $h2e6B.documentToHtmlString)(richText);
}
const $e5b766fe34aeec9b$export$36cf6d64005c1ddf = ({ story: story })=>{
    var _story_bodyAsset_url, _story_bodyAsset_description;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "customer-story-article-content",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp1ejb"
        ]),
        children: [
            (story === null || story === void 0 ? void 0 : story.storyText) && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_rrz6idpf _1cobidpf _7exw1ejb _1o6v1ejb"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                    name: null,
                    text: $e5b766fe34aeec9b$var$getRichText(story.storyText)
                })
            }),
            (story === null || story === void 0 ? void 0 : story.quote) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                layout: "10",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.PullQuote), {
                    quote: story.quote.quote,
                    authorName: story.quote.authorName,
                    authorDetails: story.quote.authorDetails,
                    alignment: "start",
                    variant: story.quote.heroQuote ? "cutout" : "basic"
                })
            }),
            (story === null || story === void 0 ? void 0 : story.bodyAsset) && (story === null || story === void 0 ? void 0 : story.embeddedVideoLink) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $6O6jV.AgileVideo), {
                embedLink: story.embeddedVideoLink,
                thumbnail: story.bodyAsset,
                title: ""
            }),
            (story === null || story === void 0 ? void 0 : story.bodyAsset) && !(story === null || story === void 0 ? void 0 : story.embeddedVideoLink) && /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _zulpu2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyrzP.default), {
                        src: (_story_bodyAsset_url = story.bodyAsset.url) !== null && _story_bodyAsset_url !== void 0 ? _story_bodyAsset_url : "",
                        alt: (_story_bodyAsset_description = story.bodyAsset.description) !== null && _story_bodyAsset_description !== void 0 ? _story_bodyAsset_description : "",
                        contentType: story.bodyAsset.contentType,
                        baseWidth: 856,
                        className: (0, $esG4f.default)([
                            "_p12f1osq _1bsbmebt _195g1wug"
                        ]),
                        style: {
                            "--_1396dc4": (0, $43MIc.default)(story.bodyAsset.width ? `${story.bodyAsset.width}px` : "100%")
                        }
                    }),
                    story.bodyAssetCaption && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                            "fine-print"
                        ]),
                        children: story.bodyAssetCaption
                    })
                ]
            })
        ]
    });
};

});



parcelRegister("54jXi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("fHStO")).default; });

var $fHStO = parcelRequire("fHStO");

});
parcelRegister("fHStO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e638ba4003f2be17$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $3FBn4 = parcelRequire("3FBn4");

var $lbVpk = parcelRequire("lbVpk");
const $e638ba4003f2be17$var$UniformButton = (props)=>{
    const localizedHref = (0, $3FBn4.useLocalizedHref)(props.href);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lbVpk.Button), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        href: localizedHref,
        dataEventProps: {
            "data-product-key": "uniform",
            "data-event-component": "linkButton",
            "data-event-container": "button",
            "data-event": "clicked"
        },
        children: props.text
    }));
};
var $e638ba4003f2be17$export$2e2bcd8739ae039 = $e638ba4003f2be17$var$UniformButton;

});


parcelRegister("aDgKf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("kjD5h")).default; });

var $kjD5h = parcelRequire("kjD5h");

});
parcelRegister("kjD5h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e86c567ab983d0ac$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");

var $1UUq1 = parcelRequire("1UUq1");
parcelRequire("dMM9X");
var $kyoYi = parcelRequire("kyoYi");

var $3FBn4 = parcelRequire("3FBn4");
const $e86c567ab983d0ac$export$386f3ec84bf404ad = (props)=>{
    var _props_ctaUrl;
    const localizedHref = (0, $3FBn4.useLocalizedHref)((_props_ctaUrl = props.ctaUrl) !== null && _props_ctaUrl !== void 0 ? _props_ctaUrl : "");
    const button = ()=>{
        if (props.ctaText && props.ctaText !== "" && props.ctaUrl && props.ctaUrl !== "") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
            href: localizedHref,
            dataEventProps: {
                "data-product-key": "uniform",
                "data-event-component": "linkButton",
                "data-event-container": "ctaSection",
                "data-event": "clicked"
            },
            children: props.ctaText
        });
        return;
    };
    var _button;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $kyoYi.CallToAction), {
        header: props.title,
        paragraph: props.description,
        button: (_button = button()) !== null && _button !== void 0 ? _button : /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "ctaButton"
        }),
        backgroundColor: props.backgroundColor
    });
};
var $e86c567ab983d0ac$export$2e2bcd8739ae039 = $e86c567ab983d0ac$export$386f3ec84bf404ad;

});
parcelRegister("dMM9X", function(module, exports) {

$parcel$export(module.exports, "CallToAction", function () { return (parcelRequire("kyoYi")).CallToAction; });
$parcel$export(module.exports, "HeroCarousel", function () { return (parcelRequire("5C9Aa")).HeroCarousel; });
$parcel$export(module.exports, "Logos", function () { return (parcelRequire("2Nqw3")).Logos; });
$parcel$export(module.exports, "FeaturesHighlight", function () { return (parcelRequire("3Yf2x")).FeaturesHighlight; });
$parcel$export(module.exports, "Integration", function () { return (parcelRequire("g4WuQ")).Integration; });
$parcel$export(module.exports, "MobileApp", function () { return (parcelRequire("cJh4j")).MobileApp; });
$parcel$export(module.exports, "SideNav", function () { return (parcelRequire("5STdK")).SideNav; });

var $kyoYi = parcelRequire("kyoYi");

var $55vkU = parcelRequire("55vkU");

var $3Yf2x = parcelRequire("3Yf2x");

var $gtQwZ = parcelRequire("gtQwZ");

var $5C9Aa = parcelRequire("5C9Aa");

var $g4WuQ = parcelRequire("g4WuQ");

var $2Nqw3 = parcelRequire("2Nqw3");

var $cJh4j = parcelRequire("cJh4j");

var $5STdK = parcelRequire("5STdK");

var $2p5f0 = parcelRequire("2p5f0");
parcelRequire("62VZK");
var $7CBQh = parcelRequire("7CBQh");

});
parcelRegister("kyoYi", function(module, exports) {

$parcel$export(module.exports, "CallToAction", function () { return $9844db6cec37a539$export$9438b36140854db6; });
/* call-to-action.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $9844db6cec37a539$var$callToActionStyles = null;
const $9844db6cec37a539$var$typographyOverrides = null;
const $9844db6cec37a539$var$polygonStyles = null;
const $9844db6cec37a539$var$contentStyles = null;
const $9844db6cec37a539$export$9438b36140854db6 = ({ header: header, paragraph: paragraph, button: button, backgroundColor: backgroundColor = "black" })=>{
    let transformedButton;
    if (backgroundColor === "blue") transformedButton = /*#__PURE__*/ (0, $iSvIT.cloneElement)(button, {
        variant: "primary_alt"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_p12f1git _195g1wug _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            style: {
                "--background-color": (0, $5ohHq.wacToken)(`color.primary.${backgroundColor}`)
            },
            className: (0, $esG4f.default)([
                "_11q76ulk _mkrz1q5k _1vthpg2b _1yt4koci"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c11p5 _zulpu2gc _6rthxy5q"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                className: (0, $esG4f.default)([
                                    "_1mou78py",
                                    "h3"
                                ]),
                                style: {
                                    color: (0, $5ohHq.wacToken)("color.neutral.light0")
                                },
                                children: header
                            }),
                            paragraph && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                className: (0, $esG4f.default)([
                                    "_1mou78py",
                                    ".body-md"
                                ]),
                                style: {
                                    color: (0, $5ohHq.wacToken)("color.neutral.light0")
                                },
                                children: paragraph
                            })
                        ]
                    })
                }),
                transformedButton !== null && transformedButton !== void 0 ? transformedButton : button
            ]
        })
    });
};

});

parcelRegister("55vkU", function(module, exports) {

$parcel$export(module.exports, "CustomerTestimonials", function () { return $25af9ba243d3e879$export$ff99f9acc73d9931; });
/* customer-testimonials.tsx generated by @compiled/babel-plugin v0.28.8 */ // Initial changes from ADG4CustomerTestimonials
// Removed scroll Ref and inview tracker, since there is no longer an automatic transition to new tabs
// Removed className since it was not in use
// Removed testimonialCta since that is a non standard usage in the Confluence Product Tour and clouds the core Design Pattern
// Removed Blue as an option for backgrounds for now since that is not spec
// Removed h2 heading (that should be included as a Content Block separately going forward)
// Removed TypographyStyles wrapper for consistency with other components/patterns
// Cleaned up unused classnames within the component

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $cutM5 = parcelRequire("cutM5");

var $9Kv7x = parcelRequire("9Kv7x");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");
const $25af9ba243d3e879$var$backgroundColorStyleMap = {
    black: "_bfhkr3uz",
    white: "_bfhku67f"
};
const $25af9ba243d3e879$var$backgroundShape = null;
const $25af9ba243d3e879$var$fontColorStyleMap = {
    "dark-bg": "_syaz12cp",
    "white-bg": "_syazn7od"
};
const $25af9ba243d3e879$var$topLineStyleMap = {
    black: "_bfhku67f",
    white: "_bfhkr3uz"
};
const $25af9ba243d3e879$var$logoOptionStyleMap = {
    "dark-bg": "_d4ksu67f _i862u67f _1uiy1wzc",
    "white-bg": "_d4ksr3uz _i862r3uz"
};
const $25af9ba243d3e879$var$justifyContentStyleMap = {
    "dark-bg": "_1bahh9n0",
    "white-bg": "_1bah1h6o"
};
const $25af9ba243d3e879$export$ff99f9acc73d9931 = ({ bgColor: bgColor = "black", testimonials: testimonials, productKey: productKey })=>{
    const bgTheme = bgColor === "black" ? "dark-bg" : "white-bg";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4Tabs), {
        loop: true,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _1pbykb7n _6rth1jfw",
                    $25af9ba243d3e879$var$fontColorStyleMap[bgTheme]
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_kqswstnw _1r04idpf _1bsb1lk2 _p12fklux _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1rfm1osq",
                                    $25af9ba243d3e879$var$backgroundColorStyleMap[bgColor],
                                    bgColor === "black" && "_mkrzq8qa _kxoh75ra"
                                ])
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c11p5 _yv0ehkll _2z05hkll _1ir7idpf _bhknkb7n _1rrs1txw _s9hn1ekt _16l7kb7n _w53ccs5v"
                                ]),
                                children: testimonials.map((testimonial, index)=>{
                                    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4TabPanel), {
                                        id: `${index}`,
                                        panelIndex: index,
                                        forceRender: true,
                                        hideTabPanelRole: true,
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)($25af9ba243d3e879$var$TopRowContent, {
                                            testimonial: testimonial,
                                            index: index,
                                            bgTheme: bgTheme,
                                            bgColor: bgColor
                                        })
                                    }, index);
                                })
                            }),
                            testimonials.length > 1 && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_kqswh2mm _1e0c1txw _1p57v47k _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1reo15vq _18m915vq _1bsb1osq _1bah1yb4 _1v611bp4 _476dgktf"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cutM5.Adg4DraggableTabList), {
                                        rowGap: "32px",
                                        className: (0, $esG4f.default)([
                                            "_6rth1fu0 _1q511aa3 _qtt8agmp"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_kqswstnw _152tt94y _1e02idpf _rjxpidpf _4t3it94y _2rkoyh40 _tzy4105o _xaej183y",
                                                    $25af9ba243d3e879$var$topLineStyleMap[bgColor]
                                                ])
                                            }),
                                            testimonials.map((testimonial, index)=>{
                                                return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTab), {
                                                    as: "li",
                                                    tabIndex: index,
                                                    dataEventProps: {
                                                        "data-product-key": productKey,
                                                        "data-event-component": "tab",
                                                        "data-event-container": "testimonialsSection",
                                                        "data-event": "clicked",
                                                        "data-label-english": testimonial.label
                                                    },
                                                    label: testimonial.label,
                                                    className: (0, $esG4f.default)([
                                                        $25af9ba243d3e879$var$logoOptionStyleMap[bgTheme],
                                                        "_1e0c1txw _1bah1fhb _4cvr1fhb _kqswh2mm _1atpidpf"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $loA2J.jsx)($25af9ba243d3e879$var$LogoTabContent, {
                                                        testimonialLogo: testimonial.logo
                                                    })
                                                }, index);
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $25af9ba243d3e879$var$TopRowContent = ({ testimonial: testimonial, index: index, bgTheme: bgTheme, bgColor: bgColor, isPanelActive: isPanelActive })=>{
    var _testimonial_link_type;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _1e0c1txw _1p57v47k _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o",
            "_6rth1ylp _1e0c11p5 _yv0ewxkt _gy1pzwfg _tzy4idpf _1pbykb7n _1ph4hkll",
            isPanelActive && "_tzy4kb7n _1pbycs5v"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _i0dlhwvj _1e0c1txw _1bah1h6o _4cvresu3 _16xt1ssb _1rfm1vuk _q5ugidpf _7tld1wug _14adidpf _4uro1wug _7bcc1n8h _18jmidpf _qji61wug _ms0lidpf _v5we1wug"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_bna7ng7t _1jtm1c95 _1fhe1c95 _1cwsdlvw _mezj1wug _v4pn1ule",
                        isPanelActive && "_m3691nt4"
                    ]),
                    children: typeof testimonial.image !== "string" && "contentType" in testimonial.image ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $9Kv7x.ContentPlatformImage), (0, $7Knp0._)({}, testimonial.image)) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: {
                            src: testimonial.image,
                            alt: ""
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_i0dl1nrf _1reo15vq _18m915vq _1a8l1ssb"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _4t3i1osq _2rkogktf _kqswh2mm _19pkidpf _2hwx1wug _otyridpf _18u01wug _26vxys9h _12rr1e9y _1rfm1osq",
                        $25af9ba243d3e879$var$justifyContentStyleMap[bgTheme]
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_v5641pn7 _1e0c1txw _2lx21bp4 _zulp1tcg",
                            isPanelActive && "_y44v13sw _11vozap6"
                        ]),
                        children: [
                            testimonial.eyebrow && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                className: (0, $esG4f.default)([
                                    $25af9ba243d3e879$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "eyebrow-md"
                                ]),
                                children: testimonial.eyebrow
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("blockquote", {
                                className: (0, $esG4f.default)([
                                    $25af9ba243d3e879$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "callout"
                                ]),
                                children: [
                                    "\u201C",
                                    testimonial.quote,
                                    "\u201D"
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                                className: (0, $esG4f.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        className: (0, $esG4f.default)([
                                            $25af9ba243d3e879$var$fontColorStyleMap[bgTheme],
                                            "eyebrow-lg"
                                        ]),
                                        children: testimonial.name
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        className: (0, $esG4f.default)([
                                            $25af9ba243d3e879$var$fontColorStyleMap[bgTheme],
                                            "body-md title"
                                        ]),
                                        children: testimonial.title
                                    })
                                ]
                            }),
                            testimonial.link ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                anchorProps: {
                                    tabIndex: isPanelActive ? 0 : -1
                                },
                                text: testimonial.link.text,
                                href: testimonial.link.url,
                                type: (_testimonial_link_type = testimonial.link.type) !== null && _testimonial_link_type !== void 0 ? _testimonial_link_type : "primary",
                                bgColor: bgColor === "black" ? "bgBlackBlue" : "bgWhite",
                                dataEventProps: testimonial.link.dataEventProps
                            }) : null
                        ]
                    }, index)
                })
            })
        ]
    });
};
const $25af9ba243d3e879$var$topRowActiveStyle = null;
const $25af9ba243d3e879$var$customerImagesImgActiveStyle = null;
const $25af9ba243d3e879$var$quoteContainerActiveStyle = null;
const $25af9ba243d3e879$var$LogoTabContent = ({ testimonialLogo: testimonialLogo, isSelected: isSelected = false })=>{
    const isContentfulImage = "contentType" in testimonialLogo;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_tzy4kb7n _kqswstnw _152tj39m _1e02idpf _rjxpidpf _4t3i14y2 _2rkoyh40",
                    "top-marker"
                ])
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_11q7glyw _19itidpf _r06hglyw _1q51gktf _80omtlke _kqswh2mm"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    className: (0, $esG4f.default)([
                        "_tzy4105o _v5641bs3 _16l4kb7n",
                        "_4t3i1u1b _1e0c1txw _4cvr1h6o",
                        isSelected && "_tzy4kb7n"
                    ]),
                    children: isContentfulImage ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $9Kv7x.ContentPlatformImage), (0, $6iHNw._)((0, $7Knp0._)({}, testimonialLogo), {
                        width: "140",
                        height: "34",
                        style: {
                            objectFit: "contain",
                            objectPosition: "center center"
                        },
                        className: "tab-logo"
                    })) : testimonialLogo
                })
            })
        ]
    });
}; // LogoTabContent styles
const $25af9ba243d3e879$var$logoImgStyle = null;
const $25af9ba243d3e879$var$logoImgSelectedStyle = null;
const $25af9ba243d3e879$var$logoButtonStyle = null;
const $25af9ba243d3e879$var$topMarkerStyle = null;
const $25af9ba243d3e879$var$logoImgContainerStyle = null; // ADG4CustomerTestimonials styles
const $25af9ba243d3e879$var$topLineStyles = null;
const $25af9ba243d3e879$var$testimonialKeyframeStyles = null;
const $25af9ba243d3e879$var$rowWidthStyle = null;
const $25af9ba243d3e879$var$topRowStyle = null;
const $25af9ba243d3e879$var$bgShapeStyle = null;
const $25af9ba243d3e879$var$customerImagesSectionStyles = null;
const $25af9ba243d3e879$var$customerImagesSectionImageStyles = null;
const $25af9ba243d3e879$var$customerQuotesSectionStyle = null;
const $25af9ba243d3e879$var$testimonialQuotesSectionStyle = null;
const $25af9ba243d3e879$var$quoteContainerStyle = null;
const $25af9ba243d3e879$var$quoteContainerPStyle = null;
const $25af9ba243d3e879$var$logosContainerBaseStyle = null;
const $25af9ba243d3e879$var$logosStyle = null;
const $25af9ba243d3e879$var$logoOptionStyle = null;
const $25af9ba243d3e879$var$testimonialStyles = null;
const $25af9ba243d3e879$var$tabPanelWrapperStyles = null;

});

parcelRegister("3Yf2x", function(module, exports) {

$parcel$export(module.exports, "FeaturesHighlight", function () { return $a5d0df8bfd42a304$export$bf20c48d528647dd; });
/* features-highlight.tsx generated by @compiled/babel-plugin v0.28.8 */ // import type {
//     MouseEvent as ReactMouseEvent,
//     TouchEvent as ReactTouchEvent,
//     KeyboardEvent as ReactKeyboardEvent
// } from "react";
// import { useRef, useEffect, useState, useCallback } from "react";

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $vqrsL = parcelRequire("vqrsL");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
const $a5d0df8bfd42a304$export$bf20c48d528647dd = (props)=>{
    const [activeFeature, setActiveFeature] = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useState(0);
    const onFeatureSelect = (featureKey)=>{
        setActiveFeature(featureKey);
    };
    const singleFeature = (content, featureKey)=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            onClick: ()=>onFeatureSelect(featureKey),
            onKeyDown: (e)=>{
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onFeatureSelect(featureKey);
                }
            },
            className: (0, $esG4f.default)([
                "_80omtlke _kqswh2mm _u5ggpxbi _11xx17la _uoz5x71z _suga1ule _1ah31y44",
                `feature ${activeFeature === featureKey ? "selected" : ""}`
            ]),
            role: "tab",
            tabIndex: 0,
            style: {
                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
            },
            children: [
                activeFeature === featureKey && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswstnw _1pbykb7n _bfhk17la _2rko1y44 _1bsb1osq _4t3iftgi _165t1osq _glteftgi"
                    ]),
                    style: {
                        "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                    }
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_owpupxbi _6ssjpxbi"
                    ]),
                    children: content
                })
            ]
        });
    const feature1Text = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.ContentBlock), {
        title: props.feature1Title,
        titleAs: "h3",
        text: props.feature1Body,
        eyebrow: props.feature1Eyebrow,
        alignment: "start"
    });
    var _props_feature1ImageAltText;
    const feature1Image = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: props.feature1ImageSrc,
            alt: (_props_feature1ImageAltText = props.feature1ImageAltText) !== null && _props_feature1ImageAltText !== void 0 ? _props_feature1ImageAltText : "",
            style: {
                width: "100%",
                height: "auto"
            }
        },
        style: {
            width: "100%",
            height: "auto"
        }
    });
    const feature2Text = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.ContentBlock), {
        title: props.feature2Title,
        titleAs: "h3",
        text: props.feature2Body,
        eyebrow: props.feature2Eyebrow,
        alignment: "start"
    });
    var _props_feature2ImageAltText;
    const feature2Image = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: props.feature2ImageSrc,
            alt: (_props_feature2ImageAltText = props.feature2ImageAltText) !== null && _props_feature2ImageAltText !== void 0 ? _props_feature2ImageAltText : "",
            style: {
                width: "100%",
                height: "auto"
            }
        },
        style: {
            width: "100%",
            height: "auto"
        }
    });
    const feature3Text = /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.ContentBlock), {
        title: props.feature3Title,
        titleAs: "h3",
        text: props.feature3Body,
        eyebrow: props.feature3Eyebrow,
        alignment: "start"
    });
    var _props_feature3ImageAltText;
    const feature3Image = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: props.feature3ImageSrc,
            alt: (_props_feature3ImageAltText = props.feature3ImageAltText) !== null && _props_feature3ImageAltText !== void 0 ? _props_feature3ImageAltText : "",
            style: {
                width: "100%",
                height: "auto"
            }
        },
        style: {
            width: "100%",
            height: "auto"
        }
    });
    const featureTexts = [
        feature1Text,
        feature2Text,
        props.feature3Title && feature3Text
    ];
    const images = [
        feature1Image,
        feature2Image,
        props.feature3Title && feature3Image
    ];
    const sectionContainerStyles = null;
    const topContentContainerStyles = null;
    const featuresContainerStyles = null;
    const imageContainerStyles = null;
    const navDotsContainerStyles = null;
    const navDot = (featureNum)=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1bsbftgi _4t3iftgi _2rko1y44 _bfhk1cls"
            ]),
            style: {
                "--_1lhuu6n": (0, $43MIc.default)(featureNum === activeFeature ? (0, $5ohHq.wacToken)("color.primary.black") : (0, $5ohHq.wacToken)("color.neutral.light500"))
            }
        });
    }; // @ts-ignore
    const navDotsContainer = (_)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _zulppxbi _1bah1h6o _1q51pxbi"
            ]),
            children: featureTexts.map((_, index)=>navDot(index))
        });
    const mobileCarouselContainerStyles = null;
    const sliderSettings = {
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        afterChange: (current)=>setActiveFeature(current),
        appendDots: navDotsContainer
    };
    const featureSlideStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_15fl1wug _1d2w1wug _1svy1wug _seov1wug _16imoahv _b8yq1osq _14b51osq _su071wqb _1j8bcx6w _181n11p5 _dwk3usvi _19wg14hz _11mz1tcg _owpu1wqb _10jxzqdx _1vsw1vi7 _suga1txw _1gde1bp4 _1rfm1osq _tnru1osq _8164pxbi _133i1jfw"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1rfm1osq _xlt11ejb _s51szwfg _uoz5179g _1e3ceqnf _1e0c1txw _2lx21bp4 _zulpu2gc _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.ContentBlock), {
                        title: props.title,
                        titleAs: "h2",
                        text: props.description,
                        alignment: "center"
                    }),
                    props.linkText && props.linkHref && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        text: props.linkText,
                        href: props.linkHref
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                role: "tablist",
                className: (0, $esG4f.default)([
                    "_1e3cx71z _dm251txw _1ini1bp4 _kzvi1bgi _1e0cglyw"
                ]),
                children: featureTexts.map((feature, index)=>singleFeature(feature, index))
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                role: "tabpanel",
                className: (0, $esG4f.default)([
                    "_1e3cthi2 _165t1osq _uoz5uufb _sugaglyw"
                ]),
                children: images[activeFeature]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _suga1ule",
                    "_vnijh2mm _1ls01ule _1dtvusvi _1kb1glyw _fjwtglyw _1wv2glyw _1r6vglyw _zookglyw _8rkdglyw _1tpbmuzh _u8dlmuzh _e1ct1j28 _1t25h2mm _ll151ule _8lsh15vq _kuv715vq _19moidpf _1vqqidpf _m8oxidpf _bzd2idpf _zwvbidpf _19wzidpf _2awfidpf _l1guidpf _3otn1r31 _1d59glyw _r3kx1o36 _1y6utlke _1t6x161g _1u6z161g _1vpa161g _5skb161g _1xca161g _xcl1161g _rzx1161g _1xcr161g _57of161g _b29h161g _snlxh2mm _1rfpidpf _104oidpf _j6fg1ule _gkdh1wug _1jbo1wug _1qa65mfb _r4f35mfb _y1t8b3bt _1v9lb3bt _v42h1hrf _1t4e15vq _1u35glyw _1vrb1e5h _m8yv1osq _gzcot94y _tovh1txw _160x1h6o _1a23usic _k4vw1ule _19i1glyw _1afyglyw _1xnx1ule _qzmo15vq _1xzb1ule _ntpm1wug _4v68okh7 _13h3glyw",
                    "slider-container"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($vqrsL))), (0, $6iHNw._)((0, $7Knp0._)({}, sliderSettings), {
                    children: featureTexts.map((feature, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_18zrzwfg _1e0c1txw _2lx21bp4 _zulppxbi"
                            ]),
                            children: [
                                singleFeature(feature, index),
                                images[index]
                            ]
                        }, index))
                }))
            })
        ]
    });
};
// Source https://github.com/kenwheeler/slick/blob/master/slick/slick.css
const $a5d0df8bfd42a304$var$slickStyle = null;

});

parcelRegister("gtQwZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $359d438096babc01$export$2e2bcd8739ae039; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $lbVpk = parcelRequire("lbVpk");

var $c4STr = parcelRequire("c4STr");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $359d438096babc01$export$887967f05dc521ae = (_param)=>{
    var { layout: layout = "image-right" } = _param, props = (0, $akGnX._)(_param, [
        "layout"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        style: {
            "--background-color": `${props.backgroundColor ? (0, $5ohHq.wacToken)(props.backgroundColor) : "transparent"}`
        },
        className: (0, $esG4f.default)([
            "_11q76ulk"
        ]),
        children: layout === "image-both" ? /*#__PURE__*/ (0, $loA2J.jsx)($359d438096babc01$var$HeroBothImages, (0, $7Knp0._)({
            layout: layout
        }, props)) : /*#__PURE__*/ (0, $loA2J.jsx)($359d438096babc01$var$HeroOneImage, (0, $7Knp0._)({
            layout: layout
        }, props))
    });
};
var $359d438096babc01$export$2e2bcd8739ae039 = $359d438096babc01$export$887967f05dc521ae;
const $359d438096babc01$var$DARK_BKGD_COLORS = [
    "color.primary.black"
];
const $359d438096babc01$var$HeadingContent = ({ heading: heading, subheading: subheading, callToActionProps: callToActionProps, size: size = "regular", backgroundColor: backgroundColor })=>{
    const _ref = callToActionProps !== null && callToActionProps !== void 0 ? callToActionProps : {}, { text: buttonText } = _ref, buttonProps = (0, $akGnX._)(_ref, [
        "text"
    ]);
    const isLarge = size === "large";
    const useLightText = backgroundColor ? $359d438096babc01$var$DARK_BKGD_COLORS.includes(backgroundColor) : false;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                style: {
                    color: useLightText ? (0, $5ohHq.wacToken)("color.neutral.light0") : "inherit"
                },
                className: (0, $esG4f.default)([
                    "_18s8ze3t",
                    isLarge ? "superhero" : undefined
                ]),
                children: heading
            }),
            subheading && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_6rthze3t",
                    isLarge ? "body-lg" : "body-md"
                ]),
                style: {
                    color: useLightText ? (0, $5ohHq.wacToken)("color.neutral.light0") : "inherit"
                },
                children: subheading
            }),
            buttonText && buttonProps && /*#__PURE__*/ (0, $loA2J.jsx)((0, $lbVpk.Button), (0, $6iHNw._)((0, $7Knp0._)({}, buttonProps), {
                size: "large",
                className: (0, $esG4f.default)([
                    "_1pfhxy5q"
                ]),
                children: buttonText
            }))
        ]
    });
};
const $359d438096babc01$var$HeroOneImage = (_param)=>{
    var { layout: layout = "image-right", imageProps: imageProps } = _param, props = (0, $akGnX._)(_param, [
        "layout",
        "imageProps"
    ]);
    var _imageProps_alt;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c11p5 _zulp1ejb _1rjc1jfw _y3gn1h6o _4cvr1h6o _1j8bwxkt _lagd18l3 _19wgxy5q _uj6kv2br _1ooboahv _1s0lxncg"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        layout === "image-left" && "_1b1qcs5v"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)($359d438096babc01$var$HeadingContent, (0, $7Knp0._)({}, props))
                }),
                imageProps && /*#__PURE__*/ (0, $loA2J.jsx)((0, $c4STr.Image), {
                    maxPossibleWidth: 700,
                    src: imageProps.src,
                    alt: (_imageProps_alt = imageProps.alt) !== null && _imageProps_alt !== void 0 ? _imageProps_alt : "",
                    loading: "eager",
                    width: imageProps.width,
                    height: imageProps.height
                })
            ]
        })
    });
};
const $359d438096babc01$var$gridStyle = null;
const $359d438096babc01$var$headingStyle = null;
const $359d438096babc01$var$imageStartStyle = null;
const $359d438096babc01$var$bodyStyle = null;
const $359d438096babc01$var$buttonStyle = null; /*
                          This is an experimental start to support the needs of the Hero variation with images on the sides, primary content centered
                          Initial support is seens on Product enterprise pages (such as /software/jira/enterprise) as served by WAC Authoring Engine
                          
                          TODO: We need to understand the levels of configurability desired/needed to support a variety of use cases, collab with design.
                            Currently it is very tailored to the aforementioned enterprise experience
                          */ 
const $359d438096babc01$var$HeroBothImages = (_param)=>{
    var { imageProps: imageProps, secondaryImageProps: secondaryImageProps } = _param, props = (0, $akGnX._)(_param, [
        "imageProps",
        "secondaryImageProps"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1reo15vq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            layout: "12",
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_uaqo1x3a _13j917im",
                    "_kqswh2mm _1e0c11p5 _10fp1h6o _y3gn1h6o _4cvr1h6o _6a6z1h6o _1rjc1jfw _14b51ssb _su07u2gc _1ooboahv _1s0lxncg _bxthb3bt _t4hxstnw _1yp51osq _1bpvsmen _brhgmgnk _5kbx1f51 _1gg8w2la _n4lfidpf _1nls12it _14xsidpf _16bh12it _1z0y9by0 _ixsu1osq _a6uwb3bt _dbttstnw _83tk1wn5 _10wjmgnk _tzs91f51 _wi3i1048 _1x65idpf _oppa12it _1ohy1kly _nd8fidpf _1yam12it _ugza1kly _mlxy9by0 _k4z51osq _xcpbpwvu"
                ]),
                style: {
                    "--_1thiznr": (0, $43MIc.default)(imageProps ? `url(${imageProps.src})` : "none"),
                    "--_c31b9r": (0, $43MIc.default)(secondaryImageProps ? `url(${secondaryImageProps.src})` : "none")
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)($359d438096babc01$var$HeadingContent, (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                    size: "regular"
                }))
            })
        })
    });
};
const $359d438096babc01$var$gridTwoImagesStyle = null;

});

parcelRegister("5C9Aa", function(module, exports) {

$parcel$export(module.exports, "HeroCarousel", function () { return $47d867af5ed4b3f4$export$b92905002f03c113; });
/* hero-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $eDoPe = parcelRequire("eDoPe");

var $isSvf = parcelRequire("isSvf");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $lbVpk = parcelRequire("lbVpk");

var $1O6nN = parcelRequire("1O6nN");
const $47d867af5ed4b3f4$export$b92905002f03c113 = ({ tabsData: tabsData })=>{
    const [selectedTab, setSelectedTab] = (0, $iSvIT.useState)(0);
    const listRef = (0, $iSvIT.useRef)(null);
    const { ref: lastTabRef, inView: isTabListEndVisible } = (0, $eDoPe.useInView)({
        root: listRef === null || listRef === void 0 ? void 0 : listRef.current,
        threshold: 1
    });
    const { ref: firstTabRef, inView: isTabListStartVisible } = (0, $eDoPe.useInView)({
        root: listRef === null || listRef === void 0 ? void 0 : listRef.current,
        threshold: 1
    });
    (0, $iSvIT.useEffect)(()=>{
        const listElement = listRef === null || listRef === void 0 ? void 0 : listRef.current;
        if (listElement) {
            var _listElement_children;
            const tabElement = (_listElement_children = listElement.children) === null || _listElement_children === void 0 ? void 0 : _listElement_children[selectedTab + 1];
            if (tabElement && typeof tabElement.scrollIntoView === "function") {
                tabElement.scrollIntoView({
                    behavior: "smooth",
                    inline: "center",
                    block: "end"
                });
                tabElement.focus();
            }
        }
    }, [
        selectedTab
    ]);
    const onKeyDown = (e)=>{
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
            let newFocusIndex = 0;
            if (e.key === "ArrowRight") {
                newFocusIndex = selectedTab + 1;
                if (newFocusIndex >= tabsData.length) newFocusIndex = 0;
            } else if (e.key === "ArrowLeft") {
                newFocusIndex = selectedTab - 1; // If we're at the start, move to the end
                if (newFocusIndex < 0) newFocusIndex = tabsData.length - 1;
            }
            setSelectedTab(newFocusIndex);
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        id: "hero-carousel",
        "data-testid": "hero-carousel",
        className: (0, $esG4f.default)([
            "_1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx21sxn _1bsb1osq _1reo15vq _18m915vq"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)($47d867af5ed4b3f4$var$TabList, {
                    listRef: listRef,
                    isTabListViewable: isTabListStartVisible && isTabListEndVisible,
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            ref: firstTabRef
                        }),
                        tabsData.map((tab, i)=>/*#__PURE__*/ (0, $loA2J.jsxs)($47d867af5ed4b3f4$var$Tab, {
                                isSelected: i === selectedTab,
                                id: tab.id,
                                onClick: ()=>{
                                    setSelectedTab(i);
                                },
                                onKeyDown: onKeyDown,
                                children: [
                                    tab.eyebrow && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        className: (0, $esG4f.default)([
                                            "_syaz121t _y3gnv2br _19pkidpf _2hwxidpf _otyridpf _18u0idpf _tzy4105o _v564177f",
                                            "eyebrow-sm"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                                        },
                                        children: tab.eyebrow
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        className: (0, $esG4f.default)([
                                            "_syaz121t _y3gnv2br _19pkidpf _2hwxidpf _otyridpf _18u0idpf _tzy4105o _v564177f",
                                            "_1wyb19as _k48p16tn _vwz41xr0"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                                        },
                                        children: tab.title
                                    })
                                ]
                            }, tab.id)),
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            ref: lastTabRef
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)($47d867af5ed4b3f4$var$PanelContainer, {
                    children: tabsData.map((tab, i)=>/*#__PURE__*/ (0, $loA2J.jsx)($47d867af5ed4b3f4$var$Panel, {
                            isSelected: i === selectedTab,
                            id: tab.id,
                            panel: tab.panel,
                            titleAs: i === 0 ? "h1" : "h2"
                        }, tab.id))
                })
            ]
        })
    });
};
var $47d867af5ed4b3f4$export$2e2bcd8739ae039 = $47d867af5ed4b3f4$export$b92905002f03c113;
const $47d867af5ed4b3f4$var$TabList = ({ children: children, listRef: listRef, isTabListViewable: isTabListViewable })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_11q71hlo _1bsb1osq _syazcd5j _1reo15vq _18m915vq _18zrzwfg _su071wqb"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div" // @ts-ignore
        , {
            ref: listRef,
            tabIndex: -1,
            role: "tablist",
            className: (0, $esG4f.default)([
                "_1tkegad4 _1e0c1txw _qtt8glyw _1mouidpf _195g1wug _18zridpf _1rjcie5z _1reo15zi _rjfvx6dd _b8yqzqdx _zcekze3t _kpfhglyw",
                isTabListViewable && "_1bah1h6o"
            ]),
            children: children
        })
    });
};
const $47d867af5ed4b3f4$var$Tab = ({ children: children, isSelected: isSelected, id: id, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
        type: "button",
        tabIndex: isSelected ? 0 : -1,
        role: "tab",
        "aria-selected": isSelected ? "true" : "false",
        "aria-controls": `hero-panel-${id}`,
        id: `hero-tab-${id}`,
        onClick: onClick,
        onKeyDown: onKeyDown,
        "data-label": `hero-tab-${id}`,
        className: (0, $esG4f.default)([
            "_mqm21kma _v564ucvz _179rglyw _h7alglyw _r06hglyw _bfhk1j28 _ect41kw7 _1wyb1j6v _1bsb1ltq _1ul91ltq _80omtlke _1hu1v2br _1rjcu2gc _18zr1ejb _4cvrv2br _1e0c1txw _2lx21bp4 _zulp12x7 _ihhukb7n _n41hkb7n",
            isSelected && "_mqm21hn9 _1mrhkb7n"
        ]),
        style: {
            "--_1vwzriw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.yellow"))
        },
        children: children
    });
};
const $47d867af5ed4b3f4$var$PanelContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c11p5"
        ]),
        children: children
    });
};
const $47d867af5ed4b3f4$var$Panel = (_param)=>{
    var { isSelected: isSelected, id: id, panel: panel } = _param, props = (0, $akGnX._)(_param, [
        "isSelected",
        "id",
        "panel"
    ]);
    var _panel_secondaryCallToAction, _panel_bgImage, _panel_secondaryCallToAction1;
    const [isModalOpen, setIsModalOpen] = (0, $iSvIT.useState)(false);
    const baseStyle = null;
    const isVideoLink = ((_panel_secondaryCallToAction = panel.secondaryCallToAction) === null || _panel_secondaryCallToAction === void 0 ? void 0 : _panel_secondaryCallToAction.type) === "video";
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        role: "tabpanel",
        id: `hero-panel-${id}`,
        "data-testid": `hero-panel-${id}`,
        "aria-hidden": !isSelected,
        "aria-labelledby": `hero-tab-${id}`,
        className: (0, $esG4f.default)([
            "_v564twcc _yyhy183o _1ii7183o _1e0c11p5 _tzy4idpf _1pby1mrw _kqswh2mm",
            isSelected && "_tzy4kb7n _1pbykb7n",
            "_1kt9b3bt _1g0v1mrw _1cs8stnw _1tesidpf _1rusu6yl _aetrb3bt _1bqq1mrw _18postnw _16gxidpf _z0ai1osq _wbcj14i6 _1kje1h6o _1hfku6yl _1a1fdirt _19h91dfr _z0bc12wd"
        ]),
        style: {
            "--bg-color": panel.bgColor === "neutral" ? (0, $5ohHq.wacToken)(`color.neutral.light200`) : (0, $5ohHq.wacToken)(`color.primary.${panel.bgColor}`),
            "--_1gk99st": (0, $43MIc.default)(((_panel_bgImage = panel.bgImage) === null || _panel_bgImage === void 0 ? void 0 : _panel_bgImage.lg) ? `url(${panel.bgImage.lg})` : undefined),
            "--_xe4ghn": (0, $43MIc.default)(panel.layout === "end" ? "0% 50%" : "center center")
        },
        children: [
            isVideoLink && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Modal), {
                isOpen: isModalOpen,
                closeModal: ()=>{
                    setIsModalOpen(false);
                },
                closeLabel: "Close video",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $isSvf.default), {
                    muted: false,
                    videoType: "mp4",
                    videoLink: (_panel_secondaryCallToAction1 = panel.secondaryCallToAction) === null || _panel_secondaryCallToAction1 === void 0 ? void 0 : _panel_secondaryCallToAction1.href
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_yyhy183o _1ii7183o _18zrzwfg _1rjcxncg _1e0c11p5 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulp1ejb _1qon1h6o _1lb81h6o _5qqy1h6o _su071wqb _1rqtcx6w _pdlmxy5q _10jxzqdx",
                    panel.layout === "end" ? "_1uyy1d44 _1cxzv2br _10wbv2br _s0n3v2br" : panel.layout === "start" ? "_1uyy1vi5 _1cxzv2br _10wbv2br _s0n3v2br" : "_1uyyeqnf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)($47d867af5ed4b3f4$var$PanelContent, {
                        panel: panel,
                        titleAs: props.titleAs
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($47d867af5ed4b3f4$var$PanelActions, (0, $6iHNw._)((0, $7Knp0._)({}, panel), {
                        onVideoClick: isVideoLink ? (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            setIsModalOpen(true);
                        } : undefined
                    }))
                ]
            })
        ]
    });
};
const $47d867af5ed4b3f4$var$PanelContent = (_param)=>{
    var { panel: panel } = _param, props = (0, $akGnX._)(_param, [
        "panel"
    ]);
    // We need to think about this more holistically going forward, instead of on a per component level
    const isForegroundLight = [
        "blue",
        "black"
    ].includes(panel.bgColor);
    const { titleAs: Title = "h2" } = props;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)(Title, {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                    isForegroundLight && "_syaz121t",
                    "h1"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: panel.title
            }),
            panel.body && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                    isForegroundLight && "_syaz121t",
                    "body-lg"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: panel.body
            })
        ]
    });
};
const $47d867af5ed4b3f4$var$PanelActions = (panel)=>{
    return panel && /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _1n261g80 _zulp1ejb",
            (panel.layout === "start" || panel.layout === "end") && "_msupv2br"
        ]),
        children: [
            panel.primaryCallToAction && /*#__PURE__*/ (0, $loA2J.jsx)($47d867af5ed4b3f4$var$PrimaryCallToAction, (0, $7Knp0._)({
                bgColor: panel.bgColor
            }, panel.primaryCallToAction)),
            panel.secondaryCallToAction && /*#__PURE__*/ (0, $loA2J.jsx)($47d867af5ed4b3f4$var$SecondaryCallToAction, (0, $7Knp0._)({}, panel))
        ]
    });
};
const $47d867af5ed4b3f4$var$PrimaryCallToAction = (props)=>{
    const { bgColor: bgColor } = props, rest = (0, $akGnX._)(props, [
        "bgColor"
    ]);
    let variant = "primary";
    if (bgColor === "blue") variant = "primary_alt";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lbVpk.Button), (0, $6iHNw._)((0, $7Knp0._)({}, rest), {
        variant: variant,
        "data-testid": "primary-cta",
        children: props.text
    }));
};
const $47d867af5ed4b3f4$var$SecondaryCallToAction = (panel)=>{
    const { secondaryCallToAction: secondaryCallToAction } = panel;
    const bgColor = [
        "blue",
        "black"
    ].includes(panel.bgColor) ? "bgBlackBlue" : "bgWhite";
    return(// @ts-ignore
    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1O6nN.Link), (0, $6iHNw._)((0, $7Knp0._)({}, secondaryCallToAction), {
        bgColor: bgColor,
        anchorProps: {
            "data-testid": "secondary-cta"
        },
        onClick: panel.onVideoClick
    })));
};
const $47d867af5ed4b3f4$var$sectionStyles = null;
const $47d867af5ed4b3f4$var$tabListStyle = null;
const $47d867af5ed4b3f4$var$scrollableStyle = null;
const $47d867af5ed4b3f4$var$fittableStyle = null;
const $47d867af5ed4b3f4$var$tabStyle = null;
const $47d867af5ed4b3f4$var$tabTextStyle = null; /* Need to refactor our default typography to reduce need for important on a classless paragraph */ 
const $47d867af5ed4b3f4$var$tabTitleStyle = null;
const $47d867af5ed4b3f4$var$tabSelectedStyle = null;
const $47d867af5ed4b3f4$var$panelContainerStyle = null;
const $47d867af5ed4b3f4$var$panelStyle = null;
const $47d867af5ed4b3f4$var$panelSelectedStyle = null;
const $47d867af5ed4b3f4$var$panelDetailsStyle = null;
const $47d867af5ed4b3f4$var$panelEndStyle = null;
const $47d867af5ed4b3f4$var$panelStartStyle = null;
const $47d867af5ed4b3f4$var$panelCenteredStyle = null;
const $47d867af5ed4b3f4$var$detailsTextStyle = null;
const $47d867af5ed4b3f4$var$panelColorStyle = null;
const $47d867af5ed4b3f4$var$actionContainerStyle = null;
const $47d867af5ed4b3f4$var$actionStartStyle = null;

});

parcelRegister("g4WuQ", function(module, exports) {

$parcel$export(module.exports, "Integration", function () { return $edab1f6e8003d45e$export$8912007324034abd; });
/* integration.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
const $edab1f6e8003d45e$var$logoSizes = {
    regular: {
        size: "78px",
        cornerRadius: "18.7px"
    },
    large: {
        size: "100px",
        cornerRadius: "24px"
    }
};
const $edab1f6e8003d45e$var$IntegrationLogo = (props)=>{
    const logoListItemStyles = null;
    const logoLinkStyles = null;
    const logoImageContainerStyles = null;
    if (!props.href) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("li", {
        className: (0, $esG4f.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _80omtlke _1bsbcae7 _4t3icae7 _bfhkcd5j _19it1k0a _2rko13r7 _gltef22m _165tf22m _2oz41w8s _1dbz1cd0"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300")),
            "--_1jpuyj7": (0, $43MIc.default)($edab1f6e8003d45e$var$logoSizes[props.logoSize].size),
            "--_1k7rxgg": (0, $43MIc.default)($edab1f6e8003d45e$var$logoSizes[props.logoSize].cornerRadius)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
            href: props.href,
            className: (0, $esG4f.default)([
                "_1e0c1txw _4t3i1osq _1bsb1osq _4cvr1h6o _1bah1h6o _1yt4u2gc"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbsq37 _4t3isbdl"
                ]),
                style: {
                    "--_1hn5070": (0, $43MIc.default)(props.width ? `${props.width}px` : "100%"),
                    "--_1jk4xy3": (0, $43MIc.default)(props.width ? "auto" : "100%")
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: props.src,
                    alt: props.alt,
                    style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "contain"
                    }
                })
            })
        })
    });
};
const $edab1f6e8003d45e$export$8912007324034abd = ({ eyebrow: eyebrow, title: title, titleAs: titleAs = "h3", body: body, linkLabel: linkLabel, linkHref: linkHref, logos: logos, background: background = "polygon", backgroundColor: backgroundColor = "neutral.light100", flipLayout: flipLayout = false })=>{
    const numLogos = logos.filter((logo)=>{
        var _logo_href;
        return (_logo_href = logo.href) !== null && _logo_href !== void 0 ? _logo_href : false;
    }).length;
    const logoSize = numLogos <= 6 ? "large" : "regular";
    const responsiveSectionDividerHeightsStyles = null;
    const sectionStyles = null;
    const polygonStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _kqswh2mm _1moul8wr _11q7fulm _1rjcq9zu",
            "_9luy1wqb _ce5au29b _wfa7llbu"
        ]),
        style: {
            "--_pxzrua": (0, $43MIc.default)(background === "full" ? 0 : "var(--ds-space-800, 64px)"),
            "--_1sgx88i": (0, $43MIc.default)(background === "full" ? (0, $5ohHq.wacToken)(`color.${backgroundColor}`) : "transparent")
        },
        children: [
            background === "polygon" && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_11q71xvm _kqswstnw _1bsb1osq _4t3imhst _14b5zqdx _b8yq87gh _1e021ssb _t9eczr6s _1kt9b3bt _1cs8stnw _iajm14o7 _kfgtq9zu _1mp41osq _1s6k1xvm _tgsmcdv4 _aetrb3bt _18postnw _1qdgq9zu _19nq1osq _z0ai1osq _16r21xvm _1oj41mhh"
                ]),
                style: {
                    "--_vp2za": (0, $43MIc.default)((0, $5ohHq.wacToken)(`color.${backgroundColor}`))
                }
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_195g1wug _p12f1osq _1bsb1osq _kqswh2mm _1pbykb7n _13ltwklj _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bwxkt _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1e0c11p5 _vchhusvi _zulp14hz _1dsl1tcg _4t3i1osq _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _1n261g80 _p12f1to9 _195g1wug _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bah1h6o _4cvr1h6o _1p571ejb _gy1pxy5q _8fz6nklw _688gkb7n",
                            flipLayout && "_1f49kb7n",
                            numLogos === 7 && "_w9am12am _1bhm12am"
                        ]),
                        children: logos.map((logo, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($edab1f6e8003d45e$var$IntegrationLogo, (0, $6iHNw._)((0, $7Knp0._)({}, logo), {
                                logoSize: logoSize
                            }), index))
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.ContentBlock), {
                        eyebrow: eyebrow,
                        title: title,
                        titleAs: titleAs,
                        text: body,
                        callToActionProps: linkLabel && linkHref ? {
                            link: {
                                text: linkLabel,
                                href: linkHref
                            }
                        } : undefined,
                        alignment: {
                            mobile: "center",
                            tablet: "start",
                            desktop: "start"
                        }
                    })
                ]
            })
        ]
    });
};
const $edab1f6e8003d45e$var$contentContainerStyles = null;
const $edab1f6e8003d45e$var$logosContainerStyles = null;
const $edab1f6e8003d45e$var$sevenLogosGridStyles = null;

});

parcelRegister("2Nqw3", function(module, exports) {

$parcel$export(module.exports, "Logos", function () { return $cfbf5b5ca75d407c$export$c847549a613b9060; });
/* logos.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $1UUq1 = parcelRequire("1UUq1");
const $cfbf5b5ca75d407c$export$c847549a613b9060 = ({ logos: logos })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1n261g80 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw _1bah1h6o _1p57oahv _gy1pxy5q _99s6xncg _1plrxncg _4cvr1h6o"
        ]),
        children: logos.map((logo, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: logo.src,
                    alt: logo.alt,
                    style: (0, $7Knp0._)({}, $cfbf5b5ca75d407c$var$logoStyles, logo.width ? {
                        width: `${logo.width}px`,
                        height: "auto"
                    } : {})
                })
            }, index))
    });
};
const $cfbf5b5ca75d407c$var$logosContainerStyle = null;
const $cfbf5b5ca75d407c$var$logoStyles = {
    height: "32px",
    width: "auto",
    maxWidth: "auto",
    filter: "grayscale(100%) brightness(66%)",
    ["-webkit-filter"]: "grayscale(100%) brightness(66%)"
};

});

parcelRegister("cJh4j", function(module, exports) {

$parcel$export(module.exports, "MobileApp", function () { return $998fa7af6915eee4$export$f81bbe9088ca57b0; });
/* mobile-app.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $1UUq1 = parcelRequire("1UUq1");
const $998fa7af6915eee4$export$f81bbe9088ca57b0 = ({ title: title, description: description, linkLabel: linkLabel, linkHref: linkHref, imageSrc: imageSrc, imageAlt: imageAlt = "", appleAppStoreUrl: appleAppStoreUrl, googlePlayStoreUrl: googlePlayStoreUrl })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1e0c11p5 _vchhusvi _zulp14hz _1bsb1osq _1dsl1tcg _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bwxkt _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1pfhxncg"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1yd3xy5q _40tuxncg _1mou1wug"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.ContentBlock), {
                        title: title,
                        titleAs: "h2",
                        text: description,
                        callToActionProps: linkLabel && linkHref ? {
                            link: {
                                text: linkLabel,
                                href: linkHref
                            }
                        } : undefined
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _zulppxbi _1pfhxy5q"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                href: appleAppStoreUrl,
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3g0xj4162q6vj8iis1nr5pkh2scjm13a.png",
                                    alt: "Download on the Apple App Store"
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                href: googlePlayStoreUrl,
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/md1w60b88865q56fl84744t5u0heh751.png",
                                    alt: "Get it on the Google Play Store"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1reo15vq _18m915vq"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: imageSrc,
                    alt: imageAlt,
                    className: (0, $esG4f.default)([
                        "_glte1osq _165t1pna _12rrk5xz _1vkhidpf _1x6l1osq _1bsb1osq _4t3ia91z _5ral1dfr _rsufq0ho"
                    ])
                })
            })
        ]
    });
};
const $998fa7af6915eee4$var$sectionStyles = null;
const $998fa7af6915eee4$var$leftSideContentStyles = null;
const $998fa7af6915eee4$var$appStoreLinksContainerStyles = null;
const $998fa7af6915eee4$var$imageContainerStyles = null;
const $998fa7af6915eee4$var$imageStyles = null;

});

parcelRegister("5STdK", function(module, exports) {

$parcel$export(module.exports, "SideNav", function () { return $3b6a124da0322dbd$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $ayjUl = parcelRequire("ayjUl");

var $2wO91 = parcelRequire("2wO91");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
const $3b6a124da0322dbd$var$MobileExpandableNav = ({ title: title, children: children })=>{
    const [isExpanded, setIsExpanded] = (0, $iSvIT.useState)(false);
    const [buttonBottom, setButtonBottom] = (0, $iSvIT.useState)(0);
    const navRef = (0, $iSvIT.useRef)(null);
    const buttonRef = (0, $iSvIT.useRef)(null);
    const contentRef = (0, $iSvIT.useRef)(null);
    const handleToggle = ()=>{
        setIsExpanded(!isExpanded);
    }; // Calculate button position for nav positioning
    (0, $iSvIT.useEffect)(()=>{
        const updateButtonPosition = ()=>{
            if (buttonRef.current) {
                const rect = buttonRef.current.getBoundingClientRect();
                setButtonBottom(rect.bottom);
            }
        };
        updateButtonPosition();
        window.addEventListener("resize", updateButtonPosition);
        window.addEventListener("scroll", updateButtonPosition);
        return ()=>{
            window.removeEventListener("resize", updateButtonPosition);
            window.removeEventListener("scroll", updateButtonPosition);
        };
    }, []);
    // Prevent body scroll when nav is open
    (0, $iSvIT.useEffect)(()=>{
        if (isExpanded) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "unset";
        return ()=>{
            document.body.style.overflow = "unset";
        };
    }, [
        isExpanded
    ]);
    // Handle click outside to close nav
    (0, $iSvIT.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (isExpanded && navRef.current && !navRef.current.contains(event.target)) setIsExpanded(false);
        };
        if (isExpanded) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isExpanded
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        ref: navRef,
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("button", {
                ref: buttonRef,
                onClick: handleToggle,
                "aria-expanded": isExpanded,
                "aria-controls": "mobile-side-nav-content",
                className: (0, $esG4f.default)([
                    "_1bsb1osq _4t3i1wqb _bfhk150w _19itglyw _1yt41hnt _1e0c1txw _4cvr1h6o _zulpu2gc _80omtlke _v564mfn2 _kqswh2mm _1pbyibnn _irr3u4vp _s51sxy5q"
                ]),
                style: {
                    "--_8nj8hf": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light200")),
                    "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: (0, $esG4f.default)([
                            "_4t3i1ejb _1bsb1ejb _1e0c1txw _4cvr1h6o _1bah1h6o _syaz17la"
                        ]),
                        style: {
                            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                        },
                        children: isExpanded ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2wO91))), {
                            label: ""
                        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ayjUl))), {
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: "eyebrow-md",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                ref: contentRef,
                id: "mobile-side-nav-content",
                className: (0, $esG4f.default)([
                    "_bfhkcd5j _1bsb1osq _18zr1wqb _v564vpel _1reo1wug _18m91wug _s51sxy5q",
                    isExpanded ? "_kqsw1n9t _152t1um1 _dk5didpf _u7coidpf _1bsbauwl _4t3iqi8f _c71lqi8f _tzy4kb7n _1pbyzo7u _1reo15vq _18m915vq _bfhkcd5j _1q51v47k _85i51wqb _18zr1wqb _s51sxy5q" : "_kqsw1n9t _c71lidpf _tzy4idpf _lcxvglyw _152tidpf _dk5didpf _1bsbauwl"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                    "--_ab93rs": (0, $43MIc.default)(buttonBottom, "px")
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_4t3i1osq _1reo1wug _18m91wug"
                    ]),
                    children: children
                })
            })
        ]
    });
};
const $3b6a124da0322dbd$export$6b43f262d1299a2e = ({ sideNavItems: sideNavItems })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
        className: (0, $esG4f.default)([
            "_qtt8glyw _18s8ze3t _1yt4ze3t _1reo1wug _18m91wug _1jc21nkh _1xey1k0a",
            "sidenav-menu"
        ]),
        style: {
            "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
        },
        children: sideNavItems.map((sideNavItem)=>{
            if (sideNavItem.type === "collection") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.SideNavCollection), {
                type: "collection",
                collectionName: sideNavItem.collectionName,
                sideNavItems: sideNavItem.sideNavItems,
                depth: 0
            }, sideNavItem.collectionName);
            if (sideNavItem.type === "link") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.SideNavLink), {
                dataEventProps: sideNavItem.dataEventProps,
                type: "link",
                text: sideNavItem.text,
                href: sideNavItem.href,
                anchors: sideNavItem.anchors,
                depth: 0
            }, sideNavItem.text);
            return null;
        })
    });
};
const $3b6a124da0322dbd$export$1a35787d6353cf6a = ({ title: title, sideNavItems: sideNavItems })=>{
    const intl = (0, $f6qj2.default)();
    const navTitle = intl.formatMessage({
        id: "hub.sidenav.title",
        defaultMessage: `{hub} topics`
    }, {
        hub: title
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("nav", {
                id: "side-nav-desktop",
                "aria-label": intl.formatMessage({
                    id: "hub.sidenav.desktop.label",
                    defaultMessage: `{hub} Hub desktop navigation`
                }, {
                    hub: title
                }),
                className: (0, $esG4f.default)([
                    "_1mjbglyw",
                    "_kqsw1if8 _152t1dln",
                    "_19ityzqy _2rkovwyg _1yt4v47k _85i51wqb _4t3i1ns9"
                ]),
                style: {
                    "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400")),
                    "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _4cvr1h6o _1tke1wqb _1yt41dg4",
                            "eyebrow-md"
                        ]),
                        children: navTitle
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($3b6a124da0322dbd$export$6b43f262d1299a2e, {
                        sideNavItems: sideNavItems
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("nav", {
                id: "side-nav-tablet-mobile",
                "aria-label": intl.formatMessage({
                    id: "hub.sidenav.mobile.label",
                    defaultMessage: `{hub} Hub mobile navigation`
                }, {
                    hub: title
                }),
                className: (0, $esG4f.default)([
                    "_dm25glyw",
                    "_kqsw1n9t _1e02idpf _1pbyegat _1bsbauwl"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($3b6a124da0322dbd$var$MobileExpandableNav, {
                    title: navTitle,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)($3b6a124da0322dbd$export$6b43f262d1299a2e, {
                        sideNavItems: sideNavItems
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_dm25glyw",
                    "_4t3i1wqb"
                ])
            })
        ]
    });
};
const $3b6a124da0322dbd$var$desktopCss = null;
const $3b6a124da0322dbd$var$tabletMobileCss = null;
const $3b6a124da0322dbd$var$stickyCss = null;
const $3b6a124da0322dbd$var$fixedCss = null;
const $3b6a124da0322dbd$var$listCss = null;
const $3b6a124da0322dbd$var$containerCss = null;
const $3b6a124da0322dbd$var$desktopTitleCss = null;
const $3b6a124da0322dbd$var$mobileIconCss = null;
const $3b6a124da0322dbd$var$mobileExpandableButtonCss = null;
const $3b6a124da0322dbd$var$mobileNavContentCss = null;
const $3b6a124da0322dbd$var$mobileNavContentCollapsedCss = null;
const $3b6a124da0322dbd$var$mobileInnerContentCss = null;

});

parcelRegister("62VZK", function(module, exports) {

$parcel$export(module.exports, "useTabsContext", function () { return (parcelRequire("cPhXv")).useTabsContext; });
$parcel$export(module.exports, "Tabs", function () { return (parcelRequire("cPhXv")).Tabs; });
$parcel$export(module.exports, "DraggableTabList", function () { return (parcelRequire("gq8af")).DraggableTabList; });
$parcel$export(module.exports, "DraggableTab", function () { return (parcelRequire("6YaIp")).DraggableTab; });
$parcel$export(module.exports, "TabPanel", function () { return (parcelRequire("bN8aD")).TabPanel; });
$parcel$export(module.exports, "TabsSection", function () { return (parcelRequire("7CBQh")).TabsSection; });
$parcel$export(module.exports, "mapChild", function () { return (parcelRequire("kWavG")).mapChild; });

var $cPhXv = parcelRequire("cPhXv");

var $gq8af = parcelRequire("gq8af");

var $6YaIp = parcelRequire("6YaIp");

var $bN8aD = parcelRequire("bN8aD");

var $7CBQh = parcelRequire("7CBQh");

var $kWavG = parcelRequire("kWavG");

});
parcelRegister("cPhXv", function(module, exports) {

$parcel$export(module.exports, "useTabsContext", function () { return $5601ed8c8774e035$export$5c3d36c3adf0ba92; });
$parcel$export(module.exports, "Tabs", function () { return $5601ed8c8774e035$export$b2539bed5023c21c; });
/* tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $eDoPe = parcelRequire("eDoPe");

var $4xseM = parcelRequire("4xseM");

var $kWavG = parcelRequire("kWavG");
const $5601ed8c8774e035$var$TabsContext = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $5601ed8c8774e035$export$5c3d36c3adf0ba92 = ()=>{
    const context = (0, $iSvIT.useContext)($5601ed8c8774e035$var$TabsContext);
    if (!context) throw new Error("useTabsContext must be used within Tabs");
    return context;
};
let $5601ed8c8774e035$var$nextId = 0;
const $5601ed8c8774e035$export$b2539bed5023c21c = ({ id: id, initialTab: initialTab, loop: loop = true, children: children, useInViewOptionsContainer: useInViewOptionsContainer })=>{
    const [currentTab, setCurrentTab] = (0, $iSvIT.useState)(initialTab !== null && initialTab !== void 0 ? initialTab : 0);
    const [userSelected, setUserSelected] = (0, $iSvIT.useState)(false);
    const [focus, setFocus] = (0, $iSvIT.useState)(false);
    const tabIds = (0, $iSvIT.useRef)([]);
    const contextId = (0, $iSvIT.useRef)(`:tabs:${id ? id : $5601ed8c8774e035$var$nextId++}:`);
    const DEFAULT_IN_VIEW_THRESHOLD = 0.3;
    const { ref: containerScrollRef, inView: tabsContainerIsVisible } = (0, $eDoPe.useInView)((0, $7Knp0._)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD
    }, useInViewOptionsContainer));
    const { ref: tabListScrollRef, inView: tabListIsVisible } = (0, $eDoPe.useInView)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD
    });
    function getTabsCount() {
        let count = 0;
        (0, $kWavG.deepForEach)(children, (child)=>{
            if ((0, $kWavG.isTab)(child)) count++;
        });
        return count;
    }
    function getChildren() {
        let panelIndex = 0;
        tabIds.current = tabIds.current || [];
        let diff = tabIds.current.length - getTabsCount(); // Add ids if new tabs have been added
        // Don't bother removing ids, just keep them in case they are added again
        // This is more efficient, and keeps the uuid counter under control
        while(diff++ < 0)tabIds.current.push(`${contextId.current}${tabIds.current.length}`);
         // Map children to dynamically setup refs
        return (0, $kWavG.deepMap)(children, (child)=>{
            var _window_document_activeElement;
            let result = child; // Check if the window is available
            const windowAvailable = !!window && !!window.document && !!window.document.activeElement; // Get the active element id
            const activeElementId = windowAvailable ? (_window_document_activeElement = window.document.activeElement) === null || _window_document_activeElement === void 0 ? void 0 : _window_document_activeElement.id : null; // Clone TabList and Tab components to have refs
            if ((0, $kWavG.isTabList)(child)) {
                let listIndex = 0; // Figure out if the current focus in the DOM is set on a Tab
                // If it is we should keep the focus on the next selected tab
                let wasTabFocus = false;
                if (windowAvailable && activeElementId) // Check if the active element is a tab
                wasTabFocus = (0, $iSvIT.Children).toArray(child.props.children).filter((0, $kWavG.isTab)).some((_, i)=>{
                    return activeElementId === `tab${tabIds.current[i]}`;
                });
                result = /*#__PURE__*/ (0, $iSvIT.cloneElement)(child, {
                    children: (0, $kWavG.deepMap)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    child.props.children, (tab)=>{
                        const selected = currentTab === listIndex;
                        const props = {
                            id: tabIds.current[listIndex],
                            tabIndex: listIndex,
                            focus: selected && (focus || wasTabFocus)
                        };
                        listIndex++;
                        return /*#__PURE__*/ (0, $iSvIT.cloneElement)(tab, props);
                    })
                });
            } else if ((0, $kWavG.isTabPanel)(child)) {
                // Preserve existing props (like hideTabPanelRole) when cloning
                const existingProps = child.props || {};
                const props = (0, $6iHNw._)((0, $7Knp0._)({}, existingProps), {
                    id: tabIds.current[panelIndex],
                    panelIndex: panelIndex
                });
                panelIndex++;
                result = /*#__PURE__*/ (0, $iSvIT.cloneElement)(child, props);
            }
            return result;
        });
    }
    const goToTab = (tabIndex)=>{
        if (tabIndex === undefined) return;
        setCurrentTab(tabIndex);
    };
    const isCurrentTab = (tabIndex)=>{
        return tabIndex === currentTab;
    };
    const goToNextTab = (0, $iSvIT.useCallback)(()=>{
        if (currentTab + 1 < tabIds.current.length) goToTab(currentTab + 1);
        else if (loop) goToTab(0);
    }, [
        loop,
        currentTab
    ]);
    const goToPrevTab = (0, $iSvIT.useCallback)(()=>{
        if (currentTab - 1 >= 0) goToTab(currentTab - 1);
        else if (loop) goToTab(tabIds.current.length - 1);
    }, [
        loop,
        currentTab
    ]);
    const goToFirstTab = ()=>{
        goToTab(0);
    };
    const goToLastTab = ()=>{
        goToTab(tabIds.current.length - 1);
    };
    const onKeyDown = (e)=>{
        if (e.code === "ArrowLeft" || e.code === "ArrowUp") goToPrevTab();
        else if (e.code === "ArrowRight" || e.code === "ArrowDown") goToNextTab();
        else if (e.code === "End") // Select last tab (End key)
        goToFirstTab();
        else if (e.code === "Home") // Select first tab (Home key)
        goToLastTab();
        else return;
        setUserSelected(true);
        setFocus(true); // This prevents scrollbars from moving around
        e.preventDefault();
    }; // Reset the userSelected state when the section is visible again
    (0, $iSvIT.useEffect)(()=>{
        if (tabsContainerIsVisible) setUserSelected(false);
    }, [
        tabsContainerIsVisible
    ]); // Reinitialize analytics when the tab changes
    // this is needed because the content wasn't rendered before
    (0, $iSvIT.useEffect)(()=>{
        (0, $4xseM.Initializer).autoTrack();
    }, [
        currentTab
    ]);
    const containerStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)($5601ed8c8774e035$var$TabsContext.Provider, {
        value: {
            currentTab: currentTab,
            userSelected: userSelected,
            goToTab: goToTab,
            isCurrentTab: isCurrentTab,
            goToNextTab: goToNextTab,
            goToPrevTab: goToPrevTab,
            goToFirstTab: goToFirstTab,
            goToLastTab: goToLastTab,
            onKeyDown: onKeyDown,
            tabsContainerIsVisible: tabsContainerIsVisible,
            tabListIsVisible: tabListIsVisible,
            tabListScrollRef: tabListScrollRef
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            ref: containerScrollRef,
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx21bp4 _zulp1jfw _1reo15vq _18m915vq"
            ]),
            children: getChildren()
        })
    });
};

});
parcelRegister("kWavG", function(module, exports) {

$parcel$export(module.exports, "isTab", function () { return $9ba823149c88c072$export$bdc9792d96913679; });
$parcel$export(module.exports, "isTabList", function () { return $9ba823149c88c072$export$9c326233b9ae5588; });
$parcel$export(module.exports, "isTabPanel", function () { return $9ba823149c88c072$export$9e12445c79db89b; });
$parcel$export(module.exports, "mapChild", function () { return $9ba823149c88c072$export$886f34b49305b07b; });
$parcel$export(module.exports, "deepMap", function () { return $9ba823149c88c072$export$ce7eaaed37329a1b; });
$parcel$export(module.exports, "deepForEach", function () { return $9ba823149c88c072$export$519ada94592b97fc; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $iSvIT = parcelRequire("iSvIT");
function $9ba823149c88c072$var$makeTypeChecker(tabsRole) {
    return (element)=>!!element.type && element.type.tabsRole === tabsRole;
}
const $9ba823149c88c072$export$bdc9792d96913679 = $9ba823149c88c072$var$makeTypeChecker("Tab");
const $9ba823149c88c072$export$9c326233b9ae5588 = $9ba823149c88c072$var$makeTypeChecker("TabList");
const $9ba823149c88c072$export$9e12445c79db89b = $9ba823149c88c072$var$makeTypeChecker("TabPanel");
const $9ba823149c88c072$export$dbaa4172856e20ab = (element)=>!!element.type && typeof element.type === "function";
function $9ba823149c88c072$var$isTabChild(child) {
    return $9ba823149c88c072$export$bdc9792d96913679(child) || $9ba823149c88c072$export$9c326233b9ae5588(child) || $9ba823149c88c072$export$9e12445c79db89b(child);
}
function $9ba823149c88c072$export$886f34b49305b07b(child, additionalProps) {
    if (child === null) return null;
    // Only pass additionalProps to functional components
    // React.cloneElement will throw an error if you pass additionalProps to a dom component like div
    if ($9ba823149c88c072$export$dbaa4172856e20ab(child)) return (0, $iSvIT.cloneElement)(child, (0, $7Knp0._)({}, child.props, additionalProps));
    return child;
}
function $9ba823149c88c072$export$ce7eaaed37329a1b(children, callback) {
    return (0, $iSvIT.Children).map(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return null;
        if ($9ba823149c88c072$var$isTabChild(child)) return callback(child, index);
        if (child && child.props && child.props.children && typeof child.props.children === "object") // Clone the child that has children and map them too
        return (0, $iSvIT.cloneElement)(child, (0, $6iHNw._)((0, $7Knp0._)({}, child.props), {
            children: $9ba823149c88c072$export$ce7eaaed37329a1b(child.props.children, callback)
        }));
        return child;
    });
}
function $9ba823149c88c072$export$519ada94592b97fc(children, callback) {
    return (0, $iSvIT.Children).forEach(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return;
        if ($9ba823149c88c072$export$bdc9792d96913679(child) || $9ba823149c88c072$export$9e12445c79db89b(child)) callback(child, index);
        else if (child && child.props && child.props.children && typeof child.props.children === "object") {
            if ($9ba823149c88c072$export$9c326233b9ae5588(child)) callback(child, index);
            $9ba823149c88c072$export$519ada94592b97fc(child.props.children, callback);
        }
    });
}

});


parcelRegister("gq8af", function(module, exports) {

$parcel$export(module.exports, "DraggableTabList", function () { return $36f3fdc852638cc4$export$dbb4ac5a817c6612; });
/* draggable-tab-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
parcelRequire("62VZK");
var $cPhXv = parcelRequire("cPhXv");
const $36f3fdc852638cc4$export$dbb4ac5a817c6612 = ({ alignment: alignment = "start", tabSize: // @ts-ignore
tabSize = "large", children: children })=>{
    const containerRef = (0, $iSvIT.useRef)(null);
    const mouseDown = (0, $iSvIT.useRef)(false);
    const startX = (0, $iSvIT.useRef)(0);
    const scrollLeft = (0, $iSvIT.useRef)(0);
    const canDrag = (0, $iSvIT.useRef)(false);
    const { onKeyDown: onKeyDown } = (0, $cPhXv.useTabsContext)();
    const startDragging = (mouse, touch)=>{
        var _containerRef_current;
        if (!canDrag.current) return;
         // Start listening for mouseup and mousemove events outside of the tab list
        document.addEventListener("mouseup", stopDragging);
        document.addEventListener("mousemove", move);
        mouseDown.current = true;
        var _ref;
        startX.current = (_ref = touch && touch.touches[0] ? touch.touches[0].clientX : mouse === null || mouse === void 0 ? void 0 : mouse.clientX) !== null && _ref !== void 0 ? _ref : 0;
        var _containerRef_current_scrollLeft;
        scrollLeft.current = (_containerRef_current_scrollLeft = (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.scrollLeft) !== null && _containerRef_current_scrollLeft !== void 0 ? _containerRef_current_scrollLeft : 0;
    };
    const stopDragging = ()=>{
        if (!canDrag.current) return;
         // Stop listening for mouseup and mousemove events
        document.removeEventListener("mouseup", stopDragging);
        document.removeEventListener("mousemove", move);
        mouseDown.current = false;
    };
    const move = (mouse, touch)=>{
        if (!canDrag.current || !mouseDown.current || !containerRef.current) return;
        let dragAmount = 0;
        if (touch && touch.changedTouches[0]) dragAmount = touch.changedTouches[0].clientX - startX.current;
        else if (mouse) dragAmount = mouse.clientX - startX.current;
        containerRef.current.scrollLeft = scrollLeft.current - dragAmount;
    };
    (0, $iSvIT.useEffect)(()=>{
        const updateCanDrag = ()=>{
            if (containerRef.current) {
                const container = containerRef.current;
                canDrag.current = container.scrollWidth > container.clientWidth;
            }
        };
        const setStartingPoint = ()=>{
            if (containerRef.current) {
                if (canDrag.current) {
                    const tabPanels = document.querySelector(".tab-panels");
                    const tabPanelsStyle = tabPanels && window.getComputedStyle(tabPanels);
                    containerRef.current.setAttribute("style", `padding-left: calc(${tabPanelsStyle === null || tabPanelsStyle === void 0 ? void 0 : tabPanelsStyle.marginLeft} + ${tabPanelsStyle === null || tabPanelsStyle === void 0 ? void 0 : tabPanelsStyle.paddingLeft});`);
                } else if (alignment === "start") containerRef.current.setAttribute("style", "margin-inline: 0px; padding-inline: 0px;");
            }
        };
        if (!containerRef.current) return;
        const observer = new ResizeObserver(()=>{
            updateCanDrag();
            setStartingPoint();
        });
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    });
    const wrapperStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        ref: containerRef,
        className: (0, $esG4f.default)([
            "_1reo15vq _p12f1osq _195g1wug _18zrzwfg _11q81vi7 _su071wqb _3hzp1wqb"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div" // @ts-ignore
        , {
            onTouchStart: (e)=>startDragging(undefined, e),
            onMouseDown: (e)=>startDragging(e),
            onTouchEnd: (e)=>{
                // @ts-ignore
                move(undefined, e);
                stopDragging();
            },
            onTouchMove: (e)=>move(undefined, e),
            onKeyDown: onKeyDown,
            className: (0, $esG4f.default)([
                "_1e0c1txw _4cvr1y6m _1bah1y6m _1n261q9c _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw _1bsb1ns9 _p12f1osq _1moupxbi _zulp1ejb",
                "tab-list"
            ]),
            tabIndex: -1,
            role: "tablist",
            children: children
        })
    });
};
const $36f3fdc852638cc4$var$tabsContainerStyles = null;
$36f3fdc852638cc4$export$dbb4ac5a817c6612.tabsRole = "TabList";

});

parcelRegister("6YaIp", function(module, exports) {

$parcel$export(module.exports, "DraggableTab", function () { return $e90b6760ea28386b$export$3a29ca89d63c5c20; });
/* draggable-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("62VZK");
var $cPhXv = parcelRequire("cPhXv");
// eslint-disable-next-line complexity
const $e90b6760ea28386b$export$3a29ca89d63c5c20 = (_param)=>{
    var { id: id, focus: focus, tabIndex: tabIndex, title: title, iconUrl: iconUrl, tabSize: tabSize = "large", bgColor: bgColor = "bgWhite", label: label, dataEventProps: dataEventProps, className: className, enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false } = _param, props = (0, $akGnX._)(_param, [
        "id",
        "focus",
        "tabIndex",
        "title",
        "iconUrl",
        "tabSize",
        "bgColor",
        "label",
        "dataEventProps",
        "className",
        "enableRovoBorder",
        "enableResponsiveTabSize"
    ]);
    const { goToTab: goToTab, isCurrentTab: isCurrentTab, userSelected: userSelected } = (0, $cPhXv.useTabsContext)();
    const startX = (0, $iSvIT.useRef)(0);
    const tabRef = /*#__PURE__*/ (0, $iSvIT.createRef)();
    const isTabSelected = isCurrentTab(tabIndex);
    (0, $iSvIT.useEffect)(()=>{
        if (!tabRef.current || !tabRef.current.parentElement || !tabRef.current.parentElement.scrollTo || !tabRef.current.parentElement.parentElement || !tabRef.current.parentElement.parentElement.scrollTo) return;
         // Scroll to the selected tab if it's not in view
        if (isTabSelected) {
            var _tabRef_current_parentElement;
            if ((_tabRef_current_parentElement = tabRef.current.parentElement) === null || _tabRef_current_parentElement === void 0 ? void 0 : _tabRef_current_parentElement.parentElement) {
                // calculate the offset to center the tab in the parent
                const offsetLeft = tabRef.current.offsetLeft - tabRef.current.parentElement.offsetLeft - tabRef.current.parentElement.offsetWidth / 2 + tabRef.current.offsetWidth / 2;
                tabRef.current.parentElement.parentElement.scrollTo({
                    left: offsetLeft,
                    top: 0,
                    behavior: "smooth"
                });
            }
            if (focus) tabRef.current.focus({
                preventScroll: true
            });
        }
        if (isTabSelected && dataEventProps && userSelected) tabRef.current.dispatchEvent(new Event("select"));
    }, [
        tabRef,
        isTabSelected,
        focus,
        userSelected,
        dataEventProps
    ]);
    const onMouseDown = (e)=>{
        var _props_onMouseDown;
        var _e_clientX;
        startX.current = (_e_clientX = e.clientX) !== null && _e_clientX !== void 0 ? _e_clientX : 0;
        (_props_onMouseDown = props.onMouseDown) === null || _props_onMouseDown === void 0 ? void 0 : _props_onMouseDown.call(props, e);
    };
    const onClick = (0, $iSvIT.useCallback)((e)=>{
        var _props_onClick;
        if (Math.abs(e.clientX - startX.current) > 15) // Prevent click event if user is dragging
        return;
        (_props_onClick = props.onClick) === null || _props_onClick === void 0 ? void 0 : _props_onClick.call(props, e);
        if (isTabSelected) return;
        goToTab(tabIndex);
    }, [
        isTabSelected,
        tabIndex,
        goToTab,
        props
    ]);
    const onKeyDown = (e)=>{
        if (e.code === "Space" || e.code === "Enter") {
            goToTab(tabIndex);
            e.preventDefault();
        }
    };
    const tabColor = bgColor === "bgWhite" ? (0, $5ohHq.wacToken)("color.neutral.light200") : (0, $5ohHq.wacToken)("color.neutral.light0");
    const tabStyles = null;
    const rovoBorderStyles = null;
    const borderStyles = null;
    const largeTabStyles = null;
    const smallTabStyles = null;
    const iconTabStyles = null;
    const iconLargeTabStyles = null;
    const iconSmallTabStyles = null;
    const responsiveIconTabStyles = null;
    const iconLargeContainerStyles = null;
    const iconSmallContainerStyles = null;
    const responsiveIconContainerStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", (0, $6iHNw._)((0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, props), {
        ref: tabRef,
        className: className,
        id: `tab${id}`,
        "aria-selected": isTabSelected,
        "aria-controls": `panel${id}`,
        "aria-label": label,
        title: label,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onKeyDown: onKeyDown,
        role: "tab",
        tabIndex: -1
    }), dataEventProps), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("button", {
            className: (0, $esG4f.default)([
                "_o5721q9c _1ul9ymf6 _bfhk1jrh _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko17td _19itq75r _80omtlke _4cvx17la _8y9r1hlo",
                iconUrl && "_2lx21bp4 _2rkoi2wt _1wyb1j6v",
                iconUrl && enableRovoBorder ? "_1h6d1j28 _1s79mzrp _1esp1ws1 _494pusvi _iusibx47" : "_1npj1ybm _1s7917la",
                iconUrl && enableResponsiveTabSize && "_4t3i1n2x _1ul9176v _1yt437zh _1xlocmky _1d2y11ux _6ytt139i",
                !iconUrl && tabSize === "large" && "_ca0qdlk8 _u5f31f4h _n3tddlk8 _19bv1f4h _vwz41f4h _4t3i1wqb _1wyb1cby",
                !iconUrl && tabSize === "small" && "_1yt41c98 _vwz4v47k _4t3i1ylp _1wyb1j6v",
                iconUrl && !enableResponsiveTabSize && tabSize === "large" && "_4t3icmky _1ul911ux _1yt4139i",
                iconUrl && !enableResponsiveTabSize && tabSize === "small" && "_4t3i1n2x _1ul9176v _1yt437zh",
                `${isTabSelected ? "currentTab" : ""}`
            ]),
            "data-product-key": "template",
            "data-event": "clicked",
            "data-event-component": "button",
            "data-event-container": "tabsMenu",
            "data-label": title,
            style: {
                "--_7aj7gm": (0, $43MIc.default)(tabColor),
                "--_514je1": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.pill")),
                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100"))
            },
            children: [
                iconUrl && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        !enableResponsiveTabSize && tabSize === "large" && "_4t3ickbl _1bsbckbl",
                        !enableResponsiveTabSize && tabSize === "small" && "_4t3i10mc _1bsb10mc",
                        enableResponsiveTabSize && "_4t3i10mc _1bsb10mc _1xlockbl _14b5ckbl",
                        "default-icon"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                        src: `${iconUrl || ""}`,
                        alt: "",
                        draggable: false
                    })
                }),
                title
            ]
        })
    }));
};
$e90b6760ea28386b$export$3a29ca89d63c5c20.tabsRole = "Tab";

});

parcelRegister("bN8aD", function(module, exports) {

$parcel$export(module.exports, "TabPanel", function () { return $9a33649b5acaee05$export$3d96ec278d3efce4; });
/* tab-panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $8lB1y = parcelRequire("8lB1y");
parcelRequire("62VZK");
var $cPhXv = parcelRequire("cPhXv");
var $kWavG = parcelRequire("kWavG");
const $9a33649b5acaee05$var$hidePanelStyle = null;
const $9a33649b5acaee05$export$3d96ec278d3efce4 = (_param)=>{
    var { forceRender: forceRender, children: children, panelIndex: panelIndex, id: id, hideTabPanelRole: hideTabPanelRole } = _param, props = (0, $akGnX._)(_param, [
        "forceRender",
        "children",
        "panelIndex",
        "id",
        "hideTabPanelRole"
    ]);
    const { isCurrentTab: isCurrentTab } = (0, $cPhXv.useTabsContext)();
    const isTabSelected = isCurrentTab(panelIndex);
    const activeClass = isTabSelected ? "active-panel" : "";
    const { panelId: panelId, tabId: tabId } = (0, $8lB1y.generateSafeIds)(id, panelIndex);
    const originalChildrenCount = (0, $iSvIT.Children).count(children);
    const shouldHideRole = hideTabPanelRole !== undefined ? hideTabPanelRole : originalChildrenCount === 0;
    const { css: existingCss } = props, propsWithoutCss = (0, $akGnX._)(props, [
        "css"
    ]);
    const filteredProps = Object.fromEntries(Object.entries(propsWithoutCss).filter(([key])=>!key.startsWith("aria-") && key !== "role"));
    if (!shouldHideRole) return /*#__PURE__*/ (0, $loA2J.jsx)("div", (0, $6iHNw._)((0, $7Knp0._)({}, filteredProps), {
        id: panelId,
        "aria-labelledby": tabId,
        "aria-hidden": !isTabSelected,
        role: "tabpanel",
        className: (0, $esG4f.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                "tab-panel",
                activeClass
            ].join(" ")
        ]),
        children: (0, $iSvIT.Children).map(children, (child)=>{
            return (0, $kWavG.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    }));
    const cssProp = [
        !isTabSelected && !forceRender && $9a33649b5acaee05$var$hidePanelStyle
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        id: panelId,
        className: (0, $esG4f.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                "tab-panel",
                activeClass
            ].join(" ")
        ]),
        "aria-labelledby": undefined,
        "aria-hidden": undefined,
        role: undefined,
        children: (0, $iSvIT.Children).map(children, (child)=>{
            return (0, $kWavG.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    });
};
$9a33649b5acaee05$export$3d96ec278d3efce4.tabsRole = "TabPanel";

});

parcelRegister("7CBQh", function(module, exports) {

$parcel$export(module.exports, "TabsSection", function () { return $8c54ab3226897d8a$export$502de1d4d55224c1; });
/* tabs-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");
parcelRequire("62VZK");
var $cPhXv = parcelRequire("cPhXv");
var $gq8af = parcelRequire("gq8af");
var $6YaIp = parcelRequire("6YaIp");
var $bN8aD = parcelRequire("bN8aD");
const $8c54ab3226897d8a$export$502de1d4d55224c1 = ({ alignment: alignment = "start", tabsData: tabsData, tabSize: tabSize = "large", bgColor: bgColor = "bgWhite", enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false })=>{
    const sectionStyles = null;
    const fullWidthContainerStyles = null;
    const enableIconTabs = tabsData.every((tab)=>tab.iconUrl);
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        id: "tabs",
        className: (0, $esG4f.default)([
            "_1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cPhXv.Tabs), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $gq8af.DraggableTabList), {
                    tabSize: tabSize,
                    alignment: alignment,
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $6YaIp.DraggableTab), {
                            tabIndex: index,
                            title: tab.title,
                            iconUrl: enableIconTabs ? tab.iconUrl : undefined,
                            tabSize: tabSize,
                            bgColor: bgColor,
                            className: "round-tab",
                            enableRovoBorder: enableIconTabs && enableRovoBorder,
                            enableResponsiveTabSize: enableIconTabs && enableResponsiveTabSize
                        }, index))
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        tabSize === "large" && "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _1reoewfl _18m9ewfl _bozgzwfg _y4tizwfg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx",
                        "tab-panels"
                    ]),
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $bN8aD.TabPanel), {
                            panelIndex: index,
                            id: tab.id || `tab-${index}`,
                            children: tab.tabComponent
                        }, index))
                })
            ]
        })
    });
};

});





parcelRegister("7vkxP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("6q68w")).default; });

var $6q68w = parcelRequire("6q68w");

});
parcelRegister("6q68w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94975d69a8f24321$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $1UUq1 = parcelRequire("1UUq1");

var $8lB1y = parcelRequire("8lB1y");

var $3FBn4 = parcelRequire("3FBn4");
const $94975d69a8f24321$var$getBodyText = (props)=>{
    if (!props.body && !props.richText) return undefined;
    if (props.richText) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
        text: props.richText
    });
    return props.body;
};
const $94975d69a8f24321$var$UniformCard = (props)=>{
    var _props_linkUrl;
    var _props_linkUrl_toString;
    const localizedHref = (0, $3FBn4.useLocalizedHref)((_props_linkUrl_toString = (_props_linkUrl = props.linkUrl) === null || _props_linkUrl === void 0 ? void 0 : _props_linkUrl.toString()) !== null && _props_linkUrl_toString !== void 0 ? _props_linkUrl_toString : "");
    var _props_imageAlt;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Card), {
        align: props.alignment,
        orientation: props.orientation,
        columns: props.columns,
        background: props.background,
        eyebrow: props.eyebrow ? props.eyebrow : undefined,
        logo: props.logo,
        title: props.title ? props.title : undefined,
        titleAs: props.titleAs,
        body: $94975d69a8f24321$var$getBodyText(props),
        callToAction: props.linkUrl && props.linkText ? {
            text: props.linkText,
            href: localizedHref,
            dataEventProps: {
                "data-product-key": "uniform",
                "data-event-component": "linkButton",
                "data-event-container": "card",
                "data-event": "clicked"
            }
        } : undefined,
        image: props.imageUrl ? {
            image: {
                src: props.imageUrl,
                alt: (_props_imageAlt = props.imageAlt) !== null && _props_imageAlt !== void 0 ? _props_imageAlt : ""
            }
        } : undefined,
        icon: props.iconUrl ? {
            linkedIcon: {
                url: props.iconUrl,
                size: props.iconSize
            }
        } : undefined,
        spotIllustrationUrl: props.spotIllustrationUrl
    });
};
var $94975d69a8f24321$export$2e2bcd8739ae039 = $94975d69a8f24321$var$UniformCard;

});


parcelRegister("fNs39", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("fgHWA")).default; });

var $fgHWA = parcelRequire("fgHWA");

});
parcelRegister("fgHWA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bde48239d505432b$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $53lGm = parcelRequire("53lGm");

var $3FxzV = parcelRequire("3FxzV");

var $51Zx0 = parcelRequire("51Zx0");
const $bde48239d505432b$var$UniformCollectionPricingHero = (props)=>{
    if (props.collectionType === "teamwork") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $51Zx0.TeamworkCollectionPricingHero), {});
    if (props.collectionType === "strategy") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3FxzV.StrategyCollectionPricingHero), {});
    if (props.collectionType === "service") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $53lGm.ServiceCollectionPricingHero), {});
    return null;
};
var $bde48239d505432b$export$2e2bcd8739ae039 = $bde48239d505432b$var$UniformCollectionPricingHero;

});
parcelRegister("53lGm", function(module, exports) {

$parcel$export(module.exports, "ServiceCollectionPricingHero", function () { return $14ea60a252a718ba$export$5eff9997197d8e50; });

var $loA2J = parcelRequire("loA2J");

var $juk3G = parcelRequire("juk3G");
const $14ea60a252a718ba$export$5eff9997197d8e50 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $juk3G.CollectionPricingHero), {
        orientation: "vertical",
        collectionImage: {
            height: 48,
            width: 168,
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/wq7706lsya8q6fb1sj2k15h48h450ssr.svg",
            alt: "Service Collection"
        },
        products: [
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7jcq40x67167gax15ux7b27r5r575tk5.svg",
                    alt: "Jira Service Management"
                }
            },
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/466ke7l5j3i276s3p7k5660c525ru38d.svg",
                    alt: "Customer Service Management"
                }
            },
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8hgm0up275i80h6m7b5j3f8t68a7fcp4.svg",
                    alt: "Assets"
                }
            },
            {
                name: "Rovo",
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6kq772n08c357g2p82f8bnw824do06dn.svg",
                    alt: "Rovo"
                }
            }
        ]
    });
};

});

parcelRegister("3FxzV", function(module, exports) {

$parcel$export(module.exports, "StrategyCollectionPricingHero", function () { return $fda3d9fdacb70743$export$4a5cc933f6e8553a; });

var $loA2J = parcelRequire("loA2J");

var $juk3G = parcelRequire("juk3G");
const $fda3d9fdacb70743$export$4a5cc933f6e8553a = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $juk3G.CollectionPricingHero), {
        collectionImage: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5j2mvlle35t45d0e48ye5tqpoe0m63gu.svg",
            alt: "Strategy Collection"
        },
        products: [
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/hd3m515u7j3s37rldpf0dgeb7m383j4s.svg",
                    alt: "Align"
                }
            },
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/241h1u1khig63kccl1fe3hisqom3q007/fl_keep_metadata/Apps-Talent.svg",
                    alt: "Talent"
                }
            },
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/24e3l0ul76q4fpa4l2mmc7t00k202322.svg",
                    alt: "Focus"
                }
            }
        ]
    });
};

});



parcelRegister("haYnf", function(module, exports) {
$parcel$export(module.exports, "UniformColumnLayout", function () { return (parcelRequire("gVN7C")).UniformColumnLayout; });
$parcel$export(module.exports, "UniformSubColumnLayout", function () { return (parcelRequire("gVN7C")).UniformSubColumnLayout; });
parcelRequire("gVN7C");

});
parcelRegister("gVN7C", function(module, exports) {

$parcel$export(module.exports, "UniformColumnLayout", function () { return $cf835c6cfdad349b$export$23133ddca0202abb; });
$parcel$export(module.exports, "UniformSubColumnLayout", function () { return $cf835c6cfdad349b$export$8807233e43f557a9; });
/* column-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");
const $cf835c6cfdad349b$var$baseStyle = null;
const $cf835c6cfdad349b$var$fullWidthStyles = null;
const $cf835c6cfdad349b$var$layout10 = null;
const $cf835c6cfdad349b$var$layout8 = null; // For 8-4 the following is equivalent to having a 12 column grid
// where the first child is `gridColumn: 1 / span 8` and the second is `9 / -1`
const $cf835c6cfdad349b$var$layout84 = null;
const $cf835c6cfdad349b$var$layout48 = null;
const $cf835c6cfdad349b$var$layout93 = null;
const $cf835c6cfdad349b$var$layout39 = null;
const $cf835c6cfdad349b$var$layout66 = null;
const $cf835c6cfdad349b$var$layout75 = null;
const $cf835c6cfdad349b$var$layout57 = null;
const $cf835c6cfdad349b$var$layout336 = null;
const $cf835c6cfdad349b$var$layout633 = null;
const $cf835c6cfdad349b$var$layout444 = null;
const $cf835c6cfdad349b$var$layout3333 = null;
const $cf835c6cfdad349b$var$layout222222 = null;
const $cf835c6cfdad349b$var$layoutArticle = null;
const $cf835c6cfdad349b$var$resetListStyles = null;
const $cf835c6cfdad349b$var$slotWrapper = ({ items: items })=>{
    return items.map((element, index)=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)("li", {
            children: element
        }, index);
    });
}; // Compiled styling requires complex set of choices
const $cf835c6cfdad349b$export$23133ddca0202abb = ({ layout: layout = "12", paddingTopv2: paddingTopv2, paddingBottomv2: paddingBottomv2, verticalAlignment: verticalAlignment = "normal", renderAsList: renderAsList, children: children // eslint-disable-next-line complexity
 })=>{
    var _paddingTopv2_mobile, _paddingTopv2_tablet, _ref, // @ts-ignore
    _paddingTopv2_desktop, _ref1, _ref2;
    const paddingTopObject = {
        // @ts-ignore
        mobile: (_paddingTopv2_mobile = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _paddingTopv2_mobile !== void 0 ? _paddingTopv2_mobile : "0",
        // @ts-ignore
        tablet: (_ref = (_paddingTopv2_tablet = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.tablet) !== null && _paddingTopv2_tablet !== void 0 ? _paddingTopv2_tablet : paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _ref !== void 0 ? _ref : "0",
        desktop: (_ref2 = (_ref1 = (_paddingTopv2_desktop = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.desktop) !== null && _paddingTopv2_desktop !== void 0 ? _paddingTopv2_desktop : // @ts-ignore
        paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.tablet) !== null && _ref1 !== void 0 ? _ref1 : // @ts-ignore
        paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _ref2 !== void 0 ? _ref2 : "0"
    };
    var _paddingBottomv2_mobile, _paddingBottomv2_tablet, _ref3, // @ts-ignore
    _paddingBottomv2_desktop, _ref4, _ref5;
    const paddingBottomObject = {
        // @ts-ignore
        mobile: (_paddingBottomv2_mobile = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _paddingBottomv2_mobile !== void 0 ? _paddingBottomv2_mobile : "0",
        // @ts-ignore
        tablet: (_ref3 = (_paddingBottomv2_tablet = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.tablet) !== null && _paddingBottomv2_tablet !== void 0 ? _paddingBottomv2_tablet : paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _ref3 !== void 0 ? _ref3 : "0",
        desktop: (_ref5 = (_ref4 = (_paddingBottomv2_desktop = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.desktop) !== null && _paddingBottomv2_desktop !== void 0 ? _paddingBottomv2_desktop : // @ts-ignore
        paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.tablet) !== null && _ref4 !== void 0 ? _ref4 : // @ts-ignore
        paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _ref5 !== void 0 ? _ref5 : "0"
    };
    const paddingStyles = null;
    const alignmentStyles = null;
    const Container = renderAsList !== null && renderAsList !== void 0 ? renderAsList : "div";
    return /*#__PURE__*/ (0, $loA2J.jsx)(Container, {
        className: (0, $esG4f.default)([
            renderAsList && "_qtt815ep _18zridpf _1e7yidpf _go4ridpf _omn3idpf _s22yidpf _1eg6idpf _1xnlidpf _53osidpf _138kidpf",
            "_1e0c11p5 _vchhusvi _zulp14hz _1bsb1osq _1dsl1tcg _13ltwklj _1vsw1vi7 _99hyidpf",
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx",
            "_1q51aqwo _85i51jtx _1waf136c _1yd317nz _26vx1ut2 _40tu7014",
            "_4cvr1ekp",
            layout === "10" && "_1j8bcx6w _klsv179g",
            layout === "8" && "_1j8bcx6w _klsveqnf",
            layout === "8-4" && "_19smexmx _1j8b1890",
            layout === "4-8" && "_19smexmx _1j8bi0c8",
            layout === "9-3" && "_1i4gqiai _1j8b1i9f",
            layout === "3-9" && "_1i4gqiai _1j8bvfzv",
            layout === "7-5" && "_13wb12kr _1j8bkxgm",
            layout === "5-7" && "_13wb12kr _1j8bdq95",
            layout === "6-6" && "_1j8bwxkt",
            layout === "4-4-4" && "_1j8b16hb",
            layout === "3-3-3-3" && "_1j8bwxkt _1rqt1ezz",
            layout === "2-2-2-2-2-2" && "_yv0ewxkt _1j8b1g7m",
            layout === "6-3-3" && "_1i4gqiai _1j8b1jr3",
            layout === "3-3-6" && "_1i4gqiai _1j8bmdi6",
            layout === "article" && "_z9r4exmx _1rqti0c8"
        ]),
        style: {
            "--_x9jeny": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.mobile + ")"),
            "--_15jk1js": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.mobile + ")"),
            "--_d48zib": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.tablet + ")"),
            "--_8w0mk6": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.tablet + ")"),
            "--_1l28e2h": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.desktop + ")"),
            "--_14v99j0": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.desktop + ")"),
            "--_1813xhc": (0, $43MIc.default)(verticalAlignment)
        },
        children: children ? children : /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "content",
            wrapperComponent: renderAsList ? $cf835c6cfdad349b$var$slotWrapper : undefined
        })
    });
}; // Compiled styling requires complex set of choices
const $cf835c6cfdad349b$export$8807233e43f557a9 = ({ layout: layout = "12", paddingTopv2: paddingTopv2, paddingBottomv2: paddingBottomv2, verticalAlignment: verticalAlignment = "normal", renderAsList: renderAsList, children: children // eslint-disable-next-line complexity
 })=>{
    var _paddingTopv2_mobile, _paddingTopv2_tablet, _ref, // @ts-ignore
    _paddingTopv2_desktop, _ref1, _ref2;
    const paddingTopObject = {
        // @ts-ignore
        mobile: (_paddingTopv2_mobile = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _paddingTopv2_mobile !== void 0 ? _paddingTopv2_mobile : "0",
        // @ts-ignore
        tablet: (_ref = (_paddingTopv2_tablet = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.tablet) !== null && _paddingTopv2_tablet !== void 0 ? _paddingTopv2_tablet : paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _ref !== void 0 ? _ref : "0",
        desktop: (_ref2 = (_ref1 = (_paddingTopv2_desktop = paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.desktop) !== null && _paddingTopv2_desktop !== void 0 ? _paddingTopv2_desktop : // @ts-ignore
        paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.tablet) !== null && _ref1 !== void 0 ? _ref1 : // @ts-ignore
        paddingTopv2 === null || paddingTopv2 === void 0 ? void 0 : paddingTopv2.mobile) !== null && _ref2 !== void 0 ? _ref2 : "0"
    };
    var _paddingBottomv2_mobile, _paddingBottomv2_tablet, _ref3, // @ts-ignore
    _paddingBottomv2_desktop, _ref4, _ref5;
    const paddingBottomObject = {
        // @ts-ignore
        mobile: (_paddingBottomv2_mobile = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _paddingBottomv2_mobile !== void 0 ? _paddingBottomv2_mobile : "0",
        // @ts-ignore
        tablet: (_ref3 = (_paddingBottomv2_tablet = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.tablet) !== null && _paddingBottomv2_tablet !== void 0 ? _paddingBottomv2_tablet : paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _ref3 !== void 0 ? _ref3 : "0",
        // @ts-ignore
        desktop: (_ref5 = (_ref4 = (_paddingBottomv2_desktop = paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.desktop) !== null && _paddingBottomv2_desktop !== void 0 ? _paddingBottomv2_desktop : // @ts-ignore
        paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.tablet) !== null && _ref4 !== void 0 ? _ref4 : // @ts-ignore
        paddingBottomv2 === null || paddingBottomv2 === void 0 ? void 0 : paddingBottomv2.mobile) !== null && _ref5 !== void 0 ? _ref5 : "0"
    };
    const paddingStyles = null;
    const alignmentStyles = null;
    const Container = renderAsList !== null && renderAsList !== void 0 ? renderAsList : "div";
    return /*#__PURE__*/ (0, $loA2J.jsx)(Container, {
        className: (0, $esG4f.default)([
            "_1e0c11p5 _vchhusvi _zulp14hz _1bsb1osq _1dsl1tcg _13ltwklj _1vsw1vi7 _99hyidpf",
            "_1q51aqwo _85i51jtx _1waf136c _1yd317nz _26vx1ut2 _40tu7014",
            "_4cvr1ekp",
            renderAsList && "_qtt815ep _18zridpf _1e7yidpf _go4ridpf _omn3idpf _s22yidpf _1eg6idpf _1xnlidpf _53osidpf _138kidpf",
            layout === "10" && "_1j8bcx6w _klsv179g",
            layout === "8" && "_1j8bcx6w _klsveqnf",
            layout === "8-4" && "_19smexmx _1j8b1890",
            layout === "4-8" && "_19smexmx _1j8bi0c8",
            layout === "9-3" && "_1i4gqiai _1j8b1i9f",
            layout === "3-9" && "_1i4gqiai _1j8bvfzv",
            layout === "7-5" && "_13wb12kr _1j8bkxgm",
            layout === "5-7" && "_13wb12kr _1j8bdq95",
            layout === "6-6" && "_1j8bwxkt",
            layout === "4-4-4" && "_1j8b16hb",
            layout === "3-3-3-3" && "_1j8bwxkt _1rqt1ezz",
            layout === "2-2-2-2-2-2" && "_yv0ewxkt _1j8b1g7m",
            layout === "6-3-3" && "_1i4gqiai _1j8b1jr3",
            layout === "3-3-6" && "_1i4gqiai _1j8bmdi6"
        ]),
        style: {
            "--_x9jeny": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.mobile + ")"),
            "--_15jk1js": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.mobile + ")"),
            "--_d48zib": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.tablet + ")"),
            "--_8w0mk6": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.tablet + ")"),
            "--_1l28e2h": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.desktop + ")"),
            "--_14v99j0": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.desktop + ")"),
            "--_1813xhc": (0, $43MIc.default)(verticalAlignment)
        },
        children: children ? children : /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "content",
            wrapperComponent: renderAsList ? $cf835c6cfdad349b$var$slotWrapper : undefined
        })
    });
}; // Both components are exported as named exports above

});


parcelRegister("jMHQc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("jiwkx")).default; });

var $jiwkx = parcelRequire("jiwkx");

});
parcelRegister("jiwkx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5443937a92fde21e$export$2e2bcd8739ae039; });
/* confluence-animated-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $2bAHw = parcelRequire("2bAHw");

var $aiugz = parcelRequire("aiugz");

var $f6qj2 = parcelRequire("f6qj2");

var $gF60T = parcelRequire("gF60T");

var $7ShLR = parcelRequire("7ShLR");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
const $5443937a92fde21e$var$sectionCss = null;
const $5443937a92fde21e$var$cardContainerCss = null;
const $5443937a92fde21e$var$cardCss = null;
const $5443937a92fde21e$var$cardTextCss = null;
const $5443937a92fde21e$var$cardHeadingCss = null;
const $5443937a92fde21e$var$cardBodyTextCss = null;
const $5443937a92fde21e$var$controlButtonStyles = null;
const $5443937a92fde21e$var$videoContainerCss = null;
const $5443937a92fde21e$export$235b37640a653467 = ({ title: title, bodytext: bodytext, image: image, altText: altText })=>{
    const videoRef = (0, $iSvIT.useRef)(null);
    const [isPlaying, setPlaying] = (0, $iSvIT.useState)(false);
    const intl = (0, $f6qj2.default)();
    const prefersReducedMotion = typeof window !== "undefined" ? window.matchMedia("(prefers-reduced-motion: reduce)").matches : false;
    const togglePlay = ()=>{
        if (videoRef.current) {
            if (isPlaying) videoRef.current.pause();
            else videoRef.current.play().catch(()=>{});
        }
    };
    const handleVideoPlay = ()=>setPlaying(true);
    const handleVideoPause = ()=>setPlaying(false);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp7vkz _kqswh2mm _1k9hgrho _1mj31wqb _162p1nty _1xjr1nty _1scc1gha _1nr41gha _1axucs5v _15z31nut _hauj1nut _188c150m _y5pt150m _11za1o02 _1rgq1o02 _tnzz120m _s118120m _ikf21klr _18zx1klr _zcbv1osq _mezj1osq _12l01wug _bna71wug _eq9p15vq _pzs515vq _175j15vq _dknm15vq _1gbl1wug _1cr61wug _qpgx1wug _1hlx1wug _1d2pidpf _1874idpf _s93b1wug _10ew1wug _1th61xym _k9x81xym _1wi11m52 _1biu1m52 _ldg0vwyg _dzwgvwyg _8wcmcd5j _d3lpcd5j _1dhb1cd0 _t1ov1cd0 _1sdaagmp _ktt3agmp",
            "single-hero-card"
        ]),
        style: {
            "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: "text-container",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_gxfkidpf _tfg1idpf _16yqidpf _15zyidpf _14dwidpf _1u6jidpf _1ikgidpf _1p3yidpf _1niwidpf _a15ridpf _12k0idpf _1fx6idpf _104aidpf _10pqidpf _5ybeidpf _1avnidpf _1cmpidpf _174lidpf _tlu6idpf _kopkidpf _4s33idpf _lychidpf _zzhoidpf _x9vnidpf _65gh10nf _18ko10nf _17ie10nf _1dlt10nf _1t9o10nf _1x5u10nf _1g4p1ejb _1l3z1ejb _1qkw1ejb _8znu1ejb _vh191ejb _ret01ejb _kgcl1nn1 _1m1k1nn1 _b08d1nn1 _1bau1nn1 _zmdp1nn1 _1r881nn1",
                            "_kdam16zr _19pkidpf _2hwxidpf _otyr1kwk _18u0idpf _v5644yh6 _pxcp4jg8 _60qani7l _1kpj1qqw",
                            "card-text card-heading"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformRichTextNode), {
                            node: title["root"] || title
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1axaidpf _420lidpf _195sidpf _thjjidpf _jhbppxbi _1yq31k8s _zcsk1nn1",
                            "_kdam16zr _19pkidpf _2hwxidpf _otyr1kwk _18u0idpf _v5644yh6 _pxcp4jg8 _60qani7l _1kpj1qqw",
                            "card-text card-body"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformRichTextNode), {
                            node: bodytext["root"] || bodytext
                        })
                    })
                ]
            }),
            image.includes(".mp4") ? /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _npsn1dfr _1y2k1osq _z18o1osq",
                    "imagery video video-container"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("video", {
                        ref: videoRef,
                        src: image,
                        autoPlay: !prefersReducedMotion,
                        muted: true,
                        loop: true,
                        playsInline: true,
                        onPlay: handleVideoPlay,
                        onPause: handleVideoPause,
                        onLoadedMetadata: ()=>{
                            if (videoRef.current && !prefersReducedMotion) videoRef.current.play().catch(()=>{}); // autoplay by default but if browser restrictions prevent it button will show in play state
                        }
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                        className: (0, $esG4f.default)([
                            "_80omtlke _tzy41ou4 _bfhk1j28 _syazcd5j _19it1axk _2rko17td _4t3i1ul9 _1bsb1ul9 _1e0c1txw _4cvr1h6o _1bah1h6o _kqswstnw _1pbyegat _rjxppxbi _u7co1jfw _16l4kb7n _w8l5dlk8",
                            "control-button"
                        ]),
                        onClick: togglePlay,
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                            "--_514je1": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.pill"))
                        },
                        children: isPlaying ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gF60T))), {
                            label: intl.formatMessage({
                                id: "uniform-video.pause",
                                defaultMessage: "Pause"
                            })
                        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7ShLR))), {
                            label: intl.formatMessage({
                                id: "uniform-video.play",
                                defaultMessage: "Play"
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                src: image,
                alt: altText
            })
        ]
    });
};
const $5443937a92fde21e$var$UniformConfluenceAnimatedHero = ({ confluenceHeroCards: confluenceHeroCards, imagesWidth: imagesWidth, imagesHeight: imagesHeight, flattenData: flattenData = true })=>{
    if (flattenData) confluenceHeroCards = (0, $2bAHw.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    confluenceHeroCards);
    const [inview, setInview] = (0, $iSvIT.useState)(false);
    const [hasScrolled, setHasScrolled] = (0, $iSvIT.useState)(false);
    const [moveUpValue, setMoveUpValue] = (0, $iSvIT.useState)(120);
    const containerRef = (0, $iSvIT.useRef)(null);
    (0, $iSvIT.useEffect)(()=>{
        const handleScroll = ()=>{
            if (window.scrollY <= 50) {
                setInview(false);
                setHasScrolled(false);
                return;
            } else setHasScrolled(true);
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    (0, $iSvIT.useEffect)(()=>{
        if (!hasScrolled || !containerRef.current) return;
        const io = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) setInview(true);
            });
        }, {
            threshold: 0.5
        });
        io.observe(containerRef.current);
        return ()=>{
            io.disconnect();
        };
    }, [
        hasScrolled
    ]);
    (0, $iSvIT.useEffect)(()=>{
        var _document_fonts_ready, _document_fonts, _document;
        const updateMoveUpValue = ()=>{
            if (!containerRef.current) return;
            const textContainers = containerRef.current.querySelectorAll(".text-container");
            let maxHeight = 0;
            textContainers.forEach((container)=>{
                const height = container.offsetHeight;
                maxHeight = Math.max(maxHeight, height);
            });
            const calculatedMoveUp = maxHeight + 16;
            setMoveUpValue(calculatedMoveUp);
        };
        const timeoutId = setTimeout(updateMoveUpValue, 100);
        (_document = document) === null || _document === void 0 ? void 0 : (_document_fonts = _document.fonts) === null || _document_fonts === void 0 ? void 0 : (_document_fonts_ready = _document_fonts.ready) === null || _document_fonts_ready === void 0 ? void 0 : _document_fonts_ready.then(updateMoveUpValue);
        window.addEventListener("resize", updateMoveUpValue);
        return ()=>{
            clearTimeout(timeoutId);
            window.removeEventListener("resize", updateMoveUpValue);
        };
    }, []);
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_11q71ybm _v5641r9r _lwq31qpa _ia4wwomy _mbuvwomy",
            "scroll-hero" + (inview ? " inview" : " outview")
        ]),
        style: {
            "--moveup": `-${moveUpValue}px`,
            "--imagesWidth": imagesWidth,
            "--imagesHeight": imagesHeight,
            "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            ref: containerRef,
            className: (0, $esG4f.default)([
                "_1e0c11p5 _1bsb1osq _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _bozgzwfg _y4tizwfg _zulp14hz _1dsl1tcg _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx _1vsw1vi7 _1j8b16hb _1wafpxbi _1bah1h6o _1ojfg8ja _3qvcg8ja _1utg36zz _1fjs36zz _12n71qqw _xlt1xncg _131yxncg _bkwyglyw _xon5glyw _128dglyw _q8ukglyw _4y3qglyw _uzo21qqw",
                inview ? "inview" : "outview"
            ]),
            style: {
                "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card"))
            },
            children: confluenceHeroCards.map((card, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($5443937a92fde21e$export$235b37640a653467, {
                    title: card.cardTitle,
                    bodytext: card.cardDescription,
                    image: card.cardImageOrVideo,
                    altText: card.cardImageAlt
                }, index))
        })
    });
};
var $5443937a92fde21e$export$2e2bcd8739ae039 = $5443937a92fde21e$var$UniformConfluenceAnimatedHero;

});


parcelRegister("kuzIk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("gGkrX")).default; });

var $gGkrX = parcelRequire("gGkrX");

});
parcelRegister("gGkrX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f3e06674b05ade7$export$2e2bcd8739ae039; });
/* connector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $2bAHw = parcelRequire("2bAHw");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("haYnf");
var $gVN7C = parcelRequire("gVN7C");

var $icTgC = parcelRequire("icTgC");

var $lKfOm = parcelRequire("lKfOm");
const $2f3e06674b05ade7$var$UniformConnector = ({ title: title, text: text, linkText: linkText, linkHref: linkHref, customerQuotes: customerQuotes, mobileLogos: mobileLogos, tabletLogos: tabletLogos, desktopLogos: desktopLogos, flattenData: flattenData = true })=>{
    if (flattenData) {
        customerQuotes = (0, $2bAHw.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        customerQuotes); // eslint-disable-next-line @typescript-eslint/no-explicit-any
        mobileLogos = (0, $2bAHw.flattenValues)(mobileLogos); // eslint-disable-next-line @typescript-eslint/no-explicit-any
        tabletLogos = (0, $2bAHw.flattenValues)(tabletLogos); // eslint-disable-next-line @typescript-eslint/no-explicit-any
        desktopLogos = (0, $2bAHw.flattenValues)(desktopLogos);
    }
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1rjc1epz _bfhk1hlo _1e0c1txw _2lx21bp4 _zulpoahv"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $gVN7C.UniformColumnLayout), {
                layout: "5-7",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_cg41cd5j _125xcd5j _xsmr1h6o",
                            "contentBlock"
                        ]),
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                        },
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                className: (0, $esG4f.default)([
                                    "_1pfhxy5q _6rthu2gc _476dze3t"
                                ]),
                                children: title
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                className: (0, $esG4f.default)([
                                    "_1mouze3t"
                                ]),
                                children: text
                            }),
                            linkText && linkHref && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1pfh1ejb _6rthxy5q _srwz1ejb"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                    text: linkText,
                                    href: linkHref,
                                    type: "primary",
                                    bgColor: "bgBlackBlue"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $icTgC.CustomerQuoteCarousel), {
                        customerQuotes: customerQuotes
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $lKfOm.LogosMarquee), {
                mobileLogos: mobileLogos,
                tabletLogos: tabletLogos,
                desktopLogos: desktopLogos
            })
        ]
    });
};
var $2f3e06674b05ade7$export$2e2bcd8739ae039 = $2f3e06674b05ade7$var$UniformConnector;
const $2f3e06674b05ade7$var$containerCss = null;
const $2f3e06674b05ade7$var$lightTextCss = null;
const $2f3e06674b05ade7$var$titleCss = null;
const $2f3e06674b05ade7$var$textCss = null;
const $2f3e06674b05ade7$var$linkCss = null;

});
parcelRegister("icTgC", function(module, exports) {

$parcel$export(module.exports, "CustomerQuoteCarousel", function () { return $7dc39b09f5bfce5f$export$abab76d12bbd8406; });
/* customer-quote-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $c9BrD = parcelRequire("c9BrD");

var $eAfof = parcelRequire("eAfof");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
const $7dc39b09f5bfce5f$var$messages = {
    previousSlide: {
        id: "customer-quote-carousel.previous-slide",
        defaultMessage: "Previous slide"
    },
    nextSlide: {
        id: "customer-quote-carousel.previous-slide",
        defaultMessage: "Previous slide"
    }
};
const $7dc39b09f5bfce5f$export$abab76d12bbd8406 = ({ customerQuotes: customerQuotes })=>{
    const [activeQuoteIndex, setactiveQuoteIndex] = (0, $iSvIT.useState)(0);
    const prevSlide = ()=>{
        if (activeQuoteIndex > 0) setactiveQuoteIndex(activeQuoteIndex - 1);
    };
    const nextSlide = ()=>{
        if (activeQuoteIndex < customerQuotes.length - 1) setactiveQuoteIndex(activeQuoteIndex + 1);
    };
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c11p5 _4t3i1ns9"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                "aria-hidden": true,
                className: (0, $esG4f.default)([
                    "_nd5lgbua",
                    "_1yt4xy5q _15tx1ejb"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c11p5 _4t3i1ns9",
                        "_1q5188uy"
                    ]),
                    children: customerQuotes.map((customerQuote, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_nd5lgbua",
                                "_3um015vq",
                                "_tfwpidpf"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.PullQuote), {
                                quote: customerQuote.quote,
                                authorName: customerQuote.advocateName,
                                authorDetails: customerQuote.advocateJobTitle
                            })
                        }, index))
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_2rkovwyg _bfhk1nc2 _1yt4xy5q _4t3i1ns9 _1e0c1txw _2lx21bp4 _zulp1ejb _15tx1ejb",
                    "_cg4111ib _125x11ib _1tjq11ib",
                    "_nd5lgbua"
                ]),
                style: {
                    "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
                    "--_yrk0lp": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark100")),
                    "--_44ufl2": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark1000"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _1bah1yb4 _4cvr1h6o"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c11p5 _4t3i1ns9"
                                ]),
                                children: customerQuotes.map(({ companyLogo: companyLogo }, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        "aria-hidden": index !== activeQuoteIndex,
                                        className: (0, $esG4f.default)([
                                            "_nd5lgbua _3um015tv _1bsb11ux _4t3i1ylp"
                                        ]),
                                        style: {
                                            "--_neqv2r": (0, $43MIc.default)(index === activeQuoteIndex ? "visible" : "hidden")
                                        },
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image // @ts-ignore
                                        ), {
                                            src: companyLogo[0].src,
                                            alt: companyLogo[0].alt,
                                            style: {
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain",
                                                objectPosition: "left"
                                            }
                                        })
                                    }, index))
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _4cvr1h6o _zulputpp"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                        onClick: prevSlide,
                                        disabled: activeQuoteIndex === 0,
                                        "aria-label": intl.formatMessage($7dc39b09f5bfce5f$var$messages.previousSlide),
                                        className: (0, $esG4f.default)([
                                            "_4t3i1ady _1bsb1ady _bfhk1j28 _19itglyw _2rko1osq _d0altlke _1x1a73ad _v42d73ad _1tc8pmk4 _64781yg0"
                                        ]),
                                        style: {
                                            "--_1ljptrt": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light1000")),
                                            "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
                                        },
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_4t3izwfg _1bsbzwfg _bfhkzwk4 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31io3"
                                            ]),
                                            style: {
                                                "--_qeag6c": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark400")),
                                                "--_138lqrp": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark500"))
                                            },
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c9BrD))), {
                                                label: intl.formatMessage($7dc39b09f5bfce5f$var$messages.previousSlide)
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        className: (0, $esG4f.default)([
                                            "_cg4111ib _125x11ib _1tjq11ib",
                                            "_1bsb183y _1mouidpf"
                                        ]),
                                        style: {
                                            "--_44ufl2": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark1000"))
                                        },
                                        children: `${activeQuoteIndex + 1}/${customerQuotes.length}`
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                        onClick: nextSlide,
                                        disabled: activeQuoteIndex === customerQuotes.length - 1,
                                        "aria-label": intl.formatMessage($7dc39b09f5bfce5f$var$messages.nextSlide),
                                        className: (0, $esG4f.default)([
                                            "_4t3i1ady _1bsb1ady _bfhk1j28 _19itglyw _2rko1osq _d0altlke _1x1a73ad _v42d73ad _1tc8pmk4 _64781yg0"
                                        ]),
                                        style: {
                                            "--_1ljptrt": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light1000")),
                                            "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
                                        },
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_4t3izwfg _1bsbzwfg _bfhkzwk4 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31io3"
                                            ]),
                                            style: {
                                                "--_qeag6c": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark400")),
                                                "--_138lqrp": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark500"))
                                            },
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eAfof))), {
                                                label: intl.formatMessage($7dc39b09f5bfce5f$var$messages.nextSlide)
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c11p5 _4t3i1ns9",
                            "_tfwpidpf"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.PullQuote // @ts-ignore
                        ), {
                            quote: customerQuotes[activeQuoteIndex].quote,
                            authorName: // @ts-ignore
                            customerQuotes[activeQuoteIndex].advocateName,
                            authorDetails: // @ts-ignore
                            customerQuotes[activeQuoteIndex].advocateJobTitle
                        })
                    })
                ]
            })
        ]
    });
};
const $7dc39b09f5bfce5f$var$lightTextCss = null;
const $7dc39b09f5bfce5f$var$carouselContainerCss = null;
const $7dc39b09f5bfce5f$var$logoAndButtonContainerCss = null;
const $7dc39b09f5bfce5f$var$gridCss = null;
const $7dc39b09f5bfce5f$var$overlapGridItemCss = null;
const $7dc39b09f5bfce5f$var$buttonsContainerCss = null;
const $7dc39b09f5bfce5f$var$slideNumberCss = null;
const $7dc39b09f5bfce5f$var$buttonCss = null;
const $7dc39b09f5bfce5f$var$chevronCirlceCss = null;
const $7dc39b09f5bfce5f$var$hiddenCarouselContainerCss = null;
const $7dc39b09f5bfce5f$var$hiddenQuoteCss = null;
const $7dc39b09f5bfce5f$var$visibilityHiddenCss = null;
const $7dc39b09f5bfce5f$var$overrideQuotePadding = null;

});

parcelRegister("lKfOm", function(module, exports) {

$parcel$export(module.exports, "LogosMarquee", function () { return $b383584eb4fcfdf4$export$143c39d1bfa1977e; });
/* logos-marquee.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $gF60T = parcelRequire("gF60T");

var $7ShLR = parcelRequire("7ShLR");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("haYnf");
var $gVN7C = parcelRequire("gVN7C");
const $b383584eb4fcfdf4$var$Logo = ({ src: src, href: href, alt: alt, ariaHidden: ariaHidden, tabIndex: tabIndex })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("li", {
        "aria-hidden": ariaHidden,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
            href: href,
            tabIndex: tabIndex,
            className: (0, $esG4f.default)([
                "_1e0c1txw _bfhk1nc2 _2rkovwyg _irr3gc2p"
            ]),
            style: {
                "--_yrk0lp": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark100")),
                "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
                "--_1jncskl": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark300"))
            },
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4t3i1wqb _1bsb1wqb _19pk19bv _2hwx19bv _otyr19bv _18u019bv"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: src,
                    alt: alt,
                    style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "contain"
                    }
                })
            })
        })
    });
};
const $b383584eb4fcfdf4$export$143c39d1bfa1977e = ({ mobileLogos: mobileLogos, tabletLogos: tabletLogos, desktopLogos: desktopLogos })=>{
    const [running, setRunning] = (0, $iSvIT.useState)(true);
    tabletLogos = (tabletLogos === null || tabletLogos === void 0 ? void 0 : tabletLogos.length) === 0 ? desktopLogos : tabletLogos;
    mobileLogos = (mobileLogos === null || mobileLogos === void 0 ? void 0 : mobileLogos.length) === 0 ? desktopLogos : mobileLogos; // @ts-ignore
    const mobileLogosLength = mobileLogos.length; // @ts-ignore
    const tabletLogosLength = tabletLogos.length;
    const desktopLogosLength = desktopLogos.length;
    mobileLogos = [
        // @ts-ignore
        ...mobileLogos,
        ...mobileLogos,
        ...mobileLogos,
        ...mobileLogos
    ];
    tabletLogos = [
        ...tabletLogos,
        ...tabletLogos,
        ...tabletLogos,
        ...tabletLogos
    ];
    desktopLogos = [
        ...desktopLogos,
        ...desktopLogos,
        ...desktopLogos,
        ...desktopLogos
    ];
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1reo15vq _18m915vq _kqswh2mm _1e0c1txw _2lx21bp4 _zulputpp"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $gVN7C.UniformColumnLayout), {
                layout: "12",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1bsb1osq _1e0c1txw _1bahh9n0"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                        onClick: ()=>setRunning((r)=>!r),
                        className: (0, $esG4f.default)([
                            "_4t3i1ady _1bsb1ady _bfhk1j28 _19itglyw _2rko1osq _d0altlke"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_4t3izwfg _1bsbzwfg _bfhkzwk4 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31io3 _1tjq11ib"
                            ]),
                            style: {
                                "--_qeag6c": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark400")),
                                "--_138lqrp": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark500")),
                                "--_44ufl2": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark1000"))
                            },
                            children: running ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gF60T))), {
                                label: intl.formatMessage({
                                    id: "connector-logo-marquee.pause",
                                    defaultMessage: "Pause"
                                })
                            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7ShLR))), {
                                label: intl.formatMessage({
                                    id: "connector-logo-marquee.play",
                                    defaultMessage: "Play"
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1bsb1osq _p12f1s5k _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1reo15vq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                        className: (0, $esG4f.default)([
                            "_1bsb1osq _o5721q9c",
                            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _zulpv47k _1bsb1ns9",
                            "_y44vc8cz _1y0c4ukn",
                            "_16uvtrqk",
                            "_181nglyw"
                        ]),
                        style: {
                            "--_1ikxs8u": (0, $43MIc.default)(running ? "running" : "paused")
                        },
                        children: mobileLogos.map((logo, index)=>{
                            const isOriginal = index < mobileLogosLength;
                            return /*#__PURE__*/ (0, $loA2J.jsx)($b383584eb4fcfdf4$var$Logo, (0, $7Knp0._)({
                                ariaHidden: !isOriginal,
                                tabIndex: isOriginal ? 0 : -1
                            }, logo), index);
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                        className: (0, $esG4f.default)([
                            "_1bsb1osq _o5721q9c",
                            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _zulpv47k _1bsb1ns9",
                            "_y44v7abo _1y0c4ukn",
                            "_16uvtrqk",
                            "_dm25glyw _sugaglyw"
                        ]),
                        style: {
                            "--_1ikxs8u": (0, $43MIc.default)(running ? "running" : "paused")
                        },
                        children: tabletLogos.map((logo, index)=>{
                            const isOriginal = index < tabletLogosLength;
                            return /*#__PURE__*/ (0, $loA2J.jsx)($b383584eb4fcfdf4$var$Logo, (0, $7Knp0._)({
                                ariaHidden: !isOriginal,
                                tabIndex: isOriginal ? 0 : -1
                            }, logo), index);
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                        className: (0, $esG4f.default)([
                            "_1bsb1osq _o5721q9c",
                            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _zulpv47k _1bsb1ns9",
                            "_y44vhu9l _1y0c4ukn",
                            "_16uvtrqk",
                            "_1mjbglyw"
                        ]),
                        style: {
                            "--_1ikxs8u": (0, $43MIc.default)(running ? "running" : "paused")
                        },
                        children: desktopLogos.map((logo, index)=>{
                            const isOriginal = index < desktopLogosLength;
                            return /*#__PURE__*/ (0, $loA2J.jsx)($b383584eb4fcfdf4$var$Logo, (0, $7Knp0._)({
                                ariaHidden: !isOriginal,
                                tabIndex: isOriginal ? 0 : -1
                            }, logo), index);
                        })
                    })
                ]
            })
        ]
    });
};
const $b383584eb4fcfdf4$var$linkCss = null;
const $b383584eb4fcfdf4$var$logoCss = null;
const $b383584eb4fcfdf4$var$listCss = null;
const $b383584eb4fcfdf4$var$marqueeContainerCss = null;
const $b383584eb4fcfdf4$var$marqueeButtonContainerCss = null;
const $b383584eb4fcfdf4$var$marqueeButtonCss = null;
const $b383584eb4fcfdf4$var$buttonCirlceCss = null;
const $b383584eb4fcfdf4$var$listContainerCss = null;
const $b383584eb4fcfdf4$var$animationKeyframesCss = null;
const $b383584eb4fcfdf4$var$pauseOnHoverCss = null;
const $b383584eb4fcfdf4$var$desktopCss = null;
const $b383584eb4fcfdf4$var$tabletCss = null;
const $b383584eb4fcfdf4$var$mobileCss = null;

});



parcelRegister("hQud5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("jgBDg")).default; });

var $jgBDg = parcelRequire("jgBDg");

});
parcelRegister("jgBDg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af65450661bcb715$export$2e2bcd8739ae039; });
/* container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");

var $5ohHq = parcelRequire("5ohHq");

var $8lB1y = parcelRequire("8lB1y");

var $bpp2j = parcelRequire("bpp2j");

var $gAJUc = parcelRequire("gAJUc");

var $ccYBS = parcelRequire("ccYBS");
const $af65450661bcb715$var$UniformContainer = ({ spacing: spacing, horizontalAlignment: horizontalAlignment = "default", verticalAlignment: verticalAlignment = "default", orientation: orientation = {
    mobile: "vertical"
}, gapv2: gapv2 = {
    mobile: "0"
}, hat: hat, pants: pants, backgroundColor: backgroundColor, extendBackgroundColor: extendBackgroundColor, sticky: sticky = false, responsiveHiding: responsiveHiding, overflow: overflow = "visible", label: label // eslint-disable-next-line complexity
 })=>{
    var _composition_data, _spacing_mobile, _spacing_mobile1, _spacing_mobile2, _spacing_mobile3, _spacing_mobile4, _spacing_mobile5, _spacing_mobile6, _spacing_mobile7, _spacing_tablet, _spacing_mobile8, _spacing_tablet1, _spacing_mobile9, _spacing_tablet2, _spacing_mobile10, _spacing_tablet3, _spacing_mobile11, _spacing_tablet4, _spacing_mobile12, _spacing_tablet5, _spacing_mobile13, _spacing_tablet6, _spacing_mobile14, _spacing_tablet7, _spacing_mobile15, _spacing_desktop, _spacing_tablet8, _spacing_mobile16, _spacing_desktop1, _spacing_tablet9, _spacing_mobile17, _spacing_desktop2, _spacing_tablet10, _spacing_mobile18, _spacing_desktop3, _spacing_tablet11, _spacing_mobile19, _spacing_desktop4, _spacing_tablet12, _spacing_mobile20, _spacing_desktop5, _spacing_tablet13, _spacing_mobile21, _spacing_desktop6, _spacing_tablet14, _spacing_mobile22, _spacing_desktop7, _spacing_tablet15, _spacing_mobile23;
    const composition = (0, $aiugz.useUniformCurrentComposition)();
    const compositionId = composition === null || composition === void 0 ? void 0 : (_composition_data = composition.data) === null || _composition_data === void 0 ? void 0 : _composition_data._id;
    const tracker = (0, $ccYBS.useScrollTracking)(label !== null && label !== void 0 ? label : "", {
        dwellTimeEnabled: true,
        additionalAttributes: {
            compositionId: compositionId
        }
    });
    var _spacing_mobile_marginTop, _spacing_mobile_marginBottom, _spacing_mobile_marginLeft, _spacing_mobile_marginRight, _spacing_mobile_paddingTop, _spacing_mobile_paddingBottom, _spacing_mobile_paddingLeft, _spacing_mobile_paddingRight, _spacing_tablet_marginTop, _ref, _spacing_tablet_marginBottom, _ref1, _spacing_tablet_marginLeft, _ref2, _spacing_tablet_marginRight, _ref3, _spacing_tablet_paddingTop, _ref4, _spacing_tablet_paddingBottom, _ref5, _spacing_tablet_paddingLeft, _ref6, _spacing_tablet_paddingRight, _ref7, _spacing_desktop_marginTop, _ref8, _ref9, _spacing_desktop_marginBottom, _ref10, _ref11, _spacing_desktop_marginLeft, _ref12, _ref13, _spacing_desktop_marginRight, _ref14, _ref15, _spacing_desktop_paddingTop, _ref16, _ref17, _spacing_desktop_paddingBottom, _ref18, _ref19, _spacing_desktop_paddingLeft, _ref20, _ref21, _spacing_desktop_paddingRight, _ref22, _ref23;
    const spacingObject = {
        mobile: {
            marginTop: (_spacing_mobile_marginTop = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile = spacing.mobile) === null || _spacing_mobile === void 0 ? void 0 : _spacing_mobile.marginTop) !== null && _spacing_mobile_marginTop !== void 0 ? _spacing_mobile_marginTop : "0",
            marginBottom: (_spacing_mobile_marginBottom = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile1 = spacing.mobile) === null || _spacing_mobile1 === void 0 ? void 0 : _spacing_mobile1.marginBottom) !== null && _spacing_mobile_marginBottom !== void 0 ? _spacing_mobile_marginBottom : "0",
            marginLeft: (_spacing_mobile_marginLeft = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile2 = spacing.mobile) === null || _spacing_mobile2 === void 0 ? void 0 : _spacing_mobile2.marginLeft) !== null && _spacing_mobile_marginLeft !== void 0 ? _spacing_mobile_marginLeft : "0",
            marginRight: (_spacing_mobile_marginRight = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile3 = spacing.mobile) === null || _spacing_mobile3 === void 0 ? void 0 : _spacing_mobile3.marginRight) !== null && _spacing_mobile_marginRight !== void 0 ? _spacing_mobile_marginRight : "0",
            paddingTop: (_spacing_mobile_paddingTop = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile4 = spacing.mobile) === null || _spacing_mobile4 === void 0 ? void 0 : _spacing_mobile4.paddingTop) !== null && _spacing_mobile_paddingTop !== void 0 ? _spacing_mobile_paddingTop : "0",
            paddingBottom: (_spacing_mobile_paddingBottom = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile5 = spacing.mobile) === null || _spacing_mobile5 === void 0 ? void 0 : _spacing_mobile5.paddingBottom) !== null && _spacing_mobile_paddingBottom !== void 0 ? _spacing_mobile_paddingBottom : "0",
            paddingLeft: (_spacing_mobile_paddingLeft = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile6 = spacing.mobile) === null || _spacing_mobile6 === void 0 ? void 0 : _spacing_mobile6.paddingLeft) !== null && _spacing_mobile_paddingLeft !== void 0 ? _spacing_mobile_paddingLeft : "0",
            paddingRight: (_spacing_mobile_paddingRight = spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile7 = spacing.mobile) === null || _spacing_mobile7 === void 0 ? void 0 : _spacing_mobile7.paddingRight) !== null && _spacing_mobile_paddingRight !== void 0 ? _spacing_mobile_paddingRight : "0"
        },
        tablet: {
            marginTop: (_ref = (_spacing_tablet_marginTop = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet = spacing.tablet) === null || _spacing_tablet === void 0 ? void 0 : _spacing_tablet.marginTop) !== null && _spacing_tablet_marginTop !== void 0 ? _spacing_tablet_marginTop : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile8 = spacing.mobile) === null || _spacing_mobile8 === void 0 ? void 0 : _spacing_mobile8.marginTop) !== null && _ref !== void 0 ? _ref : "0",
            marginBottom: (_ref1 = (_spacing_tablet_marginBottom = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet1 = spacing.tablet) === null || _spacing_tablet1 === void 0 ? void 0 : _spacing_tablet1.marginBottom) !== null && _spacing_tablet_marginBottom !== void 0 ? _spacing_tablet_marginBottom : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile9 = spacing.mobile) === null || _spacing_mobile9 === void 0 ? void 0 : _spacing_mobile9.marginBottom) !== null && _ref1 !== void 0 ? _ref1 : "0",
            marginLeft: (_ref2 = (_spacing_tablet_marginLeft = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet2 = spacing.tablet) === null || _spacing_tablet2 === void 0 ? void 0 : _spacing_tablet2.marginLeft) !== null && _spacing_tablet_marginLeft !== void 0 ? _spacing_tablet_marginLeft : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile10 = spacing.mobile) === null || _spacing_mobile10 === void 0 ? void 0 : _spacing_mobile10.marginLeft) !== null && _ref2 !== void 0 ? _ref2 : "0",
            marginRight: (_ref3 = (_spacing_tablet_marginRight = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet3 = spacing.tablet) === null || _spacing_tablet3 === void 0 ? void 0 : _spacing_tablet3.marginRight) !== null && _spacing_tablet_marginRight !== void 0 ? _spacing_tablet_marginRight : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile11 = spacing.mobile) === null || _spacing_mobile11 === void 0 ? void 0 : _spacing_mobile11.marginRight) !== null && _ref3 !== void 0 ? _ref3 : "0",
            paddingTop: (_ref4 = (_spacing_tablet_paddingTop = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet4 = spacing.tablet) === null || _spacing_tablet4 === void 0 ? void 0 : _spacing_tablet4.paddingTop) !== null && _spacing_tablet_paddingTop !== void 0 ? _spacing_tablet_paddingTop : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile12 = spacing.mobile) === null || _spacing_mobile12 === void 0 ? void 0 : _spacing_mobile12.paddingTop) !== null && _ref4 !== void 0 ? _ref4 : "0",
            paddingBottom: (_ref5 = (_spacing_tablet_paddingBottom = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet5 = spacing.tablet) === null || _spacing_tablet5 === void 0 ? void 0 : _spacing_tablet5.paddingBottom) !== null && _spacing_tablet_paddingBottom !== void 0 ? _spacing_tablet_paddingBottom : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile13 = spacing.mobile) === null || _spacing_mobile13 === void 0 ? void 0 : _spacing_mobile13.paddingBottom) !== null && _ref5 !== void 0 ? _ref5 : "0",
            paddingLeft: (_ref6 = (_spacing_tablet_paddingLeft = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet6 = spacing.tablet) === null || _spacing_tablet6 === void 0 ? void 0 : _spacing_tablet6.paddingLeft) !== null && _spacing_tablet_paddingLeft !== void 0 ? _spacing_tablet_paddingLeft : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile14 = spacing.mobile) === null || _spacing_mobile14 === void 0 ? void 0 : _spacing_mobile14.paddingLeft) !== null && _ref6 !== void 0 ? _ref6 : "0",
            paddingRight: (_ref7 = (_spacing_tablet_paddingRight = spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet7 = spacing.tablet) === null || _spacing_tablet7 === void 0 ? void 0 : _spacing_tablet7.paddingRight) !== null && _spacing_tablet_paddingRight !== void 0 ? _spacing_tablet_paddingRight : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile15 = spacing.mobile) === null || _spacing_mobile15 === void 0 ? void 0 : _spacing_mobile15.paddingRight) !== null && _ref7 !== void 0 ? _ref7 : "0"
        },
        desktop: {
            marginTop: (_ref9 = (_ref8 = (_spacing_desktop_marginTop = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop = spacing.desktop) === null || _spacing_desktop === void 0 ? void 0 : _spacing_desktop.marginTop) !== null && _spacing_desktop_marginTop !== void 0 ? _spacing_desktop_marginTop : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet8 = spacing.tablet) === null || _spacing_tablet8 === void 0 ? void 0 : _spacing_tablet8.marginTop) !== null && _ref8 !== void 0 ? _ref8 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile16 = spacing.mobile) === null || _spacing_mobile16 === void 0 ? void 0 : _spacing_mobile16.marginTop) !== null && _ref9 !== void 0 ? _ref9 : "0",
            marginBottom: (_ref11 = (_ref10 = (_spacing_desktop_marginBottom = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop1 = spacing.desktop) === null || _spacing_desktop1 === void 0 ? void 0 : _spacing_desktop1.marginBottom) !== null && _spacing_desktop_marginBottom !== void 0 ? _spacing_desktop_marginBottom : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet9 = spacing.tablet) === null || _spacing_tablet9 === void 0 ? void 0 : _spacing_tablet9.marginBottom) !== null && _ref10 !== void 0 ? _ref10 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile17 = spacing.mobile) === null || _spacing_mobile17 === void 0 ? void 0 : _spacing_mobile17.marginBottom) !== null && _ref11 !== void 0 ? _ref11 : "0",
            marginLeft: (_ref13 = (_ref12 = (_spacing_desktop_marginLeft = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop2 = spacing.desktop) === null || _spacing_desktop2 === void 0 ? void 0 : _spacing_desktop2.marginLeft) !== null && _spacing_desktop_marginLeft !== void 0 ? _spacing_desktop_marginLeft : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet10 = spacing.tablet) === null || _spacing_tablet10 === void 0 ? void 0 : _spacing_tablet10.marginLeft) !== null && _ref12 !== void 0 ? _ref12 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile18 = spacing.mobile) === null || _spacing_mobile18 === void 0 ? void 0 : _spacing_mobile18.marginLeft) !== null && _ref13 !== void 0 ? _ref13 : "0",
            marginRight: (_ref15 = (_ref14 = (_spacing_desktop_marginRight = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop3 = spacing.desktop) === null || _spacing_desktop3 === void 0 ? void 0 : _spacing_desktop3.marginRight) !== null && _spacing_desktop_marginRight !== void 0 ? _spacing_desktop_marginRight : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet11 = spacing.tablet) === null || _spacing_tablet11 === void 0 ? void 0 : _spacing_tablet11.marginRight) !== null && _ref14 !== void 0 ? _ref14 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile19 = spacing.mobile) === null || _spacing_mobile19 === void 0 ? void 0 : _spacing_mobile19.marginRight) !== null && _ref15 !== void 0 ? _ref15 : "0",
            paddingTop: (_ref17 = (_ref16 = (_spacing_desktop_paddingTop = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop4 = spacing.desktop) === null || _spacing_desktop4 === void 0 ? void 0 : _spacing_desktop4.paddingTop) !== null && _spacing_desktop_paddingTop !== void 0 ? _spacing_desktop_paddingTop : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet12 = spacing.tablet) === null || _spacing_tablet12 === void 0 ? void 0 : _spacing_tablet12.paddingTop) !== null && _ref16 !== void 0 ? _ref16 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile20 = spacing.mobile) === null || _spacing_mobile20 === void 0 ? void 0 : _spacing_mobile20.paddingTop) !== null && _ref17 !== void 0 ? _ref17 : "0",
            paddingBottom: (_ref19 = (_ref18 = (_spacing_desktop_paddingBottom = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop5 = spacing.desktop) === null || _spacing_desktop5 === void 0 ? void 0 : _spacing_desktop5.paddingBottom) !== null && _spacing_desktop_paddingBottom !== void 0 ? _spacing_desktop_paddingBottom : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet13 = spacing.tablet) === null || _spacing_tablet13 === void 0 ? void 0 : _spacing_tablet13.paddingBottom) !== null && _ref18 !== void 0 ? _ref18 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile21 = spacing.mobile) === null || _spacing_mobile21 === void 0 ? void 0 : _spacing_mobile21.paddingBottom) !== null && _ref19 !== void 0 ? _ref19 : "0",
            paddingLeft: (_ref21 = (_ref20 = (_spacing_desktop_paddingLeft = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop6 = spacing.desktop) === null || _spacing_desktop6 === void 0 ? void 0 : _spacing_desktop6.paddingLeft) !== null && _spacing_desktop_paddingLeft !== void 0 ? _spacing_desktop_paddingLeft : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet14 = spacing.tablet) === null || _spacing_tablet14 === void 0 ? void 0 : _spacing_tablet14.paddingLeft) !== null && _ref20 !== void 0 ? _ref20 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile22 = spacing.mobile) === null || _spacing_mobile22 === void 0 ? void 0 : _spacing_mobile22.paddingLeft) !== null && _ref21 !== void 0 ? _ref21 : "0",
            paddingRight: (_ref23 = (_ref22 = (_spacing_desktop_paddingRight = spacing === null || spacing === void 0 ? void 0 : (_spacing_desktop7 = spacing.desktop) === null || _spacing_desktop7 === void 0 ? void 0 : _spacing_desktop7.paddingRight) !== null && _spacing_desktop_paddingRight !== void 0 ? _spacing_desktop_paddingRight : spacing === null || spacing === void 0 ? void 0 : (_spacing_tablet15 = spacing.tablet) === null || _spacing_tablet15 === void 0 ? void 0 : _spacing_tablet15.paddingRight) !== null && _ref22 !== void 0 ? _ref22 : spacing === null || spacing === void 0 ? void 0 : (_spacing_mobile23 = spacing.mobile) === null || _spacing_mobile23 === void 0 ? void 0 : _spacing_mobile23.paddingRight) !== null && _ref23 !== void 0 ? _ref23 : "0"
        }
    };
    const marginStyles = null;
    const paddingStyles = null;
    (0, $iSvIT.useEffect)(()=>{
        (0, $8lB1y.updateStickyNavOffset)();
    }, []);
    const hiddenMobileStyle = null;
    const hiddenTabletStyle = null;
    const hiddenDesktopStyle = null; // determine text color based on background color luminance
    const getTextColor = (bgColor)=>{
        if (!bgColor) return undefined;
        try {
            // white text for dark backgrounds, dark text for light backgrounds
            return (0, $bpp2j.isDarkColor)(bgColor) ? (0, $5ohHq.wacToken)("color.neutral.light0") : (0, $5ohHq.wacToken)("color.primary.black");
        } catch (error) {
            // invalid color format, return undefined to use default
            console.error("Invalid backgroundColor format:", bgColor, error);
            return undefined;
        }
    };
    const textColor = getTextColor(backgroundColor);
    const colorStyle = null;
    var _gapv2_mobile, _gapv2_tablet, _ref24, _gapv2_desktop, _ref25, _ref26;
    const gapObject = {
        mobile: (_gapv2_mobile = gapv2.mobile) !== null && _gapv2_mobile !== void 0 ? _gapv2_mobile : "0",
        tablet: (_ref24 = (_gapv2_tablet = gapv2 === null || gapv2 === void 0 ? void 0 : gapv2.tablet) !== null && _gapv2_tablet !== void 0 ? _gapv2_tablet : gapv2.mobile) !== null && _ref24 !== void 0 ? _ref24 : "0",
        desktop: (_ref26 = (_ref25 = (_gapv2_desktop = gapv2 === null || gapv2 === void 0 ? void 0 : gapv2.desktop) !== null && _gapv2_desktop !== void 0 ? _gapv2_desktop : gapv2 === null || gapv2 === void 0 ? void 0 : gapv2.tablet) !== null && _ref25 !== void 0 ? _ref25 : gapv2.mobile) !== null && _ref26 !== void 0 ? _ref26 : "0"
    };
    const innerStyle = null;
    const orientationObject = {
        mobile: orientation.mobile || "vertical",
        tablet: orientation.tablet || orientation.mobile || "vertical",
        desktop: orientation.desktop || orientation.tablet || orientation.mobile || "vertical"
    };
    const orientationStyle = null;
    const verticalAlignmentValue = verticalAlignment === "center" ? "center" : "flex-start";
    const horizontalAlignmentValue = horizontalAlignment === "center" ? "center" : horizontalAlignment === "start" ? "flex-start" : horizontalAlignment === "end" ? "flex-end" : "initial";
    const hiddenOnMobile = responsiveHiding === null || responsiveHiding === void 0 ? void 0 : responsiveHiding.includes("mobile");
    const hiddenOnTablet = responsiveHiding === null || responsiveHiding === void 0 ? void 0 : responsiveHiding.includes("tablet");
    const hiddenOnDesktop = responsiveHiding === null || responsiveHiding === void 0 ? void 0 : responsiveHiding.includes("desktop");
    const overflowStyle = null;
    const responsiveSectionDividerHeightsStyles = null;
    const extendedBackgroundColorComponent = /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswstnw _1bsbauwl _4t3i1cn3 _14b5zqdx _b8yq87gh _1e021ssb _t9eczr6s _11q7wvjo",
            hat && "_1kt9b3bt _cfu11ule _kfgt1m3o _1s6kwvjo",
            hat && "_1cs8h2mm _iajm18y9",
            hat && hat === "high-right" ? "_tgsmkyn1" : hat === "high-left" ? "_tgsmvrmp" : "_tgsmcdv4",
            pants && "_aetrb3bt _1ywu1ule _1qdg1aiy _16r2wvjo",
            pants && "_18poh2mm _19nq1osq",
            pants && hat && "_18poh2mm _19nq1e6p",
            pants && pants === "high-right" ? "_1oj4snn3" : pants === "high-left" ? "_1oj4df5m" : "_1oj41mhh"
        ])
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        ref: (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7603UniformPageDwellTime) && label ? tracker === null || tracker === void 0 ? void 0 : tracker.ref : null,
        className: (0, $esG4f.default)([
            "_vhvk1xho _wsfyeyca _11nbax5h _tqhlzoxj _9s88d2ta _1rcb14zp",
            "_1pfhanyo _6rthpu7k _ahbq5tu6 _12l21ubn _kiya1jt3 _1ob9vj1y _1ywm6esm _1lva1cm9 _1mt1153n _1tntw79i _3l1a4z27 _161b1c8k",
            "_14lsaxbu _9if11u00",
            hat && !extendBackgroundColor && "_1kt9b3bt _cfu11ule _kfgt1m3o _1s6kwvjo",
            hat && !extendBackgroundColor && hat === "high-right" ? "_tgsmkyn1" : hat === "high-left" ? "_tgsmvrmp" : "_tgsmcdv4",
            pants && !extendBackgroundColor && "_aetrb3bt _1ywu1ule _1qdg1aiy _16r2wvjo",
            pants && !extendBackgroundColor && pants === "high-right" ? "_1oj4snn3" : pants === "high-left" ? "_1oj4df5m" : "_1oj41mhh",
            hiddenOnMobile && "_sugaglyw",
            hiddenOnTablet && "_kzviglyw",
            hiddenOnDesktop && "_dm25glyw",
            "_1idncgrn",
            extendBackgroundColor && "_kqswh2mm",
            extendBackgroundColor && hat && "_1q511m3o",
            extendBackgroundColor && pants && "_85i51aiy"
        ]),
        style: {
            "--_9ux5rl": (0, $43MIc.default)(hat ? `${(0, $8lB1y.SECTION_DIVIDER_HEIGHTS).mobile}px` : "0px"),
            "--_eu2x2b": (0, $43MIc.default)(pants ? `${(0, $8lB1y.SECTION_DIVIDER_HEIGHTS).mobile}px` : "0px"),
            "--_up8d13": (0, $43MIc.default)(hat ? `${(0, $8lB1y.SECTION_DIVIDER_HEIGHTS).tablet}px` : "0px"),
            "--_alf06v": (0, $43MIc.default)(pants ? `${(0, $8lB1y.SECTION_DIVIDER_HEIGHTS).tablet}px` : "0px"),
            "--_138i2bk": (0, $43MIc.default)(hat ? `${(0, $8lB1y.SECTION_DIVIDER_HEIGHTS).desktop}px` : "0px"),
            "--_1r8eu8k": (0, $43MIc.default)(pants ? `${(0, $8lB1y.SECTION_DIVIDER_HEIGHTS).desktop}px` : "0px"),
            "--_gbj3vn": (0, $43MIc.default)("var(--ds-space-" + spacingObject.mobile.marginTop + ")"),
            "--_1ml8i62": (0, $43MIc.default)("var(--ds-space-" + spacingObject.mobile.marginBottom + ")"),
            "--_eitxkt": (0, $43MIc.default)("var(--ds-space-" + spacingObject.mobile.marginLeft + ")"),
            "--_17oyghn": (0, $43MIc.default)("var(--ds-space-" + spacingObject.mobile.marginRight + ")"),
            "--_13w6wc6": (0, $43MIc.default)("var(--ds-space-" + spacingObject.tablet.marginTop + ")"),
            "--_1g7gc60": (0, $43MIc.default)("var(--ds-space-" + spacingObject.tablet.marginBottom + ")"),
            "--_1w7fn9j": (0, $43MIc.default)("var(--ds-space-" + spacingObject.tablet.marginLeft + ")"),
            "--_y26vmc": (0, $43MIc.default)("var(--ds-space-" + spacingObject.tablet.marginRight + ")"),
            "--_12q7gcg": (0, $43MIc.default)("var(--ds-space-" + spacingObject.desktop.marginTop + ")"),
            "--_1unjz24": (0, $43MIc.default)("var(--ds-space-" + spacingObject.desktop.marginBottom + ")"),
            "--_6sej3x": (0, $43MIc.default)("var(--ds-space-" + spacingObject.desktop.marginLeft + ")"),
            "--_4gatm0": (0, $43MIc.default)("var(--ds-space-" + spacingObject.desktop.marginRight + ")"),
            "--_1ly4823": (0, $43MIc.default)(backgroundColor),
            "--_srel9g": (0, $43MIc.default)(textColor),
            "--_lyok2l": (0, $43MIc.default)(overflow)
        },
        children: [
            extendBackgroundColor && extendedBackgroundColorComponent,
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_11q7wvjo _1bsb1osq _4t3i1wug _1e0c1txw _zulp1a6y _19wggsi3 _pdlmxbqd",
                    extendBackgroundColor && "_bfhk1j28 _kqswh2mm _1pbykb7n",
                    "_1q5117qr _85i51lcc _bozg1k1r _y4ti1one _1wafbrnf _1yd32emj _1wfq1myb _15vt1nm0 _26vx19ue _40tu16pv _d2ik8srg _exxmep75",
                    "_1e0c1txw _2lx22h65 _1lp71tnc _1inip4d6",
                    orientationObject.mobile === "horizontal" && "_4cvrop21 _1bah8u0b",
                    orientationObject.tablet === "horizontal" && "_q8t5op21 _e8gh8u0b",
                    orientationObject.desktop === "horizontal" && "_1jsvop21 _msup8u0b",
                    orientationObject.mobile === "vertical" && "_4cvr8u0b _1bahop21",
                    orientationObject.tablet === "vertical" && "_q8t58u0b _e8ghop21",
                    orientationObject.desktop === "vertical" && "_1jsv8u0b _msupop21",
                    sticky && "_kqsw1if8 _152txohi"
                ]),
                style: {
                    "--_rkv8x9": (0, $43MIc.default)("var(--ds-space-" + gapObject.mobile + ")"),
                    "--_9wptik": (0, $43MIc.default)("var(--ds-space-" + gapObject.tablet + ")"),
                    "--_3wdyhk": (0, $43MIc.default)("var(--ds-space-" + gapObject.desktop + ")"),
                    "--_16fd4zu": (0, $43MIc.default)("var(--ds-space-" + spacingObject.mobile.paddingTop + ")"),
                    "--_1j5swcl": (0, $43MIc.default)("var(--ds-space-" + spacingObject.mobile.paddingBottom + ")"),
                    "--_u69j6n": (0, $43MIc.default)("var(--ds-space-" + spacingObject.mobile.paddingLeft + ")"),
                    "--_o2jkov": (0, $43MIc.default)("var(--ds-space-" + spacingObject.mobile.paddingRight + ")"),
                    "--_703coj": (0, $43MIc.default)("var(--ds-space-" + spacingObject.tablet.paddingTop + ")"),
                    "--_1fsgwhq": (0, $43MIc.default)("var(--ds-space-" + spacingObject.tablet.paddingBottom + ")"),
                    "--_13hg674": (0, $43MIc.default)("var(--ds-space-" + spacingObject.tablet.paddingLeft + ")"),
                    "--_1qs0f4o": (0, $43MIc.default)("var(--ds-space-" + spacingObject.tablet.paddingRight + ")"),
                    "--_pqmqgy": (0, $43MIc.default)("var(--ds-space-" + spacingObject.desktop.paddingTop + ")"),
                    "--_1ybsets": (0, $43MIc.default)("var(--ds-space-" + spacingObject.desktop.paddingBottom + ")"),
                    "--_okopco": (0, $43MIc.default)("var(--ds-space-" + spacingObject.desktop.paddingLeft + ")"),
                    "--_x42pdd": (0, $43MIc.default)("var(--ds-space-" + spacingObject.desktop.paddingRight + ")"),
                    "--_pv2ypa": (0, $43MIc.default)(orientationObject.mobile === "horizontal" ? "row" : "column"),
                    "--_dek1s0": (0, $43MIc.default)(orientationObject.tablet === "horizontal" ? "row" : "column"),
                    "--_1ng513r": (0, $43MIc.default)(orientationObject.desktop === "horizontal" ? "row" : "column"),
                    "--_7phn4c": (0, $43MIc.default)(verticalAlignmentValue),
                    "--_7e5uq9": (0, $43MIc.default)(horizontalAlignmentValue)
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                    name: "component"
                })
            })
        ]
    });
};
const $af65450661bcb715$var$hatCommonStyle = null;
const $af65450661bcb715$var$extendedBackgroundColorHatStyle = null;
const $af65450661bcb715$var$hatHighLeft = null;
const $af65450661bcb715$var$hatHighRight = null;
const $af65450661bcb715$var$hatPolygon = null;
const $af65450661bcb715$var$pantsCommonStyle = null;
const $af65450661bcb715$var$extendedBackgroundColorPantsStyle = null;
const $af65450661bcb715$var$extendedBackgroundColorPantsWithHatStyle = null;
const $af65450661bcb715$var$pantsHighLeft = null;
const $af65450661bcb715$var$pantsHighRight = null;
const $af65450661bcb715$var$pantsPolygon = null;
var $af65450661bcb715$export$2e2bcd8739ae039 = $af65450661bcb715$var$UniformContainer;

});


parcelRegister("bvk3D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("j5qkq")).default; });

var $j5qkq = parcelRequire("j5qkq");

});
parcelRegister("j5qkq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5b2b3e6806e7c2d$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $40KoW = parcelRequire("40KoW");

var $1UUq1 = parcelRequire("1UUq1");

var $8lB1y = parcelRequire("8lB1y");

var $3FBn4 = parcelRequire("3FBn4");
const $d5b2b3e6806e7c2d$var$UniformContentBlock = (props)=>{
    var _props_linkHref, _props_buttonHref;
    var _props_linkHref_path;
    const localizedLinkHref = (0, $3FBn4.useLocalizedHref)((_props_linkHref_path = (_props_linkHref = props.linkHref) === null || _props_linkHref === void 0 ? void 0 : _props_linkHref.path) !== null && _props_linkHref_path !== void 0 ? _props_linkHref_path : "");
    var _props_buttonHref_path;
    const localizedButtonHref = (0, $3FBn4.useLocalizedHref)((_props_buttonHref_path = (_props_buttonHref = props.buttonHref) === null || _props_buttonHref === void 0 ? void 0 : _props_buttonHref.path) !== null && _props_buttonHref_path !== void 0 ? _props_buttonHref_path : "");
    const callToActionProps = $d5b2b3e6806e7c2d$var$transformCtaProps((0, $6iHNw._)((0, $7Knp0._)({}, props), {
        linkHref: props.linkHref ? {
            path: localizedLinkHref
        } : undefined,
        buttonHref: props.buttonHref ? {
            path: localizedButtonHref
        } : undefined
    }));
    var _props_imageAlt, _props_iconAlt;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.ContentBlock), {
        title: props.title,
        text: props.richText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            text: props.richText
        }) : !(0, $40KoW.isRichTextValueConsideredEmpty)(props.uniformRichText) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            uniformParameter: "uniformRichText"
        }) : props.text,
        titleAs: props.titleAs,
        logo: props.logo,
        eyebrow: props.eyebrow,
        alignment: props.alignment,
        callToActionProps: callToActionProps,
        pictureProps: props.imageUrl ? {
            image: {
                src: props.imageUrl,
                alt: (_props_imageAlt = props.imageAlt) !== null && _props_imageAlt !== void 0 ? _props_imageAlt : ""
            }
        } : undefined,
        spotIllustrationUrl: props.spotIllustrationUrl,
        icon: props.iconUrl ? {
            linkedIcon: {
                url: props.iconUrl,
                size: props.iconSize,
                alt: (_props_iconAlt = props.iconAlt) !== null && _props_iconAlt !== void 0 ? _props_iconAlt : ""
            }
        } : undefined,
        orientation: props.orientation,
        columns: props.columns,
        backgroundColor: props.backgroundColor,
        hat: props.hat,
        pants: props.pants
    });
};
function $d5b2b3e6806e7c2d$var$transformCtaProps({ buttonHref: buttonHref, buttonLabel: buttonLabel, buttonVariant: buttonVariant, linkHref: linkHref, linkText: linkText, linkType: linkType }) {
    const isButton = !!(buttonHref === null || buttonHref === void 0 ? void 0 : buttonHref.path) && !!buttonLabel;
    const isLink = !!(linkHref === null || linkHref === void 0 ? void 0 : linkHref.path) && !!linkText;
    if (isButton || isLink) {
        const ctaProps = {
            button: isButton ? {
                href: buttonHref.path,
                dataEventProps: {
                    "data-product-key": "uniform",
                    "data-event-component": "linkButton",
                    "data-event-container": "contentBlock",
                    "data-event": "clicked",
                    "data-label": buttonLabel
                }
            } : undefined,
            buttonText: buttonLabel !== null && buttonLabel !== void 0 ? buttonLabel : undefined,
            buttonVariant: buttonVariant !== null && buttonVariant !== void 0 ? buttonVariant : undefined,
            link: isLink ? {
                href: linkHref.path,
                text: linkText,
                type: linkType,
                dataEventProps: {
                    "data-product-key": "uniform",
                    "data-event-component": "linkButton",
                    "data-event-container": "contentBlock",
                    "data-event": "clicked",
                    "data-label": linkText
                }
            } : undefined
        };
        return ctaProps;
    }
    return undefined;
}
var $d5b2b3e6806e7c2d$export$2e2bcd8739ae039 = $d5b2b3e6806e7c2d$var$UniformContentBlock;

});


parcelRegister("dX6Xs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("jgCjv")).default; });

var $jgCjv = parcelRequire("jgCjv");

});
parcelRegister("jgCjv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26db6e668dcd1535$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $2bAHw = parcelRequire("2bAHw");

var $iThfY = parcelRequire("iThfY");
const $26db6e668dcd1535$export$760d8d36b06866af = (props)=>{
    const statProps = (0, $7Knp0._)({}, props);
    statProps.stats = (0, $2bAHw.flattenValues)(props.stats);
    return statProps;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $26db6e668dcd1535$var$UniformCustomerStat = (props)=>{
    const statProps = $26db6e668dcd1535$export$760d8d36b06866af(props);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iThfY.CustomerDetailsStats), (0, $7Knp0._)({}, statProps));
};
var $26db6e668dcd1535$export$2e2bcd8739ae039 = $26db6e668dcd1535$var$UniformCustomerStat;

});


parcelRegister("JGvCj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("6Y74j")).default; });

var $6Y74j = parcelRequire("6Y74j");

});
parcelRegister("6Y74j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de57eb9f51f78d6e$export$2e2bcd8739ae039; });
/* customer-stories-details-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $aiugz = parcelRequire("aiugz");

var $gAJUc = parcelRequire("gAJUc");

var $ccYBS = parcelRequire("ccYBS");
parcelRequire("e992t");
var $8fNuT = parcelRequire("8fNuT");

var $7opTn = parcelRequire("7opTn");
const $de57eb9f51f78d6e$var$heroContainerCss = null;
const $de57eb9f51f78d6e$export$74f30557f8a70c45 = ({ title: title, subtitle: subtitle, imgSrc: imgSrc, imgAlt: imgAlt, quote: quote, author: author, role: role, company: company })=>{
    var _composition_data;
    const composition = (0, $aiugz.useUniformCurrentComposition)();
    const compositionId = composition === null || composition === void 0 ? void 0 : (_composition_data = composition.data) === null || _composition_data === void 0 ? void 0 : _composition_data._id;
    const tracker = (0, $ccYBS.useScrollTracking)("UniformCustomerStoriesDetailsHero", {
        dwellTimeEnabled: true,
        additionalAttributes: {
            compositionId: compositionId
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        ref: (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7603UniformPageDwellTime) ? tracker === null || tracker === void 0 ? void 0 : tracker.ref : null,
        className: (0, $esG4f.default)([
            "_1e0c11p5 _1bah1yb4 _1pfhxy5q _p12f1osq _vchhusvi _zulp1tcg _1bsb1osq _yv0ei47z _pdlmzwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8fNuT.default), {
                title: title,
                subtitle: subtitle,
                alignment: imgSrc ? "left" : "center"
            }),
            quote && /*#__PURE__*/ (0, $loA2J.jsx)((0, $7opTn.default), {
                imgSrc: imgSrc,
                imgAlt: imgAlt,
                quote: quote,
                author: author,
                role: role,
                company: company
            })
        ]
    });
};
var $de57eb9f51f78d6e$export$2e2bcd8739ae039 = $de57eb9f51f78d6e$export$74f30557f8a70c45;

});
parcelRegister("e992t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("8fNuT")).default; });

var $8fNuT = parcelRequire("8fNuT");

});
parcelRegister("8fNuT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2094b45cba049d08$export$2e2bcd8739ae039; });
/* hero-intro.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
const $2094b45cba049d08$var$UniformHeroIntro = ({ title: title, subtitle: subtitle, alignment: alignment })=>{
    const heroContainer = null;
    const textCss = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_y3gnoues _yv0ecx6w _1e0c11p5 _gy1p1tcg _1rqtaigu _ikjdzwfg"
        ]),
        style: {
            "--_1v0xqnb": (0, $43MIc.default)(alignment)
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_6rthidpf _yyhy13k5 _1e3c9kbg"
                ]),
                style: {
                    "--_1gb0l6x": (0, $43MIc.default)(alignment == "center" ? "2" : "1")
                },
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_6rthidpf _yyhy13k5 _1e3c9kbg",
                    "body-lg"
                ]),
                style: {
                    "--_1gb0l6x": (0, $43MIc.default)(alignment == "center" ? "2" : "1")
                },
                children: subtitle
            })
        ]
    });
};
var $2094b45cba049d08$export$2e2bcd8739ae039 = $2094b45cba049d08$var$UniformHeroIntro;

});


parcelRegister("7opTn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f04546e5dcf926f8$export$2e2bcd8739ae039; });
/* customer-stories-details-hero-quote.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $aiugz = parcelRequire("aiugz");

var $dyrzP = parcelRequire("dyrzP");

var $1UUq1 = parcelRequire("1UUq1");

var $gAJUc = parcelRequire("gAJUc");

var $ccYBS = parcelRequire("ccYBS");
const $f04546e5dcf926f8$var$quoteBodyCss = null;
const $f04546e5dcf926f8$var$quoteStylingWithImage = null;
const $f04546e5dcf926f8$var$quoteStylingNoImage = null;
const $f04546e5dcf926f8$var$imageCss = null;
const $f04546e5dcf926f8$var$quoteContainerStyles = null;
const $f04546e5dcf926f8$export$d35b0bc1e0617ca6 = ({ imgSrc: imgSrc, imgAlt: imgAlt, quote: quote, author: author, role: role, company: company })=>{
    var _composition_data;
    const composition = (0, $aiugz.useUniformCurrentComposition)();
    const compositionId = composition === null || composition === void 0 ? void 0 : (_composition_data = composition.data) === null || _composition_data === void 0 ? void 0 : _composition_data._id;
    const tracker = (0, $ccYBS.useScrollTracking)("UniformCustomerStoriesDetailsHeroQuote", {
        dwellTimeEnabled: true,
        additionalAttributes: {
            compositionId: compositionId
        }
    });
    const authorDetails = [
        role,
        company
    ].filter(Boolean).join(", ");
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        ref: (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7603UniformPageDwellTime) ? tracker === null || tracker === void 0 ? void 0 : tracker.ref : null,
        className: (0, $esG4f.default)([
            "_1e0c11p5 _yv0ecx6w _zulp1tcg _4cvr1h6o _6a6zv2br _1rqtaigu _pdlmzwfg"
        ]),
        children: [
            imgSrc && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1461kb7n _f0zu1ohn _nw6ekb7n _1jpu1mrw _uhi5kb7n _eao7qfx8"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyrzP.default), {
                    contentType: /* Since we do not pass in the direct Contentful image via Uniform,
      this uses a rough assumption to trigger a webp transformation */ imgSrc.endsWith(".png") ? "image/png" : undefined,
                    src: imgSrc,
                    alt: imgAlt !== null && imgAlt !== void 0 ? imgAlt : "",
                    style: {
                        maxWidth: "100%"
                    },
                    baseWidth: 440
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1461kb7n _f0zu1mrw _1vb6grf3",
                    imgSrc ? "_1e3c1gti" : "_1e3ceqnf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.PullQuote), {
                    quote: quote !== null && quote !== void 0 ? quote : "",
                    authorName: author !== null && author !== void 0 ? author : "",
                    authorDetails: authorDetails,
                    alignment: imgSrc ? "start" : "center",
                    size: "large",
                    variant: "basic"
                })
            })
        ]
    });
};
var $f04546e5dcf926f8$export$2e2bcd8739ae039 = $f04546e5dcf926f8$export$d35b0bc1e0617ca6;

});



parcelRegister("dUTg3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("dPZ0n")).default; });

var $dPZ0n = parcelRequire("dPZ0n");

});
parcelRegister("dPZ0n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0da449692bf398b2$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $55vkU = parcelRequire("55vkU");
const $0da449692bf398b2$var$transformImage = (props, alt)=>{
    var _props_file, _props_file1, _props_file_details_image, _props_file_details, _props_file2, _props_file_details_image1, _props_file_details1, _props_file3;
    if (!props) return undefined;
    return {
        contentType: (_props_file = props.file) === null || _props_file === void 0 ? void 0 : _props_file.contentType,
        src: (_props_file1 = props.file) === null || _props_file1 === void 0 ? void 0 : _props_file1.url,
        alt: alt !== null && alt !== void 0 ? alt : "",
        baseWidth: 500,
        width: (_props_file2 = props.file) === null || _props_file2 === void 0 ? void 0 : (_props_file_details = _props_file2.details) === null || _props_file_details === void 0 ? void 0 : (_props_file_details_image = _props_file_details.image) === null || _props_file_details_image === void 0 ? void 0 : _props_file_details_image.width,
        height: (_props_file3 = props.file) === null || _props_file3 === void 0 ? void 0 : (_props_file_details1 = _props_file3.details) === null || _props_file_details1 === void 0 ? void 0 : (_props_file_details_image1 = _props_file_details1.image) === null || _props_file_details_image1 === void 0 ? void 0 : _props_file_details_image1.height
    };
};
const $0da449692bf398b2$var$transformCta = (linkUrl, linkText)=>{
    if (linkUrl && linkText) return {
        url: linkUrl,
        text: linkText
    };
    return undefined;
};
const $0da449692bf398b2$var$transformProps = (props)=>{
    var _props_theme;
    return {
        bgColor: (_props_theme = props.theme) !== null && _props_theme !== void 0 ? _props_theme : "white",
        testimonials: props.quotes.map((quote)=>{
            var _fields_advocateCta__fields, _fields_advocateCta_, _fields_advocateCta, _fields_advocateCta__fields1, _fields_advocateCta_1, _fields_advocateCta1, _fields_organization_fields_logo_, _fields_organization_fields_logo, _fields_organization_fields, _fields_organization, _fields_organization_fields1, _fields_organization1, _fields_advocateHeadshot;
            const fields = quote.fields;
            const linkUrl = (_fields_advocateCta = fields.advocateCta) === null || _fields_advocateCta === void 0 ? void 0 : (_fields_advocateCta_ = _fields_advocateCta[0]) === null || _fields_advocateCta_ === void 0 ? void 0 : (_fields_advocateCta__fields = _fields_advocateCta_.fields) === null || _fields_advocateCta__fields === void 0 ? void 0 : _fields_advocateCta__fields.ctaUrl;
            const linkText = (_fields_advocateCta1 = fields.advocateCta) === null || _fields_advocateCta1 === void 0 ? void 0 : (_fields_advocateCta_1 = _fields_advocateCta1[0]) === null || _fields_advocateCta_1 === void 0 ? void 0 : (_fields_advocateCta__fields1 = _fields_advocateCta_1.fields) === null || _fields_advocateCta__fields1 === void 0 ? void 0 : _fields_advocateCta__fields1.ctaButtonText;
            return {
                logo: $0da449692bf398b2$var$transformImage((_fields_organization = fields.organization) === null || _fields_organization === void 0 ? void 0 : (_fields_organization_fields = _fields_organization.fields) === null || _fields_organization_fields === void 0 ? void 0 : (_fields_organization_fields_logo = _fields_organization_fields.logo) === null || _fields_organization_fields_logo === void 0 ? void 0 : (_fields_organization_fields_logo_ = _fields_organization_fields_logo[0]) === null || _fields_organization_fields_logo_ === void 0 ? void 0 : _fields_organization_fields_logo_.fields, (_fields_organization1 = fields.organization) === null || _fields_organization1 === void 0 ? void 0 : (_fields_organization_fields1 = _fields_organization1.fields) === null || _fields_organization_fields1 === void 0 ? void 0 : _fields_organization_fields1.organizationNameExternal),
                name: fields.advocateName,
                title: fields.advocateJobTitle,
                image: $0da449692bf398b2$var$transformImage((_fields_advocateHeadshot = fields.advocateHeadshot) === null || _fields_advocateHeadshot === void 0 ? void 0 : _fields_advocateHeadshot.fields),
                quote: fields.advocateQuote,
                link: $0da449692bf398b2$var$transformCta(linkUrl, linkText)
            };
        }).filter((quote)=>{
            return !!quote.logo && !!quote.name && !!quote.title && !!quote.image && !!quote.quote;
        })
    };
};
const $0da449692bf398b2$var$UniformCustomerTestimonials = (props)=>{
    //TODO GWP-6632: add CTA links, and ensure they are localized in each panel
    const transformed = $0da449692bf398b2$var$transformProps(props);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $55vkU.CustomerTestimonials), {
        bgColor: transformed.bgColor,
        testimonials: transformed.testimonials
    });
};
var $0da449692bf398b2$export$2e2bcd8739ae039 = $0da449692bf398b2$var$UniformCustomerTestimonials;

});


parcelRegister("4hRws", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("jezov")).default; });

var $jezov = parcelRequire("jezov");

});
parcelRegister("jezov", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d851a660ceb2ce6$export$2e2bcd8739ae039; });
/* download-row.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $aiugz = parcelRequire("aiugz");

var $5ohHq = parcelRequire("5ohHq");
const $6d851a660ceb2ce6$var$rowStyle = null;
const $6d851a660ceb2ce6$var$versionContainerStyle = null;
const $6d851a660ceb2ce6$var$releaseNotesStyle = null;
const $6d851a660ceb2ce6$var$cellStyle = null;
const $6d851a660ceb2ce6$var$firstCellStyle = null;
const $6d851a660ceb2ce6$var$UniformDownloadRow = ({ size: size, date: date })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("tr", {
        className: (0, $esG4f.default)([
            "_vwz4kb7n _ect4q6fz _syazvejh _yq5hcfaq _btyzidpf _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _179r1gln"
        ]),
        style: {
            "--_nl5by5": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue1000"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("td", {
                className: (0, $esG4f.default)([
                    "_ca0q19bv _u5f3ftgi _n3td19bv _19bvftgi _y3gn1h6o",
                    "_y3gn1e5h",
                    "p"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                            name: "version"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("small", {
                            className: (0, $esG4f.default)([
                                "_1wyb1wqq _1pfhi2wt"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                                name: "releaseNotes"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("td", {
                className: (0, $esG4f.default)([
                    "_ca0q19bv _u5f3ftgi _n3td19bv _19bvftgi _y3gn1h6o",
                    "p"
                ]),
                children: size
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("td", {
                className: (0, $esG4f.default)([
                    "_ca0q19bv _u5f3ftgi _n3td19bv _19bvftgi _y3gn1h6o",
                    "p"
                ]),
                children: date
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("td", {
                className: (0, $esG4f.default)([
                    "_ca0q19bv _u5f3ftgi _n3td19bv _19bvftgi _y3gn1h6o",
                    "p"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                    name: "format"
                })
            })
        ]
    });
};
var $6d851a660ceb2ce6$export$2e2bcd8739ae039 = $6d851a660ceb2ce6$var$UniformDownloadRow;

});


parcelRegister("7w1de", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("kIPoi")).default; });

var $kIPoi = parcelRequire("kIPoi");

});
parcelRegister("kIPoi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f79b36ad9223e74$export$2e2bcd8739ae039; });
/* download-table.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $aiugz = parcelRequire("aiugz");

var $5ohHq = parcelRequire("5ohHq");
const $6f79b36ad9223e74$var$containerStyle = null;
const $6f79b36ad9223e74$var$titleStyle = null;
const $6f79b36ad9223e74$var$tableStyle = null;
const $6f79b36ad9223e74$var$headStyle = null;
const $6f79b36ad9223e74$var$bodyStyle = null;
const $6f79b36ad9223e74$var$UniformDownloadTable = ({ title: title })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1y6m"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyr7vkz _18u0idpf _k48p8n31 _1wyb1q5e"
                ]),
                children: title
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("table", {
                className: (0, $esG4f.default)([
                    "_vwz4kb7n _ect4q6fz _syazvejh _1bsb1osq _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _yq5hcfaq _btyzidpf _6rth1tcg"
                ]),
                style: {
                    "--_nl5by5": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue1000"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("thead", {
                        className: (0, $esG4f.default)([
                            "_vwz4kb7n _ect4q6fz _syazvejh _yq5hcfaq _btyzidpf _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _n7zlzv82 _1fr819bv _1160ftgi _lxpr19bv _il49ftgi _xhev1h6o _7dd61e5h"
                        ]),
                        style: {
                            "--_nl5by5": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue1000")),
                            "--_8nj8hf": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light200"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("th", {
                                    className: "h5",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                                        children: "Version"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("th", {
                                    className: "h5",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                                        children: "Size"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("th", {
                                    className: "h5",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                                        children: "Build Date"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("th", {
                                    className: "h5",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                                        children: "Format"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("tbody", {
                        className: (0, $esG4f.default)([
                            "_vwz4kb7n _ect4q6fz _syazvejh _yq5hcfaq _btyzidpf _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _1a0z87ef _1czs19bv _ayjoftgi _7zpg19bv _3m4tftgi _1omd150w _ue36cd5j"
                        ]),
                        style: {
                            "--_nl5by5": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue1000")),
                            "--_8nj8hf": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light200")),
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                            name: "downloadrow"
                        })
                    })
                ]
            })
        ]
    });
};
var $6f79b36ad9223e74$export$2e2bcd8739ae039 = $6f79b36ad9223e74$var$UniformDownloadTable;

});


parcelRegister("2RHFR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("kW4qU")).default; });

var $kW4qU = parcelRequire("kW4qU");

});
parcelRegister("kW4qU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bdf1894685fc30e$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $49RK4 = parcelRequire("49RK4");
const $4bdf1894685fc30e$var$UniformEnhancedBanner = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $49RK4.EnhancedBanner), (0, $7Knp0._)({}, props));
};
var $4bdf1894685fc30e$export$2e2bcd8739ae039 = $4bdf1894685fc30e$var$UniformEnhancedBanner;

});


parcelRegister("3MlHp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1a586d8aa0b7967$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");

var $lK5pR = parcelRequire("lK5pR");

var $8lB1y = parcelRequire("8lB1y");
const $a1a586d8aa0b7967$var$UniformExpand = (props)=>{
    var _props_eventDataName, _props_expandedLabelText;
    const expandProps = {
        eventDataName: (_props_eventDataName = props.eventDataName) !== null && _props_eventDataName !== void 0 ? _props_eventDataName : undefined,
        chevronColor: props.chevronColor,
        boldLabel: props.richText ? false : props.boldLabel,
        label: props.richText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            text: props.richText
        }) : props.label,
        expandedLabelText: (_props_expandedLabelText = props.expandedLabelText) !== null && _props_expandedLabelText !== void 0 ? _props_expandedLabelText : null
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lK5pR.Expand), (0, $6iHNw._)((0, $7Knp0._)({}, expandProps), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "contents"
        })
    }));
};
var $a1a586d8aa0b7967$export$2e2bcd8739ae039 = $a1a586d8aa0b7967$var$UniformExpand;

});

parcelRegister("9WxMx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("ipijV")).default; });

var $ipijV = parcelRequire("ipijV");

});
parcelRegister("ipijV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76970d4a009ce6ab$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");

var $8jdfl = parcelRequire("8jdfl");

var $j27rt = parcelRequire("j27rt");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");
const $76970d4a009ce6ab$var$UniformExperiment = (props)=>{
    var _Object_entries_find;
    const { experimentId: experimentId, override: override, postExperimentationMode: postExperimentationMode } = props;
    const context = (0, $j27rt.useWAEContextSafe)();
    if (postExperimentationMode) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: experimentId,
        group: "Test",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "treatment"
        })
    });
    const experiment = (_Object_entries_find = Object.entries((0, $9iWJ8.experiments)).find(([, value])=>value.experimentName === experimentId)) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[1];
    if (override && (context === null || context === void 0 ? void 0 : context.wacEnvironment) !== "production") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: override
    });
    if (!experiment) return (context === null || context === void 0 ? void 0 : context.wacEnvironment) === "production" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: "control"
    }) : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8jdfl.ManifestErrorMessage), {
                id: experimentId
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                name: "control"
            })
        ]
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const experimentStatus = (0, $9iWJ8.useExperiment)(experiment);
    const showTreatment = experimentStatus.type === "enrolled" && experimentStatus.value;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: showTreatment ? "treatment" : "control"
    });
};
var $76970d4a009ce6ab$export$2e2bcd8739ae039 = $76970d4a009ce6ab$var$UniformExperiment;

});
parcelRegister("8jdfl", function(module, exports) {

$parcel$export(module.exports, "ManifestErrorMessage", function () { return $641d3f539f73a96d$export$702dc26c1a322512; });

var $loA2J = parcelRequire("loA2J");

var $cUvUr = parcelRequire("cUvUr");
const $641d3f539f73a96d$export$702dc26c1a322512 = ({ id: id })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: id.length === 0 ? null : /*#__PURE__*/ (0, $loA2J.jsx)((0, $cUvUr.default), {
            appearance: "error",
            isDismissible: true,
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                        children: "Manifest entry not found for:"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $loA2J.jsx)("code", {
                        children: id
                    }),
                    ". Rendering control slot."
                ]
            })
        })
    });
};

});



parcelRegister("gp86Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("hhL3A")).default; });

var $hhL3A = parcelRequire("hhL3A");

});
parcelRegister("hhL3A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd5d4138f36a46c2$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");

var $8jdfl = parcelRequire("8jdfl");

var $j27rt = parcelRequire("j27rt");

var $gAJUc = parcelRequire("gAJUc");
const $fd5d4138f36a46c2$var$UniformFeatureGate = (props)=>{
    var _Object_entries_find;
    const { featureGateId: featureGateId, override: override } = props;
    const context = (0, $j27rt.useWAEContextSafe)();
    const featureGate = (_Object_entries_find = Object.entries((0, $gAJUc.featureFlags)).find(([, value])=>value.featureFlagName === featureGateId)) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[1];
    if (override && (context === null || context === void 0 ? void 0 : context.wacEnvironment) !== "production") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: override
    });
    if (!featureGate) return (context === null || context === void 0 ? void 0 : context.wacEnvironment) === "production" ? null : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8jdfl.ManifestErrorMessage), {
                id: featureGateId
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                name: "control"
            })
        ]
    });
    const showTreatment = (0, $gAJUc.checkFeatureFlagGate)(featureGate);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: showTreatment ? "treatment" : "control"
    });
};
var $fd5d4138f36a46c2$export$2e2bcd8739ae039 = $fd5d4138f36a46c2$var$UniformFeatureGate;

});


parcelRegister("lwXlz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("bVuUk")).default; });

var $bVuUk = parcelRequire("bVuUk");

});
parcelRegister("bVuUk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5257a26eb9cdb4bd$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dMM9X");
var $3Yf2x = parcelRequire("3Yf2x");

var $8lB1y = parcelRequire("8lB1y");
const $5257a26eb9cdb4bd$var$UniformFeaturesHighlight = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3Yf2x.FeaturesHighlight), {
        title: props.title,
        description: props.richText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            text: props.richText
        }) : props.description,
        linkText: props.linkText,
        linkHref: props.linkHref,
        feature1Eyebrow: props.feature1Eyebrow,
        feature1Title: props.feature1Title,
        feature1Body: props.feature1RichText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            text: props.feature1RichText
        }) : props.feature1Body,
        feature1ImageSrc: props.feature1ImageSrc,
        feature1ImageAltText: props.feature1ImageAltText,
        feature2Eyebrow: props.feature2Eyebrow,
        feature2Title: props.feature2Title,
        feature2Body: props.feature2RichText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            text: props.feature2RichText
        }) : props.feature2Body,
        feature2ImageSrc: props.feature2ImageSrc,
        feature2ImageAltText: props.feature2ImageAltText,
        feature3Eyebrow: props.feature3Eyebrow,
        feature3Title: props.feature3Title,
        feature3Body: props.feature3RichText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            text: props.feature3RichText
        }) : props.feature3Body,
        feature3ImageSrc: props.feature3ImageSrc,
        feature3ImageAltText: props.feature3ImageAltText
    });
};
var $5257a26eb9cdb4bd$export$2e2bcd8739ae039 = $5257a26eb9cdb4bd$var$UniformFeaturesHighlight;

});


parcelRegister("gMNh2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("8TUqr")).default; });

var $8TUqr = parcelRequire("8TUqr");

});
parcelRegister("8TUqr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70d47a54af07b35a$export$2e2bcd8739ae039; });

var $kex29 = parcelRequire("kex29");
var $70d47a54af07b35a$export$2e2bcd8739ae039 = (0, $kex29.GlobalFooter);

});


parcelRegister("l0zDw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("3qApo")).default; });

var $3qApo = parcelRequire("3qApo");

});
parcelRegister("3qApo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4d70652145ea3ff$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $6NDAm = parcelRequire("6NDAm");
const $a4d70652145ea3ff$var$UniformGlobalNav = ({ productKey: // This productKey is used for UFO instrumentation
// This prop is standardized to the value `uniform`
// See ldr/0018-set-standard-uniform-globalnav-productkey.md for more details
productKey = "uniform", isShowTryNowLink: isShowTryNowLink = true })=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $6NDAm.GlobalNav), {
        productKey: productKey,
        isShowTryNowLink: isShowTryNowLink
    });
var $a4d70652145ea3ff$export$2e2bcd8739ae039 = $a4d70652145ea3ff$var$UniformGlobalNav;

});


parcelRegister("19QOl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("das6y")).default; });

var $das6y = parcelRequire("das6y");

});
parcelRegister("das6y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03bb69f29d14e6f6$export$2e2bcd8739ae039; });
/* heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $aiugz = parcelRequire("aiugz");

var $40KoW = parcelRequire("40KoW");

var $5ohHq = parcelRequire("5ohHq");

var $4jHZw = parcelRequire("4jHZw");
var $03bb69f29d14e6f6$var$GestureLineType;
(function(GestureLineType) {
    GestureLineType["UNDERLINE_SQUIGGLE"] = "underline-squiggle";
    GestureLineType["EYELASH"] = "eyelash";
})($03bb69f29d14e6f6$var$GestureLineType || ($03bb69f29d14e6f6$var$GestureLineType = {}));
const $03bb69f29d14e6f6$var$UniformHeading = ({ text: text, uniformRichText: uniformRichText, customRichText: customRichText, alignment: alignment = "start", wordWrap: wordWrap })=>{
    const [headingRef, textColor] = (0, $4jHZw.useStylePropertyVariableValueFromParent)("--dxp-container-text-color");
    const baseHeadingCss = null;
    const headingCss = [
        baseHeadingCss,
        wordWrap && null
    ];
    function resolveUniformRichText({ node: node, children: children }) {
        const nodeIsBold = (node)=>{
            return node.type === "text" && (0, $40KoW.getRichTextTagsFromTextFormat)(node.format).includes("strong");
        };
        const richTextValueHasBold = (value)=>{
            let hasBold = false;
            (0, $40KoW.walkRichTextTree)(value, (node)=>{
                if (nodeIsBold(node)) hasBold = true;
            });
            return hasBold;
        };
        const hasBoldText = richTextValueHasBold(node);
        return /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
            ref: headingRef,
            className: (0, $esG4f.default)([
                "_1mouidpf _y3gnoues",
                wordWrap && "_ct361wug",
                hasBoldText ? "h1-contrast" : ""
            ]),
            style: (0, $6iHNw._)((0, $7Knp0._)({}, textColor ? {
                color: textColor
            } : undefined), {
                "--_1v0xqnb": (0, $43MIc.default)(alignment)
            }),
            children: children
        });
    }
    function resolveUniformRichTextRenderer(node) {
        if (node.type === "paragraph") return resolveUniformRichText;
        return undefined;
    }
    const customRichTextIsConsideredEmpty = (customRichTextPropValue)=>{
        return !customRichTextPropValue || customRichTextPropValue.plainText === "";
    };
    const renderCustomRichText = ()=>{
        const nodeIsBold = (node)=>{
            return node.type === "bold";
        };
        const walkCustomRichTextTree = (node, callBack)=>{
            callBack(node);
            if (node.children) node.children.forEach((child)=>{
                walkCustomRichTextTree(child, callBack);
            });
        };
        const customRichTextValueHasBold = (value)=>{
            let hasBold = false;
            walkCustomRichTextTree(value, (node)=>{
                if (nodeIsBold(node)) hasBold = true;
            });
            return hasBold;
        };
        const hasBoldText = ()=>{
            let hasBold = false;
            customRichText === null || customRichText === void 0 ? void 0 : customRichText.content.forEach((node)=>{
                if (customRichTextValueHasBold(node)) hasBold = true;
            });
            return hasBold;
        };
        const renderCustomRichTextNode = (node, index)=>{
            switch(node.type){
                case "bold":
                    var _node_children;
                    return /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                        children: (_node_children = node.children) === null || _node_children === void 0 ? void 0 : _node_children.map((child, childIndex)=>renderCustomRichTextNode(child, childIndex))
                    }, index);
                case "underline-squiggle":
                    var _node_children1;
                    return /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                        className: (0, $esG4f.default)([
                            "_kqswh2mm"
                        ]),
                        children: [
                            $03bb69f29d14e6f6$var$getGestureLine(node.type, node.color),
                            (_node_children1 = node.children) === null || _node_children1 === void 0 ? void 0 : _node_children1.map((child, childIndex)=>renderCustomRichTextNode(child, childIndex))
                        ]
                    }, index);
                case "eyelash":
                    var _node_children2;
                    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("br", {}),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                                className: (0, $esG4f.default)([
                                    "_kqswh2mm"
                                ]),
                                children: [
                                    $03bb69f29d14e6f6$var$getGestureLine(node.type, node.color),
                                    (_node_children2 = node.children) === null || _node_children2 === void 0 ? void 0 : _node_children2.map((child, childIndex)=>renderCustomRichTextNode(child, childIndex))
                                ]
                            }, index)
                        ]
                    });
                case "text":
                default:
                    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        children: node.text || ""
                    }, index);
            }
        };
        return /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
            ref: headingRef,
            className: (0, $esG4f.default)([
                "_1mouidpf _y3gnoues",
                wordWrap && "_ct361wug",
                hasBoldText() ? "h1-contrast" : ""
            ]),
            style: (0, $6iHNw._)((0, $7Knp0._)({}, textColor ? {
                color: textColor
            } : undefined), {
                "--_1v0xqnb": (0, $43MIc.default)(alignment)
            }),
            children: customRichText === null || customRichText === void 0 ? void 0 : customRichText.content.map((node, index)=>renderCustomRichTextNode(node, index))
        });
    };
    return !(0, $40KoW.isRichTextValueConsideredEmpty)(uniformRichText) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformRichText), {
        parameterId: "uniformRichText",
        resolveRichTextRenderer: resolveUniformRichTextRenderer
    }) : !customRichTextIsConsideredEmpty(customRichText) ? renderCustomRichText() : /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
        ref: headingRef,
        className: (0, $esG4f.default)([
            "_1mouidpf _y3gnoues",
            wordWrap && "_ct361wug"
        ]),
        style: (0, $6iHNw._)((0, $7Knp0._)({}, textColor ? {
            color: textColor
        } : undefined), {
            "--_1v0xqnb": (0, $43MIc.default)(alignment)
        }),
        children: text
    });
};
const $03bb69f29d14e6f6$var$getGestureLine = (gestureLine, gestureColor)=>{
    switch(gestureLine){
        case "underline-squiggle":
            return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "168",
                height: "16",
                viewBox: "0 0 168 16",
                fill: "none",
                "aria-hidden": "true",
                className: (0, $esG4f.default)([
                    "_kqswstnw _u7comgjw _1e021ssb _t9eczr6s"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M2.28772 11.6604C3.27772 12.0304 4.34772 11.9903 5.35772 11.8503C7.39772 11.5403 9.37772 10.8704 11.5877 10.1904C12.1377 9.84043 12.2377 9.88052 12.0577 9.53052C12.1777 9.40052 12.3777 9.17054 12.2377 9.05054C11.7477 8.23054 13.1677 7.92036 13.7077 7.62036C13.8777 8.38036 14.7577 8.34047 15.9677 7.98047C16.3177 7.88047 16.4477 7.83054 16.7777 7.80054C17.1377 7.75054 17.5177 7.69037 17.9177 7.63037C18.6977 7.55037 19.5677 7.43051 20.3677 7.52051C21.1777 7.59051 21.9477 7.82033 22.5477 8.34033C23.1577 8.85033 23.5977 9.61033 23.9377 10.3403C24.2777 11.0803 24.5277 11.7703 24.7977 12.3303C25.0477 12.8903 25.3077 13.2605 25.4377 13.4805C25.2677 13.7805 25.3077 14.2403 25.6877 14.5603C25.8477 14.7603 26.1177 14.8404 26.3877 14.9504C26.6777 15.0204 26.9977 15.0505 27.3177 15.0405C27.9777 14.9905 28.6077 14.7703 29.1477 14.6003C29.6277 14.4003 30.0777 14.2805 30.4177 14.2905C30.3777 14.3905 29.9477 14.8704 29.8977 14.9504C30.2677 15.0804 31.5877 14.5504 33.0877 13.6204C34.5877 12.6804 36.3277 11.3904 37.8377 10.1504C40.8877 7.70039 43.2477 5.65034 41.7577 7.85034C42.9077 7.23034 44.1177 6.56054 45.3277 5.80054C45.6277 5.61054 45.9377 5.42047 46.2477 5.23047L46.4577 5.10034L46.5577 5.05054C46.6177 5.02054 46.6877 4.98046 46.7477 4.97046H46.9577C46.9577 4.97046 47.0077 4.99048 47.0677 4.99048L47.3177 4.97046C47.6477 4.93046 47.9577 4.97046 48.2877 4.97046C49.5577 5.03046 50.7077 5.27036 51.5177 5.87036C52.3577 6.43036 53.0377 7.39032 53.8677 8.83032C54.2877 9.54032 54.7477 10.3605 55.4377 11.2405C56.1177 12.1105 57.1877 13.1003 58.5577 13.5903C58.8977 13.6903 59.2377 13.8104 59.5777 13.8804C59.9077 13.9304 60.2477 13.9705 60.5877 14.0005C61.2077 14.0005 61.8677 14.0004 62.4177 13.8804C62.6977 13.8304 62.9977 13.7905 63.2677 13.7205L64.0477 13.5005C64.5877 13.3605 65.0377 13.1605 65.5277 12.9805C69.2577 11.4205 72.3477 9.28033 75.4077 7.09033L77.3177 5.68042L78.2877 5.3103C78.6577 5.1603 78.9877 5.13052 79.3377 5.03052C79.5177 4.97052 79.6677 4.96045 79.8177 4.96045L80.2677 4.92041C80.4177 4.90041 80.5077 4.95044 80.6377 4.95044C80.7577 4.96044 80.8877 4.9505 80.9677 5.0105C81.3577 5.0805 81.7077 5.38037 82.1877 5.88037C83.1277 6.87037 84.1977 8.90048 86.2677 10.2405C86.7977 10.5505 87.3177 10.8705 87.8977 11.0505C88.1777 11.1505 88.4677 11.2603 88.7477 11.3403L89.6277 11.5005L90.1877 11.5903C90.3777 11.6103 90.5577 11.6904 90.7377 11.6204L91.7777 11.4004L93.0077 11.1504C99.5477 9.79039 105.978 9.92039 111.408 10.6504L111.248 10.4805C111.418 10.5405 111.958 10.4604 112.088 10.6704C113.168 10.3804 115.148 10.2204 116.858 10.1104C118.568 9.99035 120.008 9.98047 120.008 9.98047L126.178 9.68042C126.178 9.68042 128.828 10.0004 132.038 10.1804C135.248 10.3504 139.018 10.3505 141.168 9.75049C146.538 9.91049 151.978 9.90038 157.378 9.14038C157.378 9.14038 157.798 9.06042 158.458 8.93042C159.108 8.76042 159.998 8.50045 160.938 8.21045C161.878 7.90045 162.878 7.63048 163.728 7.24048C164.578 6.84048 165.308 6.46038 165.738 6.14038C166.818 5.34038 167.398 4.60032 167.398 4.08032C167.398 3.56032 166.798 3.26034 165.488 3.35034C164.838 3.40034 164.008 3.5403 162.978 3.8103C161.958 4.0903 160.678 4.30047 159.188 4.73047C159.108 4.69047 158.848 4.68034 158.798 4.60034C155.658 5.58034 152.388 5.81031 149.118 5.82031C147.488 5.85031 145.828 5.71044 144.178 5.70044C142.518 5.66044 140.838 5.55033 139.138 5.59033C139.218 5.88033 138.988 6.11045 138.788 5.96045L138.868 5.60034C134.278 6.20034 131.478 4.87037 127.188 5.88037C127.188 5.88037 127.698 5.43041 127.708 5.42041C124.088 5.28041 120.148 5.02035 115.968 4.86035C111.798 4.67035 107.398 4.61033 102.918 4.84033C101.798 4.92033 100.678 5.00032 99.5477 5.08032C98.4277 5.18032 97.2977 5.37051 96.1777 5.52051L94.4977 5.7605L92.8277 6.12036L91.1677 6.49048L90.4477 6.65039C90.5277 6.65039 90.4077 6.67039 90.3977 6.65039C90.3677 6.65039 90.3977 6.65037 90.3277 6.63037L90.0777 6.60034C89.8977 6.60034 89.7877 6.50046 89.6377 6.47046C89.3377 6.41046 89.1177 6.22034 88.8477 6.10034C88.3577 5.76034 87.8377 5.20043 87.2377 4.44043C86.6277 3.70043 85.9777 2.69047 84.7877 1.73047C84.5377 1.49047 84.1477 1.29032 83.8277 1.08032C83.4977 0.860322 83.1177 0.720332 82.7377 0.590332C81.9677 0.270332 81.2177 0.260439 80.4877 0.200439C80.5177 0.210439 80.5577 0.240498 80.5977 0.260498L80.5477 0.310303C80.8177 0.380303 81.2077 0.480342 81.6777 0.600342C82.1377 0.700342 82.7077 1.02054 83.2677 1.30054C84.3877 2.00054 85.2177 3.07043 85.7777 3.94043C86.3577 4.84043 86.7577 5.54052 87.1077 6.03052C87.4577 6.48052 87.6877 6.76048 87.6877 6.74048C86.5777 6.38048 85.6577 5.36052 84.6977 4.28052C84.1877 3.75052 83.6877 3.17048 82.9877 2.74048C82.3277 2.26048 81.5077 2.01037 80.6977 1.88037C79.8977 1.79037 79.0677 1.79041 78.3077 1.92041C77.4877 1.99041 76.8377 2.21041 76.0077 2.42041L75.6577 2.52051C75.5477 2.57051 75.4477 2.64045 75.3377 2.71045L74.8077 3.03052L73.9177 3.58032C73.3277 3.96032 72.7577 4.34047 72.1877 4.73047L71.9477 4.32031C72.9277 3.67031 73.7977 2.95035 74.5077 2.36035L74.6377 2.25049L74.8677 2.07031C75.0177 1.96031 75.1377 1.82049 75.2977 1.75049C75.5977 1.62049 75.8977 1.48039 76.0577 1.40039C76.4177 1.22039 76.7177 1.06042 76.9377 0.93042C76.6377 1.02042 76.3377 1.10043 76.0177 1.19043C75.8277 1.25043 75.6377 1.31036 75.4477 1.37036L75.0877 1.49048C74.9677 1.55048 74.8677 1.63044 74.7577 1.70044C74.2077 2.06044 73.6377 2.43031 73.0377 2.82031C71.9577 3.52031 70.7877 4.26048 69.5577 4.99048C68.3377 5.72048 67.0477 6.48035 65.7477 7.11035C64.4677 7.75035 63.1077 8.35031 61.9777 8.57031C61.4477 8.66031 60.9377 8.7304 60.6677 8.6604C60.3877 8.6004 60.2477 8.55031 59.9677 8.32031C59.6977 8.10031 59.3477 7.66033 58.9677 7.09033C58.5877 6.53033 58.1977 5.88043 57.7177 5.19043C56.8077 3.83043 55.4277 2.36054 53.8077 1.55054C52.1877 0.720537 50.5777 0.550342 49.3377 0.600342C49.3977 0.690342 49.6377 0.730479 49.9777 0.740479C50.3177 0.770479 50.7777 0.8304 51.2477 0.9104C51.7177 1.0204 52.2077 1.20043 52.5777 1.44043C52.9477 1.71043 53.2077 2.02036 53.2477 2.37036C52.0777 1.73036 50.7777 1.51044 49.5877 1.45044L48.6977 1.43042L47.8477 1.50049C47.5677 1.52049 47.2777 1.53032 47.0177 1.58032C46.6977 1.63032 46.3777 1.67046 46.0677 1.72046C46.0177 1.53046 46.0977 1.40053 46.2577 1.29053C46.3377 1.24053 46.4377 1.19039 46.5477 1.15039C46.6377 1.11039 46.7077 1.0903 46.7977 1.0603C47.1377 0.950303 47.5377 0.960381 47.6577 0.890381C47.5377 0.880381 47.3277 0.840352 47.0677 0.860352C46.9377 0.860352 46.7877 0.870371 46.6277 0.880371C46.3877 0.900371 46.1277 0.930439 45.8477 0.950439C45.6977 0.960439 45.5477 0.980488 45.3777 1.00049L45.1277 1.02051C45.0477 1.05051 44.9877 1.11039 44.9177 1.15039C44.6377 1.35039 44.3377 1.56053 44.0177 1.79053C43.6377 2.05053 43.2077 2.3404 42.7477 2.6604C40.9377 3.9104 38.5277 5.5904 35.7377 7.4104C34.3477 8.3304 32.8477 9.23033 31.3077 10.0903C30.9277 10.2903 30.5377 10.4804 30.1477 10.6804C29.7677 10.8504 29.3877 11.0204 28.9977 11.1904L28.4577 11.3704L28.1877 11.4705L28.0877 11.4905C27.9377 11.5305 27.8877 11.5305 27.8177 11.5205C27.6677 11.5205 27.5777 11.3805 27.5377 11.2505L27.2377 10.2505C27.0977 9.76049 26.9177 9.1703 26.6777 8.5603C26.4377 7.9403 26.0877 7.27035 25.6277 6.61035C25.3577 6.29035 25.0977 5.96041 24.7877 5.67041C24.4577 5.40041 24.1377 5.09038 23.7677 4.89038C22.2977 3.98038 20.7377 3.74048 19.4877 3.74048C18.1677 3.71048 17.0877 3.89035 15.9277 4.11035C15.7477 4.16035 15.5177 4.15049 15.3077 4.25049L14.7377 4.49048L13.9977 4.83032C13.5277 5.06032 13.0777 5.2805 12.6577 5.5105C10.9577 6.4105 9.43772 7.26043 8.02772 7.94043C6.62772 8.62043 5.32772 9.14035 4.32772 9.36035C3.83772 9.47035 3.42772 9.49046 3.18772 9.47046C2.95772 9.46046 2.81772 9.42033 2.64772 9.34033C2.36772 9.20033 2.02772 8.68046 1.82772 8.22046C1.59772 7.77046 1.46772 7.39051 1.29772 7.27051C1.13772 7.14051 0.99772 7.24036 0.86772 7.62036C0.73772 8.01036 0.61772 8.68038 0.80772 9.64038C0.63772 9.58038 0.44772 9.51041 0.28772 9.42041C0.58772 10.4404 1.30772 11.3504 2.30772 11.7004L2.28772 11.6604Z",
                    fill: (0, $5ohHq.wacToken)(`color.${gestureColor}`)
                })
            });
        case "eyelash":
            return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "117",
                height: "117",
                viewBox: "0 0 117 117",
                fill: "none",
                "aria-hidden": "true",
                className: (0, $esG4f.default)([
                    "_kqswstnw _rjxp120u _152txmi2 _1bsb1wug _4t3i1vuk"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M25.93 74.8872C25.1564 75.4245 12.3829 73.151 16.0089 71.2258C17.2313 70.3577 18.3652 70.4522 18.7372 71.7455C19.127 69.2416 21.5364 72.5841 22.7056 71.7691C22.3041 70.0211 25.7765 73.6706 25.115 71.8518C38.9455 69.9857 66.6537 86.9815 32.7862 76.7356C36.1641 75.956 32.987 75.2593 31.4693 75.6431C33.6248 77.8813 27.306 75.9325 26.1426 75.1589C28.1032 75.2061 24.8788 73.5526 25.9359 74.8813L25.93 74.8872Z",
                        fill: (0, $5ohHq.wacToken)(`color.${gestureColor}`)
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M51.0103 53.7517C49.2092 53.6395 41.6974 41.3562 40.7526 40.187C39.1994 37.311 43.345 37.0866 44.0123 39.5374C44.3489 39.9566 45.5123 43.4468 46.3568 41.9527C49.8823 42.7263 50.3548 48.9624 53.3311 49.3522C52.8528 50.173 53.9039 51.1533 53.6618 51.7025C54.5476 51.608 55.0377 52.795 54.8251 52.9013C58.5987 55.978 53.898 59.604 51.8784 55.1867C51.7248 55.3757 50.6973 54.5961 51.0102 53.7635L51.0103 53.7517Z",
                        fill: (0, $5ohHq.wacToken)(`color.${gestureColor}`)
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M96.948 30.7506C98.5602 32.788 98.4539 30.6385 97.6566 29.6523C96.198 31.477 96.2098 27.2133 96.6999 26.1208C96.7885 26.5637 97.5562 26.6346 97.4263 25.7133C95.5838 26.5637 94.0779 14.9005 98.5661 19.991C98.5779 20.1918 97.0838 20.4457 97.5739 20.6287C99.8121 19.9851 98.4007 21.9989 98.2767 22.5363C99.4578 22.3945 98.4066 23.0087 98.9086 23.0855C100.438 22.2764 98.0641 25.5598 99.57 24.6681C102.245 27.0834 99.564 32.7408 101.962 34.5478C99.44 36.2545 104.241 44.3981 98.8437 41.6462C97.3378 38.0734 96.3988 35.1147 96.948 30.7506Z",
                        fill: (0, $5ohHq.wacToken)(`color.${gestureColor}`)
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M67.6391 11.4579C71.2001 10.1291 71.1824 18.2727 72.8891 20.2983C75.2808 22.7136 85.4263 50.3746 77.5308 43.7665C74.5308 35.3689 70.6037 29.0087 68.2533 18.3672C67.7454 16.6664 65.0643 11.5051 67.6391 11.4579Z",
                        fill: (0, $5ohHq.wacToken)(`color.${gestureColor}`)
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M43.5337 100.854C45.9077 103.617 48.5592 99.584 50.7796 101.828C54.2166 106.222 27.3351 110.663 27.7485 105.737C28.6757 101.551 41.7739 102.826 43.5337 100.854Z",
                        fill: (0, $5ohHq.wacToken)(`color.${gestureColor}`)
                    })
                ]
            });
        default:
            return null;
    }
};
var $03bb69f29d14e6f6$export$2e2bcd8739ae039 = $03bb69f29d14e6f6$var$UniformHeading;

});
parcelRegister("4jHZw", function(module, exports) {

$parcel$export(module.exports, "useStylePropertyVariableValueFromParent", function () { return $baac376c55aaca28$export$a43348ac9682b5fa; });

var $iSvIT = parcelRequire("iSvIT");
const $baac376c55aaca28$export$a43348ac9682b5fa = (cssVariableName)=>{
    const ref = (0, $iSvIT.useRef)(null);
    const [propertyValue, setPropertyValue] = (0, $iSvIT.useState)();
    (0, $iSvIT.useEffect)(()=>{
        if (!ref.current) return;
        let element = ref.current;
        let depth = 0;
        const maxDepth = 20; // prevent infinite loops
        while(element && depth < maxDepth){
            const computedStyle = getComputedStyle(element);
            const value = computedStyle.getPropertyValue(cssVariableName).trim();
            if (value && value !== "") {
                setPropertyValue(value);
                return;
            }
            element = element.parentElement;
            depth++;
        }
        setPropertyValue(undefined);
    }, [
        cssVariableName
    ]);
    return [
        ref,
        propertyValue
    ];
};

});



parcelRegister("lrMw1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("25N89")).default; });

var $25N89 = parcelRequire("25N89");

});
parcelRegister("25N89", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5301e65b8a5b2dde$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");
parcelRequire("dMM9X");
var $5C9Aa = parcelRequire("5C9Aa");
const $5301e65b8a5b2dde$var$renderHeroCarousel = ({ items: items })=>{
    // First pass to work through Uniform setting empty to "" vs undefined that underlying component expects
    // eslint-disable-next-line complexity
    const transformed = items.map((heroSlide)=>{
        var _heroSlide_props_children_props_data, _heroSlide_props_children_props, _heroSlide_props_children, _heroSlide_props, _params_id, _params_tabEyebrow, _params_tabLabel, _params_title, _params_body, _params_buttonText, _params_buttonHref, _params_buttonText1, _params_buttonHref1, _params_buttonAriaLabel, _params_linkText, _params_linkHref, _params_linkText1, _params_linkHref1, _params_linkType, _params_linkAriaLabel, _params_bgColor, _params_imageLarge, _params_alignment;
        const params = (_heroSlide_props = heroSlide.props) === null || _heroSlide_props === void 0 ? void 0 : (_heroSlide_props_children = _heroSlide_props.children) === null || _heroSlide_props_children === void 0 ? void 0 : (_heroSlide_props_children_props = _heroSlide_props_children.props) === null || _heroSlide_props_children_props === void 0 ? void 0 : (_heroSlide_props_children_props_data = _heroSlide_props_children_props.data) === null || _heroSlide_props_children_props_data === void 0 ? void 0 : _heroSlide_props_children_props_data.parameters;
        return {
            id: ((_params_id = params.id) === null || _params_id === void 0 ? void 0 : _params_id.value) || undefined,
            eyebrow: ((_params_tabEyebrow = params.tabEyebrow) === null || _params_tabEyebrow === void 0 ? void 0 : _params_tabEyebrow.value) || undefined,
            title: (params === null || params === void 0 ? void 0 : (_params_tabLabel = params.tabLabel) === null || _params_tabLabel === void 0 ? void 0 : _params_tabLabel.value) || undefined,
            panel: {
                title: ((_params_title = params.title) === null || _params_title === void 0 ? void 0 : _params_title.value) || undefined,
                body: ((_params_body = params.body) === null || _params_body === void 0 ? void 0 : _params_body.value) || undefined,
                primaryCallToAction: ((_params_buttonText = params.buttonText) === null || _params_buttonText === void 0 ? void 0 : _params_buttonText.value) && ((_params_buttonHref = params.buttonHref) === null || _params_buttonHref === void 0 ? void 0 : _params_buttonHref.value) ? {
                    "text": (_params_buttonText1 = params.buttonText) === null || _params_buttonText1 === void 0 ? void 0 : _params_buttonText1.value,
                    "href": (_params_buttonHref1 = params.buttonHref) === null || _params_buttonHref1 === void 0 ? void 0 : _params_buttonHref1.value,
                    "aria-label": ((_params_buttonAriaLabel = params.buttonAriaLabel) === null || _params_buttonAriaLabel === void 0 ? void 0 : _params_buttonAriaLabel.value) || undefined
                } : undefined,
                secondaryCallToAction: ((_params_linkText = params.linkText) === null || _params_linkText === void 0 ? void 0 : _params_linkText.value) && ((_params_linkHref = params.linkHref) === null || _params_linkHref === void 0 ? void 0 : _params_linkHref.value) ? {
                    text: (_params_linkText1 = params.linkText) === null || _params_linkText1 === void 0 ? void 0 : _params_linkText1.value,
                    href: (_params_linkHref1 = params.linkHref) === null || _params_linkHref1 === void 0 ? void 0 : _params_linkHref1.value,
                    type: ((_params_linkType = params.linkType) === null || _params_linkType === void 0 ? void 0 : _params_linkType.value) || undefined,
                    ariaLabel: ((_params_linkAriaLabel = params.linkAriaLabel) === null || _params_linkAriaLabel === void 0 ? void 0 : _params_linkAriaLabel.value) || undefined
                } : undefined,
                bgColor: ((_params_bgColor = params.bgColor) === null || _params_bgColor === void 0 ? void 0 : _params_bgColor.value) || undefined,
                bgImage: {
                    lg: ((_params_imageLarge = params.imageLarge) === null || _params_imageLarge === void 0 ? void 0 : _params_imageLarge.value) || undefined
                },
                layout: ((_params_alignment = params.alignment) === null || _params_alignment === void 0 ? void 0 : _params_alignment.value) || undefined
            }
        };
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5C9Aa.HeroCarousel), {
        tabsData: transformed
    });
};
const $5301e65b8a5b2dde$var$UniformHeroCarousel = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "tabdata",
            wrapperComponent: $5301e65b8a5b2dde$var$renderHeroCarousel
        })
    });
};
var $5301e65b8a5b2dde$export$2e2bcd8739ae039 = $5301e65b8a5b2dde$var$UniformHeroCarousel;

});


parcelRegister("hS2Tl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("bEbxJ")).default; });

var $bEbxJ = parcelRequire("bEbxJ");

});
parcelRegister("bEbxJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $facb2e5cfffff962$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $gtQwZ = parcelRequire("gtQwZ");

var $3FBn4 = parcelRequire("3FBn4");
const $facb2e5cfffff962$var$UniformHeroSection = (props)=>{
    var _props_buttonHref;
    var _props_buttonHref_path;
    const localizedButtonHref = (0, $3FBn4.useLocalizedHref)((_props_buttonHref_path = (_props_buttonHref = props.buttonHref) === null || _props_buttonHref === void 0 ? void 0 : _props_buttonHref.path) !== null && _props_buttonHref_path !== void 0 ? _props_buttonHref_path : "");
    var _props_layout, _props_imageAlt;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $gtQwZ.default), {
        heading: props.heading,
        subheading: props.subheading,
        layout: (_props_layout = props.layout) !== null && _props_layout !== void 0 ? _props_layout : "image-right",
        // @ts-ignore
        backgroundColor: props.backgroundColor,
        callToActionProps: props.buttonHref && props.buttonLabel ? {
            text: props.buttonLabel,
            href: localizedButtonHref
        } : undefined,
        imageProps: props.imageUrl ? {
            src: props.imageUrl,
            alt: (_props_imageAlt = props.imageAlt) !== null && _props_imageAlt !== void 0 ? _props_imageAlt : ""
        } : undefined,
        secondaryImageProps: props.secondaryImageUrl ? {
            src: props.secondaryImageUrl,
            alt: ""
        } : undefined
    });
};
var $facb2e5cfffff962$export$2e2bcd8739ae039 = $facb2e5cfffff962$var$UniformHeroSection;

});


parcelRegister("7JHqD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("3IgE4")).default; });

var $3IgE4 = parcelRequire("3IgE4");

});
parcelRegister("3IgE4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9df49062445c098$export$2e2bcd8739ae039; });
/* horizontal-divider.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $4J1z5 = parcelRequire("4J1z5");

var $5ohHq = parcelRequire("5ohHq");
const $e9df49062445c098$var$dividerStyle = null;
const $e9df49062445c098$var$UniformHorizontalDivider = ({ lineStyle: lineStyle = "solid" })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("hr", {
        role: "presentation",
        style: {
            borderBlockStart: `1px ${lineStyle} ${(0, $5ohHq.wacToken)("color.neutral.light400")}`
        },
        className: (0, $esG4f.default)([
            "_1bsb1osq _19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    });
};
$e9df49062445c098$var$UniformHorizontalDivider.propTypes = {
    lineStyle: (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).string
};
var $e9df49062445c098$export$2e2bcd8739ae039 = $e9df49062445c098$var$UniformHorizontalDivider;

});


parcelRegister("e6r6l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("l8rpb")).default; });

var $l8rpb = parcelRequire("l8rpb");

});
parcelRegister("l8rpb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a14fc0a3a762f3f$export$2e2bcd8739ae039; });
/* image.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $bhreu = parcelRequire("bhreu");
// eslint-disable-next-line complexity
const $6a14fc0a3a762f3f$var$UniformImage = ({ source: source, altText: altText = "", width: width, maxWidth: maxWidth, height: height, maxHeight: maxHeight, objectFit: objectFit, objectPosition: objectPosition, tabletWidth: tabletWidth, desktopWidth: desktopWidth, tabletHeight: tabletHeight, desktopHeight: desktopHeight, makeCircle: makeCircle = false })=>{
    const imageStyle = {
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    const widthStyle = null;
    const heightStyle = null;
    const tabletWidthStyle = null;
    const desktopWidthStyle = null;
    const tabletHeightStyle = null;
    const desktopHeightStyle = null; // @ts-ignore
    const responsiveStyles = null;
    const makeCircleStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: source,
            alt: altText
        },
        className: (0, $esG4f.default)([
            width && "_1bsbzdsf",
            height && "_4t3i1rot",
            tabletWidth && "_14b51mzn",
            desktopWidth && "_glte1k6c",
            tabletHeight && "_1xloa7f3",
            desktopHeight && "_165tbekw",
            makeCircle && "_2rko1ssb"
        ]),
        style: (0, $6iHNw._)((0, $7Knp0._)({}, imageStyle), {
            "--_m5r7t4": (0, $43MIc.default)(width ? width : "auto"),
            "--_mzs5ed": (0, $43MIc.default)(height ? height : "auto"),
            "--_dwkr3u": (0, $43MIc.default)(tabletWidth ? tabletWidth : "auto"),
            "--_1mc860w": (0, $43MIc.default)(desktopWidth ? desktopWidth : "auto"),
            "--_1cta8t7": (0, $43MIc.default)(tabletHeight ? tabletHeight : "auto"),
            "--_1frmj6s": (0, $43MIc.default)(desktopHeight ? desktopHeight : "auto")
        })
    });
};
var $6a14fc0a3a762f3f$export$2e2bcd8739ae039 = $6a14fc0a3a762f3f$var$UniformImage;

});


parcelRegister("c81IA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("2wBma")).default; });

var $2wBma = parcelRequire("2wBma");

});
parcelRegister("2wBma", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be18c9833cb00a29$export$2e2bcd8739ae039; });
/* image-v2.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $1UUq1 = parcelRequire("1UUq1");
// eslint-disable-next-line complexity
const $be18c9833cb00a29$var$UniformImageV2 = ({ source: source, altText: altText = "", width: width, maxWidth: maxWidth, height: height, maxHeight: maxHeight, objectFit: objectFit, objectPosition: objectPosition, tabletWidth: tabletWidth, desktopWidth: desktopWidth, tabletHeight: tabletHeight, desktopHeight: desktopHeight, makeCircle: makeCircle = false })=>{
    const imageStyle = {
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    const widthStyle = null;
    const heightStyle = null;
    const tabletWidthStyle = null;
    const desktopWidthStyle = null;
    const tabletHeightStyle = null;
    const desktopHeightStyle = null; // @ts-ignore
    const responsiveStyles = null;
    const makeCircleStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
        src: source,
        alt: altText,
        className: (0, $esG4f.default)([
            width && "_1bsbzdsf",
            height && "_4t3i1rot",
            tabletWidth && "_14b51mzn",
            desktopWidth && "_glte1k6c",
            tabletHeight && "_1xloa7f3",
            desktopHeight && "_165tbekw",
            makeCircle && "_2rko1ssb"
        ]),
        style: (0, $6iHNw._)((0, $7Knp0._)({}, imageStyle), {
            "--_m5r7t4": (0, $43MIc.default)(width ? width : "auto"),
            "--_mzs5ed": (0, $43MIc.default)(height ? height : "auto"),
            "--_dwkr3u": (0, $43MIc.default)(tabletWidth ? tabletWidth : "auto"),
            "--_1mc860w": (0, $43MIc.default)(desktopWidth ? desktopWidth : "auto"),
            "--_1cta8t7": (0, $43MIc.default)(tabletHeight ? tabletHeight : "auto"),
            "--_1frmj6s": (0, $43MIc.default)(desktopHeight ? desktopHeight : "auto")
        })
    });
};
var $be18c9833cb00a29$export$2e2bcd8739ae039 = $be18c9833cb00a29$var$UniformImageV2;

});


parcelRegister("db1CJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("jnZNE")).default; });

var $jnZNE = parcelRequire("jnZNE");

});
parcelRegister("jnZNE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea9189acc3063704$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $kMNUa = parcelRequire("kMNUa");
parcelRequire("dMM9X");
var $g4WuQ = parcelRequire("g4WuQ");

var $8lB1y = parcelRequire("8lB1y");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ea9189acc3063704$var$UniformIntegration = (props)=>{
    const { eyebrow: eyebrow, title: title, titleAs: titleAs, body: body, richText: richText, linkLabel: linkLabel, linkHref: linkHref, logos: logos, background: background, backgroundColor: backgroundColor, flipLayout: flipLayout } = (0, $kMNUa.flattenLogoProps)(props);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4WuQ.Integration), {
        eyebrow: eyebrow,
        title: title,
        titleAs: titleAs,
        body: richText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            text: richText
        }) : body,
        linkLabel: linkLabel,
        linkHref: linkHref,
        logos: logos,
        background: background,
        backgroundColor: backgroundColor,
        flipLayout: flipLayout
    });
};
var $ea9189acc3063704$export$2e2bcd8739ae039 = $ea9189acc3063704$var$UniformIntegration;

});
parcelRegister("kMNUa", function(module, exports) {

$parcel$export(module.exports, "flattenLogoProps", function () { return $2de6a15df111b993$export$ffc5469ebe0e6998; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $2bAHw = parcelRequire("2bAHw");
const $2de6a15df111b993$export$ffc5469ebe0e6998 = (props)=>{
    return (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        logos: (0, $2bAHw.flattenValues)(props.logos)
    });
};

});



parcelRegister("8X3P4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("gnm3L")).default; });

var $gnm3L = parcelRequire("gnm3L");

});
parcelRegister("gnm3L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82eae7017722f440$export$2e2bcd8739ae039; });
/* invisible-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $82eae7017722f440$var$UniformInvisibleContent = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-content": props.content,
        className: (0, $esG4f.default)([
            "_1e0cglyw"
        ])
    });
};
var $82eae7017722f440$export$2e2bcd8739ae039 = $82eae7017722f440$var$UniformInvisibleContent;

});


parcelRegister("4x11f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("6wjLX")).default; });

var $6wjLX = parcelRequire("6wjLX");

});
parcelRegister("6wjLX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b643348a4469187c$export$2e2bcd8739ae039; });
/* jira-templates-tab-content-subgrid-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $aiugz = parcelRequire("aiugz");
const $b643348a4469187c$export$2f2a2862921598f6 = ()=>{
    const renderJiraTemplatesTabContent = ({ items: items })=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx21bp4 _zulpv47k _dm2511p5 _dbjgidpf _1hvkidpf _isu4idpf _15qmidpf _oqicidpf _1rmjidpf _cjbtidpf _pnmbidpf _pdlm14hz _glte1osq _1vsw13cz _18jf188f _azss12kr _1rqt1we7"
            ]),
            children: items
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: "jiraTemplatesTabContent",
        wrapperComponent: renderJiraTemplatesTabContent
    });
};
var $b643348a4469187c$export$2e2bcd8739ae039 = $b643348a4469187c$export$2f2a2862921598f6;

});


parcelRegister("dFD1n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("9KNdd")).default; });

var $9KNdd = parcelRequire("9KNdd");

});
parcelRegister("9KNdd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb3d14b85778a1e0$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $3FBn4 = parcelRequire("3FBn4");

var $9iZsm = parcelRequire("9iZsm");

var $gAJUc = parcelRequire("gAJUc");

var $1O6nN = parcelRequire("1O6nN");
const $bb3d14b85778a1e0$export$64bc9cd96d3d9a80 = (props)=>{
    let localizedHref = (0, $3FBn4.useLocalizedHref)(props.href);
    const localizedPartnerDirectoryUrl = (0, $9iZsm.useLocalizedPartnerDirectoryHref)(props.href);
    const checkGate = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwpUniformLinkLocalizePartnerDirectory);
    if (checkGate && props.href !== localizedPartnerDirectoryUrl) localizedHref = localizedPartnerDirectoryUrl;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1O6nN.Link), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        "aria-label": props.text,
        href: localizedHref,
        dataEventProps: {
            "data-product-key": "uniform",
            "data-event-component": "linkButton",
            "data-event-container": "link",
            "data-event": "clicked"
        }
    }));
};
var $bb3d14b85778a1e0$export$2e2bcd8739ae039 = $bb3d14b85778a1e0$export$64bc9cd96d3d9a80;

});


parcelRegister("hykE5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("dWM7f")).default; });

var $dWM7f = parcelRequire("dWM7f");

});
parcelRegister("dWM7f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17a81881ca6e4dbf$export$2e2bcd8739ae039; });
/* list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");

var $4muOv = parcelRequire("4muOv");
const $17a81881ca6e4dbf$var$UniformList = ({ gap: gap = "space.100", maxHeight: maxHeight, isHorizontal: isHorizontal = false })=>{
    const spaceTokenValue = (0, $4muOv.spaceTokenValues)[gap];
    const listStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21q43 _zulpfogq _c71l1nve _1reo15vq _18m915vq"
        ]),
        style: {
            "--_edet6m": (0, $43MIc.default)(isHorizontal ? "row" : "column"),
            "--_e9ez6f": (0, $43MIc.default)("var(--ds-space-" + spaceTokenValue + ")"),
            "--_6stjzx": (0, $43MIc.default)(maxHeight ? maxHeight + "px" : "none")
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "listItems"
        })
    });
};
var $17a81881ca6e4dbf$export$2e2bcd8739ae039 = $17a81881ca6e4dbf$var$UniformList;

});


parcelRegister("ee1EE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("1Yaob")).default; });

var $1Yaob = parcelRequire("1Yaob");

});
parcelRegister("1Yaob", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebf870f54152743d$export$2e2bcd8739ae039; });
/* listv2.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");

var $62pC7 = parcelRequire("62pC7");
const $ebf870f54152743d$var$createResponsiveGapObject = (gapv2)=>{
    var _gapv2_mobile, _gapv2_tablet, _ref, _gapv2_desktop, _ref1, _ref2;
    return {
        mobile: (_gapv2_mobile = gapv2.mobile) !== null && _gapv2_mobile !== void 0 ? _gapv2_mobile : "0",
        tablet: (_ref = (_gapv2_tablet = gapv2 === null || gapv2 === void 0 ? void 0 : gapv2.tablet) !== null && _gapv2_tablet !== void 0 ? _gapv2_tablet : gapv2.mobile) !== null && _ref !== void 0 ? _ref : "0",
        desktop: (_ref2 = (_ref1 = (_gapv2_desktop = gapv2 === null || gapv2 === void 0 ? void 0 : gapv2.desktop) !== null && _gapv2_desktop !== void 0 ? _gapv2_desktop : gapv2 === null || gapv2 === void 0 ? void 0 : gapv2.tablet) !== null && _ref1 !== void 0 ? _ref1 : gapv2.mobile) !== null && _ref2 !== void 0 ? _ref2 : "0"
    };
};
const $ebf870f54152743d$var$createResponsiveOrientationObject = (orientation)=>({
        mobile: orientation.mobile || "vertical",
        tablet: orientation.tablet || orientation.mobile || "vertical",
        desktop: orientation.desktop || orientation.tablet || orientation.mobile || "vertical"
    });
const $ebf870f54152743d$var$createResponsiveWrappedChildContentObject = (wrappedChildContent)=>({
        mobile: (wrappedChildContent === null || wrappedChildContent === void 0 ? void 0 : wrappedChildContent.mobile) || "nowrap",
        tablet: (wrappedChildContent === null || wrappedChildContent === void 0 ? void 0 : wrappedChildContent.tablet) || (wrappedChildContent === null || wrappedChildContent === void 0 ? void 0 : wrappedChildContent.mobile) || "nowrap",
        desktop: (wrappedChildContent === null || wrappedChildContent === void 0 ? void 0 : wrappedChildContent.desktop) || (wrappedChildContent === null || wrappedChildContent === void 0 ? void 0 : wrappedChildContent.tablet) || (wrappedChildContent === null || wrappedChildContent === void 0 ? void 0 : wrappedChildContent.mobile) || "nowrap"
    });
const $ebf870f54152743d$var$createResponsiveJustifyContentObject = (justifyContent)=>({
        mobile: justifyContent.mobile || "flex-start",
        tablet: (justifyContent === null || justifyContent === void 0 ? void 0 : justifyContent.tablet) || (justifyContent === null || justifyContent === void 0 ? void 0 : justifyContent.mobile) || "flex-start",
        desktop: (justifyContent === null || justifyContent === void 0 ? void 0 : justifyContent.desktop) || (justifyContent === null || justifyContent === void 0 ? void 0 : justifyContent.tablet) || justifyContent.mobile || "flex-start"
    });
const $ebf870f54152743d$var$getFlexWrapValue = (value)=>{
    if (value === "wrap") return "wrap";
    if (value === "wrap-reverse") return "wrap-reverse";
    return "nowrap";
};
const $ebf870f54152743d$var$zeroMarginPadding = null;
const $ebf870f54152743d$var$resetListStyles = null;
const $ebf870f54152743d$var$createRenderListItems = (listType)=>{
    return ({ items: items })=>{
        // Only works for paired dt/dd items. Would need different solution for different structure
        if (listType === "dl") return items.map((item, index)=>{
            if (index % 2 === 0) return /*#__PURE__*/ (0, $loA2J.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("dt", {
                        children: item
                    }),
                    items[index + 1] && /*#__PURE__*/ (0, $loA2J.jsx)("dd", {
                        children: items[index + 1]
                    })
                ]
            }, index);
            return null;
        });
        if (listType === "ol") return items.map((item, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("li", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
                    "_qtt8glyw _1e0c1txw _2lx21bp4 _zulp1crf _1lp7vrvc _q8t51q9y"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $62pC7.ListItemNumber), {
                        value: index + 1
                    }),
                    item
                ]
            }, index));
        return items.map((item, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                className: (0, $esG4f.default)([
                    "_kkk2n7od _1e0c1txw",
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                ]),
                children: item
            }, index));
    };
};
const $ebf870f54152743d$var$UniformListV2 = ({ listType: listType, gapv2: gapv2 = {
    mobile: "0"
}, orientation: orientation = {
    mobile: "vertical"
}, wrappedChildContent: wrappedChildContent = {
    mobile: "nowrap"
}, justifyContent: justifyContent = {
    mobile: "flex-start"
} })=>{
    const gapObject = $ebf870f54152743d$var$createResponsiveGapObject(gapv2);
    const orientationObject = $ebf870f54152743d$var$createResponsiveOrientationObject(orientation);
    const wrappedChildContentObject = $ebf870f54152743d$var$createResponsiveWrappedChildContentObject(wrappedChildContent);
    const justifyContentObject = $ebf870f54152743d$var$createResponsiveJustifyContentObject(justifyContent); // css() calls must be inline for Compiled CSS static analysis
    const listStyle = null;
    const orientationStyle = null;
    const wrappedChildContentStyle = null;
    const justifyContentStyle = null;
    const renderListItems = $ebf870f54152743d$var$createRenderListItems(listType);
    const ListTypeComponent = listType || "ul";
    return /*#__PURE__*/ (0, $loA2J.jsx)(ListTypeComponent, {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp1a6y _19wggsi3 _pdlmxbqd",
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            "_1hmt1wth _16wj1p3b _1q2jw4vn",
            "_1e0c1txw _2lx22h65 _1lp71tnc _1inip4d6",
            "_1e0c1txw _1n261g80 _zkhy1g80 _45zz1g80",
            "_1bahown3 _e8gh2fwo _msup1t9b"
        ]),
        style: {
            "--_rkv8x9": (0, $43MIc.default)("var(--ds-space-" + gapObject.mobile + ")"),
            "--_9wptik": (0, $43MIc.default)("var(--ds-space-" + gapObject.tablet + ")"),
            "--_3wdyhk": (0, $43MIc.default)("var(--ds-space-" + gapObject.desktop + ")"),
            "--_pv2ypa": (0, $43MIc.default)(orientationObject.mobile === "horizontal" ? "row" : "column"),
            "--_dek1s0": (0, $43MIc.default)(orientationObject.tablet === "horizontal" ? "row" : "column"),
            "--_1ng513r": (0, $43MIc.default)(orientationObject.desktop === "horizontal" ? "row" : "column"),
            "--_vie9y1": (0, $43MIc.default)(justifyContentObject.mobile),
            "--_1rrey82": (0, $43MIc.default)(justifyContentObject.tablet),
            "--_pc7561": (0, $43MIc.default)(justifyContentObject.desktop)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "listItems",
            wrapperComponent: renderListItems
        })
    });
};
var $ebf870f54152743d$export$2e2bcd8739ae039 = $ebf870f54152743d$var$UniformListV2;

});
parcelRegister("62pC7", function(module, exports) {

$parcel$export(module.exports, "ListItemNumber", function () { return $f824e5ec7d10d94f$export$448080ad20b09ab8; });
/* list-item-number.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $5ohHq = parcelRequire("5ohHq");
const $f824e5ec7d10d94f$export$448080ad20b09ab8 = (props)=>{
    const { value: value } = props;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _4t3ickbl _1bsbckbl _2rko1osq _11q76kkz _1e0c1txw _1bah1h6o _4cvr1h6o _syaz1tj6 _y3gn1h6o _ect41pz4 _1wybgktf _zg8l4jg8 _k48p1fw0 _vwz4183y"
        ]),
        style: {
            "--_1qa6cp7": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue200")),
            "--_1tgiy09": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue900")),
            "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
        },
        children: value
    });
};

});



parcelRegister("cmgz2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("y6XPA")).default; });

var $y6XPA = parcelRequire("y6XPA");

});
parcelRegister("y6XPA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c33207fb5f4a10c$export$2e2bcd8739ae039; });
/* logos.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
parcelRequire("dMM9X");
var $2Nqw3 = parcelRequire("2Nqw3");

var $kMNUa = parcelRequire("kMNUa");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0c33207fb5f4a10c$var$UniformLogos = (intakeProps)=>{
    const { title: title, logos: logos } = (0, $kMNUa.flattenLogoProps)(intakeProps);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulpoahv _pdlmxncg _y3gn1h6o"
        ]),
        children: [
            title && /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: title
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $2Nqw3.Logos), {
                logos: logos
            })
        ]
    });
};
var $0c33207fb5f4a10c$export$2e2bcd8739ae039 = $0c33207fb5f4a10c$var$UniformLogos;

});


parcelRegister("kgmR5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("fq2e7")).default; });

var $fq2e7 = parcelRequire("fq2e7");

});
parcelRegister("fq2e7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a78475915aa8c839$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $5VMi0 = parcelRequire("5VMi0");
const $a78475915aa8c839$export$d64e2f97651f7f4d = (props)=>{
    const appearance = props.color === "red" ? "danger" : props.color || "neutral";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5VMi0.Lozenge), {
        appearance: appearance,
        text: props.text
    });
};
var $a78475915aa8c839$export$2e2bcd8739ae039 = $a78475915aa8c839$export$d64e2f97651f7f4d;

});


parcelRegister("kh16D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("3HmCN")).default; });

var $3HmCN = parcelRequire("3HmCN");

});
parcelRegister("3HmCN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85cb8a5f1dff2eeb$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dMM9X");
var $cJh4j = parcelRequire("cJh4j");

var $8lB1y = parcelRequire("8lB1y");
const $85cb8a5f1dff2eeb$var$UniformMobileApp = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cJh4j.MobileApp), {
        title: props.title,
        description: props.richText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            text: props.richText
        }) : props.description,
        linkLabel: props.linkLabel,
        linkHref: props.linkHref,
        imageSrc: props.imageSrc,
        imageAlt: props.imageAlt,
        appleAppStoreUrl: props.appleAppStoreUrl,
        googlePlayStoreUrl: props.googlePlayStoreUrl
    });
};
var $85cb8a5f1dff2eeb$export$2e2bcd8739ae039 = $85cb8a5f1dff2eeb$var$UniformMobileApp;

});


parcelRegister("liGDD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("9ScPv")).default; });

var $9ScPv = parcelRequire("9ScPv");

});
parcelRegister("9ScPv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cb2f8cde4557d14$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");

var $1rLfN = parcelRequire("1rLfN");
// Pass modalSize as the width directly to the Modal component
const $0cb2f8cde4557d14$var$UniformModal = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1rLfN.ModalLink), {
        modalTitle: props.modalTitle,
        modalCloseLabel: props.modalCloseLabel,
        ctaText: props.ctaText,
        modalWidth: props.modalSize,
        modalLinkType: props.modalLinkType,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "modalContent"
        })
    });
};
var $0cb2f8cde4557d14$export$2e2bcd8739ae039 = $0cb2f8cde4557d14$var$UniformModal;

});
parcelRegister("1rLfN", function(module, exports) {

$parcel$export(module.exports, "ModalLink", function () { return $8bb80322af964ea2$export$cf363aa9ce73688b; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $1O6nN = parcelRequire("1O6nN");

var $edRuD = parcelRequire("edRuD");
const $8bb80322af964ea2$export$cf363aa9ce73688b = ({ modalTitle: modalTitle, modalCloseLabel: modalCloseLabel, children: children, ctaText: ctaText, modalWidth: modalWidth, modalLinkType: modalLinkType = "modal" })=>{
    const [isOpen, setIsOpen] = (0, $iSvIT.useState)(false);
    const openModal = (e)=>{
        e.preventDefault();
        setIsOpen(true);
    };
    const closeModal = (0, $iSvIT.useCallback)(()=>setIsOpen(false), []);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1O6nN.Link), {
                onClick: openModal,
                "aria-label": "modal-link",
                text: ctaText,
                href: "#modal-section",
                type: modalLinkType
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $edRuD.Modal), {
                closeModal: closeModal,
                closeLabel: modalCloseLabel,
                title: modalTitle,
                isOpen: isOpen,
                width: modalWidth,
                children: children
            })
        ]
    });
};

});



parcelRegister("ixWw7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("cJj5V")).default; });

var $cJj5V = parcelRequire("cJj5V");

});
parcelRegister("cJj5V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a9cc98f36fb0b33$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");

var $gPr7r = parcelRequire("gPr7r");

var $aRHrH = parcelRequire("aRHrH");

var $4XrxY = parcelRequire("4XrxY");

var $kex29 = parcelRequire("kex29");

var $cP0Yq = parcelRequire("cP0Yq");

var $2RWab = parcelRequire("2RWab");

var $a4JY7 = parcelRequire("a4JY7");

var $8PL6n = parcelRequire("8PL6n");

var $bwE7U = parcelRequire("bwE7U");

var $gxFZp = parcelRequire("gxFZp");

var $hDoR2 = parcelRequire("hDoR2");

var $kGZng = parcelRequire("kGZng");

var $lGc56 = parcelRequire("lGc56");

var $4Cacz = parcelRequire("4Cacz");

var $j6Axx = parcelRequire("j6Axx");

var $dJVgs = parcelRequire("dJVgs");

var $61A0C = parcelRequire("61A0C");

var $9g0oR = parcelRequire("9g0oR");

var $2ChcF = parcelRequire("2ChcF");

var $68wZ4 = parcelRequire("68wZ4");

var $g99nl = parcelRequire("g99nl");

var $7lLj0 = parcelRequire("7lLj0");

var $3663Y = parcelRequire("3663Y");

var $gAJUc = parcelRequire("gAJUc");

var $2ceSC = parcelRequire("2ceSC");

var $gygyq = parcelRequire("gygyq");

var $52gYK = parcelRequire("52gYK");
const $1a9cc98f36fb0b33$export$6955bcca4cd3539f = (props)=>{
    var _component_slots;
    const { component: component, siteSelectorProductKey: siteSelectorProductKey, siteSelectorAnalyticsPrefix: siteSelectorAnalyticsPrefix } = props;
    const fullSiteSelectorProductKey = siteSelectorProductKey === "jira-service-management" ? "jira-servicedesk.ondemand" : `${siteSelectorProductKey}.ondemand`;
    const locale = (0, $2ceSC.useLocale)();
    const isBootIntercom = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp5381AddIntercomWidgetToUniform);
    const intercomAppId = locale === "ja" ? "p0ww63i2" : "";
    var _component_slots_content;
    const contentSlot = (_component_slots_content = (_component_slots = component.slots) === null || _component_slots === void 0 ? void 0 : _component_slots["content"]) !== null && _component_slots_content !== void 0 ? _component_slots_content : [];
    const pageHasGlobalNavComponent = !!contentSlot.find((content)=>content.type === "globalNav");
    const pageHasGlobalFooterComponent = !!contentSlot.find((content)=>content.type === "globalFooter");
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $aRHrH.IntercomProvider), {
        appId: intercomAppId,
        triggerBoot: isBootIntercom,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $gPr7r.default), {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $52gYK.OptionalSiteSelectorContextProvider), {
                    siteSelectorProductKey: fullSiteSelectorProductKey,
                    siteSelectorAnalyticsPrefix: siteSelectorAnalyticsPrefix,
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                                name: "enhancedBannerSlot"
                            })
                        }),
                        !pageHasGlobalNavComponent && /*#__PURE__*/ (0, $loA2J.jsx)($1a9cc98f36fb0b33$export$f24150b9675a2c65, {
                            component: component
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("main", {
                                id: "content",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                                    name: "content"
                                })
                            })
                        })
                    ]
                })
            }),
            !pageHasGlobalFooterComponent && /*#__PURE__*/ (0, $loA2J.jsx)($1a9cc98f36fb0b33$export$1b198b648cc5b0ce, {
                component: component
            })
        ]
    });
};
const $1a9cc98f36fb0b33$export$f24150b9675a2c65 = ({ component: component })=>{
    const pageNavType = component.parameters && component.parameters["nav"] && component.parameters["nav"].value;
    let pageNav;
    switch(pageNavType){
        case "confluence":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $kGZng.default), {});
            break;
        case "bitbucket":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $gxFZp.BitbucketNav), {});
            break;
        case "confluence-template-experiment":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $lGc56.ConfluenceTemplateHeaderContainer), {});
            break;
        case "enterprise":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bwE7U.default), {});
            break;
        case "jira-software":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJVgs.default), {});
            break;
        case "jira-service-management":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.default), {});
            break;
        case "jira-product-discovery":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $j6Axx.default), {});
            break;
        case "gwp-7880-jira-software-templates-experiment":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $61A0C.default), {});
            break;
        case "gwp-7880-jira-service-management-templates-experiment":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $2ChcF.default), {});
            break;
        case "compass":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $hDoR2.CompassNav), {});
            break;
        case "atlassian-access":
        case "guard":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4Cacz.GuardNav), {});
            break;
        case "rovo":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $g99nl.RovoNav), {});
            break;
        case "rovo-dev":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $gygyq.RovoDevNav), {});
            break;
        case "loom":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $68wZ4.LoomNav), {});
            break;
        case "teamwork-collection":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $8PL6n.TeamworkCollectionNavbar), {});
            break;
        case "strategy-collection":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $2RWab.StrategyCollectionNavbar), {});
            break;
        case "service-collection":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $a4JY7.ServiceCollectionNavbar), {});
            break;
        case "sourcetree-app":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $3663Y.SourcetreeAppNav), {});
            break;
        case "global-nav-no-try-now-cta":
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.default), {
                productKey: "uniform",
                isShowTryNowLink: false
            });
            break;
        case "none":
            break;
        case "global":
        default:
            pageNav = /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.default), {
                productKey: "uniform",
                isShowTryNowLink: true
            });
            break;
    }
    return pageNav;
};
const $1a9cc98f36fb0b33$export$1b198b648cc5b0ce = ({ component: component })=>{
    const pageFooterType = component.parameters && component.parameters["footer"] && component.parameters["footer"].value;
    let pageFooter;
    switch(pageFooterType){
        case "sourcetree-app":
            pageFooter = /*#__PURE__*/ (0, $loA2J.jsx)((0, $7lLj0.SourcetreeAppFooter), {});
            break;
        case "none":
            break;
        case "global":
        default:
            pageFooter = /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {});
            break;
    }
    return pageFooter;
};
var $1a9cc98f36fb0b33$export$2e2bcd8739ae039 = $1a9cc98f36fb0b33$export$6955bcca4cd3539f;

});
parcelRegister("gPr7r", function(module, exports) {

$parcel$export(module.exports, "useProductTemplateContext", function () { return $205f85a083271d56$export$9aa15cd8273c8730; });
$parcel$export(module.exports, "default", function () { return $205f85a083271d56$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $205f85a083271d56$var$ProductTemplateContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    template: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setTemplate: ()=>{}
});
const $205f85a083271d56$export$d254455f6d2132ac = ({ children: children })=>{
    const [template, setTemplate] = (0, $iSvIT.useState)(null);
    const value = (0, $iSvIT.useMemo)(()=>({
            template: template,
            setTemplate: setTemplate
        }), [
        template
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($205f85a083271d56$var$ProductTemplateContext.Provider, {
        value: value,
        children: children
    });
};
const $205f85a083271d56$export$9aa15cd8273c8730 = ()=>{
    const context = (0, $iSvIT.useContext)($205f85a083271d56$var$ProductTemplateContext);
    if (!context) throw new Error("useProductTemplateContext must be used within a ProductTemplateContextProvider");
    return context;
};
var $205f85a083271d56$export$2e2bcd8739ae039 = $205f85a083271d56$export$d254455f6d2132ac;

});

parcelRegister("a4JY7", function(module, exports) {

$parcel$export(module.exports, "ServiceCollectionNavbar", function () { return $d8f13c7e7c4f9ba4$export$21a8ade06194f818; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $cP0Yq = parcelRequire("cP0Yq");

var $4R0f2 = parcelRequire("4R0f2");

var $lCocY = parcelRequire("lCocY");
const $d8f13c7e7c4f9ba4$export$21a8ade06194f818 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.GlobalNav), {
        productKey: "home",
        compoundNav: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $4R0f2.CollectionsCompoundSubNavProps)()), {
            ctaUrl: (0, $lCocY.CTA_URL_PATH)
        })
    });
};

});
parcelRegister("lCocY", function(module, exports) {

$parcel$export(module.exports, "CTA_URL_PATH", function () { return $753242cc13657a15$export$d5587a12d9eea1dc; });
const $753242cc13657a15$export$d5587a12d9eea1dc = "/collections/service#contact";

});


parcelRegister("61A0C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $537cd27d87d2a568$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $gPr7r = parcelRequire("gPr7r");

var $5ZKRm = parcelRequire("5ZKRm");

var $dJVgs = parcelRequire("dJVgs");
const $537cd27d87d2a568$var$JiraSoftwareNavUniform = ()=>{
    const { template: template } = (0, $gPr7r.useProductTemplateContext)();
    const { openModalForTemplate: openModalForTemplate } = (0, $5ZKRm.useSiteSelectorContext)();
    const [isUseOpenCrossFlow, setIsUseOpenCrossFlow] = (0, $iSvIT.useState)(false);
    const openModalForTemplateClickAction = (0, $iSvIT.useMemo)(()=>{
        return (event)=>{
            event.preventDefault();
            event.stopPropagation();
            openModalForTemplate({
                templateId: template === null || template === void 0 ? void 0 : template.templateId,
                templateName: template === null || template === void 0 ? void 0 : template.templateName,
                productKey: template === null || template === void 0 ? void 0 : template.productKey
            });
        };
    }, [
        openModalForTemplate,
        template === null || template === void 0 ? void 0 : template.templateId,
        template === null || template === void 0 ? void 0 : template.templateName,
        template === null || template === void 0 ? void 0 : template.productKey
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if ((template === null || template === void 0 ? void 0 : template.templateId) && (template === null || template === void 0 ? void 0 : template.templateName) && (template === null || template === void 0 ? void 0 : template.productKey)) setIsUseOpenCrossFlow(true);
    }, [
        template === null || template === void 0 ? void 0 : template.templateId,
        template === null || template === void 0 ? void 0 : template.templateName,
        template === null || template === void 0 ? void 0 : template.productKey
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJVgs.default), {
        productNavCtaCTAClickFunction: openModalForTemplateClickAction,
        isUseOpenCrossFlow: isUseOpenCrossFlow
    });
};
$537cd27d87d2a568$var$JiraSoftwareNavUniform.displayName = "JiraSoftwareNavUniform";
var $537cd27d87d2a568$export$2e2bcd8739ae039 = $537cd27d87d2a568$var$JiraSoftwareNavUniform;

});

parcelRegister("2ChcF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5968950e65378e4$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $gPr7r = parcelRequire("gPr7r");

var $5ZKRm = parcelRequire("5ZKRm");

var $9g0oR = parcelRequire("9g0oR");
const $f5968950e65378e4$var$JiraServiceManagementSoftwareNavV2Uniform = ()=>{
    const { template: template } = (0, $gPr7r.useProductTemplateContext)();
    const { openModalForTemplate: openModalForTemplate } = (0, $5ZKRm.useSiteSelectorContext)();
    const [isUseOpenCrossFlow, setIsUseOpenCrossFlow] = (0, $iSvIT.useState)(false);
    const openModalForTemplateClickAction = (0, $iSvIT.useMemo)(()=>{
        return (event)=>{
            event.preventDefault();
            event.stopPropagation();
            openModalForTemplate({
                templateId: template === null || template === void 0 ? void 0 : template.templateId,
                templateName: template === null || template === void 0 ? void 0 : template.templateName,
                productKey: template === null || template === void 0 ? void 0 : template.productKey
            });
        };
    }, [
        openModalForTemplate,
        template === null || template === void 0 ? void 0 : template.templateId,
        template === null || template === void 0 ? void 0 : template.templateName,
        template === null || template === void 0 ? void 0 : template.productKey
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if ((template === null || template === void 0 ? void 0 : template.templateId) && (template === null || template === void 0 ? void 0 : template.templateName) && (template === null || template === void 0 ? void 0 : template.productKey)) setIsUseOpenCrossFlow(true);
    }, [
        template === null || template === void 0 ? void 0 : template.templateId,
        template === null || template === void 0 ? void 0 : template.templateName,
        template === null || template === void 0 ? void 0 : template.productKey
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.default), {
        productNavCtaCTAClickFunction: openModalForTemplateClickAction,
        isUseOpenCrossFlow: isUseOpenCrossFlow
    });
};
$f5968950e65378e4$var$JiraServiceManagementSoftwareNavV2Uniform.displayName = "JiraServiceManagementSoftwareNavV2Uniform";
var $f5968950e65378e4$export$2e2bcd8739ae039 = $f5968950e65378e4$var$JiraServiceManagementSoftwareNavV2Uniform;

});

parcelRegister("7lLj0", function(module, exports) {

$parcel$export(module.exports, "SourcetreeAppFooter", function () { return $a9fe91560901d175$export$e1512df89103926d; });
/* sourcetree-app-footer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");

var $3SXL2 = parcelRequire("3SXL2");

var $dKbKl = parcelRequire("dKbKl");
const $a9fe91560901d175$var$globalFooterStyle = null;
const $a9fe91560901d175$var$globalFooterContentContainerStyle = null;
const $a9fe91560901d175$export$e1512df89103926d = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("footer", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _11q7cd5j _1e0c1txw _2lx2vrvc _1bah1h6o"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_bfhkcd5j _1rjcpxbi _1e0c1txw _2lx21bp4 _zulppxbi _1bsb1osq _195g1tcg _dm251txw _10jx1fra _owpuidpf _xtn71wqb"
            ]),
            style: {
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $dKbKl.SourcetreeAppFooterTop), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $3SXL2.SourcetreeAppFooterBottom), {})
            ]
        })
    });

});
parcelRegister("3SXL2", function(module, exports) {

$parcel$export(module.exports, "SourcetreeAppFooterBottom", function () { return $38e759a0befcb3a5$export$89b0be2f0f7ea8dd; });
/* sourcetree-app-footer-bottom.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $4wAIt = parcelRequire("4wAIt");

var $8hHsi = parcelRequire("8hHsi");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");
// CSS styling
// ==================================================================
const $38e759a0befcb3a5$var$containerStyle = null;
const $38e759a0befcb3a5$var$linkStyle = null;
const $38e759a0befcb3a5$var$copyrightStyle = null;
const $38e759a0befcb3a5$var$linksAndLanguageStyle = null;
const $38e759a0befcb3a5$var$listStyle = null;
const $38e759a0befcb3a5$var$bottomViewAllLinkLiAnchorStyle = null; // ==================================================================
// Rendering Functions
// ==================================================================
const $38e759a0befcb3a5$var$BottomLinks = ()=>{
    const intl = (0, $f6qj2.default)();
    (0, $iSvIT.useEffect)(()=>{
        var _window_AtlOneTrustWrapper, _window;
        if ((_window = window) === null || _window === void 0 ? void 0 : (_window_AtlOneTrustWrapper = _window.AtlOneTrustWrapper) === null || _window_AtlOneTrustWrapper === void 0 ? void 0 : _window_AtlOneTrustWrapper.updatePolicyLinks) window.AtlOneTrustWrapper.updatePolicyLinks();
    }, []);
    const bottomLinks = [
        {
            text: intl.formatMessage({
                id: "sourcetreeapp.globalfooter.bottom.privacy-policy",
                defaultMessage: "Privacy policy"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/legal/privacy-policy"),
            isOneTrustWrapped: false
        },
        {
            text: intl.formatMessage({
                id: "sourcetreeapp.globalfooter.bottom.notice-at-collection",
                defaultMessage: "Notice at Collection"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/legal/privacy-policy#additional-disclosures-for-ca-residents"),
            isOneTrustWrapped: true
        },
        {
            text: intl.formatMessage({
                id: "sourcetreeapp.globalfooter.bottom.terms",
                defaultMessage: "Terms of use"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/legal/cloud-terms-of-service"),
            isOneTrustWrapped: false
        },
        {
            text: intl.formatMessage({
                id: "sourcetreeapp.globalfooter.bottom.trust.security",
                defaultMessage: "Trust & security"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/legal/atlassian-customer-agreement#intro"),
            isOneTrustWrapped: false
        }
    ];
    const bottomViewAllLink = {
        text: intl.formatMessage({
            id: "sourcetreeapp.globalfooter.bottom.view-all-products",
            defaultMessage: "View all Atlassian products"
        }),
        href: "http://www.atlassian.com/software",
        bgColor: "bgWhite"
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            bottomLinks.map((bottomLink)=>{
                if (bottomLink.isOneTrustWrapped) return /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                    className: "link-wrapper atl-policy-link-container",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8hHsi.LinkWithIcon), {
                        linkText: bottomLink.text,
                        href: bottomLink.href,
                        type: "anchor",
                        isHaveIcon: false,
                        isUsePlainSpanTagForLinkText: true,
                        className: (0, $esG4f.default)([
                            "_1wybdlk8 _vwz4dlk8 _4t3idlk8 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1hlo _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw",
                            "atl-policy-link"
                        ]),
                        spanLinkTextClassName: "atl-policy-link-text",
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                        }
                    })
                }, bottomLink.text);
                else return /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        text: bottomLink.text,
                        href: bottomLink.href,
                        type: "anchor",
                        bgColor: "bgColored",
                        "aria-label": "footer-link",
                        className: (0, $esG4f.default)([
                            "_1wybdlk8 _vwz4dlk8 _4t3idlk8 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1hlo _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw"
                        ]),
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                        }
                    })
                }, bottomLink.text);
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                    text: bottomViewAllLink.text,
                    href: bottomViewAllLink.href,
                    type: "primary",
                    bgColor: "bgColored",
                    "aria-label": "footer-link",
                    className: (0, $esG4f.default)([
                        "_syaz1hlo _1wyboxwj _4bfu1r31 _1hmsglyw _ajmmnqa1 _1dyz1a1y _ect4kipj _1a3b1r31 _9oik1r31 _1ydc1r31 _4fpr8stv _1bnx8stv _1x288stv _5goinqa1 _jf4cnqa1 _1726nqa1 _1ygbqgpo"
                    ]),
                    style: {
                        "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                        "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                    }
                })
            }, bottomViewAllLink.text.trim().replace(" ", "-"))
        ]
    });
};
const $38e759a0befcb3a5$var$copyRightYear = new Date().getFullYear();
const $38e759a0befcb3a5$export$89b0be2f0f7ea8dd = ({ className: className })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4wAIt.default), {
        name: "global-footer-v2-bottom",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1bsb1osq _p12fsgih _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1rjc1tcg _18zrpxbi _1e0c1txw _2lx21bp4 _zulpxy5q _su071ady _19wgxy5q _owpu1tcg _1inivrvc _msup1yb4 _1jsv1h6o",
                className
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    "data-testid": "footer-copyright",
                    className: (0, $esG4f.default)([
                        "_syaz1yg0 _vwz4f6fq _4t3if6fq _1wybdlk8 _10hl1h6o"
                    ]),
                    style: {
                        "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
                    },
                    children: [
                        "Copyright \xa9 ",
                        $38e759a0befcb3a5$var$copyRightYear,
                        " Atlassian"
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _zulppxbi _1lp7vrvc _19wgxy5q _q8t51h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4wAIt.default), {
                        name: "global-footer-v2-bottom-links",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                            className: (0, $esG4f.default)([
                                "_2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx21bp4 _zulppxbi _1lp7vrvc _19wgxy5q _q8t51h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)($38e759a0befcb3a5$var$BottomLinks, {})
                        })
                    })
                })
            ]
        })
    });
};

});

parcelRegister("dKbKl", function(module, exports) {

$parcel$export(module.exports, "SourcetreeAppFooterTop", function () { return $4e8d92d7f0378652$export$e7a002b3133bbe21; });
/* sourcetree-app-footer-top.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $4wAIt = parcelRequire("4wAIt");

var $bQawl = parcelRequire("bQawl");

var $9Yq3D = parcelRequire("9Yq3D");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $ehK1w = parcelRequire("ehK1w");

var $lrVTP = parcelRequire("lrVTP");
// ==================================================================
// CSS styling
// ==================================================================
const $4e8d92d7f0378652$var$containerStyle = null;
const $4e8d92d7f0378652$var$linksWrapperStyle = null;
const $4e8d92d7f0378652$export$26b6a80e48da8316 = {
    margin: "0",
    padding: "0",
    border: "0",
    fontSize: "100%",
    verticalAlign: "baseline"
}; // ==================================================================
// Rendering Functions
// ==================================================================
const $4e8d92d7f0378652$var$headerContainerStyle = null;
const $4e8d92d7f0378652$var$listOfLinksColumnHeaderStyle = null;
const $4e8d92d7f0378652$var$listOfLinksUlStyle = null;
const $4e8d92d7f0378652$var$textStyle = null;
const $4e8d92d7f0378652$var$connectTextStyle = null;
const $4e8d92d7f0378652$var$inputContainerStyle = null;
const $4e8d92d7f0378652$var$inputStyle = null;
const $4e8d92d7f0378652$var$socialButtonStandardStyle = null;
const $4e8d92d7f0378652$var$socialButtonsStyle = null;
const $4e8d92d7f0378652$var$twitterLinkStyle = null;
const $4e8d92d7f0378652$var$facebookLinkStyle = null;
const $4e8d92d7f0378652$var$socialButtonsListStyle = null;
const $4e8d92d7f0378652$var$socialButtonsGroupStyle = null;
const $4e8d92d7f0378652$var$searchInputContainerStyle = null;
const $4e8d92d7f0378652$var$sourcetreeTextStyle = null;
const $4e8d92d7f0378652$var$buttonStyle = null;
const $4e8d92d7f0378652$var$ConnectColumn = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4t3izwfg _1pfhze3t _6rthxy5q _1e0c1txw _4cvr1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    className: (0, $esG4f.default)([
                        "_1wybw1gv _o10x10nf _1p1dangw _syazr2ho _k48p53lb _ect48q0o",
                        "eyebrow-md"
                    ]),
                    style: {
                        "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                    },
                    children: "Connect with us"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rthidpf _qtt8glyw"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: (0, $esG4f.default)([
                        "_k48p1nn1 _1wyb1j6v _19pkidpf _2hwxidpf _otyr1tcg _18u0idpf _syaz1mpp _s7n41q9y"
                    ]),
                    children: "Sign up for Git articles and resources:"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("form", {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _4cvr1h6o _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1o8l _y3gn1e5h _1bsb1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9Yq3D.TextInput // ref={inputRef}
                            ), {
                                placeholder: "",
                                label: "",
                                name: "q",
                                id: "subscribe-input",
                                value: "Email address",
                                "data-testid": "subscribe-input",
                                "aria-label": "Subscribe Input",
                                className: (0, $esG4f.default)([
                                    "_16jlkb7n _1o9zkb7n _i0dlf1ug"
                                ])
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $bQawl.Button), {
                            text: "Subscribe",
                            type: "secondary",
                            size: "large",
                            color: "whiteblue",
                            className: (0, $esG4f.default)([
                                "_ahbq7vkz"
                            ])
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1yb4 _1bsb1osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _o5721q9c"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_k48p1nn1 _1wyb1j6v _syaz1mpp _s7n41q9y"
                            ]),
                            children: "Connect with Sourcetree"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _4cvr1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("ul", {
                            className: (0, $esG4f.default)([
                                "_vwz4kb7n _syazvejh _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _bozgidpf _qtt8glyw _1aaxusic _ahbq19bv"
                            ]),
                            style: {
                                "--_nl5by5": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue1000"))
                            },
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                                    className: (0, $esG4f.default)([
                                        "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                        href: "https://www.facebook.com/Atlassian",
                                        title: "Atlassian on Facebook",
                                        className: (0, $esG4f.default)([
                                            "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2 _syaz1yg0 _1wyboxwj _vwz4rrl5 _12l27vkz _azhwdzkh _11q71tu0 _1lrw1osq"
                                        ]),
                                        style: {
                                            "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
                                        },
                                        children: "Facebook"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                                    className: (0, $esG4f.default)([
                                        "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                        href: "https://twitter.com/sourcetree",
                                        title: "Follow us on Twitter",
                                        className: (0, $esG4f.default)([
                                            "_qtt8glyw _1e0c1o8l _1aax1e5h _4t3izwfg _1bsbzwfg _19pkidpf _2hwxidpf _otyridpf _18u014y2 _syaz1yg0 _1wyboxwj _vwz4rrl5 _12l27vkz _azhwdzkh _11q713k9 _1lrw1osq"
                                        ]),
                                        style: {
                                            "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
                                        },
                                        children: "Twitter"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const $4e8d92d7f0378652$export$e7a002b3133bbe21 = ()=>{
    const intl = (0, $f6qj2.default)();
    const location = (0, $lrVTP.useLocation)();
    const resourcesLinkList = {
        headerText: intl.formatMessage({
            id: "sourcetreeapp.top.resources",
            defaultMessage: "Resources"
        }),
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.support",
                    defaultMessage: "Support"
                }),
                href: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.support.link",
                    defaultMessage: "https://support.atlassian.com/sourcetree"
                })
            },
            {
                text: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.documentation",
                    defaultMessage: "Documentation"
                }),
                href: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.documentation.link",
                    defaultMessage: "https://confluence.atlassian.com/get-started-with-sourcetree"
                })
            },
            {
                text: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.about.atlassian",
                    defaultMessage: "About Atlassian"
                }),
                href: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.about.atlassian.link",
                    defaultMessage: "https://www.atlassian.com/company"
                })
            },
            {
                text: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.download.archive",
                    defaultMessage: "Download archive"
                }),
                href: intl.formatMessage({
                    id: "sourcetreeapp.globalfooter.top.download.archive.link",
                    defaultMessage: "https://sourcetreeapp.com/download-archives"
                })
            }
        ]
    };
    const sourcetreeAppLinkList = {
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: "sourcetreeapp.top.blog",
                    defaultMessage: "Blog"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/blog/sourcetree")
            }
        ]
    }; // Adding pdf to french locale for compliance
    if (location.pathname.startsWith("/fr")) sourcetreeAppLinkList.listOfLinks.push({
        text: `Index de l'\xe9galit\xe9 professionnelle`,
        // eslint-disable-next-line local/no-non-orangelogic-images-eslint
        href: "https://wac-cdn.atlassian.com/misc-assets/pdfs/2024-France-Gender-Equality-Index.pdf"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4wAIt.default), {
        name: "global-footer-sourcetreeapp-top",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_bfhk1rga _1rjc1tcg _18zrpxbi _2rko16cp _1bsb1osq _p12fsgih _19pk1wug _2hwx1wug _otyr1wug _18u01wug _umua1ady _owpu1tcg"
            ]),
            style: {
                "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
            },
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_nd5lrwmx _1e0c11p5 _yv0ehkll _zulpxy5q _1da71t02 _bcla1tcg _kd3kckbl _1rqt1raq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $ehK1w.LinkListContainer), (0, $6iHNw._)((0, $7Knp0._)({}, sourcetreeAppLinkList), {
                        logoType: "sourcetreeapp"
                    })),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $ehK1w.LinkListContainer), (0, $7Knp0._)({}, resourcesLinkList)),
                    /*#__PURE__*/ (0, $loA2J.jsx)($4e8d92d7f0378652$var$ConnectColumn, {})
                ]
            })
        })
    });
};

});


parcelRegister("3663Y", function(module, exports) {

$parcel$export(module.exports, "SourcetreeAppNav", function () { return $0c2bd20e3e225353$export$5ba9b99d6060872; });
/* sourcetree-app-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $lbVpk = parcelRequire("lbVpk");

var $5ohHq = parcelRequire("5ohHq");

var $cssyA = parcelRequire("cssyA");
const $0c2bd20e3e225353$var$stickyWrapperStyle = null;
const $0c2bd20e3e225353$var$imktNavbarStyle = null;
const $0c2bd20e3e225353$var$containerFluidStyle = null;
const $0c2bd20e3e225353$var$rowStyle = null;
const $0c2bd20e3e225353$var$columnStyle = null;
const $0c2bd20e3e225353$var$titleWrapperStyle = null;
const $0c2bd20e3e225353$var$rightNavStyle = null;
const $0c2bd20e3e225353$var$linkStyle = null;
const $0c2bd20e3e225353$var$logoStyle = null;
const $0c2bd20e3e225353$export$5ba9b99d6060872 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_vwz4kb7n _vchhusvi _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _1f491mrw"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("nav", {
            className: (0, $esG4f.default)([
                "_vwz4kb7n _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _1e0c1ule _1f491mrw _1bsb1osq"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_vwz4kb7n _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _bfhkcd5j _16qs1cd0 _12l21wug _ahbq1wug _1ul91osq _11rm1hrf _kqswh2mm _c71l11ux _1reo15vq _18m915vq _1pby1406 _1tket9kd"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_vwz4kb7n _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _ahbq1wug _12l21wug _p12f1fra"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_vwz4kb7n _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _1aax1e5h _1tket94y _bozg7vkz _y4ti7vkz _kqswh2mm _1bsb1osq _1e0c1txw _2lx2vrvc _1n261g80 _4cvr1h6o _1bah1yb4"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_vwz4kb7n _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _1e0c1txw _2lx2vrvc _4cvr1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                    href: "/",
                                    className: (0, $esG4f.default)([
                                        "_vwz4kb7n _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _syaz17la _1e0c1ule _1gjfrbkw _4t3i1wqb _4bfu1r31 _1hmsglyw _ajmmnqa1"
                                    ]),
                                    style: {
                                        "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                                    },
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cssyA.Picture), {
                                        image: {
                                            src: "https://wac-cdn.atlassian.com/dam/jcr:f32681c1-355d-4806-b29c-319b0c6ecb06/Sourcetree-blue.svg?cdnVersion=3108",
                                            alt: "Sourcetree logo"
                                        },
                                        className: (0, $esG4f.default)([
                                            "_vwz4kb7n _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _syaz17la _4t3i1ul9 _p12f1osq _6rth7vkz _s7n4yfq0 _kqswh2mm _152t1ssb _t9ec1i34 _lcxvglyw"
                                        ]),
                                        style: {
                                            height: "30px",
                                            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_vwz4kb7n _vchh1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1wyb1osq _s7n41q9y _85i5o7ao _1q51o7ao"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $lbVpk.Button), {
                                    variant: "primary",
                                    color: "blue",
                                    href: "https://product-downloads.atlassian.com/software/sourcetree/ga/Sourcetree_4.2.14_297.zip",
                                    dataEventProps: {
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "navbar",
                                        "data-product-key": "sourcetreeapp",
                                        "data-label-english": "Download free"
                                    },
                                    children: [
                                        " ",
                                        "Download free"
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};

});

parcelRegister("gygyq", function(module, exports) {

$parcel$export(module.exports, "RovoDevNav", function () { return $585a7ff05ee5573e$export$446da800ffd5a425; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $bhreu = parcelRequire("bhreu");

var $3FBn4 = parcelRequire("3FBn4");

var $cP0Yq = parcelRequire("cP0Yq");
const $585a7ff05ee5573e$export$446da800ffd5a425 = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=devai");
    const pricingHref = (0, $3FBn4.useLocalizedHref)("/software/rovo-dev/pricing");
    const documentationHref = (0, $3FBn4.useLocalizedHref)("https://support.atlassian.com/rovo/docs/work-with-rovo-dev-agents");
    const logo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/d888ipg7v6w1c6x4xfb578gfiw5238d0.svg",
            alt: "Rovo Dev"
        },
        style: {
            height: "26px"
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
        productLogoUrl: "/software/rovo-dev",
        productLogo: logo,
        productLogoAriaLabel: intl.formatMessage({
            id: "RovoDevNav.productLogoAriaLabel",
            defaultMessage: "Rovo Dev logo"
        }),
        mobileCtaText: intl.formatMessage({
            id: "RovoDevNav.tryItFree",
            defaultMessage: "Try it Free"
        }),
        navigationTrynowCtaText: intl.formatMessage({
            id: "RovoDevNav.tryItFree",
            defaultMessage: "Try it Free"
        }),
        mobileCtaUrl: signupLink,
        mobileLogo: logo,
        productPageNavLinks: [
            {
                globalLinksKey: "pricing",
                linkText: intl.formatMessage({
                    id: "RovoDevNav.pricing",
                    defaultMessage: "Pricing"
                }),
                hasSubnav: false,
                productKey: "rovo-dev",
                href: pricingHref
            },
            {
                globalLinksKey: "documentation",
                linkText: intl.formatMessage({
                    id: "RovoDevNav.documentation",
                    defaultMessage: "Documentation"
                }),
                hasSubnav: false,
                productKey: "rovo-dev",
                href: documentationHref
            }
        ],
        navigationTrynowCtaUrl: signupLink,
        mobileLinksSections: [
            {
                mobileLinkKey: "mobile-rovo-dev",
                mobileLinksProps: [
                    {
                        globalLinksKey: "pricing",
                        linkText: intl.formatMessage({
                            id: "RovoDevNav.pricing",
                            defaultMessage: "Pricing"
                        }),
                        hasSubnav: false,
                        productKey: "rovo-dev",
                        href: pricingHref
                    },
                    {
                        globalLinksKey: "documentation",
                        linkText: intl.formatMessage({
                            id: "RovoDevNav.documentation",
                            defaultMessage: "Documentation"
                        }),
                        hasSubnav: false,
                        productKey: "rovo-dev",
                        href: documentationHref
                    }
                ]
            }
        ]
    });
};

});

parcelRegister("52gYK", function(module, exports) {

$parcel$export(module.exports, "OptionalSiteSelectorContextProvider", function () { return $f7786a656b77b76d$export$ef73016e54e00d81; });

var $loA2J = parcelRequire("loA2J");

var $gkV6l = parcelRequire("gkV6l");
const $f7786a656b77b76d$export$ef73016e54e00d81 = (props)=>{
    const { siteSelectorProductKey: siteSelectorProductKey, siteSelectorAnalyticsPrefix: siteSelectorAnalyticsPrefix, children: children } = props;
    if (!siteSelectorProductKey) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $gkV6l.SiteSelectorContextProvider), {
        productKey: siteSelectorProductKey,
        analyticsPrefix: siteSelectorAnalyticsPrefix !== null && siteSelectorAnalyticsPrefix !== void 0 ? siteSelectorAnalyticsPrefix : siteSelectorProductKey,
        children: children
    });
};

});



parcelRegister("bMQWw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("k3kI6")).default; });

var $k3kI6 = parcelRequire("k3kI6");

});
parcelRegister("k3kI6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fedb85474fab90c9$export$2e2bcd8739ae039; });
/* pagination.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $8LSiz = parcelRequire("8LSiz");
const $fedb85474fab90c9$var$centerStyles = null;
const $fedb85474fab90c9$var$UniformPagination = (props)=>{
    // Generate pages array from total pages
    const pagesArray = Array.from({
        length: props.pages
    }, (_, i)=>i + 1); // For now, using defaults until page logic is implemented
    const selectedIndex = 0;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8LSiz.Pagination), {
            pages: pagesArray,
            selectedIndex: selectedIndex
        })
    });
};
var $fedb85474fab90c9$export$2e2bcd8739ae039 = $fedb85474fab90c9$var$UniformPagination;

});


parcelRegister("4DwX2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("a35tB")).default; });

var $a35tB = parcelRequire("a35tB");

});
parcelRegister("a35tB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3794429f5920107$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $7eZEV = parcelRequire("7eZEV");

var $krNyQ = parcelRequire("krNyQ");
const $d3794429f5920107$var$UniformPanel = (props)=>{
    var _props_description;
    const panelProps = {
        panelType: props.panelType,
        label: props.label,
        description: props.richText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
            name: null,
            text: props.richText
        }) : (_props_description = props.description) !== null && _props_description !== void 0 ? _props_description : null
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eZEV.Panel), (0, $7Knp0._)({}, panelProps));
};
var $d3794429f5920107$export$2e2bcd8739ae039 = $d3794429f5920107$var$UniformPanel;

});


parcelRegister("5TIC4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("6Lfpq")).default; });

var $6Lfpq = parcelRequire("6Lfpq");

});
parcelRegister("6Lfpq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67ea48e347ad7dcf$export$2e2bcd8739ae039; });
/* personalization-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");

var $g9kzu = parcelRequire("g9kzu");

var $5ohHq = parcelRequire("5ohHq");

var $9iWJ8 = parcelRequire("9iWJ8");

var $gAJUc = parcelRequire("gAJUc");

var $kNCWT = parcelRequire("kNCWT");

var $jFQmg = parcelRequire("jFQmg");

var $1mZZG = parcelRequire("1mZZG");

var $bQiYD = parcelRequire("bQiYD");
var $67ea48e347ad7dcf$var$VariantsStatus;
(function(VariantsStatus) {
    VariantsStatus["NO_VARIANT_MATCH"] = "no_variant_match";
    VariantsStatus["VARIANTS_AVAILABLE"] = "variants_available";
    VariantsStatus["FETCHING_SEGMENTS"] = "fetching_segments";
    VariantsStatus["SEGMENT_FETCH_ERROR"] = "segment_fetch_error";
    VariantsStatus["MISSING_USER_SEGMENTS"] = "missing_user_segments";
    VariantsStatus["PERSONALIZATION_DISABLED"] = "personalization_disabled";
    VariantsStatus["NOT_ENROLLED_IN_EXPERIMENT"] = "not_enrolled_in_experiment";
})($67ea48e347ad7dcf$var$VariantsStatus || ($67ea48e347ad7dcf$var$VariantsStatus = {}));
const $67ea48e347ad7dcf$var$VariantSelector = (props)=>{
    return(// this should only be one item, but the SlotWrapper expects an array
    /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
        children: props.items.map((item, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                children: item
            }, `variant-${index}`))
    }));
}; // Helper function to render default slot
const $67ea48e347ad7dcf$var$renderDefaultSlot = (variantStatus, setRenderMessage)=>{
    const messages = {
        ["no_variant_match"]: "No variants match. Rendering Default",
        ["missing_user_segments"]: "No User Segments acquired. Rendering Default",
        ["personalization_disabled"]: "Personalization is disabled. Rendering Default",
        ["segment_fetch_error"]: "Error fetching User Segments. Rendering Default",
        ["not_enrolled_in_experiment"]: "User not enrolled in experiment. Rendering Default",
        ["fetching_segments"]: "Fetching User Segments. Temporarily rendering Default",
        // never invoked, but needed to satisfy the type system s
        ["variants_available"]: ""
    };
    setRenderMessage(messages[variantStatus]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: "default",
        wrapperComponent: $67ea48e347ad7dcf$var$VariantSelector
    });
}; // Helper function to find matching variant index
const $67ea48e347ad7dcf$var$findMatchingVariant = (variantCandidates, personalizationSegmentValues)=>{
    if (!personalizationSegmentValues) return -1;
    return variantCandidates.findIndex((variantCandidate)=>{
        var _variantCandidate_parameters_personalizationSegment, _variantCandidate_parameters;
        // all user segments specified by the Author in the variant (product, job function, domain type, etc.)
        const segments = (_variantCandidate_parameters = variantCandidate.parameters) === null || _variantCandidate_parameters === void 0 ? void 0 : (_variantCandidate_parameters_personalizationSegment = _variantCandidate_parameters["personalizationSegment"]) === null || _variantCandidate_parameters_personalizationSegment === void 0 ? void 0 : _variantCandidate_parameters_personalizationSegment.value; // check if all segments match the user's profile
        return segments.every(({ segmentType: segmentType, value: segmentTargets })=>{
            const userValueForThisSegment = personalizationSegmentValues[segmentType]; // if the user doesn't have a value for this segment, it can't match
            if (!userValueForThisSegment) return false;
             // handle owned products differently, since it's an array of products.
            if (segmentType === (0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS) // we want to check if any of the user's owned products match one of the author-defined segment's value
            return segmentTargets.some((product)=>userValueForThisSegment.includes(product));
             // for all other single-valued segments, simply check if the user's value
            return segmentTargets.includes(userValueForThisSegment || "");
        });
    });
}; // Helper function to get final personalization values
const $67ea48e347ad7dcf$var$getFinalPersonalizationValues = (userSegments, overrides)=>{
    const finalValues = (0, $6iHNw._)((0, $7Knp0._)({}, userSegments, (overrides === null || overrides === void 0 ? void 0 : overrides.useOverrides) ? overrides : {}), {
        useOverrides: (overrides === null || overrides === void 0 ? void 0 : overrides.useOverrides) || false,
        enrollInExperiment: (overrides === null || overrides === void 0 ? void 0 : overrides.enrollInExperiment) || false
    });
    return finalValues;
};
const $67ea48e347ad7dcf$var$ExperimentallyPersonalizedSection = ({ experimentId: experimentId, setVariantStatus: setVariantStatus, overrides: overrides, setRenderMessage: setRenderMessage, variantComponent: variantComponent })=>{
    const experimentStatus = (0, $9iWJ8.useExperiment)({
        experimentName: experimentId,
        parameterName: "enrolled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: (value)=>typeof value === "boolean"
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Personalization Experiment - configured in Uniform",
            expectedReleaseDate: "unknown - configured in Uniform",
            expectedRuntime: "unknown - configured in Uniform",
            context: {
                urls: []
            }
        }
    });
    const showTreatment = experimentStatus.type === "enrolled" && experimentStatus.value;
    (0, $iSvIT.useEffect)(()=>{
        if (!showTreatment && !(overrides === null || overrides === void 0 ? void 0 : overrides.enrollInExperiment)) {
            if (setVariantStatus) setVariantStatus("not_enrolled_in_experiment");
        }
    }, [
        showTreatment,
        overrides === null || overrides === void 0 ? void 0 : overrides.enrollInExperiment,
        setVariantStatus
    ]);
    if (!showTreatment && !(overrides === null || overrides === void 0 ? void 0 : overrides.enrollInExperiment)) return $67ea48e347ad7dcf$var$renderDefaultSlot("not_enrolled_in_experiment", setRenderMessage);
    return variantComponent;
}; // Helper function to validate personalization prerequisites
const $67ea48e347ad7dcf$var$validatePersonalizationPrerequisites = (shouldPersonalize, userSegments, userSegmentStatus, error, overrides)=>{
    if (userSegmentStatus !== "complete") return {
        isValid: false,
        status: "fetching_segments"
    };
    if (!shouldPersonalize) return {
        isValid: false,
        status: "personalization_disabled"
    };
    if (!userSegments) return {
        isValid: false,
        status: "missing_user_segments"
    };
    if (error && !(overrides === null || overrides === void 0 ? void 0 : overrides.useOverrides)) return {
        isValid: false,
        status: "segment_fetch_error"
    };
    return {
        isValid: true
    };
}; // Helper function to create variant component
const $67ea48e347ad7dcf$var$createVariantComponent = (chosenVariantIndex)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: "variants",
        wrapperComponent: (slotProps)=>$67ea48e347ad7dcf$var$VariantSelector((0, $6iHNw._)((0, $7Knp0._)({}, slotProps), {
                items: [
                    slotProps.items[chosenVariantIndex]
                ]
            }))
    }); // Helper function to set render message for variant
const $67ea48e347ad7dcf$var$setVariantRenderMessage = (variantCandidates, chosenVariantIndex, overrides, setRenderMessage)=>{
    const variantName = $67ea48e347ad7dcf$var$getCurrentVariantName(variantCandidates, chosenVariantIndex);
    const sourceType = (overrides === null || overrides === void 0 ? void 0 : overrides.useOverrides) ? "Overrides" : "User Segments";
    setRenderMessage(`Rendering "${variantName}" Variant based on ${sourceType}`);
};
const $67ea48e347ad7dcf$var$getCurrentVariantName = (variantCandidates, chosenVariantIndex)=>{
    var _variantCandidates_chosenVariantIndex_parameters_variantName, _variantCandidates_chosenVariantIndex_parameters, _variantCandidates_chosenVariantIndex;
    return ((_variantCandidates_chosenVariantIndex = variantCandidates[chosenVariantIndex]) === null || _variantCandidates_chosenVariantIndex === void 0 ? void 0 : (_variantCandidates_chosenVariantIndex_parameters = _variantCandidates_chosenVariantIndex.parameters) === null || _variantCandidates_chosenVariantIndex_parameters === void 0 ? void 0 : (_variantCandidates_chosenVariantIndex_parameters_variantName = _variantCandidates_chosenVariantIndex_parameters["variantName"]) === null || _variantCandidates_chosenVariantIndex_parameters_variantName === void 0 ? void 0 : _variantCandidates_chosenVariantIndex_parameters_variantName.value) || "unknown";
};
const $67ea48e347ad7dcf$var$PersonalizedSection = (props)=>{
    var _composition_data;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const analyticsClient = (0, $jFQmg.useAnalyticsClient)();
    const [selectedVariantKey, setSelectedVariantKey] = (0, $iSvIT.useState)(null);
    const [variantStatus, setVariantStatus] = (0, $iSvIT.useState)(null);
    const [renderedExperience, setRenderedExperience] = (0, $iSvIT.useState)(null);
    const { data: userSegments, error: error, status: userSegmentStatus } = (0, $bQiYD.useUserSegments)();
    const shouldPersonalize = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).uniformPersonalizationEnabled);
    const composition = (0, $aiugz.useUniformCurrentComposition)();
    const compositionId = composition === null || composition === void 0 ? void 0 : (_composition_data = composition.data) === null || _composition_data === void 0 ? void 0 : _composition_data._id; // Memoize slots to prevent infinite loops
    const variantSlots = (0, $iSvIT.useMemo)(()=>{
        var _props_component_slots;
        var _props_component_slots_variants;
        return (_props_component_slots_variants = (_props_component_slots = props.component.slots) === null || _props_component_slots === void 0 ? void 0 : _props_component_slots["variants"]) !== null && _props_component_slots_variants !== void 0 ? _props_component_slots_variants : [];
    }, [
        props.component.slots
    ]); // Send metrics once when variant changes
    (0, $iSvIT.useEffect)(()=>{
        const validation = $67ea48e347ad7dcf$var$validatePersonalizationPrerequisites(shouldPersonalize, userSegments, userSegmentStatus, error, props.overrides);
        if (!validation.isValid) {
            setSelectedVariantKey("default_experience");
            setVariantStatus(validation.status);
            setRenderedExperience($67ea48e347ad7dcf$var$renderDefaultSlot(validation.status, props.setRenderMessage));
            return;
        } // Process personalization logic
        const personalizationValues = $67ea48e347ad7dcf$var$getFinalPersonalizationValues(userSegments, props.overrides);
        const chosenVariantIndex = $67ea48e347ad7dcf$var$findMatchingVariant(variantSlots, personalizationValues); // Check if variant was found
        if (chosenVariantIndex < 0) {
            setSelectedVariantKey("default_experience");
            setVariantStatus("no_variant_match");
            setRenderedExperience($67ea48e347ad7dcf$var$renderDefaultSlot("no_variant_match", props.setRenderMessage));
            return;
        }
        const variantName = $67ea48e347ad7dcf$var$getCurrentVariantName(variantSlots, chosenVariantIndex);
        setSelectedVariantKey(variantName);
        setVariantStatus("variants_available");
        $67ea48e347ad7dcf$var$setVariantRenderMessage(variantSlots, chosenVariantIndex, props.overrides, props.setRenderMessage);
        const variantComponent = $67ea48e347ad7dcf$var$createVariantComponent(chosenVariantIndex);
        setRenderedExperience(variantComponent); // Handle experimental personalization
        if (props.experimentId) setRenderedExperience(/*#__PURE__*/ (0, $loA2J.jsx)($67ea48e347ad7dcf$var$ExperimentallyPersonalizedSection, {
            containerName: props.containerName,
            setRenderMessage: props.setRenderMessage,
            setVariantStatus: setVariantStatus,
            experimentId: props.experimentId,
            variantComponent: variantComponent,
            overrides: props.overrides,
            component: props.component
        }));
        return;
    }, [
        error,
        props.overrides,
        props.setRenderMessage,
        props.experimentId,
        props.containerName,
        props.component,
        shouldPersonalize,
        userSegmentStatus,
        userSegments,
        variantSlots,
        setVariantStatus
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (!selectedVariantKey || !variantStatus) return;
        if (analyticsClient) createAnalyticsEvent({
            name: "waePersonalizationVariantRender",
            action: "personalizationVariantRender",
            actionSubject: "uniformPage",
            eventType: "screen",
            source: window.location.pathname,
            attributes: {
                containerName: props.containerName,
                path: window.location.pathname,
                compositionId: compositionId,
                variantName: selectedVariantKey,
                status: variantStatus
            }
        }).fire();
    }, [
        compositionId,
        createAnalyticsEvent,
        selectedVariantKey,
        props.containerName,
        variantStatus,
        analyticsClient
    ]);
    return renderedExperience;
};
const $67ea48e347ad7dcf$var$UniformPersonalizationContainer = (props)=>{
    const isProd = (0, $kNCWT.isProduction)();
    const [overrides, setOverrides] = (0, $iSvIT.useState)({
        useOverrides: false,
        enrollInExperiment: false
    });
    const [renderMessage, setRenderMessage] = (0, $iSvIT.useState)("");
    const [isContainerHovered, setIsContainerHovered] = (0, $iSvIT.useState)(false);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        onMouseEnter: !isProd ? ()=>setIsContainerHovered(true) : undefined,
        onMouseLeave: !isProd ? ()=>setIsContainerHovered(false) : undefined,
        className: (0, $esG4f.default)([
            "_kqswh2mm _19itv6l3 _2rko1m5y _1yt41tub _v564u973 _1qs911pv"
        ]),
        style: {
            "--_1k5ts5z": (0, $43MIc.default)(!isProd && isContainerHovered ? `2px solid ${(0, $5ohHq.wacToken)("color.extended.blue300")}` : "2px solid transparent"),
            "--_1r0zder": (0, $43MIc.default)(!isProd ? (0, $5ohHq.wacToken)("corner.radius.card") : "0"),
            "--_15yoqdp": (0, $43MIc.default)(!isProd ? "var(--ds-space-100, 8px)" : "0"),
            "--_i1pnuw": (0, $43MIc.default)(!isProd ? "border-color 0.2s ease" : "none"),
            "--_hiqpr4": (0, $43MIc.default)(!isProd ? {
                border: `2px solid ${(0, $5ohHq.wacToken)("color.extended.blue300")}`
            } : {})
        },
        children: [
            !isProd && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1mZZG.PersonalizationOverrideControls), {
                values: overrides,
                setValues: setOverrides,
                renderMessage: renderMessage,
                isContainerHovered: isContainerHovered
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)($67ea48e347ad7dcf$var$PersonalizedSection, (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                overrides: overrides,
                setRenderMessage: setRenderMessage,
                experimentId: props.experimentId
            }))
        ]
    });
};
var $67ea48e347ad7dcf$export$2e2bcd8739ae039 = $67ea48e347ad7dcf$var$UniformPersonalizationContainer;

});
parcelRegister("1mZZG", function(module, exports) {

$parcel$export(module.exports, "PersonalizationOverrideControls", function () { return $1acdd970fef71b54$export$3509149ef9c5f46; });
/* personalization-controls.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("fYEXy");
var $53o08 = parcelRequire("53o08");

var $9REvE = parcelRequire("9REvE");

var $9Yq3D = parcelRequire("9Yq3D");

var $5ohHq = parcelRequire("5ohHq");

var $bQiYD = parcelRequire("bQiYD");
const $1acdd970fef71b54$var$JOB_FUNCTION = [
    {
        value: "engineering",
        label: "Engineering"
    },
    {
        value: "product management",
        label: "Product Management"
    },
    {
        value: "design",
        label: "Design"
    },
    {
        value: "data science",
        label: "Data Science"
    },
    {
        value: "marketing",
        label: "Marketing"
    },
    {
        value: "sales",
        label: "Sales"
    },
    {
        value: "human resources",
        label: "Human Resources"
    },
    {
        value: "finance",
        label: "Finance"
    },
    {
        value: "operations",
        label: "Operations"
    },
    {
        value: "legal",
        label: "Legal"
    },
    {
        value: "customer success",
        label: "Customer Success"
    },
    {
        value: "executive",
        label: "Executive"
    },
    {
        value: "other",
        label: "Other"
    },
    {
        value: "information technology",
        label: "Information Technology"
    },
    {
        value: "customer service",
        label: "Customer Service"
    },
    {
        value: "program management",
        label: "Program Management"
    },
    {
        value: "c-suite",
        label: "C-Suite"
    }
];
const $1acdd970fef71b54$var$PRODUCT_OPTIONS = [
    {
        value: "jira",
        label: "Jira"
    },
    {
        value: "confluence",
        label: "Confluence"
    },
    {
        value: "jsm",
        label: "JSM"
    },
    {
        value: "loom",
        label: "Loom"
    },
    {
        value: "jpd",
        label: "JPD"
    },
    {
        value: "rovo",
        label: "Rovo"
    }
];
const $1acdd970fef71b54$var$PersonalizationControlPanel = ({ values: values, handleSelectChange: handleSelectChange })=>{
    var _JOB_FUNCTION_find;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulpu2gc"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                onClick: (e)=>{
                    const target = e.target;
                    if (target.type === "checkbox") handleSelectChange("enrollInExperiment", target.checked);
                },
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleSelectChange("enrollInExperiment", !values.enrollInExperiment);
                    }
                },
                role: "button",
                tabIndex: 0,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $53o08.Checkbox), {
                    id: "enrollInExperiment",
                    name: "enrollInExperiment",
                    value: "enrollInExperiment",
                    label: "Enroll in Experiment Treatment?",
                    checked: values.enrollInExperiment
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                onClick: (e)=>{
                    const target = e.target;
                    if (target.type === "checkbox") handleSelectChange("useOverrides", target.checked);
                },
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleSelectChange("useOverrides", !values.useOverrides);
                    }
                },
                role: "button",
                tabIndex: 0,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $53o08.Checkbox), {
                    id: "useOverrides",
                    name: "useOverrides",
                    value: "useOverrides",
                    label: "Use Overrides?",
                    checked: values.useOverrides
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9REvE.DropdownSelector), {
                    name: (0, $bQiYD.UserSegmentTypes).LOGIN_STATUS,
                    id: (0, $bQiYD.UserSegmentTypes).LOGIN_STATUS,
                    label: "Login Status",
                    options: [
                        {
                            value: "loggedIn",
                            label: "Logged In"
                        },
                        {
                            value: "loggedOut",
                            label: "Logged Out"
                        }
                    ],
                    defaultValue: {
                        value: values[(0, $bQiYD.UserSegmentTypes).LOGIN_STATUS] || "",
                        label: values[(0, $bQiYD.UserSegmentTypes).LOGIN_STATUS] === "loggedIn" ? "Logged In" : "Logged Out"
                    },
                    onChangeHandler: (value)=>{
                        handleSelectChange((0, $bQiYD.UserSegmentTypes).LOGIN_STATUS, value);
                    }
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9Yq3D.TextInput), {
                    id: "geolocation",
                    name: (0, $bQiYD.UserSegmentTypes).GEOLOCATION,
                    label: "Geolocation",
                    placeholder: "e.g. US, UK, AU",
                    value: values[(0, $bQiYD.UserSegmentTypes).GEOLOCATION],
                    onChangeHandler: (value)=>{
                        handleSelectChange((0, $bQiYD.UserSegmentTypes).GEOLOCATION, value);
                    }
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9REvE.DropdownSelector), {
                    name: (0, $bQiYD.UserSegmentTypes).JOB_FUNCTION,
                    id: (0, $bQiYD.UserSegmentTypes).JOB_FUNCTION,
                    label: "Job Function",
                    options: $1acdd970fef71b54$var$JOB_FUNCTION.map((entry)=>({
                            value: entry.value,
                            label: entry.label
                        })),
                    defaultValue: {
                        value: values[(0, $bQiYD.UserSegmentTypes).JOB_FUNCTION] || "",
                        label: ((_JOB_FUNCTION_find = $1acdd970fef71b54$var$JOB_FUNCTION.find((e)=>{
                            return e.value === values[(0, $bQiYD.UserSegmentTypes).JOB_FUNCTION];
                        })) === null || _JOB_FUNCTION_find === void 0 ? void 0 : _JOB_FUNCTION_find.label) || "test"
                    },
                    onChangeHandler: (value)=>{
                        handleSelectChange((0, $bQiYD.UserSegmentTypes).JOB_FUNCTION, value);
                    }
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9REvE.DropdownSelector), {
                    name: (0, $bQiYD.UserSegmentTypes).DOMAIN_TYPE,
                    id: (0, $bQiYD.UserSegmentTypes).DOMAIN_TYPE,
                    label: "Domain Type",
                    options: [
                        {
                            value: "BUSINESS",
                            label: "Business"
                        },
                        {
                            value: "PERSONAL",
                            label: "Personal"
                        }
                    ],
                    defaultValue: {
                        value: values[(0, $bQiYD.UserSegmentTypes).DOMAIN_TYPE] || "",
                        label: values[(0, $bQiYD.UserSegmentTypes).DOMAIN_TYPE] === "BUSINESS" ? "Business" : "Personal"
                    },
                    onChangeHandler: (value)=>{
                        handleSelectChange((0, $bQiYD.UserSegmentTypes).DOMAIN_TYPE, value);
                    }
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                        htmlFor: (0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS,
                        className: (0, $esG4f.default)([
                            "_1e0c1ule _syaz5k8o _1wyboqnp _vwz41gnr _6rth1b66 _y3gn1e5h"
                        ]),
                        style: {
                            "--_1ntr8rj": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark200"))
                        },
                        children: "Owned Products"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _1n261g80 _zulp1b66 _1yt4u2gc _19it1nj5 _2rko1y44 _1tke1ylp _4cvr1h6o"
                        ]),
                        style: {
                            "--_19aes6n": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark700"))
                        },
                        children: [
                            {
                                value: "jira-software",
                                label: "Jira"
                            },
                            {
                                value: "confluence",
                                label: "Confluence"
                            },
                            {
                                value: "bitbucket",
                                label: "Bitbucket"
                            },
                            {
                                value: "compass",
                                label: "Compass"
                            },
                            {
                                value: "jira-product-discovery",
                                label: "Jira Product Discovery"
                            },
                            {
                                value: "statuspage",
                                label: "Statuspage"
                            },
                            {
                                value: "loom",
                                label: "Loom"
                            },
                            {
                                value: "compass",
                                label: "Compass"
                            },
                            {
                                value: "rovo.ondemand",
                                label: "Rovo"
                            },
                            {
                                value: "trello",
                                label: "Trello"
                            }
                        ].map((product)=>{
                            var _values_UserSegmentTypes_OWNED_PRODUCTS;
                            const isSelected = Array.isArray(values[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS]) ? (_values_UserSegmentTypes_OWNED_PRODUCTS = values[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS]) === null || _values_UserSegmentTypes_OWNED_PRODUCTS === void 0 ? void 0 : _values_UserSegmentTypes_OWNED_PRODUCTS.includes(product.value) : values[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS] === product.value;
                            return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                type: "button",
                                onClick: ()=>{
                                    const currentProducts = Array.isArray(values[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS]) ? values[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS] || [] : values[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS] ? [
                                        values[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS]
                                    ] : [];
                                    let updatedProducts;
                                    if (isSelected) updatedProducts = currentProducts.filter((p)=>p !== product.value);
                                    else updatedProducts = [
                                        ...currentProducts,
                                        product.value
                                    ];
                                    handleSelectChange((0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS, updatedProducts);
                                },
                                className: (0, $esG4f.default)([
                                    "_1yt418iy _bfhkl9kt _syaz1o9l _19itglyw _2rko1y44 _80omtlke _1wyboxwj _irr31nu1"
                                ]),
                                style: {
                                    "--_3kul7g": (0, $43MIc.default)(isSelected ? (0, $5ohHq.wacToken)("color.extended.blue300") : (0, $5ohHq.wacToken)("color.neutral.light200")),
                                    "--_8buy8y": (0, $43MIc.default)(isSelected ? (0, $5ohHq.wacToken)("color.neutral.light0") : (0, $5ohHq.wacToken)("color.neutral.dark200")),
                                    "--_1pblbmt": (0, $43MIc.default)(isSelected ? (0, $5ohHq.wacToken)("color.extended.blue400") : (0, $5ohHq.wacToken)("color.neutral.light300"))
                                },
                                children: product.label
                            }, product.value);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                        htmlFor: (0, $bQiYD.UserSegmentTypes).CLUSTER_TAG,
                        className: (0, $esG4f.default)([
                            "_1e0c1ule _syaz5k8o _1wyboqnp _vwz41gnr _6rth1b66 _y3gn1e5h"
                        ]),
                        style: {
                            "--_1ntr8rj": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark200"))
                        },
                        children: "Anchor/Cluster Tag"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                        id: (0, $bQiYD.UserSegmentTypes).CLUSTER_TAG,
                        "data-testid": (0, $bQiYD.UserSegmentTypes).CLUSTER_TAG,
                        type: "text",
                        value: values[(0, $bQiYD.UserSegmentTypes).CLUSTER_TAG],
                        onChange: (event)=>{
                            handleSelectChange((0, $bQiYD.UserSegmentTypes).CLUSTER_TAG, event.target.value.toLowerCase());
                        },
                        className: (0, $esG4f.default)([
                            "_1bsb1osq"
                        ])
                    })
                ]
            }),
            [
                {
                    segmentType: (0, $bQiYD.UserSegmentTypes).FIRST_RECOMMENDATION,
                    label: "First Recommendation",
                    defaultValue: "jira",
                    defaultLabel: "Jira"
                },
                {
                    segmentType: (0, $bQiYD.UserSegmentTypes).SECOND_RECOMMENDATION,
                    label: "Second Recommendation",
                    defaultValue: "confluence",
                    defaultLabel: "Confluence"
                },
                {
                    segmentType: (0, $bQiYD.UserSegmentTypes).THIRD_RECOMMENDATION,
                    label: "Third Recommendation",
                    defaultValue: "jsm",
                    defaultLabel: "JSM"
                },
                {
                    segmentType: (0, $bQiYD.UserSegmentTypes).FOURTH_RECOMMENDATION,
                    label: "Fourth Recommendation",
                    defaultValue: "loom",
                    defaultLabel: "Loom"
                }
            ].map(({ segmentType: segmentType, label: label, defaultValue: defaultValue, defaultLabel: defaultLabel })=>{
                const selectedValue = values[segmentType] || defaultValue;
                const selectedOption = $1acdd970fef71b54$var$PRODUCT_OPTIONS.find((opt)=>opt.value === selectedValue);
                return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9REvE.DropdownSelector), {
                        name: segmentType,
                        id: segmentType,
                        label: label,
                        options: $1acdd970fef71b54$var$PRODUCT_OPTIONS,
                        defaultValue: {
                            value: selectedValue,
                            label: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || defaultLabel
                        },
                        onChangeHandler: (value)=>{
                            handleSelectChange(segmentType, value);
                        }
                    })
                }, segmentType);
            })
        ]
    });
};
const $1acdd970fef71b54$export$3509149ef9c5f46 = ({ values: values, setValues: setValues, renderMessage: renderMessage, isContainerHovered: isContainerHovered })=>{
    const [isVisible, setIsVisible] = (0, $iSvIT.useState)(false);
    const handleSelectChange = (field, value)=>{
        setValues((0, $6iHNw._)((0, $7Knp0._)({}, values), {
            [field]: value
        }));
    }; // Only show the dog-ear when container is hovered
    if (!isContainerHovered) return null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        onMouseEnter: ()=>setIsVisible(true),
        onMouseLeave: ()=>setIsVisible(false),
        onFocus: ()=>setIsVisible(true),
        onBlur: ()=>setIsVisible(false),
        role: "button",
        tabIndex: 0,
        "data-testid": "personalization-controls",
        className: (0, $esG4f.default)([
            "_kqswstnw _152t12gs _1e0212gs _1bsb1lmt _4t3i1n85 _1pbyzo7u"
        ]),
        style: {
            "--_6q42yv": (0, $43MIc.default)(isVisible ? "320px" : "auto"),
            "--_1j9tq0n": (0, $43MIc.default)(isVisible ? "400px" : "auto")
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                title: "Personalization Controls",
                className: (0, $esG4f.default)([
                    "_kqswstnw _152tidpf _1e02idpf _1pby3ced _1bsbckbl _4t3ickbl _80omtlke _v5641hdd _tzy413ze _t9ec13e0"
                ]),
                style: {
                    "--_ymxjy5": (0, $43MIc.default)(isContainerHovered ? 1 : 0),
                    "--_51sge": (0, $43MIc.default)(isContainerHovered ? "scale(1)" : "scale(0.8)")
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_kqswstnw _152tidpf _1e02idpf _1bsbckbl _4t3ickbl _bfhk1mxb _2rko1dia _v5641hdd _16qs1s6v _irr3cqtm"
                        ]),
                        style: {
                            "--_9qtbdu": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue300")),
                            "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
                            "--_1mbq9ci": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark800")),
                            "--_r4erkq": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue400"))
                        }
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_kqswstnw _152t1ssb _1e021ssb _t9ec1ooe _syazcd5j _1wyb7vkz _vwz4kb7n _lcxvglyw _w19j12yu"
                        ]),
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                            "--_1mbq9ci": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark800"))
                        },
                        children: "\uD83D\uDC65"
                    })
                ]
            }),
            isVisible && /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _152t1ex1 _1e02ftgi _1bsb1178 _1pby1rya _1yt4pxbi _bfhkcd5j _2rkovwyg _16qsswb1 _19it1nj5"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                    "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
                    "--_1mbq9ci": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark800")),
                    "--_19aes6n": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark700"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                        className: (0, $esG4f.default)([
                            "_18s819a1 _1wybbzd7 _syaz5k8o"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                            "--_1ntr8rj": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark200"))
                        },
                        children: "Personalization Controls"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_18s8h2s3 _1yt412x7 _1wyboqnp _syazgc2p _bfhkjzbh _2rko1y44 _19itacih"
                        ]),
                        style: {
                            "--_1jncskl": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark300")),
                            "--_1bsbd8h": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.yellow100")),
                            "--_1oxqp4m": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.yellow300"))
                        },
                        children: "These controls and the blue border are only visible in pre-production environments"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($1acdd970fef71b54$var$PersonalizationControlPanel, {
                        values: values,
                        handleSelectChange: handleSelectChange
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1pfhutpp _1yt4u2gc _bfhk1ybm _syazgc2p"
                        ]),
                        style: {
                            "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100")),
                            "--_1jncskl": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark300"))
                        },
                        children: renderMessage
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("fYEXy", function(module, exports) {
$parcel$export(module.exports, "Checkbox", function () { return (parcelRequire("53o08")).Checkbox; });

var $53o08 = parcelRequire("53o08");

});
parcelRegister("53o08", function(module, exports) {

$parcel$export(module.exports, "Checkbox", function () { return $72b2951a2c888331$export$48513f6b9f8ce62d; });
/* checkbox.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $72b2951a2c888331$var$textStyle = null;
const $72b2951a2c888331$var$containerStyle = null;
const $72b2951a2c888331$var$checkboxStyle = null;
const $72b2951a2c888331$export$48513f6b9f8ce62d = (props)=>{
    const { id: id, name: name, value: value, label: label, color: color = "light", accentColor: accentColor = "#0065ff", disabled: disabled, testId: testId, checked: checked, indeterminate: indeterminate, className: className } = props;
    const ref = (0, $iSvIT.useRef)(null);
    (0, $iSvIT.useEffect)(()=>{
        if (ref.current) {
            if (indeterminate) ref.current.indeterminate = indeterminate;
            else ref.current.checked = checked || false;
        }
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _1e0c1txw _4cvr1y6m _ca0qyh40 _u5f3idpf _n3tdyh40 _19bvidpf _vwz4bs82",
            className
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                id: id,
                type: "checkbox",
                "data-testid": testId ? testId : id,
                style: {
                    accentColor: accentColor
                },
                ref: ref,
                name: name,
                value: value,
                disabled: disabled || false,
                className: (0, $esG4f.default)([
                    "_s7n4nkob _1bsb7vkz _4t3i7vkz _19pk1y44 _2hwxidpf _otyridpf _18u0idpf _1372tlke _d0altlke _jomr3739 _irr33739"
                ])
            }),
            label && /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                style: {
                    color: color == "dark" ? "#172b4d" : "#5e6c84"
                },
                htmlFor: id,
                className: (0, $esG4f.default)([
                    "_80omtlke _1wyboxwj _k48p1nn1 _ahbqftgi"
                ]),
                children: label
            })
        ]
    });
};

});





parcelRegister("1fx7M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("hCb7M")).default; });

var $hCb7M = parcelRequire("hCb7M");

});
parcelRegister("hCb7M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e24a006ad056402e$export$2e2bcd8739ae039; });
/* price-calculator.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $3ayMq = parcelRequire("3ayMq");

var $5ohHq = parcelRequire("5ohHq");

var $jnh2H = parcelRequire("jnh2H");

var $gEOac = parcelRequire("gEOac");
parcelRequire("MciJy");
var $1rXz0 = parcelRequire("1rXz0");
var $chlmU = parcelRequire("chlmU");
parcelRequire("MciJy");
var $85vSY = parcelRequire("85vSY");
parcelRequire("hqKpV");
var $3ItZP = parcelRequire("3ItZP");

var $bd3Mi = parcelRequire("bd3Mi");

var $bU2dC = parcelRequire("bU2dC");

var $5YjMr = parcelRequire("5YjMr");

var $hmeL1 = parcelRequire("hmeL1");
const $e24a006ad056402e$var$RecommendationTracker = ({ plan: plan, index: index, onRecommendedChange: onRecommendedChange })=>{
    const state = (0, $gEOac.useCalculationState)({
        offeringSku: plan.fields.sku
    });
    (0, $iSvIT.useEffect)(()=>{
        onRecommendedChange(index, state.recommended);
    }, [
        index,
        state.recommended,
        onRecommendedChange
    ]);
    return null;
};
const $e24a006ad056402e$var$PricingCalculatorContent = ({ comparePlansData: comparePlansData, urlSlug: urlSlug, selectedCardIndex: selectedCardIndex, setSelectedCardIndex: setSelectedCardIndex, disclaimer: disclaimer, omitInputs: omitInputs, numSections: numSections })=>{
    const intl = (0, $f6qj2.default)();
    const handleRecommendedChange = (0, $iSvIT.useCallback)((index, isRecommended)=>{
        if (isRecommended) setSelectedCardIndex(index);
    }, [
        setSelectedCardIndex
    ]);
    const unitsLabel = $e24a006ad056402e$var$useUnitsLabel(comparePlansData);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            comparePlansData.length > 1 && comparePlansData.map((planData, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($e24a006ad056402e$var$RecommendationTracker, {
                    plan: planData,
                    index: index,
                    onRecommendedChange: handleRecommendedChange
                }, `tracker-${planData.fields.sku}`)),
            !omitInputs && /*#__PURE__*/ (0, $loA2J.jsx)((0, $85vSY.PricingCalculatorInputs), {
                unitCountLabel: intl.formatMessage($5YjMr.units.teamSizePrompt),
                unitsLabel: unitsLabel,
                dataProductKey: (0, $3ayMq.urlSlugToDataProductKey)[urlSlug]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jnh2H.PricingCards // must set the number of sections here if removing the bottom section
            ), {
                // could also infer this from planData's getFeaturesList(fields.highlightedFeaturesContainer)
                numSections: numSections,
                selectedCardIndex: selectedCardIndex ? selectedCardIndex + 1 : 1,
                children: comparePlansData.map((planData, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $hmeL1.PricingCalculatorCard), {
                        showBannerText: comparePlansData.length > 1,
                        planData: planData,
                        urlSlug: urlSlug,
                        index: index,
                        isSingleCard: comparePlansData.length === 1
                    }, planData.fields.sku))
            }),
            disclaimer && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bah1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: (0, $esG4f.default)([
                        "_p12frdnh _k48p1nn1 _vwz4gktf _1wybdlk8 _syaz1hlo _1yt4utpp _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                    ]),
                    style: {
                        "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                    },
                    children: disclaimer
                })
            })
        ]
    });
};
const $e24a006ad056402e$var$disclaimerContainerCss = null;
const $e24a006ad056402e$var$disclaimerCss = null;
const $e24a006ad056402e$var$UniformPricingCalculator = (props)=>{
    var _comparePlansData__fields, _comparePlansData_;
    const { comparePlansData: comparePlansData, urlSlug: urlSlug, disclaimer: disclaimer } = props;
    const [selectedCardIndex, setSelectedCardIndex] = (0, $iSvIT.useState)(undefined);
    const providerResult = (0, $bU2dC.useProviderProps)({
        plans: comparePlansData,
        product: urlSlug
    });
    if (providerResult.status === "pending") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1rXz0.LoadingSpinner), {});
    if (providerResult.status === "error") return null; // todo: fire an event @bsparks GWP-6943
    if (providerResult.status !== "ready") return null; // this should never happen due to checks above, but fixes type error
    const { config: config, inputValues: inputValues } = providerResult.props;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bd3Mi.PricingCalculatorContextProvider), {
        config: config,
        inputValues: inputValues,
        children: /*#__PURE__*/ (0, $loA2J.jsx)($e24a006ad056402e$var$PricingCalculatorContent, {
            comparePlansData: comparePlansData,
            urlSlug: urlSlug,
            selectedCardIndex: selectedCardIndex,
            setSelectedCardIndex: setSelectedCardIndex,
            disclaimer: disclaimer,
            numSections: (0, $chlmU.getFeaturesList)(comparePlansData === null || comparePlansData === void 0 ? void 0 : (_comparePlansData_ = comparePlansData[0]) === null || _comparePlansData_ === void 0 ? void 0 : (_comparePlansData__fields = _comparePlansData_.fields) === null || _comparePlansData__fields === void 0 ? void 0 : _comparePlansData__fields.highlightedFeaturesContainer) === undefined ? 1 : 2,
            omitInputs: !config.billingCycleConfig.monthly && !config.billingCycleConfig.annual
        })
    });
};
var $e24a006ad056402e$export$2e2bcd8739ae039 = $e24a006ad056402e$var$UniformPricingCalculator;
function $e24a006ad056402e$var$useUnitsLabel(comparePlansData) {
    const intl = (0, $f6qj2.default)();
    const hasAgents = comparePlansData.some((plan)=>{
        return [
            (0, $3ItZP.serviceCollectionOfferingSkus).free,
            (0, $3ItZP.serviceCollectionOfferingSkus).standard,
            (0, $3ItZP.serviceCollectionOfferingSkus).premium,
            (0, $3ItZP.serviceCollectionOfferingSkus).enterprise
        ].includes(plan.fields.sku);
    });
    if (hasAgents) return intl.formatMessage($5YjMr.units.agentsUnitsLabel);
    return intl.formatMessage($5YjMr.units.usersUnitsLabel);
}

});
parcelRegister("3ayMq", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_PRODUCT_KEY", function () { return $ae0d591ec5522d40$export$b65b36d21c9a62a9; });
$parcel$export(module.exports, "urlSlugToDataProductKey", function () { return $ae0d591ec5522d40$export$9c59efe722f16a54; });
const $ae0d591ec5522d40$export$e36fc9e5c75fc113 = "jiraSoftware";
const $ae0d591ec5522d40$export$b65b36d21c9a62a9 = "confluence";
const $ae0d591ec5522d40$export$b24966420407028a = "strategyCollection";
const $ae0d591ec5522d40$export$46061d552ba374f4 = "teamworkCollection";
const $ae0d591ec5522d40$export$e7e2043098922532 = "compass";
const $ae0d591ec5522d40$export$6648fdba742bde2c = "serviceCollection";
const $ae0d591ec5522d40$export$b3fce742f95b2633 = "atlassianGuard";
const $ae0d591ec5522d40$export$9c59efe722f16a54 = {
    jira: $ae0d591ec5522d40$export$e36fc9e5c75fc113,
    confluence: $ae0d591ec5522d40$export$b65b36d21c9a62a9,
    strategy: $ae0d591ec5522d40$export$b24966420407028a,
    teamwork: $ae0d591ec5522d40$export$46061d552ba374f4,
    compass: $ae0d591ec5522d40$export$e7e2043098922532,
    service: $ae0d591ec5522d40$export$6648fdba742bde2c,
    guard: $ae0d591ec5522d40$export$b3fce742f95b2633
};

});

parcelRegister("jnh2H", function(module, exports) {

$parcel$export(module.exports, "PricingCards", function () { return $4ff5675958f7efd2$export$eb5ade451900e238; });
/* pricing-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
const $4ff5675958f7efd2$export$eb5ade451900e238 = (props)=>{
    const { selectedCardIndex: selectedCardIndex, children: children, numSections: numSections = 2, hasCalloutSlot: hasCalloutSlot, hasRangeSlot: hasRangeSlot, hasLinkSlot: hasLinkSlot, hasBannerSlot: hasBannerSlot } = props;
    const numberOfChildren = (0, $iSvIT.Children).count(children);
    const getBorderProps = (childIndex, numSections)=>{
        if (numSections !== 1) return {};
        const isFirstChild = childIndex === 1;
        const isLastChild = childIndex === numberOfChildren;
        return {
            topSectionStyle: {
                borderStartEndRadius: isFirstChild ? "0" : undefined,
                borderEndEndRadius: isFirstChild ? "0px" : undefined,
                borderStartStartRadius: isLastChild ? "0" : undefined,
                borderEndStartRadius: isLastChild ? "0px" : undefined
            }
        };
    };
    const getSelectedBorderProps = (childIndex)=>{
        if (selectedCardIndex === undefined || selectedCardIndex !== childIndex) return {};
        const isFirstChild = childIndex === 1;
        const isLastChild = childIndex === numberOfChildren;
        const blackBorder = `1px solid ${(0, $5ohHq.wacToken)("color.primary.black")}`;
        return {
            topSectionStyle: {
                borderInlineEnd: blackBorder,
                borderInlineStart: blackBorder,
                borderBlockStart: blackBorder,
                borderLeftRadius: "10px",
                borderTopRightRadius: numSections === 1 && isLastChild ? "20px" : undefined,
                borderBottomLeftRadius: numSections === 1 && isLastChild ? "0px" : undefined,
                borderBottomRightRadius: numSections === 1 && isFirstChild ? "0px" : undefined,
                borderRadius: numSections === 1 && !isFirstChild && !isLastChild ? `0px` : undefined,
                borderBottom: numSections === 1 ? blackBorder : undefined
            },
            bottomSectionStyle: {
                borderInlineEnd: blackBorder,
                borderInlineStart: blackBorder,
                borderBlockEnd: blackBorder
            }
        };
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_2z054em0 _yv0e1579 _1e0c11p5 _wij21bp4 _1bsb1ns9 _ca0q1crf _u5f31crf _n3td1crf _19bv1crf _glte1ns9 _1ao8yzqy _37tx5os2 _11nh5os2 _157nyzqy _1r9zyzqy _qrtggktf _bzkjkpzv _bi30wrl1 _x330kpzv _1q1tyzqy _14bpgktf _uedh18ji _sqhgyzqy _1bs9gktf _1o36gktf _r0rayzqy _23ugyzqy _4ezvyzqy",
            numSections !== 1 && "_1aqcftgi",
            "_1mjb1txw _na0i1bp4 _1s4p1osq _1a7ngktf _1xwygktf _9h3lyzqy _9rrkyzqy _18xwyzqy",
            numSections === 1 && "_pmhu1txs _ukazftgi _i370yzqy _1635yzqy"
        ]),
        style: {
            "--_wcq253": (0, $43MIc.default)(numSections),
            "--_1j6te2o": (0, $43MIc.default)(numberOfChildren),
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400")),
            "--_vgqxqn": (0, $43MIc.default)(numSections === 1 ? `1px solid ${(0, $5ohHq.wacToken)("color.neutral.light400")}` : undefined),
            "--_3ro2cj": (0, $43MIc.default)(numSections === 1 ? "0px" : "20px"),
            "--_14z1886": (0, $43MIc.default)(numSections === 1 ? "0px" : undefined),
            "--_1ecp6y0": (0, $43MIc.default)(numSections === 1 ? "20px" : undefined)
        },
        children: (0, $iSvIT.Children).map(children, (child, index)=>{
            if (!child) return null;
            return /*#__PURE__*/ (0, $iSvIT.cloneElement)(child, (0, $7Knp0._)({
                key: index,
                hasCalloutSlot: hasCalloutSlot,
                hasRangeSlot: hasRangeSlot,
                hasLinkSlot: hasLinkSlot,
                hasBannerSlot: hasBannerSlot
            }, index + 1 === selectedCardIndex ? getSelectedBorderProps(index + 1) : getBorderProps(index + 1, numSections)));
        })
    });
};

});

parcelRegister("gEOac", function(module, exports) {

$parcel$export(module.exports, "useCalculationState", function () { return $7fc6bb143d8dc713$export$5ac48a71a65a15bc; });

var $j1tjc = parcelRequire("j1tjc");

var $iXUxi = parcelRequire("iXUxi");
function $7fc6bb143d8dc713$export$5ac48a71a65a15bc(props) {
    const { offeringSku: offeringSku } = props;
    return {
        billingCycle: (0, $j1tjc.useSelector)($iXUxi.getBillingCycle),
        isUnitCountAboveMaxThreshold: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.isUnitCountAboveMaxThreshold(ctx, offeringSku)),
        unitCountMin: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.getUnitCountMinThreshold(ctx, offeringSku)),
        isUnitCountBelowMinThreshold: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.isUnitCountBelowMinThreshold(ctx, offeringSku)),
        price: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.getFormattedPlanPrice(ctx, offeringSku)),
        recommended: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.isOfferingRecommended(ctx, offeringSku)),
        unitCount: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.getUnitCount(ctx)),
        unitTierLowerBound: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.getUnitTierLowerBound(ctx, offeringSku)),
        unitTierUpperBound: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.getUnitTierUpperBound(ctx, offeringSku)),
        unitsAvailableInTier: (0, $j1tjc.useSelector)((ctx)=>$iXUxi.getUnitsAvailableInTier(ctx, offeringSku)),
        numberFormatLocale: (0, $j1tjc.useSelector)($iXUxi.getNumberFormatLocale)
    };
}

});
parcelRegister("j1tjc", function(module, exports) {

$parcel$export(module.exports, "useUnitCount", function () { return $58bc496f267c3520$export$856785685ba8098f; });
$parcel$export(module.exports, "useBillingCycle", function () { return $58bc496f267c3520$export$ada282ac321ec3b9; });
$parcel$export(module.exports, "useSelector", function () { return $58bc496f267c3520$export$2105062e25df4afe; });
$parcel$export(module.exports, "useCcpPricingData", function () { return $58bc496f267c3520$export$97374d6e908d2c; });

var $iSvIT = parcelRequire("iSvIT");

var $kxn2n = parcelRequire("kxn2n");

var $bd3Mi = parcelRequire("bd3Mi");
function $58bc496f267c3520$export$856785685ba8098f() {
    const { inputValues: inputValues, changeInputValues: changeInputValues } = (0, $bd3Mi.usePricingCalculatorContext)();
    const { unitCount: unitCount } = inputValues;
    const changeUnitCount = (value)=>{
        return changeInputValues({
            unitCount: value
        });
    };
    return [
        unitCount,
        changeUnitCount
    ];
}
function $58bc496f267c3520$export$ada282ac321ec3b9() {
    const { inputValues: inputValues, changeInputValues: changeInputValues } = (0, $bd3Mi.usePricingCalculatorContext)();
    const { billingCycle: billingCycle } = inputValues;
    const changeBillingCycle = (value)=>{
        return changeInputValues({
            billingCycle: value
        });
    };
    return [
        billingCycle,
        changeBillingCycle
    ];
}
function $58bc496f267c3520$export$f3fe2cc7a9497569() {
    return (0, $bd3Mi.usePricingCalculatorContext)().calculationResult;
}
const $58bc496f267c3520$export$2105062e25df4afe = (selector)=>{
    const context = (0, $bd3Mi.usePricingCalculatorContext)();
    return selector(context);
};
const $58bc496f267c3520$var$PRODUCT_CATALOG_DELIVERY_KEY = "nDQjfHDrrDfmPuccfIHYNMU3pSNCi1WOTRsI-q0igVU";
const $58bc496f267c3520$var$PRODUCT_CATALOG_SPACE = "3s3v3nq72la0";
const $58bc496f267c3520$export$97374d6e908d2c = (props)=>{
    const { offeringSkus: offeringSkus, ssrData: ssrData } = props;
    const { fetchData: fetchData, status: fetchStatus, prices: clientSideData } = (0, $kxn2n.useCCPPriceFinderData)(offeringSkus, $58bc496f267c3520$var$PRODUCT_CATALOG_DELIVERY_KEY, $58bc496f267c3520$var$PRODUCT_CATALOG_SPACE);
    const execFetch = (0, $iSvIT.useCallback)(async ()=>{
        await fetchData();
    }, []);
    (0, $iSvIT.useEffect)(()=>{
        if (!ssrData) execFetch();
    }, []);
    const status = $58bc496f267c3520$var$getCcpPricingDataStatus({
        hasSsrData: !!ssrData,
        fetchStatus: fetchStatus
    });
    return {
        data: ssrData !== null && ssrData !== void 0 ? ssrData : clientSideData,
        status: status
    };
};
function $58bc496f267c3520$var$getCcpPricingDataStatus(args) {
    const { fetchStatus: fetchStatus, hasSsrData: hasSsrData } = args;
    if (hasSsrData || fetchStatus === "complete") return "ready";
    if (fetchStatus === "idle" || fetchStatus === "fetching") return "pending";
    return "error";
}

});
parcelRegister("bd3Mi", function(module, exports) {

$parcel$export(module.exports, "usePricingCalculatorContext", function () { return $6a1ababb8109d222$export$cf6d27bb6377cd5b; });
$parcel$export(module.exports, "PricingCalculatorContextProvider", function () { return $6a1ababb8109d222$export$5a79cf764fd87278; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("8aCoe");
var $gz56C = parcelRequire("gz56C");
var $8XIVp = parcelRequire("8XIVp");
const $6a1ababb8109d222$var$PricingCalculatorContext = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);
const $6a1ababb8109d222$export$cf6d27bb6377cd5b = ()=>{
    const pricingCalculatorContext = (0, $iSvIT.useContext)($6a1ababb8109d222$var$PricingCalculatorContext);
    if (!pricingCalculatorContext) throw new Error("usePricingCalculatorContext must be used within a PricingCalculatorProvider");
    return pricingCalculatorContext;
};
const $6a1ababb8109d222$export$5a79cf764fd87278 = (props)=>{
    const [inputValues, setInputValues] = (0, $iSvIT.useState)(props.inputValues);
    const calculate = (0, $iSvIT.useCallback)((v)=>{
        const { config: config } = props;
        const productCalculationInputs = (0, $gz56C.getProductCalculationInputs)(config.planLimitConfigs, config.unitMinEnterprise, v.unitCount, v.billingCycle);
        return (0, $8XIVp.calculateProductPricing)(config.ccpPricingData, productCalculationInputs, config.currencyISOCode, config.localeISOCode);
    }, [
        props
    ]);
    const [calculationResult, setCalculationResult] = (0, $iSvIT.useState)(()=>calculate(inputValues));
    // Recalculate when config (including currency) changes
    (0, $iSvIT.useEffect)(()=>{
        const result = calculate(inputValues);
        setCalculationResult(result);
    }, [
        props.config,
        inputValues,
        calculate
    ]);
    const changeInputValues = (changes)=>{
        const nextValues = (0, $7Knp0._)({}, inputValues, changes);
        setInputValues(nextValues);
        const result = calculate(nextValues);
        setCalculationResult(result);
        return result;
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)($6a1ababb8109d222$var$PricingCalculatorContext.Provider, {
        value: {
            inputValues: inputValues,
            changeInputValues: changeInputValues,
            calculationResult: calculationResult,
            config: props.config
        },
        children: props.children
    });
};

});
parcelRegister("8aCoe", function(module, exports) {
$parcel$export(module.exports, "calculateProductPricing", function () { return (parcelRequire("8XIVp")).calculateProductPricing; });
$parcel$export(module.exports, "getProductCalculationInputs", function () { return (parcelRequire("gz56C")).getProductCalculationInputs; });
parcelRequire("8XIVp");
parcelRequire("gz56C");

});
parcelRegister("8XIVp", function(module, exports) {

$parcel$export(module.exports, "calculateProductPricing", function () { return $050627253a5a34fa$export$6c0aa9d51dade71d; });

var $7Knp0 = parcelRequire("7Knp0");

var $3FlK9 = parcelRequire("3FlK9");
const $050627253a5a34fa$export$6c0aa9d51dade71d = (ccpPricingData, productCalculationInputs, currencyISOCode, localeISOCode)=>{
    const productPricing = [];
    for (const planCalculationInputs of productCalculationInputs){
        const { ccpOfferingSKU: ccpOfferingSKU, numUnits: numUnits, period: period } = planCalculationInputs;
        const planPricing = (0, $3FlK9.calculatePlanPricing)({
            ccpPricingData: ccpPricingData,
            ccpOfferingSKU: ccpOfferingSKU,
            numUnits: numUnits,
            period: period,
            currencyISOCode: currencyISOCode,
            localeISOCode: localeISOCode
        });
        productPricing.push((0, $7Knp0._)({
            // @ts-ignore
            offeringSku: ccpOfferingSKU
        }, planPricing));
    }
    return productPricing;
};

});
parcelRegister("3FlK9", function(module, exports) {

$parcel$export(module.exports, "calculatePlanPricing", function () { return $2a81506982df3304$export$f9574505c9651410; });

var $7Knp0 = parcelRequire("7Knp0");

var $jl6Sn = parcelRequire("jl6Sn");

var $455M7 = parcelRequire("455M7");

var $c3Aax = parcelRequire("c3Aax");

var $8EXPa = parcelRequire("8EXPa");
parcelRequire("hqKpV");
var $fNdr1 = parcelRequire("fNdr1");
const $2a81506982df3304$var$hamsPricingDataStub = {};
const $2a81506982df3304$var$hamsProductKeyStub = "";
function $2a81506982df3304$export$f9574505c9651410(args) {
    const { ccpPricingData: ccpPricingData, ccpOfferingSKU: ccpOfferingSKU, period: period, numUnits: numUnits, currencyISOCode: currencyISOCode, localeISOCode: localeISOCode } = args;
    if (numUnits === 0) return (0, $7Knp0._)({
        offeringSku: ccpOfferingSKU
    }, (0, $c3Aax.getFreePriceCalc)(currencyISOCode));
    else {
        let getCcpTiers = undefined;
        if (ccpOfferingSKU === (0, $fNdr1.rovoDevOfferingSkus).standard || ccpOfferingSKU === (0, $8EXPa.bitbucketOfferingSkus).standard || ccpOfferingSKU === (0, $8EXPa.bitbucketOfferingSkus).premium) // rovodev-standard price-plans contain both user and rovodev-credits charge-items
        // bitbucket-standard and bitbucket-premium price-plans contain both user and bitbucket-credits charge-items as well
        // so, we need to get the plan with the user charge-item
        // todo: GWP-8253 move out of reusable calc logic
        getCcpTiers = (pricingPlans)=>pricingPlans.items.find((item)=>item.chargeElement === "user");
        const pricingTiers = (0, $jl6Sn.extractPricingTiersFromEntry)(ccpPricingData, $2a81506982df3304$var$hamsPricingDataStub, period, currencyISOCode, ccpOfferingSKU, $2a81506982df3304$var$hamsProductKeyStub, getCcpTiers);
        if (!pricingTiers) {
            console.log(`Pricing tiers not found for ${period}.`);
            return (0, $7Knp0._)({
                offeringSku: ccpOfferingSKU
            }, (0, $c3Aax.getFreePriceCalc)(currencyISOCode));
        } else return (0, $7Knp0._)({
            offeringSku: ccpOfferingSKU
        }, (0, $455M7.calculatePrice)(numUnits, pricingTiers, currencyISOCode, period, localeISOCode));
    }
}

});
parcelRegister("8EXPa", function(module, exports) {

$parcel$export(module.exports, "BITBUCKET_DEFAULT_BILLING_CYCLE", function () { return $fdd1778c4e973722$export$6e78cb64dcbedbb9; });
$parcel$export(module.exports, "BITBUCKET_DEFAULT_UNIT_COUNT", function () { return $fdd1778c4e973722$export$36a5806a0e4fc360; });
$parcel$export(module.exports, "BITBUCKET_MIN_ENTERPRISE_USER_COUNT", function () { return $fdd1778c4e973722$export$2b15976b7672c2da; });
$parcel$export(module.exports, "bitbucketOfferingSkus", function () { return $fdd1778c4e973722$export$eeb88db779daf862; });
$parcel$export(module.exports, "BITBUCKET_SIGNUP_LIMIT", function () { return $fdd1778c4e973722$export$4d264dc26702f23b; });
$parcel$export(module.exports, "bitbucketPlanLimitConfigs", function () { return $fdd1778c4e973722$export$66d05a9262b43b7f; });
$parcel$export(module.exports, "bitbucketBillingCycleConfig", function () { return $fdd1778c4e973722$export$f9cab01559b23739; });
const $fdd1778c4e973722$export$6e78cb64dcbedbb9 = "MONTHLY";
const $fdd1778c4e973722$export$36a5806a0e4fc360 = 5;
const $fdd1778c4e973722$export$2b15976b7672c2da = 201;
const $fdd1778c4e973722$export$eeb88db779daf862 = {
    free: "bitbucket-test-free",
    standard: "bitbucket-std",
    premium: "bitbucket-premium"
};
const $fdd1778c4e973722$export$4d264dc26702f23b = 35000;
const $fdd1778c4e973722$export$9a2735659d85fd7c = Object.values($fdd1778c4e973722$export$eeb88db779daf862);
const $fdd1778c4e973722$export$66d05a9262b43b7f = [
    {
        planName: "Free",
        offeringSku: $fdd1778c4e973722$export$eeb88db779daf862.free,
        recommendationLimit: 0,
        signupLimit: $fdd1778c4e973722$export$4d264dc26702f23b
    },
    {
        planName: "Standard",
        offeringSku: $fdd1778c4e973722$export$eeb88db779daf862.standard,
        recommendationLimit: 5,
        signupLimit: $fdd1778c4e973722$export$4d264dc26702f23b
    },
    {
        planName: "Premium",
        offeringSku: $fdd1778c4e973722$export$eeb88db779daf862.premium,
        recommendationLimit: 100,
        signupLimit: $fdd1778c4e973722$export$4d264dc26702f23b
    }
];
const $fdd1778c4e973722$export$f9cab01559b23739 = {
    monthly: true,
    annual: false
};

});

parcelRegister("hqKpV", function(module, exports) {
$parcel$export(module.exports, "jiraOfferingSkus", function () { return (parcelRequire("ktygn")).jiraOfferingSkus; });
$parcel$export(module.exports, "CONFLUENCE_DEFAULT_UNIT_COUNT", function () { return (parcelRequire("1i1dJ")).CONFLUENCE_DEFAULT_UNIT_COUNT; });
$parcel$export(module.exports, "confluenceOfferingSkus", function () { return (parcelRequire("1i1dJ")).confluenceOfferingSkus; });
$parcel$export(module.exports, "strategyCollectionOfferingSkus", function () { return (parcelRequire("awylZ")).strategyCollectionOfferingSkus; });
$parcel$export(module.exports, "teamworkCollectionOfferingSkus", function () { return (parcelRequire("fPLSq")).teamworkCollectionOfferingSkus; });
$parcel$export(module.exports, "loomOfferingSkus", function () { return (parcelRequire("1F9wN")).loomOfferingSkus; });
$parcel$export(module.exports, "jpdOfferingSkus", function () { return (parcelRequire("5kiq4")).jpdOfferingSkus; });
$parcel$export(module.exports, "compassOfferingSkus", function () { return (parcelRequire("iRy5O")).compassOfferingSkus; });
$parcel$export(module.exports, "guardOfferingSkus", function () { return (parcelRequire("5Rijz")).guardOfferingSkus; });
$parcel$export(module.exports, "serviceCollectionOfferingSkus", function () { return (parcelRequire("3ItZP")).serviceCollectionOfferingSkus; });
$parcel$export(module.exports, "rovoDevOfferingSkus", function () { return (parcelRequire("fNdr1")).rovoDevOfferingSkus; });
parcelRequire("ktygn");
parcelRequire("1i1dJ");
parcelRequire("awylZ");
parcelRequire("fPLSq");
parcelRequire("1F9wN");
parcelRequire("fKYQO");
parcelRequire("5kiq4");
parcelRequire("iRy5O");
parcelRequire("5Rijz");
parcelRequire("3ItZP");
parcelRequire("fNdr1");

});
parcelRegister("ktygn", function(module, exports) {

$parcel$export(module.exports, "JIRA_DEFAULT_BILLING_CYCLE", function () { return $4898376357b002ff$export$c34e5566df36b6ba; });
$parcel$export(module.exports, "JIRA_DEFAULT_UNIT_COUNT", function () { return $4898376357b002ff$export$6521a918e64524fb; });
$parcel$export(module.exports, "JIRA_MIN_ENTERPRISE_USER_COUNT", function () { return $4898376357b002ff$export$9aef50cd5f48bb38; });
$parcel$export(module.exports, "jiraOfferingSkus", function () { return $4898376357b002ff$export$7529f2cfeec98447; });
$parcel$export(module.exports, "jiraPlanLimitConfigs", function () { return $4898376357b002ff$export$3070b86c7bc28aea; });
const $4898376357b002ff$export$c34e5566df36b6ba = "MONTHLY";
const $4898376357b002ff$export$6521a918e64524fb = 300;
const $4898376357b002ff$export$9aef50cd5f48bb38 = 801;
const $4898376357b002ff$export$7529f2cfeec98447 = {
    free: "jira-software-free",
    standard: "jira-software-standard",
    premium: "jira-software-premium",
    enterprise: "jira-software-enterprise-sku"
};
const $4898376357b002ff$export$b2b09200ca76754f = Object.values($4898376357b002ff$export$7529f2cfeec98447);
const $4898376357b002ff$export$3070b86c7bc28aea = [
    {
        planName: "Free",
        offeringSku: $4898376357b002ff$export$7529f2cfeec98447.free,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: "Standard",
        offeringSku: $4898376357b002ff$export$7529f2cfeec98447.standard,
        recommendationLimit: 10,
        signupLimit: 100000
    },
    {
        planName: "Premium",
        offeringSku: $4898376357b002ff$export$7529f2cfeec98447.premium,
        recommendationLimit: 250,
        signupLimit: 100000
    },
    {
        planName: "Enterprise",
        offeringSku: $4898376357b002ff$export$7529f2cfeec98447.enterprise,
        recommendationLimit: 5000,
        signupLimit: 100000,
        minUnitCount: $4898376357b002ff$export$9aef50cd5f48bb38
    }
];
const $4898376357b002ff$export$7a133a10c706882b = {
    monthly: true,
    annual: true
};

});

parcelRegister("1i1dJ", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_DEFAULT_BILLING_CYCLE", function () { return $5b71775fc0eefb97$export$d60dc2d142b5e9dd; });
$parcel$export(module.exports, "CONFLUENCE_DEFAULT_UNIT_COUNT", function () { return $5b71775fc0eefb97$export$ab3750ec8101ffcc; });
$parcel$export(module.exports, "CONFLUENCE_MIN_ENTERPRISE_USER_COUNT", function () { return $5b71775fc0eefb97$export$f76a76b996ace375; });
$parcel$export(module.exports, "confluenceOfferingSkus", function () { return $5b71775fc0eefb97$export$ffe6d3f38b5f7c3a; });
$parcel$export(module.exports, "confluencePlanLimitConfigs", function () { return $5b71775fc0eefb97$export$53fbba6eb29a73ad; });
const $5b71775fc0eefb97$export$d60dc2d142b5e9dd = "MONTHLY";
const $5b71775fc0eefb97$export$ab3750ec8101ffcc = 300;
const $5b71775fc0eefb97$export$f76a76b996ace375 = 801;
const $5b71775fc0eefb97$export$ffe6d3f38b5f7c3a = {
    free: "confluence-free",
    standard: "confluence-standard",
    premium: "confluence-premium",
    enterprise: "confluence-enterprise-sku"
};
const $5b71775fc0eefb97$export$39e8fbae2abd0443 = Object.values($5b71775fc0eefb97$export$ffe6d3f38b5f7c3a);
const $5b71775fc0eefb97$export$53fbba6eb29a73ad = [
    {
        planName: "Free",
        offeringSku: $5b71775fc0eefb97$export$ffe6d3f38b5f7c3a.free,
        recommendationLimit: 0,
        signupLimit: 150000
    },
    {
        planName: "Standard",
        offeringSku: $5b71775fc0eefb97$export$ffe6d3f38b5f7c3a.standard,
        recommendationLimit: 10,
        signupLimit: 150000
    },
    {
        planName: "Premium",
        offeringSku: $5b71775fc0eefb97$export$ffe6d3f38b5f7c3a.premium,
        recommendationLimit: 250,
        signupLimit: 150000
    },
    {
        planName: "Enterprise",
        offeringSku: $5b71775fc0eefb97$export$ffe6d3f38b5f7c3a.enterprise,
        recommendationLimit: 5000,
        signupLimit: 150000,
        minUnitCount: $5b71775fc0eefb97$export$f76a76b996ace375
    }
];
const $5b71775fc0eefb97$export$e8f1610e98745fd7 = {
    monthly: true,
    annual: true
};

});

parcelRegister("awylZ", function(module, exports) {

$parcel$export(module.exports, "STRATEGY_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $e331a20e06ae1835$export$c00ddd271304729a; });
$parcel$export(module.exports, "STRATEGY_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $e331a20e06ae1835$export$27579c7f06007c25; });
$parcel$export(module.exports, "STRATEGY_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $e331a20e06ae1835$export$a99f1f06dfc3702a; });
$parcel$export(module.exports, "strategyCollectionOfferingSkus", function () { return $e331a20e06ae1835$export$8427e2db10f569be; });
$parcel$export(module.exports, "strategyCollectionPlanLimitConfigs", function () { return $e331a20e06ae1835$export$bc4927fbd68771ac; });
$parcel$export(module.exports, "strategyCollectionBillingCycleConfig", function () { return $e331a20e06ae1835$export$2225b2a65811f064; });
const $e331a20e06ae1835$export$c00ddd271304729a = "ANNUAL";
const $e331a20e06ae1835$export$27579c7f06007c25 = 50;
const $e331a20e06ae1835$export$a99f1f06dfc3702a = 50;
const $e331a20e06ae1835$export$8427e2db10f569be = {
    enterprise: "strategy-collection-enterprise-sku"
};
const $e331a20e06ae1835$export$3b4c7d53b38ef615 = Object.values($e331a20e06ae1835$export$8427e2db10f569be);
const $e331a20e06ae1835$export$bc4927fbd68771ac = [
    {
        planName: "Enterprise",
        offeringSku: $e331a20e06ae1835$export$8427e2db10f569be.enterprise,
        recommendationLimit: 2000,
        signupLimit: 2000,
        minUnitCount: $e331a20e06ae1835$export$a99f1f06dfc3702a
    }
];
const $e331a20e06ae1835$export$2225b2a65811f064 = {
    monthly: false,
    annual: true
};

});

parcelRegister("fPLSq", function(module, exports) {

$parcel$export(module.exports, "TEAMWORK_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $72cd788fce91eb06$export$5784a04bb778d3c1; });
$parcel$export(module.exports, "TEAMWORK_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $72cd788fce91eb06$export$482604a575f7b4a5; });
$parcel$export(module.exports, "TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $72cd788fce91eb06$export$da0d6abd6eaa52b2; });
$parcel$export(module.exports, "teamworkCollectionOfferingSkus", function () { return $72cd788fce91eb06$export$2e2107bfa20be1d8; });
$parcel$export(module.exports, "teamworkCollectionPlanLimitConfigs", function () { return $72cd788fce91eb06$export$88bcddbae46dd5f1; });
$parcel$export(module.exports, "teamworkCollectionBillingCycleConfig", function () { return $72cd788fce91eb06$export$5861c5ce06e1556; });
const $72cd788fce91eb06$export$5784a04bb778d3c1 = "MONTHLY";
const $72cd788fce91eb06$export$482604a575f7b4a5 = 300;
const $72cd788fce91eb06$export$da0d6abd6eaa52b2 = 801;
const $72cd788fce91eb06$export$2e2107bfa20be1d8 = {
    free: "teamwork-collection-free-sku",
    standard: "teamwork-collection-standard-sku",
    premium: "teamwork-collection-premium-sku",
    enterprise: "teamwork-collection-enterprise-sku"
};
const $72cd788fce91eb06$export$b61ab2c6a18de6d4 = Object.values($72cd788fce91eb06$export$2e2107bfa20be1d8);
const $72cd788fce91eb06$export$88bcddbae46dd5f1 = [
    {
        planName: "Free",
        offeringSku: $72cd788fce91eb06$export$2e2107bfa20be1d8.free,
        recommendationLimit: 0,
        signupLimit: 10
    },
    {
        planName: "Standard",
        offeringSku: $72cd788fce91eb06$export$2e2107bfa20be1d8.standard,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: "Premium",
        offeringSku: $72cd788fce91eb06$export$2e2107bfa20be1d8.premium,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: "Enterprise",
        offeringSku: $72cd788fce91eb06$export$2e2107bfa20be1d8.enterprise,
        recommendationLimit: 5000,
        signupLimit: 100000,
        minUnitCount: $72cd788fce91eb06$export$da0d6abd6eaa52b2
    }
];
const $72cd788fce91eb06$export$5861c5ce06e1556 = {
    monthly: true,
    annual: true
};

});

parcelRegister("1F9wN", function(module, exports) {

$parcel$export(module.exports, "LOOM_DEFAULT_BILLING_CYCLE", function () { return $8db8255cb645bec1$export$501dc9dfd5b2bde4; });
$parcel$export(module.exports, "LOOM_DEFAULT_UNIT_COUNT", function () { return $8db8255cb645bec1$export$2aa1a93e0ac00fc; });
$parcel$export(module.exports, "LOOM_MIN_ENTERPRISE_USER_COUNT", function () { return $8db8255cb645bec1$export$2a2f7d7a7ae18850; });
$parcel$export(module.exports, "loomOfferingSkus", function () { return $8db8255cb645bec1$export$a64578a63428ae96; });
$parcel$export(module.exports, "loomPlanLimitConfigs", function () { return $8db8255cb645bec1$export$ed1379ed8713d252; });
$parcel$export(module.exports, "loomBillingCycleConfig", function () { return $8db8255cb645bec1$export$d2bfeac6f7899675; });
const $8db8255cb645bec1$export$501dc9dfd5b2bde4 = "MONTHLY";
const $8db8255cb645bec1$export$2aa1a93e0ac00fc = 100;
const $8db8255cb645bec1$export$2a2f7d7a7ae18850 = Infinity;
const $8db8255cb645bec1$export$a64578a63428ae96 = {
    free: "loom-free-sku",
    business: "loom-business-sku",
    businessPlusAi: "loom-business-ai-sku",
    enterprise: "loom-enterprise-sku"
};
const $8db8255cb645bec1$export$9f95f1c871571078 = Object.values($8db8255cb645bec1$export$a64578a63428ae96);
const $8db8255cb645bec1$export$ed1379ed8713d252 = [
    {
        planName: "Free",
        offeringSku: $8db8255cb645bec1$export$a64578a63428ae96.free,
        recommendationLimit: Infinity,
        signupLimit: 50000
    },
    {
        planName: "Business",
        offeringSku: $8db8255cb645bec1$export$a64578a63428ae96.business,
        recommendationLimit: Infinity,
        signupLimit: 50000
    },
    {
        planName: "Business + AI",
        offeringSku: $8db8255cb645bec1$export$a64578a63428ae96.businessPlusAi,
        recommendationLimit: 0,
        signupLimit: 50000
    },
    {
        planName: "Enterprise",
        offeringSku: $8db8255cb645bec1$export$a64578a63428ae96.enterprise,
        recommendationLimit: Infinity,
        signupLimit: 50000
    }
];
const $8db8255cb645bec1$export$d2bfeac6f7899675 = {
    monthly: true,
    annual: true
};

});

parcelRegister("fKYQO", function(module, exports) {
const $e2063f4ed18d2b98$export$be354061b07829a8 = "MONTHLY";
const $e2063f4ed18d2b98$export$2295858875312a6f = 75;
const $e2063f4ed18d2b98$export$66d53803b4a2565a = 201;
const $e2063f4ed18d2b98$export$38631f866342776a = {
    free: "jira-servicedesk-free",
    standard: "jira-servicedesk-standard",
    premium: "jira-servicedesk-premium",
    enterprise: "jira-servicedesk-enterprise-sku"
};
const $e2063f4ed18d2b98$export$efd16829e921ffb8 = Object.values($e2063f4ed18d2b98$export$38631f866342776a);
const $e2063f4ed18d2b98$export$9e62e4d7dc794618 = [
    {
        planName: "Free",
        offeringSku: $e2063f4ed18d2b98$export$38631f866342776a.free,
        recommendationLimit: 0,
        signupLimit: 20000
    },
    {
        planName: "Standard",
        offeringSku: $e2063f4ed18d2b98$export$38631f866342776a.standard,
        recommendationLimit: 3,
        signupLimit: 20000
    },
    {
        planName: "Premium",
        offeringSku: $e2063f4ed18d2b98$export$38631f866342776a.premium,
        recommendationLimit: 50,
        signupLimit: 20000
    },
    {
        planName: "Enterprise",
        offeringSku: $e2063f4ed18d2b98$export$38631f866342776a.enterprise,
        recommendationLimit: 250,
        signupLimit: 20000
    }
];
const $e2063f4ed18d2b98$export$34fbcdd33d5f7ba7 = {
    monthly: true,
    annual: true
};

});

parcelRegister("5kiq4", function(module, exports) {

$parcel$export(module.exports, "JPD_DEFAULT_BILLING_CYCLE", function () { return $3ff405992fae1ce1$export$513f99bdcd3bd2; });
$parcel$export(module.exports, "JPD_DEFAULT_UNIT_COUNT", function () { return $3ff405992fae1ce1$export$503245d941330408; });
$parcel$export(module.exports, "JPD_MIN_ENTERPRISE_USER_COUNT", function () { return $3ff405992fae1ce1$export$4ebabaf17c585254; });
$parcel$export(module.exports, "jpdOfferingSkus", function () { return $3ff405992fae1ce1$export$400db592c8d58797; });
$parcel$export(module.exports, "jpdPlanLimitConfigs", function () { return $3ff405992fae1ce1$export$886e6b42d7675517; });
$parcel$export(module.exports, "jpdBillingCycleConfig", function () { return $3ff405992fae1ce1$export$370b1f24abd91670; });
const $3ff405992fae1ce1$export$513f99bdcd3bd2 = "MONTHLY";
const $3ff405992fae1ce1$export$503245d941330408 = 10;
const $3ff405992fae1ce1$export$4ebabaf17c585254 = 201;
const $3ff405992fae1ce1$export$400db592c8d58797 = {
    free: "jira-servicedesk-free",
    // jpd-free shares the same sku as jsm-free
    standard: "jira-product-discovery-standard",
    premium: "jira-product-discovery-premium-sku"
};
const $3ff405992fae1ce1$export$cf1798af40f51188 = Object.values($3ff405992fae1ce1$export$400db592c8d58797);
const $3ff405992fae1ce1$export$886e6b42d7675517 = [
    {
        planName: "Free",
        offeringSku: $3ff405992fae1ce1$export$400db592c8d58797.free,
        recommendationLimit: 0,
        signupLimit: 20000
    },
    {
        planName: "Standard",
        offeringSku: $3ff405992fae1ce1$export$400db592c8d58797.standard,
        recommendationLimit: 3,
        signupLimit: 20000
    },
    {
        planName: "Premium",
        offeringSku: $3ff405992fae1ce1$export$400db592c8d58797.premium,
        recommendationLimit: 50,
        signupLimit: 20000
    }
];
const $3ff405992fae1ce1$export$370b1f24abd91670 = {
    monthly: true,
    annual: true
};

});

parcelRegister("iRy5O", function(module, exports) {

$parcel$export(module.exports, "COMPASS_DEFAULT_BILLING_CYCLE", function () { return $59446ee27ebc264e$export$2c789441f8bab310; });
$parcel$export(module.exports, "COMPASS_DEFAULT_UNIT_COUNT", function () { return $59446ee27ebc264e$export$887bc0e84eafd3c; });
$parcel$export(module.exports, "COMPASS_MIN_ENTERPRISE_USER_COUNT", function () { return $59446ee27ebc264e$export$862352663e0ac9d7; });
$parcel$export(module.exports, "compassOfferingSkus", function () { return $59446ee27ebc264e$export$f93fb5caff8c778a; });
$parcel$export(module.exports, "compassPlanLimitConfigs", function () { return $59446ee27ebc264e$export$4df3b64d28e0d138; });
$parcel$export(module.exports, "compassBillingCycleConfig", function () { return $59446ee27ebc264e$export$e0b3f0eba764d747; });
const $59446ee27ebc264e$export$2c789441f8bab310 = "MONTHLY";
const $59446ee27ebc264e$export$887bc0e84eafd3c = 300;
const $59446ee27ebc264e$export$862352663e0ac9d7 = Infinity;
const $59446ee27ebc264e$export$f93fb5caff8c778a = {
    free: "compass-free",
    standard: "compass-standard",
    premium: "compass-premium-sku"
};
const $59446ee27ebc264e$export$74a0fd94f40ef5c5 = Object.values($59446ee27ebc264e$export$f93fb5caff8c778a);
const $59446ee27ebc264e$export$4df3b64d28e0d138 = [
    {
        planName: "Free",
        offeringSku: $59446ee27ebc264e$export$f93fb5caff8c778a.free,
        recommendationLimit: 0,
        signupLimit: 3
    },
    {
        planName: "Standard",
        offeringSku: $59446ee27ebc264e$export$f93fb5caff8c778a.standard,
        recommendationLimit: 3,
        signupLimit: 35000
    },
    {
        planName: "Premium",
        offeringSku: $59446ee27ebc264e$export$f93fb5caff8c778a.premium,
        recommendationLimit: 250,
        signupLimit: 35000
    }
];
const $59446ee27ebc264e$export$e0b3f0eba764d747 = {
    monthly: true,
    annual: true
};

});

parcelRegister("5Rijz", function(module, exports) {

$parcel$export(module.exports, "GUARD_DEFAULT_BILLING_CYCLE", function () { return $5cadcd121392db78$export$9be98af08cc25cad; });
$parcel$export(module.exports, "GUARD_DEFAULT_UNIT_COUNT", function () { return $5cadcd121392db78$export$d28097ea69640bd5; });
$parcel$export(module.exports, "GUARD_MIN_ENTERPRISE_USER_COUNT", function () { return $5cadcd121392db78$export$13b500e201e8b319; });
$parcel$export(module.exports, "guardOfferingSkus", function () { return $5cadcd121392db78$export$91a420e9c7eb7c83; });
$parcel$export(module.exports, "guardPlanLimitConfigs", function () { return $5cadcd121392db78$export$a2329ae21ff2ff84; });
$parcel$export(module.exports, "guardBillingCycleConfig", function () { return $5cadcd121392db78$export$129a445945b6d9b3; });
const $5cadcd121392db78$export$9be98af08cc25cad = "MONTHLY";
const $5cadcd121392db78$export$d28097ea69640bd5 = 100;
const $5cadcd121392db78$export$13b500e201e8b319 = Infinity;
const $5cadcd121392db78$export$91a420e9c7eb7c83 = {
    standard: "atlassian-access-standard-sku",
    premium: "atlassian-guard-premium-addon-sku"
};
const $5cadcd121392db78$export$159558c2b3d66b11 = Object.values($5cadcd121392db78$export$91a420e9c7eb7c83);
const $5cadcd121392db78$export$a2329ae21ff2ff84 = [
    {
        planName: "Standard",
        offeringSku: $5cadcd121392db78$export$91a420e9c7eb7c83.standard,
        recommendationLimit: 0,
        signupLimit: 50000
    },
    {
        planName: "Premium",
        offeringSku: $5cadcd121392db78$export$91a420e9c7eb7c83.premium,
        recommendationLimit: 99,
        signupLimit: 50000
    }
];
const $5cadcd121392db78$export$129a445945b6d9b3 = {
    monthly: true,
    annual: true
};

});

parcelRegister("3ItZP", function(module, exports) {

$parcel$export(module.exports, "SERVICE_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $98d786164d4b1720$export$9423de11a8a6dfa7; });
$parcel$export(module.exports, "SERVICE_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $98d786164d4b1720$export$515fa2affea780b3; });
$parcel$export(module.exports, "SERVICE_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $98d786164d4b1720$export$3df704b75c4818f2; });
$parcel$export(module.exports, "serviceCollectionOfferingSkus", function () { return $98d786164d4b1720$export$84b191ede7d628ea; });
$parcel$export(module.exports, "serviceCollectionPlanLimitConfigs", function () { return $98d786164d4b1720$export$29e5f53cb4f38894; });
$parcel$export(module.exports, "serviceCollectionBillingCycleConfig", function () { return $98d786164d4b1720$export$7c96cfb0c18bfb05; });
const $98d786164d4b1720$export$9423de11a8a6dfa7 = "MONTHLY";
const $98d786164d4b1720$export$515fa2affea780b3 = 75;
const $98d786164d4b1720$export$3df704b75c4818f2 = 201;
const $98d786164d4b1720$export$84b191ede7d628ea = {
    free: "service-collection-free",
    standard: "service-collection-standard",
    premium: "service-collection-premium",
    enterprise: "service-collection-enterprise"
};
const $98d786164d4b1720$export$953539e2774d6323 = Object.values($98d786164d4b1720$export$84b191ede7d628ea);
const $98d786164d4b1720$export$29e5f53cb4f38894 = [
    {
        planName: "Free",
        offeringSku: $98d786164d4b1720$export$84b191ede7d628ea.free,
        recommendationLimit: 0,
        signupLimit: 20000
    },
    {
        planName: "Standard",
        offeringSku: $98d786164d4b1720$export$84b191ede7d628ea.standard,
        recommendationLimit: 3,
        signupLimit: 20000
    },
    {
        planName: "Premium",
        offeringSku: $98d786164d4b1720$export$84b191ede7d628ea.premium,
        recommendationLimit: 50,
        signupLimit: 20000
    },
    {
        planName: "Enterprise",
        offeringSku: $98d786164d4b1720$export$84b191ede7d628ea.enterprise,
        recommendationLimit: 250,
        signupLimit: 20000,
        minUnitCount: $98d786164d4b1720$export$3df704b75c4818f2
    }
];
const $98d786164d4b1720$export$7c96cfb0c18bfb05 = {
    monthly: true,
    annual: true
};

});

parcelRegister("fNdr1", function(module, exports) {

$parcel$export(module.exports, "ROVO_DEV_DEFAULT_BILLING_CYCLE", function () { return $9cae7a096cb356f4$export$f7b45b42f23a06a6; });
$parcel$export(module.exports, "ROVO_DEV_DEFAULT_UNIT_COUNT", function () { return $9cae7a096cb356f4$export$c80f45e98f559c29; });
$parcel$export(module.exports, "ROVO_DEV_MIN_ENTERPRISE_USER_COUNT", function () { return $9cae7a096cb356f4$export$5cdb7bb84622bb8e; });
$parcel$export(module.exports, "rovoDevOfferingSkus", function () { return $9cae7a096cb356f4$export$6a8477cfea6a8fb8; });
$parcel$export(module.exports, "rovoDevPlanLimitConfigs", function () { return $9cae7a096cb356f4$export$93aaa2531823d54e; });
$parcel$export(module.exports, "rovoDevBillingCycleConfig", function () { return $9cae7a096cb356f4$export$120b0272a23f9b21; });
const $9cae7a096cb356f4$export$f7b45b42f23a06a6 = "MONTHLY";
const $9cae7a096cb356f4$export$c80f45e98f559c29 = 10;
const $9cae7a096cb356f4$export$5cdb7bb84622bb8e = Infinity;
const $9cae7a096cb356f4$export$6a8477cfea6a8fb8 = {
    standard: "rovodev-standard"
};
const $9cae7a096cb356f4$export$69f1beff4f684452 = Object.values($9cae7a096cb356f4$export$6a8477cfea6a8fb8);
const $9cae7a096cb356f4$export$93aaa2531823d54e = [
    {
        planName: "Standard",
        offeringSku: $9cae7a096cb356f4$export$6a8477cfea6a8fb8.standard,
        recommendationLimit: Infinity,
        signupLimit: Infinity,
        minUnitCount: $9cae7a096cb356f4$export$5cdb7bb84622bb8e
    }
];
const $9cae7a096cb356f4$export$120b0272a23f9b21 = {
    monthly: false,
    annual: false
};

});




parcelRegister("gz56C", function(module, exports) {

$parcel$export(module.exports, "getProductCalculationInputs", function () { return $09379941b2c1216c$export$915d8a609f55f86e; });

var $7mfju = parcelRequire("7mfju");
const $09379941b2c1216c$export$915d8a609f55f86e = (productPlans, unitMinEnterprise, unitCount, billingCycle)=>{
    const getNumUnits = (planName, signupUnitLimit)=>{
        let adjNumUnits = 0;
        // following scenarios do not have pricing and should send a zero unit count,
        // the zero pricing will not be displayed and is needed only to retain the
        // correct array order of the pricing requests/responses
        // Free plan has no pricing
        const isFree = planName === (0, $7mfju.SpecialPlanNames).FREE;
        // Enterprise plans do not have monthly pricing
        const isMonthlyEnterprise = planName === (0, $7mfju.SpecialPlanNames).ENTERPRISE && billingCycle === "MONTHLY";
        // Enterprise plans have a minimum unit count
        const isUnmetUnitCountEnterprise = planName === (0, $7mfju.SpecialPlanNames).ENTERPRISE && unitCount < unitMinEnterprise;
        const isOverSignupUnitLimit = unitCount > signupUnitLimit;
        if (![
            isFree,
            isMonthlyEnterprise,
            isUnmetUnitCountEnterprise,
            isOverSignupUnitLimit
        ].includes(true)) adjNumUnits = unitCount;
        // keep unit count to general maximum limit
        return Math.min(adjNumUnits, signupUnitLimit);
    };
    const planPriceReqs = productPlans.map(({ offeringSku: offeringSku, planName: planName, signupLimit: signupLimit })=>({
            ccpOfferingSKU: offeringSku,
            hamsProductKey: undefined,
            numUnits: getNumUnits(planName, signupLimit || (0, $7mfju.DefaultPlanLimits).UNIT_LIMIT),
            period: billingCycle
        }));
    return planPriceReqs;
};

});




parcelRegister("iXUxi", function(module, exports) {

$parcel$export(module.exports, "getUnitCount", function () { return $aa8ab4fefb73d271$export$f188fc3b389e4986; });
$parcel$export(module.exports, "getBillingCycle", function () { return $aa8ab4fefb73d271$export$36cee2c7009ae4b; });
$parcel$export(module.exports, "hasAnnualBilling", function () { return $aa8ab4fefb73d271$export$101e70cd0fc05902; });
$parcel$export(module.exports, "hasMonthlyBilling", function () { return $aa8ab4fefb73d271$export$9adfa96ec47fe801; });
$parcel$export(module.exports, "isUnitCountAboveMaxThreshold", function () { return $aa8ab4fefb73d271$export$bdaa994f7aee683f; });
$parcel$export(module.exports, "getUnitCountMinThreshold", function () { return $aa8ab4fefb73d271$export$80145dc7d2cff456; });
$parcel$export(module.exports, "isUnitCountBelowMinThreshold", function () { return $aa8ab4fefb73d271$export$5566acad9364293b; });
$parcel$export(module.exports, "getNumberFormatLocale", function () { return $aa8ab4fefb73d271$export$3d36f1c8af14c3fb; });
$parcel$export(module.exports, "getCurrencyIsoCode", function () { return $aa8ab4fefb73d271$export$5052d5e5b6a90fdc; });
$parcel$export(module.exports, "isOfferingRecommended", function () { return $aa8ab4fefb73d271$export$d9589e71fc109cc; });
$parcel$export(module.exports, "getUnitTierLowerBound", function () { return $aa8ab4fefb73d271$export$f88112553e09e018; });
$parcel$export(module.exports, "getUnitTierUpperBound", function () { return $aa8ab4fefb73d271$export$6f3b3ca7764acc97; });
$parcel$export(module.exports, "getUnitsAvailableInTier", function () { return $aa8ab4fefb73d271$export$daa8dd568be987ed; });
$parcel$export(module.exports, "getFormattedPlanPrice", function () { return $aa8ab4fefb73d271$export$8808c13548cf959c; });
$parcel$export(module.exports, "getPricePlanId", function () { return $aa8ab4fefb73d271$export$235d4fbb478dfba0; });
const $aa8ab4fefb73d271$export$f188fc3b389e4986 = (ctx)=>ctx.inputValues.unitCount;
const $aa8ab4fefb73d271$export$36cee2c7009ae4b = (ctx)=>ctx.inputValues.billingCycle;
const $aa8ab4fefb73d271$export$101e70cd0fc05902 = (ctx)=>{
    return ctx.config.billingCycleConfig.annual;
};
const $aa8ab4fefb73d271$export$9adfa96ec47fe801 = (ctx)=>{
    return ctx.config.billingCycleConfig.monthly;
};
const $aa8ab4fefb73d271$export$bdaa994f7aee683f = (ctx, offeringSku)=>{
    const unitCount = $aa8ab4fefb73d271$export$f188fc3b389e4986(ctx);
    const planLimitConfig = $aa8ab4fefb73d271$var$getPlanLimitConfig(ctx, offeringSku);
    return unitCount > planLimitConfig.signupLimit;
};
const $aa8ab4fefb73d271$export$80145dc7d2cff456 = (ctx, offeringSku)=>{
    const { minUnitCount: minUnitCount } = $aa8ab4fefb73d271$var$getPlanLimitConfig(ctx, offeringSku);
    return minUnitCount !== null && minUnitCount !== void 0 ? minUnitCount : 0;
};
const $aa8ab4fefb73d271$export$5566acad9364293b = (ctx, offeringSku)=>{
    const minUnitCount = $aa8ab4fefb73d271$export$80145dc7d2cff456(ctx, offeringSku);
    const unitCount = $aa8ab4fefb73d271$export$f188fc3b389e4986(ctx);
    return unitCount < minUnitCount;
};
const $aa8ab4fefb73d271$export$3a3e581c62c2c0f = (ctx)=>{
    const unitCount = $aa8ab4fefb73d271$export$f188fc3b389e4986(ctx);
    const unitMinEnterprise = ctx.config.unitMinEnterprise;
    return unitCount >= unitMinEnterprise;
};
const $aa8ab4fefb73d271$var$getPlanLimitConfigs = (ctx)=>{
    return ctx.config.planLimitConfigs;
};
const $aa8ab4fefb73d271$var$getPlanLimitConfig = (ctx, offeringSku)=>{
    const planLimitConfigs = $aa8ab4fefb73d271$var$getPlanLimitConfigs(ctx);
    const planLimitConfig = planLimitConfigs.find((plan)=>plan.offeringSku === offeringSku);
    if (!planLimitConfig) throw new Error("unexpected empty value");
    return planLimitConfig;
};
const $aa8ab4fefb73d271$var$getPlanPriceResult = (ctx, offeringSku)=>{
    const planPriceResult = ctx.calculationResult.find((plan)=>plan.offeringSku === offeringSku);
    if (!planPriceResult) throw new Error("unexpected empty value");
    return planPriceResult;
};
const $aa8ab4fefb73d271$export$e3c7f1437cafb58a = (ctx, offeringSku)=>{
    const price = $aa8ab4fefb73d271$var$getPlanPriceResult(ctx, offeringSku);
    return price.formattedTotalPrice;
};
const $aa8ab4fefb73d271$export$2aabcb5d2a5bee2b = (ctx, offeringSku)=>{
    const price = $aa8ab4fefb73d271$var$getPlanPriceResult(ctx, offeringSku);
    return price.avgPerUnitPrice;
};
const $aa8ab4fefb73d271$export$10818dfc4986524e = (price)=>{
    return Math.round(price);
};
const $aa8ab4fefb73d271$export$2dd65b072d3a3106 = (price)=>{
    return Math.ceil(price);
};
const $aa8ab4fefb73d271$export$3d36f1c8af14c3fb = (ctx)=>{
    const currencyISOCode = $aa8ab4fefb73d271$export$5052d5e5b6a90fdc(ctx);
    const isJPY = currencyISOCode === "JPY";
    return isJPY ? "ja-JP" : "en-US";
};
const $aa8ab4fefb73d271$export$c86caf1be068fb8d = (ctx, price, options = {})=>{
    const numberFormatLocale = $aa8ab4fefb73d271$export$3d36f1c8af14c3fb(ctx);
    const currencyISOCode = $aa8ab4fefb73d271$export$5052d5e5b6a90fdc(ctx);
    var _options_minimumFractionDigits, _options_minimumFractionDigits1;
    return new Intl.NumberFormat(numberFormatLocale, {
        style: "currency",
        currency: currencyISOCode,
        minimumFractionDigits: (_options_minimumFractionDigits = options.minimumFractionDigits) !== null && _options_minimumFractionDigits !== void 0 ? _options_minimumFractionDigits : 0,
        maximumFractionDigits: (_options_minimumFractionDigits1 = options.minimumFractionDigits) !== null && _options_minimumFractionDigits1 !== void 0 ? _options_minimumFractionDigits1 : 0
    }).format(price);
};
const $aa8ab4fefb73d271$export$b3a0d360c4444407 = (ctx, offeringSku)=>{
    const price = $aa8ab4fefb73d271$var$getPlanPriceResult(ctx, offeringSku);
    return price.formattedAvgPerUnitPrice;
};
const $aa8ab4fefb73d271$export$d9589e71fc109cc = (ctx, offeringSku)=>{
    const recommendedOfferingSku = $aa8ab4fefb73d271$var$getRecommendedOfferingSku(ctx);
    return recommendedOfferingSku === offeringSku;
};
const $aa8ab4fefb73d271$var$getRecommendedOfferingSku = (ctx)=>{
    var _planLimitConfigs_recommendedPlanIdx;
    const getRecommendedPlanIdx = (unitCount, minUnitCounts)=>{
        const len = minUnitCounts.length - 1;
        return len - minUnitCounts.reverse().findIndex((minUnitCount)=>unitCount > minUnitCount);
    };
    const unitCount = $aa8ab4fefb73d271$export$f188fc3b389e4986(ctx);
    const planLimitConfigs = $aa8ab4fefb73d271$var$getPlanLimitConfigs(ctx);
    const recommendedPlanIdx = getRecommendedPlanIdx(unitCount, planLimitConfigs.map((productPlan)=>productPlan.recommendationLimit));
    return (_planLimitConfigs_recommendedPlanIdx = planLimitConfigs[recommendedPlanIdx]) === null || _planLimitConfigs_recommendedPlanIdx === void 0 ? void 0 : _planLimitConfigs_recommendedPlanIdx.offeringSku;
};
const $aa8ab4fefb73d271$var$getUnformattedBreakdown = (ctx, offeringSku)=>{
    const planPriceResult = $aa8ab4fefb73d271$var$getPlanPriceResult(ctx, offeringSku);
    return planPriceResult.breakdown.at(-1);
};
const $aa8ab4fefb73d271$export$f88112553e09e018 = (ctx, offeringSku)=>{
    const breakdown = $aa8ab4fefb73d271$var$getUnformattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.unitLimitLower;
};
const $aa8ab4fefb73d271$export$6f3b3ca7764acc97 = (ctx, offeringSku)=>{
    const breakdown = $aa8ab4fefb73d271$var$getUnformattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.unitLimitUpper;
};
const $aa8ab4fefb73d271$export$daa8dd568be987ed = (ctx, offeringSku)=>{
    const unitCount = $aa8ab4fefb73d271$export$f188fc3b389e4986(ctx);
    const unitTierUpperBound = $aa8ab4fefb73d271$export$6f3b3ca7764acc97(ctx, offeringSku);
    return (unitTierUpperBound !== null && unitTierUpperBound !== void 0 ? unitTierUpperBound : 0) - unitCount;
};
/**
 * @deprecated
 */ const $aa8ab4fefb73d271$var$getFormattedBreakdown = (ctx, offeringSku)=>{
    const planPriceResult = $aa8ab4fefb73d271$var$getPlanPriceResult(ctx, offeringSku);
    return planPriceResult.formattedBreakdown.at(-1);
};
const $aa8ab4fefb73d271$export$b1a3e695caa8081d = (ctx, offeringSku)=>{
    const breakdown = $aa8ab4fefb73d271$var$getFormattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.formattedUnitLimitLower;
};
const $aa8ab4fefb73d271$export$24bf67bcc0364ee6 = (ctx, offeringSku)=>{
    const breakdown = $aa8ab4fefb73d271$var$getFormattedBreakdown(ctx, offeringSku);
    return breakdown === null || breakdown === void 0 ? void 0 : breakdown.formattedUnitLimitUpper;
};
const $aa8ab4fefb73d271$export$5052d5e5b6a90fdc = (ctx)=>ctx.config.currencyISOCode;
const $aa8ab4fefb73d271$export$8808c13548cf959c = (ctx, offeringSku)=>{
    const billingCycle = $aa8ab4fefb73d271$export$36cee2c7009ae4b(ctx);
    const currencyISOCode = $aa8ab4fefb73d271$export$5052d5e5b6a90fdc(ctx);
    if (billingCycle === "ANNUAL") return $aa8ab4fefb73d271$export$e3c7f1437cafb58a(ctx, offeringSku);
    let price = $aa8ab4fefb73d271$export$2aabcb5d2a5bee2b(ctx, offeringSku);
    if (currencyISOCode === "JPY") {
        price = $aa8ab4fefb73d271$export$2dd65b072d3a3106(price);
        return $aa8ab4fefb73d271$export$c86caf1be068fb8d(ctx, price, {
            minimumFractionDigits: 0
        });
    }
    return $aa8ab4fefb73d271$export$c86caf1be068fb8d(ctx, price, {
        minimumFractionDigits: price === 0 || Number.isInteger(price) ? 0 : 2
    });
};
const $aa8ab4fefb73d271$export$235d4fbb478dfba0 = (ctx, args)=>{
    var _offering_defaultPricingPlans;
    const { offeringSku: offeringSku, edition: edition } = args;
    const offering = Object.values(ctx.config.ccpPricingData).find((offering)=>offering.sku === offeringSku);
    const currencyISOCode = $aa8ab4fefb73d271$export$5052d5e5b6a90fdc(ctx);
    const billingCycle = $aa8ab4fefb73d271$export$36cee2c7009ae4b(ctx);
    // taken from `usePricingPlan` services/wac-web/src/components/wpl/pricing/src/price-finder/price-card/experiment-direct-buy/use-pricing-plan.tsx
    const defaultPricingPlan = offering === null || offering === void 0 ? void 0 : (_offering_defaultPricingPlans = offering.defaultPricingPlans) === null || _offering_defaultPricingPlans === void 0 ? void 0 : _offering_defaultPricingPlans.filter((item)=>item.currency.toLowerCase() == currencyISOCode.toLowerCase() && item.offeringName.toLowerCase() == edition.toLowerCase() && item.primaryCycle_name.toLowerCase() == billingCycle.toLowerCase() && item.status.toLowerCase() == "active");
    const lastPricingPlan = defaultPricingPlan === null || defaultPricingPlan === void 0 ? void 0 : defaultPricingPlan[defaultPricingPlan.length - 1];
    return (lastPricingPlan === null || lastPricingPlan === void 0 ? void 0 : lastPricingPlan.id) || "";
};

});


parcelRegister("MciJy", function(module, exports) {
$parcel$export(module.exports, "PricingCalculatorInputs", function () { return (parcelRequire("85vSY")).PricingCalculatorInputs; });
$parcel$export(module.exports, "RovoDevStandardPriceCard", function () { return (parcelRequire("9IdXN")).RovoDevStandardPriceCard; });
$parcel$export(module.exports, "ServiceCollectionEnterprisePriceCard", function () { return (parcelRequire("zcwoT")).ServiceCollectionEnterprisePriceCard; });
$parcel$export(module.exports, "ServiceCollectionFreePriceCard", function () { return (parcelRequire("zcwoT")).ServiceCollectionFreePriceCard; });
$parcel$export(module.exports, "ServiceCollectionPremiumPriceCard", function () { return (parcelRequire("zcwoT")).ServiceCollectionPremiumPriceCard; });
$parcel$export(module.exports, "ServiceCollectionStandardPriceCard", function () { return (parcelRequire("zcwoT")).ServiceCollectionStandardPriceCard; });
$parcel$export(module.exports, "LoomBusinessPlusAiPriceCard", function () { return (parcelRequire("3A3AJ")).LoomBusinessPlusAiPriceCard; });
$parcel$export(module.exports, "LoomBusinessPriceCard", function () { return (parcelRequire("3A3AJ")).LoomBusinessPriceCard; });
$parcel$export(module.exports, "LoomEnterprisePriceCard", function () { return (parcelRequire("3A3AJ")).LoomEnterprisePriceCard; });
$parcel$export(module.exports, "LoomFreePriceCard", function () { return (parcelRequire("3A3AJ")).LoomFreePriceCard; });
$parcel$export(module.exports, "JiraProductDiscoveryFreePriceCard", function () { return (parcelRequire("ebQhK")).JiraProductDiscoveryFreePriceCard; });
$parcel$export(module.exports, "JiraProductDiscoveryPremiumPriceCard", function () { return (parcelRequire("ebQhK")).JiraProductDiscoveryPremiumPriceCard; });
$parcel$export(module.exports, "JiraProductDiscoveryStandardPriceCard", function () { return (parcelRequire("ebQhK")).JiraProductDiscoveryStandardPriceCard; });

$parcel$export(module.exports, "LoadingSpinner", function () { return (parcelRequire("1rXz0")).LoadingSpinner; });
$parcel$export(module.exports, "PriceAltContainer", function () { return (parcelRequire("1JG1M")).PriceAltContainer; });
$parcel$export(module.exports, "MonthlyEnterpriseMessage", function () { return (parcelRequire("1wBc7")).MonthlyEnterpriseMessage; });
$parcel$export(module.exports, "getFeaturesList", function () { return (parcelRequire("chlmU")).getFeaturesList; });
$parcel$export(module.exports, "UserTier", function () { return (parcelRequire("fKqpx")).UserTier; });
$parcel$export(module.exports, "UserTierExpanded", function () { return (parcelRequire("fKqpx")).UserTierExpanded; });
$parcel$export(module.exports, "useLocalizedCtaUrl", function () { return (parcelRequire("4oRsq")).useLocalizedCtaUrl; });
$parcel$export(module.exports, "useConfluenceDirectBuyExperiment", function () { return (parcelRequire("38spb")).useConfluenceDirectBuyExperiment; });
$parcel$export(module.exports, "ConfluenceDirectBuyButton", function () { return (parcelRequire("38spb")).ConfluenceDirectBuyButton; });
parcelRequire("85vSY");

var $1rXz0 = parcelRequire("1rXz0");

var $1JG1M = parcelRequire("1JG1M");

var $1wBc7 = parcelRequire("1wBc7");

var $chlmU = parcelRequire("chlmU");

var $fKqpx = parcelRequire("fKqpx");

var $4oRsq = parcelRequire("4oRsq");

var $38spb = parcelRequire("38spb");
parcelRequire("9IdXN");
parcelRequire("zcwoT");
parcelRequire("3A3AJ");
parcelRequire("ebQhK");

});
parcelRegister("85vSY", function(module, exports) {

$parcel$export(module.exports, "PricingCalculatorInputs", function () { return $d80e3b774d43409a$export$8c44531ca473ca22; });
/* pricing-calculator-inputs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $7mfju = parcelRequire("7mfju");

var $11puL = parcelRequire("11puL");

var $E9GJt = parcelRequire("E9GJt");

var $5ohHq = parcelRequire("5ohHq");

var $j1tjc = parcelRequire("j1tjc");

var $iXUxi = parcelRequire("iXUxi");
const $d80e3b774d43409a$export$8c44531ca473ca22 = (props)=>{
    const { unitCountLabel: unitCountLabel, unitsLabel: unitsLabel, dataProductKey: dataProductKey } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const [billingCycle, setBillingCycle] = (0, $j1tjc.useBillingCycle)();
    const [unitCount, setUnitCount] = (0, $j1tjc.useUnitCount)();
    const hasMonthlyBilling = (0, $j1tjc.useSelector)($iXUxi.hasMonthlyBilling);
    const hasAnnualBilling = (0, $j1tjc.useSelector)($iXUxi.hasAnnualBilling); // @ts-ignore
    const { isVariation: isDirectBuyExperimentVariation } = (0, $11puL.useDirectBuyCohort)(dataProductKey);
    const [visualUnitCount, setVisualUnitCount] = (0, $iSvIT.useState)(// @ts-ignore
    unitCount);
    (0, $iSvIT.useEffect)(()=>{
        if (visualUnitCount !== "" && visualUnitCount > 0 && !Number.isNaN(visualUnitCount)) // @ts-ignore
        setUnitCount(visualUnitCount);
    }, [
        visualUnitCount
    ]);
    const handleUnitCountChange = (e)=>{
        const stringValue = e.target.value;
        if (stringValue === "") return setVisualUnitCount(""); // validate max number of digits
        // default is 5
        // TODO: make this configurable
        if (stringValue.length > 6) return;
        const numberValue = parseInt(stringValue, 10);
        if (numberValue < 1) return;
        setVisualUnitCount(numberValue);
    };
    const handleUnitCountBlurChange = ()=>{
        // @ts-ignore
        if (visualUnitCount === "") setVisualUnitCount(unitCount);
        const data = {
            unitCount: unitCount,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: "ui",
            eventName: `${(0, $7mfju.TRACKING_EVENT_NAMES).unitTierBox}_blurred`,
            eventComponent: "input",
            event: "blurred",
            actionSubject: (0, $7mfju.TRACKING_EVENT_NAMES).unitTierBox,
            action: "blurred",
            attributes: data,
            data: data
        }).fire();
    };
    const handleRadioChange = (billingCycle)=>{
        const data = {
            billingCycle: billingCycle,
            productKey: dataProductKey
        };
        createAnalyticsEvent({
            eventType: "ui",
            eventName: (0, $7mfju.TRACKING_EVENT_NAMES).billingCycleChanged,
            eventComponent: "radioButton",
            event: "clicked",
            actionSubject: (0, $7mfju.TRACKING_EVENT_NAMES).billingCycleChanged,
            action: "clicked",
            attributes: data
        }).fire();
        setBillingCycle(billingCycle);
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12fogza"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_p12f1kdj _19pk1wug _2hwx1wug _otyr1wug _18u01wug _b8yq1osq _3wvkidpf _1fbnidpf _1uby1wug _1t0ridpf"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_p12f1kdj _6rth1tcg _181n1txw _b8yq1osq _e8gh1h6o _19wgys9h"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _4cvr1h6o _181n1ule"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                                htmlFor: "unit-count",
                                className: (0, $esG4f.default)([
                                    "_ect4bzd7 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                    "_12l2ftgi _syaz1hlo"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                                },
                                children: unitCountLabel
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _1bah1h6o _4cvr1h6o _1bsb1ns9 _15flidpf _1d2widpf _1svyidpf _seovidpf _1akoidpf _c7s7idpf _4puvidpf _1r3vidpf _181n116y _1t19kb7n _p7vbkb7n _1rhgf1ug"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                                    id: "unit-count",
                                    type: "number",
                                    value: visualUnitCount,
                                    onChange: handleUnitCountChange,
                                    onBlur: handleUnitCountBlurChange,
                                    "data-event-component": "inputNumber",
                                    "data-event-container": "priceBlock",
                                    "data-event": "clicked",
                                    className: (0, $esG4f.default)([
                                        "_syazalr3 _k48p1nn1 _1wyb1j6v _vwz41tcg _12l214y2 _ca0qftgi _u5f3i2wt _n3tdftgi _19bvi2wt _1bsb8ved _2rko1y44 _bfhk1hxd _19itglyw _13di444r _jh1sglyw _ji0mglyw"
                                    ])
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                                htmlFor: "unit-term",
                                className: (0, $esG4f.default)([
                                    "_syaz1mpp _ect4bzd7 _1wyb1j6v _1dyznl7k _k48p1nn1 _16jlkb7n _1o9zkb7n _i0dlf1ug"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                },
                                children: unitsLabel
                            })
                        ]
                    }),
                    hasMonthlyBilling && hasAnnualBilling && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $E9GJt.RadioButtons), {
                            wrap: false,
                            dataProductKey: dataProductKey,
                            selectedButtonId: billingCycle,
                            onChange: handleRadioChange,
                            groupLabel: /*#__PURE__*/ (0, $loA2J.jsx)("legend", {
                                className: (0, $esG4f.default)([
                                    "_ect4bzd7 _1wyb1j6v _1dyznl7k _k48pni7l _o5721q9c",
                                    "_1aax1e5h"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "Pricing.priceFinderInputs.billMeText",
                                    defaultMessage: "Bill me:"
                                })
                            }),
                            buttons: [
                                {
                                    id: "MONTHLY",
                                    label: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "Pricing.priceFinderInputs.monthly",
                                        defaultMessage: "Monthly"
                                    })
                                },
                                {
                                    id: "ANNUAL",
                                    label: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "Pricing.pricingCalculatorInputs.anually",
                                        defaultMessage: "Annually"
                                    }),
                                    lozenge: {
                                        appearance: "blue",
                                        text: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                            id: "Pricing.pricingCalculatorInputs.saveUpTo",
                                            defaultMessage: "SAVE UP TO 17%"
                                        })
                                    }
                                }
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $d80e3b774d43409a$var$labelStyles = null;
const $d80e3b774d43409a$var$legendStyles = null;
const $d80e3b774d43409a$var$inputTermStyle = null;
const $d80e3b774d43409a$var$inputCss = null;

});

parcelRegister("1rXz0", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", function () { return $c4cc7b92cb3c529d$export$b08b517936747730; });
/* spinner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $9gh2a = parcelRequire("9gh2a");
const $c4cc7b92cb3c529d$export$b08b517936747730 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _4t3i1ogm _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            role: "alert",
            "aria-label": "Loading",
            "data-testid": "global-nav-user-profile-container-spinner",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {})
        })
    });

});

parcelRegister("1JG1M", function(module, exports) {

$parcel$export(module.exports, "PriceAltContainer", function () { return $6dfad2080b0e1df0$export$4e62248194b0727b; });
/* price-alt-container.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");
const $6dfad2080b0e1df0$export$4e62248194b0727b = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        className: (0, $esG4f.default)([
            "_1wybdlk8 _y3gn1h6o"
        ]),
        children: props.children
    }));
};
const $6dfad2080b0e1df0$var$priceAltTextCss = null;

});

parcelRegister("1wBc7", function(module, exports) {

$parcel$export(module.exports, "MonthlyEnterpriseMessage", function () { return $866173e91f168028$export$16f86c6a635bb9af; });
/* monthly-enterprise-message.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $5ohHq = parcelRequire("5ohHq");

var $5YjMr = parcelRequire("5YjMr");

var $1JG1M = parcelRequire("1JG1M");
const $866173e91f168028$export$16f86c6a635bb9af = (props)=>{
    const { switchToAnnual: switchToAnnual } = props;
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1JG1M.PriceAltContainer), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                type: "button",
                onClick: switchToAnnual,
                tabIndex: 0,
                "data-event-component": "linkButton",
                "data-event": "clicked",
                className: (0, $esG4f.default)([
                    "_bfhk1j28 _19itidpf _80omtlke _syaz17la _ect41kw7 _1wyb1kw7 _vwz4idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _4bfu1r31 _1hms8stv _ajmmnqa1 _o5721q9c _30l31ep1"
                ]),
                style: {
                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                    "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                },
                children: intl.formatMessage($5YjMr.billedAnnually)
            }),
            "\xa0",
            intl.formatMessage($5YjMr.switchToAnnualToViewEnterprise)
        ]
    });
};
const $866173e91f168028$var$buttonCss = null;

});
parcelRegister("5YjMr", function(module, exports) {

$parcel$export(module.exports, "recommended", function () { return $b760b6823903a84f$export$bc5b8d0824876806; });
$parcel$export(module.exports, "units", function () { return $b760b6823903a84f$export$fe0319385f0cf5a7; });
$parcel$export(module.exports, "perUserPerMonth", function () { return $b760b6823903a84f$export$d8b49137e99effc2; });
$parcel$export(module.exports, "perYear", function () { return $b760b6823903a84f$export$5eae4ab34e5b16ae; });
$parcel$export(module.exports, "aboveUnitMaxThreshold", function () { return $b760b6823903a84f$export$bf2ba8467ff15aa5; });
$parcel$export(module.exports, "belowUnitMinThreshold", function () { return $b760b6823903a84f$export$2e64ce41e89d1e18; });
$parcel$export(module.exports, "billedAnnually", function () { return $b760b6823903a84f$export$9e1a6bb525180618; });
$parcel$export(module.exports, "switchToAnnualToViewEnterprise", function () { return $b760b6823903a84f$export$3277af2b318f7bfa; });
$parcel$export(module.exports, "enterpriseJpyMessage", function () { return $b760b6823903a84f$export$68a1387c7d0a683f; });

var $6x1qA = parcelRequire("6x1qA");
const $b760b6823903a84f$export$bc5b8d0824876806 = (0, $6x1qA.defineMessage)({
    id: "priceFinder.recommended",
    defaultMessage: "Recommended"
});
const $b760b6823903a84f$export$fe0319385f0cf5a7 = (0, $6x1qA.defineMessages)({
    teamSizePrompt: {
        id: "priceFinder.teamSizePrompt",
        defaultMessage: "Team Size:"
    },
    usersUnitsLabel: {
        id: "priceFinder.usersUnitsLabel",
        defaultMessage: "users"
    },
    agentsUnitsLabel: {
        id: "priceFinder.agentsUnitsLabel",
        defaultMessage: "agents"
    }
});
const $b760b6823903a84f$export$d8b49137e99effc2 = (0, $6x1qA.defineMessage)({
    id: "priceFinder.perUnitPerMonth",
    defaultMessage: "per user / month"
});
const $b760b6823903a84f$export$5eae4ab34e5b16ae = (0, $6x1qA.defineMessage)({
    id: "priceFinder.perYear",
    defaultMessage: "per year"
});
const $b760b6823903a84f$export$bf2ba8467ff15aa5 = (0, $6x1qA.defineMessages)({
    default: {
        id: "priceFinder.aboveUserMaxThreshold.default",
        defaultMessage: "Your user count exceeds this plan's limit"
    },
    cloudEnterprise: {
        id: "priceFinder.aboveUserMaxThreshold.cloudEnterprise",
        defaultMessage: "Talk to our sales team about pricing for Cloud Enterprise"
    },
    agents: {
        id: "priceFinder.aboveUserMaxThreshold.agents",
        defaultMessage: "Your agent count exceeds this plan's limit"
    },
    specificCount: {
        id: "priceFinder.aboveUserMaxThreshold.specificCount",
        defaultMessage: "For teams of more than {lowerLimit}, contact our sales team."
    },
    creators: {
        id: "priceFinder.aboveUserMaxThreshold.creators",
        defaultMessage: "Your creator count exceeds this plan's limit"
    }
});
const $b760b6823903a84f$export$2e64ce41e89d1e18 = (0, $6x1qA.defineMessages)({
    cloudEnterprise: {
        id: "priceFinder.belowUnitMinThreshold.cloudEnterprise",
        defaultMessage: "Enterprise plan pricing is available when you enter {minUnitCount} or more users above"
    }
});
const $b760b6823903a84f$export$9e1a6bb525180618 = (0, $6x1qA.defineMessage)({
    id: "priceFinder.billedAnnually",
    defaultMessage: "Billed annually."
});
const $b760b6823903a84f$export$3277af2b318f7bfa = (0, $6x1qA.defineMessage)({
    id: "priceFinder.switchToAnnualToViewEnterprise",
    defaultMessage: "Switch to Annual billing above to view Enterprise pricing."
});
const $b760b6823903a84f$export$68a1387c7d0a683f = (0, $6x1qA.defineMessage)({
    id: "priceFinder.enterpriseJpyMessage",
    defaultMessage: "For pricing details see FAQ below or talk to our sales team"
});

});


parcelRegister("chlmU", function(module, exports) {

$parcel$export(module.exports, "getFeaturesList", function () { return $4be00d6905ab8116$export$501f60b80ced167; });
/* features-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $7uQnK = parcelRequire("7uQnK");

var $cyfPT = parcelRequire("cyfPT");
const $4be00d6905ab8116$export$501f60b80ced167 = (highlightedFeaturesContainer)=>{
    return highlightedFeaturesContainer === null || highlightedFeaturesContainer === void 0 ? void 0 : highlightedFeaturesContainer.map((feature)=>({
            label: feature.fields.highlightedFeatureTitleExternal,
            details: feature.fields.highlightedFeatureDetails && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_q7gqdlk8"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7uQnK.RichTextComponent), {
                    text: (0, $cyfPT.richTextToHTML)(// @ts-ignore
                    feature.fields.highlightedFeatureDetails)
                })
            }),
            lozengeText: feature.fields.highlightedLabel
        }));
};
const $4be00d6905ab8116$var$featureDetailsCss = null;

});

parcelRegister("fKqpx", function(module, exports) {

$parcel$export(module.exports, "UserTier", function () { return $3b63c85f893f58c4$export$cd4f9ca719669f8d; });
$parcel$export(module.exports, "UserTierExpanded", function () { return $3b63c85f893f58c4$export$a4c8408bf932bb2; });
/* user-tier.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");
const $3b63c85f893f58c4$export$cd4f9ca719669f8d = (props)=>{
    const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, numberFormatLocale: numberFormatLocale = "en-US", unitType: unitType } = props;
    const formatNumber = new Intl.NumberFormat(numberFormatLocale).format;
    if (unitType === "agent") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "PricingCalculator.agentTier.range",
        defaultMessage: "Agent tier: {lowerLimit} - {upperLimit}",
        values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
            lowerLimit: formatNumber(unitLimitLower),
            upperLimit: formatNumber(unitLimitUpper)
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "PriceFunder.userTier.range",
        defaultMessage: "User tier: {lowerLimit} - {upperLimit}",
        values: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)), {
            lowerLimit: formatNumber(unitLimitLower),
            upperLimit: formatNumber(unitLimitUpper)
        })
    });
};
const $3b63c85f893f58c4$export$a4c8408bf932bb2 = (props)=>{
    const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, unitsInTier: unitsInTier, unitsAvailableInTier: unitsAvailableInTier, numberFormatLocale: numberFormatLocale = "en-US" } = props;
    const intl = (0, $f6qj2.default)();
    const formatNumber = new Intl.NumberFormat(numberFormatLocale).format;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1wybdlk8 _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                children: [
                    intl.formatMessage($3b63c85f893f58c4$var$messages.tier),
                    /*#__PURE__*/ (0, $loA2J.jsx)("br", {}),
                    formatNumber(unitLimitLower),
                    " - ",
                    formatNumber(unitLimitUpper)
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                children: [
                    intl.formatMessage($3b63c85f893f58c4$var$messages.filledSeats),
                    /*#__PURE__*/ (0, $loA2J.jsx)("br", {}),
                    formatNumber(unitsInTier)
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                children: [
                    intl.formatMessage($3b63c85f893f58c4$var$messages.availableSeats),
                    /*#__PURE__*/ (0, $loA2J.jsx)("br", {}),
                    formatNumber(unitsAvailableInTier)
                ]
            })
        ]
    });
};
const $3b63c85f893f58c4$var$messages = (0, $6x1qA.defineMessages)({
    tier: {
        id: "PriceFinder.userTier.tier",
        defaultMessage: "Tier:"
    },
    filledSeats: {
        id: "PriceFinder.userTier.filledSeats",
        defaultMessage: "Filled seats:"
    },
    availableSeats: {
        id: "PriceFinder.userTier.availableSeats",
        defaultMessage: "Available seats:"
    }
});

});

parcelRegister("4oRsq", function(module, exports) {

$parcel$export(module.exports, "useLocalizedCtaUrl", function () { return $0ce07cf2e2166107$export$b5e9728b9b8ebe33; });

var $3FBn4 = parcelRequire("3FBn4");
function $0ce07cf2e2166107$export$b5e9728b9b8ebe33(ctaFields) {
    var _ctaFields_ctaUrl;
    return (0, $3FBn4.useLocalizedHref)((_ctaFields_ctaUrl = ctaFields === null || ctaFields === void 0 ? void 0 : ctaFields.ctaUrl) !== null && _ctaFields_ctaUrl !== void 0 ? _ctaFields_ctaUrl : "", {
        absolute: true
    });
}

});

parcelRegister("38spb", function(module, exports) {

$parcel$export(module.exports, "useConfluenceDirectBuyExperiment", function () { return $de6bf2b1b8db6126$export$fae015b2716f6f7; });
$parcel$export(module.exports, "ConfluenceDirectBuyButton", function () { return $de6bf2b1b8db6126$export$ac5f3af0a99903ed; });
// @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $3ayMq = parcelRequire("3ayMq");

var $2lcYG = parcelRequire("2lcYG");

var $lrAJa = parcelRequire("lrAJa");
parcelRequire("hqKpV");
var $1i1dJ = parcelRequire("1i1dJ");

var $j1tjc = parcelRequire("j1tjc");

var $iXUxi = parcelRequire("iXUxi");
function $de6bf2b1b8db6126$export$fae015b2716f6f7(props) {
    const { sku: sku } = props;
    const billingCycle = (0, $j1tjc.useSelector)((0, $iXUxi.getBillingCycle));
    return (0, $lrAJa.useDirectBuyExperiment)(billingCycle, sku, Object.values((0, $1i1dJ.confluenceOfferingSkus)).includes(// @ts-ignore
    sku));
}
const $de6bf2b1b8db6126$export$ac5f3af0a99903ed = (props)=>{
    const { sku: sku, edition: edition } = props;
    const pricingPlanId = (0, $j1tjc.useSelector)((ctx)=>(0, $iXUxi.getPricePlanId)(ctx, {
            offeringSku: sku,
            edition: edition
        }));
    const unitCount = (0, $j1tjc.useSelector)((0, $iXUxi.getUnitCount));
    let planName;
    if (edition === "standard") planName = "Standard";
    if (edition === "premium") planName = "Premium";
    if (!pricingPlanId || !planName) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $2lcYG.BuyNowButtonExperiment), {
        defaultUnitCount: (0, $1i1dJ.CONFLUENCE_DEFAULT_UNIT_COUNT),
        unitCount: unitCount,
        pricingPlanId: pricingPlanId,
        edition: edition,
        dataProductKey: (0, $3ayMq.CONFLUENCE_PRODUCT_KEY),
        planName: planName
    });
};

});

parcelRegister("9IdXN", function(module, exports) {

$parcel$export(module.exports, "RovoDevStandardPriceCard", function () { return $0517d00c4a6a340c$export$f0e8bcb2fb60056a; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $6OBwI = parcelRequire("6OBwI");
const $0517d00c4a6a340c$export$f0e8bcb2fb60056a = (props)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.StandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        isSingleCard: true,
        monthlyPerUserLabel: intl.formatMessage({
            id: "RovoDevStandardPriceCard.monthlyPerUserLabel",
            defaultMessage: "per developer / month"
        })
    }));
};

});
parcelRegister("6OBwI", function(module, exports) {

$parcel$export(module.exports, "FreePriceCard", function () { return $bc086416dfe42289$export$75a717cafbbb6b29; });
$parcel$export(module.exports, "StandardPriceCard", function () { return $bc086416dfe42289$export$b2f3ad255eaef337; });
$parcel$export(module.exports, "PremiumPriceCard", function () { return $bc086416dfe42289$export$51a8509266751bd0; });
$parcel$export(module.exports, "EnterprisePriceCard", function () { return $bc086416dfe42289$export$ba2214b2dcd26743; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $3lPlV = parcelRequire("3lPlV");

var $4gHL4 = parcelRequire("4gHL4");

var $hhkTd = parcelRequire("hhkTd");

var $jNkbn = parcelRequire("jNkbn");

var $hrScA = parcelRequire("hrScA");

var $fvAxO = parcelRequire("fvAxO");

var $gEOac = parcelRequire("gEOac");
parcelRequire("MciJy");
var $4oRsq = parcelRequire("4oRsq");
var $38spb = parcelRequire("38spb");
var $chlmU = parcelRequire("chlmU");
var $1JG1M = parcelRequire("1JG1M");
var $fKqpx = parcelRequire("fKqpx");
var $1wBc7 = parcelRequire("1wBc7");

var $j1tjc = parcelRequire("j1tjc");

var $5YjMr = parcelRequire("5YjMr");

var $iXUxi = parcelRequire("iXUxi");
function $bc086416dfe42289$var$usePriceCardEvents(props) {
    const { productKey: productKey, edition: edition } = props;
    const tryIntent = (0, $4gHL4.useTryIntent)({
        containerId: (0, $3lPlV.PRICE_FINDER_CONTAINER),
        intentType: "button",
        productKey: productKey,
        edition: edition
    });
    const handleClickCta = (0, $hhkTd.useFirePricingPlanCtaEvent)({
        edition: edition,
        productKey: productKey,
        containerId: (0, $3lPlV.PRICE_FINDER_CONTAINER)
    });
    return {
        onClick: ()=>{
            tryIntent.onClick();
            handleClickCta();
        },
        onKeyDown: tryIntent.onKeyDown
    };
}
const $bc086416dfe42289$var$FREE_EDITION = "free";
const $bc086416dfe42289$export$75a717cafbbb6b29 = (props)=>{
    var _fields_microCta_, _fields_microCta;
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, customBannerText: customBannerText } = props;
    const fields = planData.fields;
    const state = (0, $gEOac.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $f6qj2.default)();
    const currencyIsoCode = (0, $j1tjc.useSelector)((0, $iXUxi.getCurrencyIsoCode));
    const cta = (_fields_microCta = fields.microCta) === null || _fields_microCta === void 0 ? void 0 : (_fields_microCta_ = _fields_microCta[0]) === null || _fields_microCta_ === void 0 ? void 0 : _fields_microCta_.fields;
    const ctaUrl = (0, $4oRsq.useLocalizedCtaUrl)(cta);
    const eventHandlers = $bc086416dfe42289$var$usePriceCardEvents({
        productKey: props.trackingProductKey,
        edition: $bc086416dfe42289$var$FREE_EDITION
    });
    const dataEventPropsLabel = `${$bc086416dfe42289$var$FREE_EDITION}-get-it-now`;
    const { renderDirectBuyMatchSpace: renderDirectBuyMatchSpace } = (0, $38spb.useConfluenceDirectBuyExperiment)({
        sku: fields.sku
    });
    const addSignupSourceToUrlsOnPricingPageEnabled = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).addSignupSourceToUrlsOnPricingPage);
    const signupUrlSourceQueryParam = addSignupSourceToUrlsOnPricingPageEnabled ? "&signupSource=pricing" : "";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jNkbn.PricingCard), {
        hasBannerSlot: true,
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText !== null && customBannerText !== void 0 ? customBannerText : state.recommended && intl.formatMessage($5YjMr.recommended),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: state.price,
        hasUnitSlot: true,
        hasRangeSlot: props.hasRangeSlot !== undefined ? props.hasRangeSlot : state.billingCycle === "ANNUAL",
        buttonText: cta === null || cta === void 0 ? void 0 : cta.ctaButtonText,
        buttonVariant: state.recommended ? "primary" : "secondary",
        buttonHref: `${ctaUrl}${signupUrlSourceQueryParam}`,
        buttonProps: {
            onClick: eventHandlers.onClick,
            onKeyDown: eventHandlers.onKeyDown,
            dataEventProps: {
                "data-product-key": props.trackingProductKey,
                "data-event-component": "linkButton",
                "data-event-container": (0, $3lPlV.PRICE_FINDER_CONTAINER),
                "data-event": "clicked",
                "data-label": `${dataEventPropsLabel}`,
                "data-label-english": `${dataEventPropsLabel}`
            }
        },
        hasLinkSlot: renderDirectBuyMatchSpace,
        benefitsTitle: fields.highlightedFeaturesTitle,
        benefits: (0, $chlmU.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};
const $bc086416dfe42289$var$STANDARD_EDITION = "standard";
const $bc086416dfe42289$var$PREMIUM_EDITION = "premium";
const $bc086416dfe42289$export$b2f3ad255eaef337 = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)($bc086416dfe42289$var$CommonPriceCard, (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        edition: $bc086416dfe42289$var$STANDARD_EDITION
    }));
const $bc086416dfe42289$export$51a8509266751bd0 = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)($bc086416dfe42289$var$CommonPriceCard, (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        edition: $bc086416dfe42289$var$PREMIUM_EDITION
    }));
// eslint-disable-next-line complexity
const $bc086416dfe42289$var$CommonPriceCard = (props)=>{
    var _fields_microCta_, _fields_microCta;
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, tierLabelType: tierLabelType, customBannerText: customBannerText } = props;
    const fields = planData.fields;
    const state = (0, $gEOac.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $f6qj2.default)();
    const currencyIsoCode = (0, $j1tjc.useSelector)((0, $iXUxi.getCurrencyIsoCode));
    const dataEventPropsLabel = `${props.edition}-start-trial`;
    const cta = (_fields_microCta = fields.microCta) === null || _fields_microCta === void 0 ? void 0 : (_fields_microCta_ = _fields_microCta[0]) === null || _fields_microCta_ === void 0 ? void 0 : _fields_microCta_.fields;
    const ctaUrl = (0, $4oRsq.useLocalizedCtaUrl)(cta);
    const eventHandlers = $bc086416dfe42289$var$usePriceCardEvents({
        productKey: props.trackingProductKey,
        edition: props.edition
    });
    const { renderDirectBuyBtn: renderDirectBuyBtn } = (0, $38spb.useConfluenceDirectBuyExperiment)({
        sku: fields.sku
    });
    const priceAltElement = (()=>{
        if (state.isUnitCountAboveMaxThreshold && props.priceAltElementForAboveMaxThreshold !== undefined) return props.priceAltElementForAboveMaxThreshold;
        return null;
    })();
    const addSignupSourceToUrlsOnPricingPageEnabled = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).addSignupSourceToUrlsOnPricingPage);
    const signupUrlSourceQueryParam = addSignupSourceToUrlsOnPricingPageEnabled ? "&signupSource=pricing" : "";
    var _props_monthlyPerUserLabel;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jNkbn.PricingCard), {
        priceTestid: state.billingCycle === "ANNUAL" ? "annual-price" : "monthly-price",
        hasRangeSlot: state.isUnitCountAboveMaxThreshold && currencyIsoCode === "JPY" && state.billingCycle === "ANNUAL",
        hasBannerSlot: true,
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText !== null && customBannerText !== void 0 ? customBannerText : state.recommended && intl.formatMessage($5YjMr.recommended),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: !state.isUnitCountAboveMaxThreshold && state.price,
        priceAltElement: state.isUnitCountAboveMaxThreshold && props.priceAltElementForAboveMaxThreshold !== undefined ? priceAltElement : /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            children: intl.formatMessage($5YjMr.aboveUnitMaxThreshold.default)
        }),
        unit: state.isUnitCountAboveMaxThreshold ? undefined : state.billingCycle === "MONTHLY" ? (_props_monthlyPerUserLabel = props.monthlyPerUserLabel) !== null && _props_monthlyPerUserLabel !== void 0 ? _props_monthlyPerUserLabel : intl.formatMessage($5YjMr.perUserPerMonth) : intl.formatMessage($5YjMr.perYear),
        hasUnitSlot: true,
        range: state.billingCycle === "ANNUAL" && !props.omitRange && !state.isUnitCountAboveMaxThreshold && /*#__PURE__*/ (0, $loA2J.jsx)((0, $fKqpx.UserTier), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitType: tierLabelType
        }),
        tooltipContent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fKqpx.UserTierExpanded), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitsInTier: state.unitCount,
            unitsAvailableInTier: state.unitsAvailableInTier
        }),
        buttonText: cta === null || cta === void 0 ? void 0 : cta.ctaButtonText,
        buttonHref: `${ctaUrl}${signupUrlSourceQueryParam}`,
        buttonDisabled: state.isUnitCountAboveMaxThreshold,
        buttonVariant: state.recommended || props.isSingleCard ? "primary" : "secondary",
        buttonProps: {
            onClick: eventHandlers.onClick,
            onKeyDown: eventHandlers.onKeyDown,
            dataEventProps: {
                "data-product-key": props.trackingProductKey,
                "data-event-component": "linkButton",
                "data-event-container": (0, $3lPlV.PRICE_FINDER_CONTAINER),
                "data-event": "clicked",
                "data-label": `${dataEventPropsLabel}`,
                "data-label-english": `${dataEventPropsLabel}`
            }
        },
        link: renderDirectBuyBtn && /*#__PURE__*/ (0, $loA2J.jsx)((0, $38spb.ConfluenceDirectBuyButton), {
            sku: fields.sku,
            edition: props.edition
        }),
        benefitsTitle: fields.highlightedFeaturesTitle,
        benefits: (0, $chlmU.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};
const $bc086416dfe42289$export$ba2214b2dcd26743 = (props)=>{
    var _fields_microCta_, _fields_microCta;
    const { planData: planData, topSectionStyle: topSectionStyle, bottomSectionStyle: bottomSectionStyle, showBannerText: showBannerText = true, isSingleCard: isSingleCard, tierLabelType: tierLabelType, customBannerText: customBannerText, isJpyPriceEnabled: isJpyPriceEnabled } = props;
    const fields = planData.fields;
    const state = (0, $gEOac.useCalculationState)({
        offeringSku: fields.sku
    });
    const intl = (0, $f6qj2.default)();
    const currencyIsoCode = (0, $j1tjc.useSelector)((0, $iXUxi.getCurrencyIsoCode));
    const [_, changeBillingCycle] = (0, $j1tjc.useBillingCycle)();
    const priceAltElement = (()=>{
        if (props.priceAltElement !== undefined) return props.priceAltElement;
        if (currencyIsoCode === "JPY" && !isJpyPriceEnabled) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            children: intl.formatMessage($5YjMr.enterpriseJpyMessage)
        });
        if (state.billingCycle === "MONTHLY") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            style: {
                paddingBlockEnd: "24px"
            },
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1wBc7.MonthlyEnterpriseMessage), {
                switchToAnnual: ()=>changeBillingCycle("ANNUAL")
            })
        });
        if (state.isUnitCountAboveMaxThreshold) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            style: {
                paddingBlockEnd: "48px"
            },
            children: intl.formatMessage($5YjMr.aboveUnitMaxThreshold.cloudEnterprise)
        });
        if (state.isUnitCountBelowMinThreshold) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            style: {
                paddingBlockEnd: "48px"
            },
            children: intl.formatMessage($5YjMr.belowUnitMinThreshold.cloudEnterprise, {
                minUnitCount: state.unitCountMin
            })
        });
        return null;
    })();
    const isPriceShown = !state.isUnitCountAboveMaxThreshold && !priceAltElement;
    let price = undefined;
    let range = undefined;
    let tooltipContent = undefined;
    if (isPriceShown) {
        price = state.price;
        range = /*#__PURE__*/ (0, $loA2J.jsx)((0, $fKqpx.UserTier), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitType: tierLabelType
        });
        tooltipContent = /*#__PURE__*/ (0, $loA2J.jsx)((0, $fKqpx.UserTierExpanded), {
            // @ts-ignore
            unitLimitLower: state.unitTierLowerBound,
            // @ts-ignore
            unitLimitUpper: state.unitTierUpperBound,
            unitsInTier: state.unitCount,
            unitsAvailableInTier: state.unitsAvailableInTier
        });
    }
    const cta = (_fields_microCta = fields.microCta) === null || _fields_microCta === void 0 ? void 0 : (_fields_microCta_ = _fields_microCta[0]) === null || _fields_microCta_ === void 0 ? void 0 : _fields_microCta_.fields;
    const ctaUrl = (0, $4oRsq.useLocalizedCtaUrl)(cta);
    const edition = "enterprise";
    const eventHandlers = $bc086416dfe42289$var$usePriceCardEvents({
        productKey: props.trackingProductKey,
        edition: edition
    });
    const dataEventPropsLabel = `${edition}-contact-sales`;
    const { renderDirectBuyMatchSpace: renderDirectBuyMatchSpace } = (0, $38spb.useConfluenceDirectBuyExperiment)({
        sku: fields.sku
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jNkbn.PricingCard), {
        priceTestid: state.billingCycle === "ANNUAL" ? "annual-price" : "monthly-price",
        hasBannerSlot: true,
        hasRangeSlot: currencyIsoCode === "JPY" && state.billingCycle === "ANNUAL",
        topSectionStyle: topSectionStyle,
        bottomSectionStyle: bottomSectionStyle,
        bannerText: customBannerText !== null && customBannerText !== void 0 ? customBannerText : showBannerText && state.recommended && intl.formatMessage($5YjMr.recommended),
        title: fields.planTitleExternal,
        description: fields.planOneLiner,
        currencyIsoCode: currencyIsoCode,
        price: price,
        priceAltElement: priceAltElement,
        unit: // if a price alt element exists, there should be no unit
        priceAltElement ? undefined : !state.isUnitCountAboveMaxThreshold && !state.isUnitCountBelowMinThreshold ? intl.formatMessage($5YjMr.perYear) : undefined,
        range: range,
        hasUnitSlot: // the unbounded text for the price alt element makes the unbounded
        currencyIsoCode === "JPY",
        tooltipContent: tooltipContent,
        buttonText: cta === null || cta === void 0 ? void 0 : cta.ctaButtonText,
        buttonHref: ctaUrl,
        buttonVariant: state.recommended || isSingleCard ? "primary" : "secondary",
        buttonProps: {
            onClick: eventHandlers.onClick,
            onKeyDown: eventHandlers.onKeyDown,
            dataEventProps: {
                "data-product-key": props.trackingProductKey,
                "data-event-component": "linkButton",
                "data-event-container": (0, $3lPlV.PRICE_FINDER_CONTAINER),
                "data-event": "clicked",
                "data-label": `${dataEventPropsLabel}`,
                "data-label-english": `${dataEventPropsLabel}`
            }
        },
        hasLinkSlot: renderDirectBuyMatchSpace,
        benefitsTitle: fields.highlightedFeaturesTitle,
        // in order for us to render just the top section fo a pricing card, the contentful data must be empty/undefined
        benefits: (0, $chlmU.getFeaturesList)(fields.highlightedFeaturesContainer)
    });
};

});
parcelRegister("3lPlV", function(module, exports) {

$parcel$export(module.exports, "PRICE_FINDER_CONTAINER", function () { return $3e5191e452008b58$export$c5526af38120e3f; });
const $3e5191e452008b58$export$c5526af38120e3f = "priceBlock";

});



parcelRegister("zcwoT", function(module, exports) {

$parcel$export(module.exports, "ServiceCollectionFreePriceCard", function () { return $2c2a7242901762ae$export$ce09fc7b6ac40092; });
$parcel$export(module.exports, "ServiceCollectionStandardPriceCard", function () { return $2c2a7242901762ae$export$84affe19123eb209; });
$parcel$export(module.exports, "ServiceCollectionPremiumPriceCard", function () { return $2c2a7242901762ae$export$1383d1ba03ed3746; });
$parcel$export(module.exports, "ServiceCollectionEnterprisePriceCard", function () { return $2c2a7242901762ae$export$c277b80f2da61f89; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $6OBwI = parcelRequire("6OBwI");
const $2c2a7242901762ae$export$ce09fc7b6ac40092 = (props)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.FreePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};
const $2c2a7242901762ae$export$84affe19123eb209 = (props)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.StandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};
const $2c2a7242901762ae$export$1383d1ba03ed3746 = (props)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.PremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};
const $2c2a7242901762ae$export$c277b80f2da61f89 = (props)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.EnterprisePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        tierLabelType: "agent",
        monthlyPerUserLabel: intl.formatMessage({
            id: "ServiceCollectionPriceCard.perAgentPerMonth",
            defaultMessage: "per agent / month"
        })
    }));
};

});

parcelRegister("3A3AJ", function(module, exports) {

$parcel$export(module.exports, "LoomFreePriceCard", function () { return $e968a4dcab76f69a$export$947796c8957ff6ff; });
$parcel$export(module.exports, "LoomBusinessPriceCard", function () { return $e968a4dcab76f69a$export$2a7af2744a13b8c2; });
$parcel$export(module.exports, "LoomBusinessPlusAiPriceCard", function () { return $e968a4dcab76f69a$export$efaf4c20492b36b7; });
$parcel$export(module.exports, "LoomEnterprisePriceCard", function () { return $e968a4dcab76f69a$export$d88b84b01ca5e441; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $j1tjc = parcelRequire("j1tjc");

var $6OBwI = parcelRequire("6OBwI");
const $e968a4dcab76f69a$var$OMIT_TIER_UNIT_THRESHOLD = 26;
const $e968a4dcab76f69a$export$947796c8957ff6ff = (props)=>{
    const omitRange = $e968a4dcab76f69a$var$useOmitRange();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.FreePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        omitRange: omitRange,
        hasRangeSlot: omitRange ? false : undefined
    }));
};
const $e968a4dcab76f69a$export$2a7af2744a13b8c2 = (props)=>{
    const omitRange = $e968a4dcab76f69a$var$useOmitRange();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.StandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        omitRange: omitRange
    }));
};
const $e968a4dcab76f69a$export$efaf4c20492b36b7 = (props)=>{
    const omitRange = $e968a4dcab76f69a$var$useOmitRange();
    const intl = (0, $f6qj2.default)();
    const customBannerText = intl.formatMessage({
        id: "LoomBusinessPlusAiPriceCard.mostPopular",
        defaultMessage: "Most popular"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.PremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        omitRange: omitRange,
        customBannerText: customBannerText
    }));
};
const $e968a4dcab76f69a$export$d88b84b01ca5e441 = (props)=>{
    const omitRange = $e968a4dcab76f69a$var$useOmitRange();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.EnterprisePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        omitRange: omitRange,
        priceAltElement: /*#__PURE__*/ (0, $loA2J.jsx)("div", {})
    }));
};
const $e968a4dcab76f69a$var$useOmitRange = ()=>{
    const [billingCycle] = (0, $j1tjc.useBillingCycle)();
    const [unitCount] = (0, $j1tjc.useUnitCount)();
    return billingCycle === "ANNUAL" && unitCount < $e968a4dcab76f69a$var$OMIT_TIER_UNIT_THRESHOLD;
};

});

parcelRegister("ebQhK", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryFreePriceCard", function () { return $857985716a1569a3$export$9301352401a96395; });
$parcel$export(module.exports, "JiraProductDiscoveryStandardPriceCard", function () { return $857985716a1569a3$export$f632b4bee5bd80fe; });
$parcel$export(module.exports, "JiraProductDiscoveryPremiumPriceCard", function () { return $857985716a1569a3$export$1fb355a43910f211; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $5YjMr = parcelRequire("5YjMr");

var $1JG1M = parcelRequire("1JG1M");

var $6OBwI = parcelRequire("6OBwI");
const $857985716a1569a3$export$9301352401a96395 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.FreePriceCard), (0, $7Knp0._)({}, props));
};
const $857985716a1569a3$export$f632b4bee5bd80fe = (props)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.StandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        tierLabelType: "user",
        monthlyPerUserLabel: intl.formatMessage({
            id: "JiraProductDiscoveryPriceCard.perCreatorPerMonth",
            defaultMessage: "per creator / month"
        }),
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            children: intl.formatMessage($5YjMr.aboveUnitMaxThreshold.creators)
        })
    }));
};
const $857985716a1569a3$export$1fb355a43910f211 = (props)=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.PremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        tierLabelType: "user",
        monthlyPerUserLabel: intl.formatMessage({
            id: "JiraProductDiscoveryPriceCard.perCreatorPerMonth",
            defaultMessage: "per creator / month"
        }),
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            children: intl.formatMessage($5YjMr.aboveUnitMaxThreshold.creators)
        })
    }));
};

});


parcelRegister("bU2dC", function(module, exports) {

$parcel$export(module.exports, "useProviderProps", function () { return $e2230c4ac3c21599$export$521c373ccc32c300; });
// @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $9kpo9 = parcelRequire("9kpo9");

var $9Cnr8 = parcelRequire("9Cnr8");

var $8EXPa = parcelRequire("8EXPa");

var $iRy5O = parcelRequire("iRy5O");

var $1i1dJ = parcelRequire("1i1dJ");

var $5Rijz = parcelRequire("5Rijz");

var $ktygn = parcelRequire("ktygn");

var $5kiq4 = parcelRequire("5kiq4");

var $1F9wN = parcelRequire("1F9wN");

var $fNdr1 = parcelRequire("fNdr1");

var $3ItZP = parcelRequire("3ItZP");

var $awylZ = parcelRequire("awylZ");

var $fPLSq = parcelRequire("fPLSq");

var $j1tjc = parcelRequire("j1tjc");
function $e2230c4ac3c21599$export$521c373ccc32c300(props) {
    const { plans: plans, product: product } = props;
    const locale = (0, $9kpo9.useLocale)();
    const currencyISOCode = (0, $9Cnr8.getCurrencyFromUserLocale)(locale);
    const ssrData = plans.reduce((acc, plan)=>{
        return (0, $6iHNw._)((0, $7Knp0._)({}, acc), {
            [plan.fields.sku]: plan.pricingPlan
        });
    }, {});
    const { data: ccpPricingData, status: status } = (0, $j1tjc.useCcpPricingData)({
        offeringSkus: plans.map((plan)=>plan.fields.sku),
        ssrData: ssrData
    });
    if (status === "error") return {
        status: "error"
    };
    if (status === "pending") return {
        status: "pending"
    };
    if (product === "jira") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $ktygn.JIRA_DEFAULT_BILLING_CYCLE,
                unitCount: $ktygn.JIRA_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $ktygn.jiraPlanLimitConfigs,
                unitMinEnterprise: $ktygn.JIRA_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: {
                    monthly: true,
                    annual: true
                }
            }
        }
    };
    if (product === "confluence") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $1i1dJ.CONFLUENCE_DEFAULT_BILLING_CYCLE,
                unitCount: $1i1dJ.CONFLUENCE_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $1i1dJ.confluencePlanLimitConfigs,
                unitMinEnterprise: $1i1dJ.CONFLUENCE_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: {
                    monthly: true,
                    annual: true
                }
            }
        }
    };
    if (product === "teamwork") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $fPLSq.TEAMWORK_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: $fPLSq.TEAMWORK_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $fPLSq.teamworkCollectionPlanLimitConfigs,
                unitMinEnterprise: $fPLSq.TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $fPLSq.teamworkCollectionBillingCycleConfig
            }
        }
    };
    if (product === "guard") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $5Rijz.GUARD_DEFAULT_BILLING_CYCLE,
                unitCount: $5Rijz.GUARD_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $5Rijz.guardPlanLimitConfigs,
                unitMinEnterprise: $5Rijz.GUARD_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $5Rijz.guardBillingCycleConfig
            }
        }
    };
    if (product === "bitbucket") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $8EXPa.BITBUCKET_DEFAULT_BILLING_CYCLE,
                unitCount: $8EXPa.BITBUCKET_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $8EXPa.bitbucketPlanLimitConfigs,
                unitMinEnterprise: $8EXPa.BITBUCKET_MIN_ENTERPRISE_USER_COUNT,
                // bitbucket only supports USD
                currencyISOCode: "USD",
                localeISOCode: locale,
                billingCycleConfig: $8EXPa.bitbucketBillingCycleConfig
            }
        }
    };
    if (product === "strategy") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $awylZ.STRATEGY_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: $awylZ.STRATEGY_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $awylZ.strategyCollectionPlanLimitConfigs,
                unitMinEnterprise: $awylZ.STRATEGY_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $awylZ.strategyCollectionBillingCycleConfig
            }
        }
    };
    if (product === "compass") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $iRy5O.COMPASS_DEFAULT_BILLING_CYCLE,
                unitCount: $iRy5O.COMPASS_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $iRy5O.compassPlanLimitConfigs,
                // not sure why this field is necessary
                unitMinEnterprise: $iRy5O.COMPASS_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $iRy5O.compassBillingCycleConfig
            }
        }
    };
    if (product === "service") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $3ItZP.SERVICE_COLLECTION_DEFAULT_BILLING_CYCLE,
                unitCount: $3ItZP.SERVICE_COLLECTION_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $3ItZP.serviceCollectionPlanLimitConfigs,
                unitMinEnterprise: $3ItZP.SERVICE_COLLECTION_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $3ItZP.serviceCollectionBillingCycleConfig
            }
        }
    };
    if (product === "rovo-dev") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $fNdr1.ROVO_DEV_DEFAULT_BILLING_CYCLE,
                unitCount: $fNdr1.ROVO_DEV_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $fNdr1.rovoDevPlanLimitConfigs,
                unitMinEnterprise: $fNdr1.ROVO_DEV_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $fNdr1.rovoDevBillingCycleConfig
            }
        }
    };
    if (product === "loom") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $1F9wN.LOOM_DEFAULT_BILLING_CYCLE,
                unitCount: $1F9wN.LOOM_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $1F9wN.loomPlanLimitConfigs,
                unitMinEnterprise: $1F9wN.LOOM_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $1F9wN.loomBillingCycleConfig
            }
        }
    };
    if (product === "product-discovery") return {
        status: "ready",
        props: {
            inputValues: {
                billingCycle: $5kiq4.JPD_DEFAULT_BILLING_CYCLE,
                unitCount: $5kiq4.JPD_DEFAULT_UNIT_COUNT
            },
            config: {
                ccpPricingData: ccpPricingData,
                planLimitConfigs: $5kiq4.jpdPlanLimitConfigs,
                unitMinEnterprise: $5kiq4.JPD_MIN_ENTERPRISE_USER_COUNT,
                currencyISOCode: currencyISOCode,
                localeISOCode: locale,
                billingCycleConfig: $5kiq4.jpdBillingCycleConfig
            }
        }
    };
    throw new Error("unknown product");
}

});
parcelRegister("9kpo9", function(module, exports) {
"use strict";
var $6ca9acf34c85a58f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6ca9acf34c85a58f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6ca9acf34c85a58f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6ca9acf34c85a58f$var$__exportStar((parcelRequire("lzarR")), module.exports);

});
parcelRegister("lzarR", function(module, exports) {
"use strict";
var $fb34f8afabff3c89$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fb34f8afabff3c89$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fb34f8afabff3c89$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fb34f8afabff3c89$var$__exportStar((parcelRequire("lrT2K")), module.exports);

$fb34f8afabff3c89$var$__exportStar((parcelRequire("jJk5Z")), module.exports);

$fb34f8afabff3c89$var$__exportStar((parcelRequire("iZOWt")), module.exports);

$fb34f8afabff3c89$var$__exportStar((parcelRequire("3XOWT")), module.exports);

});
parcelRegister("lrT2K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LOCALES = module.exports.LOCALE_REGISTRY = module.exports.DEFAULT_LOCALE = void 0;
module.exports.DEFAULT_LOCALE = "en";
module.exports.LOCALE_REGISTRY = Object.freeze({
    [module.exports.DEFAULT_LOCALE]: {
        label: "English"
    },
    de: {
        label: "Deutsch"
    },
    es: {
        label: "Espa\xf1ol"
    },
    fr: {
        label: "Fran\xe7ais"
    },
    it: {
        label: "Italiano"
    },
    ko: {
        label: "\uD55C\uAD6D\uC5B4"
    },
    nl: {
        label: "Nederlands"
    },
    ja: {
        label: "\u65E5\u672C\u8A9E"
    },
    pl: {
        label: "Polski"
    },
    br: {
        label: "Portugu\xeas"
    },
    ru: {
        label: "\u0440\u0443\u0441\u0441\u043A\u0438\u0439"
    },
    zh: {
        label: "\u4E2D\u6587"
    }
});
module.exports.LOCALES = Object.keys(module.exports.LOCALE_REGISTRY);

});

parcelRegister("jJk5Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useLocale = $e5d1ceda02205161$var$useLocale;

var $f6qj2 = parcelRequire("f6qj2");
function $e5d1ceda02205161$var$useLocale() {
    const intl = (0, $f6qj2.default)();
    return intl.locale;
}

});

parcelRegister("iZOWt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useLocalizedHref = $dd457090bbf63b1d$var$useLocalizedHref;

var $lrT2K = parcelRequire("lrT2K");

var $jJk5Z = parcelRequire("jJk5Z");
function $dd457090bbf63b1d$var$useLocalizedHref(href) {
    const locale = (0, $jJk5Z.useLocale)();
    if (locale === $lrT2K.DEFAULT_LOCALE) return href;
    else return `/${locale}${href}`;
}

});

parcelRegister("3XOWT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_VALUES = void 0;

var $loA2J = parcelRequire("loA2J");
module.exports.DEFAULT_VALUES = Object.freeze({
    br: (0, $loA2J.jsx)("br", {}),
    p: (chunks)=>(0, $loA2J.jsx)("p", {
            children: chunks
        }),
    strong: (chunks)=>(0, $loA2J.jsx)("strong", {
            children: chunks
        }),
    span: (chunks)=>(0, $loA2J.jsx)("span", {
            children: chunks
        })
});

});




parcelRegister("hmeL1", function(module, exports) {

$parcel$export(module.exports, "PricingCalculatorCard", function () { return $0a37e8017914ab10$export$14072311c149f96f; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $3ayMq = parcelRequire("3ayMq");
parcelRequire("MciJy");
var $9IdXN = parcelRequire("9IdXN");
var $zcwoT = parcelRequire("zcwoT");
var $3A3AJ = parcelRequire("3A3AJ");
var $ebQhK = parcelRequire("ebQhK");

var $cMtLi = parcelRequire("cMtLi");

var $6OBwI = parcelRequire("6OBwI");

var $8EXPa = parcelRequire("8EXPa");
parcelRequire("hqKpV");
var $ktygn = parcelRequire("ktygn");
var $1i1dJ = parcelRequire("1i1dJ");
var $fPLSq = parcelRequire("fPLSq");
var $iRy5O = parcelRequire("iRy5O");
var $5Rijz = parcelRequire("5Rijz");
var $awylZ = parcelRequire("awylZ");
var $fNdr1 = parcelRequire("fNdr1");
var $3ItZP = parcelRequire("3ItZP");
var $1F9wN = parcelRequire("1F9wN");
var $5kiq4 = parcelRequire("5kiq4");
const $0a37e8017914ab10$export$14072311c149f96f = (props)=>{
    const sku = props.planData.fields.sku;
    const trackingProductKey = (0, $3ayMq.urlSlugToDataProductKey)[props.urlSlug];
    switch(sku){
        // Free
        case (0, $ktygn.jiraOfferingSkus).free:
        case (0, $1i1dJ.confluenceOfferingSkus).free:
        case (0, $fPLSq.teamworkCollectionOfferingSkus).free:
        case (0, $iRy5O.compassOfferingSkus).free:
        case (0, $8EXPa.bitbucketOfferingSkus).free:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.FreePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        // Standard
        case (0, $ktygn.jiraOfferingSkus).standard:
        case (0, $1i1dJ.confluenceOfferingSkus).standard:
        case (0, $fPLSq.teamworkCollectionOfferingSkus).standard:
        case (0, $5Rijz.guardOfferingSkus).standard:
        case (0, $iRy5O.compassOfferingSkus).standard:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.StandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $8EXPa.bitbucketOfferingSkus).standard:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cMtLi.BitbucketStandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        // Premium
        case (0, $ktygn.jiraOfferingSkus).premium:
        case (0, $1i1dJ.confluenceOfferingSkus).premium:
        case (0, $fPLSq.teamworkCollectionOfferingSkus).premium:
        case (0, $5Rijz.guardOfferingSkus).premium:
        case (0, $iRy5O.compassOfferingSkus).premium:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.PremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $8EXPa.bitbucketOfferingSkus).premium:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cMtLi.BitbucketPremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        // Enterprise
        case (0, $ktygn.jiraOfferingSkus).enterprise:
        case (0, $1i1dJ.confluenceOfferingSkus).enterprise:
        case (0, $fPLSq.teamworkCollectionOfferingSkus).enterprise:
            // @ts-ignore
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.EnterprisePriceCard), (0, $7Knp0._)({}, props));
        case (0, $awylZ.strategyCollectionOfferingSkus).enterprise:
            // @ts-ignore
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.EnterprisePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                isJpyPriceEnabled: true
            }));
        // Custom, for any tier
        case (0, $fNdr1.rovoDevOfferingSkus).standard:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9IdXN.RovoDevStandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $3ItZP.serviceCollectionOfferingSkus).free:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $zcwoT.ServiceCollectionFreePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $3ItZP.serviceCollectionOfferingSkus).standard:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $zcwoT.ServiceCollectionStandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $3ItZP.serviceCollectionOfferingSkus).premium:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $zcwoT.ServiceCollectionPremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $3ItZP.serviceCollectionOfferingSkus).enterprise:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $zcwoT.ServiceCollectionEnterprisePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $1F9wN.loomOfferingSkus).free:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3A3AJ.LoomFreePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $1F9wN.loomOfferingSkus).business:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3A3AJ.LoomBusinessPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $1F9wN.loomOfferingSkus).businessPlusAi:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3A3AJ.LoomBusinessPlusAiPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $1F9wN.loomOfferingSkus).enterprise:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3A3AJ.LoomEnterprisePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $5kiq4.jpdOfferingSkus).free:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $ebQhK.JiraProductDiscoveryFreePriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $5kiq4.jpdOfferingSkus).standard:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $ebQhK.JiraProductDiscoveryStandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        case (0, $5kiq4.jpdOfferingSkus).premium:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $ebQhK.JiraProductDiscoveryPremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                trackingProductKey: trackingProductKey
            }));
        default:
            // todo: @bsparks GWP-6943 fire an event for unexpected sku
            return null;
    }
};

});
parcelRegister("cMtLi", function(module, exports) {

$parcel$export(module.exports, "BitbucketStandardPriceCard", function () { return $e7bfa2be1f5e3998$export$3f65201715c64fe0; });
$parcel$export(module.exports, "BitbucketPremiumPriceCard", function () { return $e7bfa2be1f5e3998$export$3845e26e0454185b; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $8EXPa = parcelRequire("8EXPa");

var $5YjMr = parcelRequire("5YjMr");

var $1JG1M = parcelRequire("1JG1M");

var $6OBwI = parcelRequire("6OBwI");
const $e7bfa2be1f5e3998$export$3f65201715c64fe0 = (props)=>{
    const intl = (0, $f6qj2.default)();
    const formattedLimit = intl.formatNumber((0, $8EXPa.BITBUCKET_SIGNUP_LIMIT));
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.StandardPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            children: intl.formatMessage($5YjMr.aboveUnitMaxThreshold.specificCount, {
                lowerLimit: formattedLimit
            })
        })
    }));
};
const $e7bfa2be1f5e3998$export$3845e26e0454185b = (props)=>{
    const intl = (0, $f6qj2.default)();
    const formattedLimit = intl.formatNumber((0, $8EXPa.BITBUCKET_SIGNUP_LIMIT));
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6OBwI.PremiumPriceCard), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        priceAltElementForAboveMaxThreshold: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1JG1M.PriceAltContainer), {
            children: intl.formatMessage($5YjMr.aboveUnitMaxThreshold.specificCount, {
                lowerLimit: formattedLimit
            })
        })
    }));
};

});




parcelRegister("9nWUO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("3OzIV")).default; });

var $3OzIV = parcelRequire("3OzIV");

});
parcelRegister("3OzIV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02de01c697849ba2$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("aYZfk");
var $iRRBp = parcelRequire("iRRBp");

var $lQMRe = parcelRequire("lQMRe");
const $02de01c697849ba2$var$UniformPricingTable = (props)=>{
    const { tableData: tableData = [], planTitles: planTitles } = props;
    const effectivePlanTitles = planTitles.map(({ fields: fields })=>fields.planTitleExternal);
    const transformedSections = (0, $lQMRe.transformContentfulDataToTableData)(tableData, effectivePlanTitles);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iRRBp.Table), {
        header: {
            titles: [
                "",
                ...effectivePlanTitles
            ]
        },
        sections: transformedSections
    });
};
var $02de01c697849ba2$export$2e2bcd8739ae039 = $02de01c697849ba2$var$UniformPricingTable;

});
parcelRegister("aYZfk", function(module, exports) {
$parcel$export(module.exports, "Table", function () { return (parcelRequire("iRRBp")).Table; });
parcelRequire("iRRBp");

});
parcelRegister("iRRBp", function(module, exports) {

$parcel$export(module.exports, "Table", function () { return $90c5e4ded2bc5115$export$54ec01a60f47d33d; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("bwop0");
var $aBMfN = parcelRequire("aBMfN");

var $5KYDU = parcelRequire("5KYDU");

var $54y9B = parcelRequire("54y9B");

var $Hw7na = parcelRequire("Hw7na");

var $2NR3S = parcelRequire("2NR3S");
const $90c5e4ded2bc5115$export$54ec01a60f47d33d = (props)=>{
    const { sections: sections, header: header } = props;
    const columnCount = (0, $2NR3S.getColumnCount)(sections);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $aBMfN.Table), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $54y9B.Header), (0, $7Knp0._)({}, header)),
            /*#__PURE__*/ (0, $loA2J.jsx)("tbody", {
                children: sections.map((section, sectionIndex)=>{
                    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $Hw7na.SectionHeader), {
                                sectionTitle: section.title,
                                totalColumnCount: columnCount
                            }),
                            section.rows.map((row, rowIndex)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $5KYDU.ContentRow), {
                                    row: row,
                                    rowKey: `${sectionIndex}-${rowIndex}`,
                                    columnTitles: header.titles
                                }, `${sectionIndex}-${rowIndex}`))
                        ]
                    }, sectionIndex);
                })
            })
        ]
    });
};

});
parcelRegister("bwop0", function(module, exports) {
$parcel$export(module.exports, "Table", function () { return (parcelRequire("aBMfN")).Table; });
$parcel$export(module.exports, "Row", function () { return (parcelRequire("jBZAY")).Row; });
$parcel$export(module.exports, "RowCell", function () { return (parcelRequire("jBZAY")).RowCell; });
$parcel$export(module.exports, "RowHeaderCell", function () { return (parcelRequire("jBZAY")).RowHeaderCell; });
$parcel$export(module.exports, "Head", function () { return (parcelRequire("52o7a")).Head; });
$parcel$export(module.exports, "HeadCell", function () { return (parcelRequire("52o7a")).HeadCell; });
$parcel$export(module.exports, "HeadRow", function () { return (parcelRequire("52o7a")).HeadRow; });
$parcel$export(module.exports, "SectionHeader", function () { return (parcelRequire("jF79E")).SectionHeader; });
$parcel$export(module.exports, "SectionHeaderCell", function () { return (parcelRequire("jF79E")).SectionHeaderCell; });
parcelRequire("aBMfN");
parcelRequire("jBZAY");
parcelRequire("52o7a");
parcelRequire("jF79E");

});
parcelRegister("aBMfN", function(module, exports) {

$parcel$export(module.exports, "Table", function () { return $ffe506304ebe021b$export$54ec01a60f47d33d; });
/* table.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");
const $ffe506304ebe021b$export$54ec01a60f47d33d = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("table", (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        className: (0, $esG4f.default)([
            "_2lx21bp4 _1kqm1n9t _1bsb1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _y3gn1h6o _yq5hcfaq _btyzidpf _suga1txw _1e0c5mfb"
        ])
    }));
};
const $ffe506304ebe021b$var$tableCss = null;

});

parcelRegister("jBZAY", function(module, exports) {

$parcel$export(module.exports, "Row", function () { return $2aa512b05205b590$export$b59bdbef9ce70de2; });
$parcel$export(module.exports, "RowHeaderCell", function () { return $2aa512b05205b590$export$90b286dd97c43ca1; });
$parcel$export(module.exports, "RowCell", function () { return $2aa512b05205b590$export$502da2b9cfd708e5; });
/* row.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $5ohHq = parcelRequire("5ohHq");
const $2aa512b05205b590$export$b59bdbef9ce70de2 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("tr", (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        className: (0, $esG4f.default)([
            "_19pk7vkz _2hwxidpf _otyr7vkz _18u0idpf _bfhkcd5j _v56411zw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _y3gn1h6o _1ckvidpf _irr31rga _1o4gu1j4 _a5ztgktf _suga1txw _1gde1bp4"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100")),
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
        }
    }));
};
const $2aa512b05205b590$export$90b286dd97c43ca1 = (props)=>{
    const { children: children } = props, tdProps = (0, $akGnX._)(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("td", (0, $6iHNw._)((0, $7Knp0._)({}, tdProps), {
        className: (0, $esG4f.default)([
            "_y3gnv2br _16nmgktf _1w6hgktf _gtp7150w _1kmxdlk8 _1ggmdlk8 _1ykzdlk8 _1maedlk8",
            "_s7n4jp4b _1bah1yb4 _4cvr1h6o _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zyzqy _10msglyw"
        ]),
        style: {
            "--_8nj8hf": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light200")),
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            className: (0, $esG4f.default)([
                "_1bsb1osq _1reo15vq"
            ]),
            children: children
        })
    }));
};
const $2aa512b05205b590$export$502da2b9cfd708e5 = (props)=>{
    const { children: children = null, columnTitle: columnTitle } = props, tdProps = (0, $akGnX._)(props, [
        "children",
        "columnTitle"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("td", (0, $6iHNw._)((0, $7Knp0._)({}, tdProps), {
        className: (0, $esG4f.default)([
            "_s7n4jp4b _1bah1yb4 _4cvr1h6o _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zyzqy _10msglyw"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_181nglyw"
                ]),
                children: columnTitle
            }),
            children
        ]
    }));
};
const $2aa512b05205b590$var$rowCss = null;
const $2aa512b05205b590$var$rowHeaderCellCss = null;
const $2aa512b05205b590$var$rowHeaderCellSpanCss = null;
const $2aa512b05205b590$var$cellCss = null;
const $2aa512b05205b590$var$cellColumnTitleCss = null;

});

parcelRegister("52o7a", function(module, exports) {

$parcel$export(module.exports, "Head", function () { return $933bdcbf8a46a400$export$e93312b7773dfcac; });
$parcel$export(module.exports, "HeadRow", function () { return $933bdcbf8a46a400$export$b008e842a2213343; });
$parcel$export(module.exports, "HeadCell", function () { return $933bdcbf8a46a400$export$4e8024263ace498b; });
/* head.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $5ohHq = parcelRequire("5ohHq");
const $933bdcbf8a46a400$export$e93312b7773dfcac = (props)=>{
    const { stickyOffset: stickyOffset } = props;
    return /*#__PURE__*/ (0, $loA2J.jsx)("thead", (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        className: (0, $esG4f.default)([
            "_179ru1j4 _sugaglyw _1pbykb7n _11q7cd5j"
        ]),
        style: (0, $6iHNw._)((0, $7Knp0._)({}, stickyOffset === undefined ? {} : {
            top: stickyOffset,
            position: "sticky"
        }), {
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400")),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        })
    }));
};
const $933bdcbf8a46a400$export$b008e842a2213343 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("tr", (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        className: (0, $esG4f.default)([
            "_17gvangw _7dd6v2br"
        ])
    }));
};
const $933bdcbf8a46a400$export$4e8024263ace498b = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("th", (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        scope: "col",
        className: (0, $esG4f.default)([
            "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zyzqy _10msglyw"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
        }
    }));
};
const $933bdcbf8a46a400$var$headCss = null;
const $933bdcbf8a46a400$var$headRowCss = null;
const $933bdcbf8a46a400$var$headCellStyles = null;

});

parcelRegister("jF79E", function(module, exports) {

$parcel$export(module.exports, "SectionHeader", function () { return $57e91e78af4acf28$export$8adb256d999cd5a0; });
$parcel$export(module.exports, "SectionHeaderCell", function () { return $57e91e78af4acf28$export$32421cd0bed4993f; });
/* section.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $5ohHq = parcelRequire("5ohHq");
const $57e91e78af4acf28$export$8adb256d999cd5a0 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("tr", (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        className: (0, $esG4f.default)([
            "_syaz1hlo _2lx21bp4 _19pk7vkz _2hwxidpf _otyr7vkz _18u0idpf _bfhk1rga _v56411zw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _y3gn1h6o _sugaglyw"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
        }
    }));
};
const $57e91e78af4acf28$export$32421cd0bed4993f = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("td", (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        className: (0, $esG4f.default)([
            "_1bah1yb4 _k48p1nn1 _y3gn1e5h _syaz1hlo _suga1txw _1kmx1crf _1ggmdlk8 _1ykz1crf _1maedlk8 _1e0cdav6 _ca0qdlk8 _u5f3dlk8 _n3tddlk8 _19bvdlk8 _t51zyzqy _10msglyw"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
        }
    }));
};
const $57e91e78af4acf28$var$sectionHeaderCss = null;
const $57e91e78af4acf28$var$sectionHeaderCellCss = null;

});


parcelRegister("5KYDU", function(module, exports) {

$parcel$export(module.exports, "ContentRow", function () { return $dfdd9714744d1af7$export$47e3a1a30e4428e1; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");
parcelRequire("bwop0");
var $jBZAY = parcelRequire("jBZAY");

var $cmvVn = parcelRequire("cmvVn");
const $dfdd9714744d1af7$export$47e3a1a30e4428e1 = (props)=>{
    const { row: row, rowKey: rowKey, columnTitles: columnTitles } = props;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jBZAY.Row), {
        children: row.map((cell, cellIndex)=>cellIndex === 0 ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $jBZAY.RowHeaderCell), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cmvVn.ContentCell), {
                    isRowHeader: true,
                    cellData: cell
                })
            }, cellIndex) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $jBZAY.RowCell), {
                // @ts-ignore
                columnTitle: columnTitles[cellIndex],
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cmvVn.ContentCell), {
                    cellData: cell
                })
            }, cellIndex))
    }, rowKey);
};

});
parcelRegister("cmvVn", function(module, exports) {

$parcel$export(module.exports, "ContentCell", function () { return $2c7a928e1976f815$export$6245b75abe178459; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");
parcelRequire("lq8nC");
var $5nSlB = parcelRequire("5nSlB");
const $2c7a928e1976f815$export$6245b75abe178459 = (props)=>{
    const { cellData: cellData, isRowHeader: isRowHeader } = props;
    if (cellData === null) return null;
    switch(cellData.type){
        case "text":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5nSlB.CellTextContent), {
                data: cellData,
                isRowHeader: isRowHeader
            });
        case "check":
            // @ts-ignore
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5nSlB.CellCheckContent), {
                data: cellData
            });
        case "expander":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5nSlB.CellExpanderContent), {
                data: cellData
            });
        case "hyperlink":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5nSlB.CellHyperlinkContent), {
                data: cellData
            });
        case "render":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5nSlB.CellRenderContent), {
                data: cellData
            });
        default:
            return null;
    }
};

});
parcelRegister("lq8nC", function(module, exports) {
$parcel$export(module.exports, "CellCheckContent", function () { return (parcelRequire("5nSlB")).CellCheckContent; });
$parcel$export(module.exports, "CellExpanderContent", function () { return (parcelRequire("5nSlB")).CellExpanderContent; });
$parcel$export(module.exports, "CellHyperlinkContent", function () { return (parcelRequire("5nSlB")).CellHyperlinkContent; });
$parcel$export(module.exports, "CellRenderContent", function () { return (parcelRequire("5nSlB")).CellRenderContent; });
$parcel$export(module.exports, "CellTextContent", function () { return (parcelRequire("5nSlB")).CellTextContent; });
parcelRequire("5nSlB");
parcelRequire("laObo");

});
parcelRegister("5nSlB", function(module, exports) {

$parcel$export(module.exports, "CellTextContent", function () { return $4f8d7018fec2d385$export$6336b55f7613eff7; });
$parcel$export(module.exports, "CellCheckContent", function () { return $4f8d7018fec2d385$export$2ff19a9fa1e2bf3d; });
$parcel$export(module.exports, "CellExpanderContent", function () { return $4f8d7018fec2d385$export$9df6260913c83267; });
$parcel$export(module.exports, "CellHyperlinkContent", function () { return $4f8d7018fec2d385$export$baed7aa80eb77f27; });
$parcel$export(module.exports, "CellRenderContent", function () { return $4f8d7018fec2d385$export$70b9bce915221e55; });
/* cell-variants.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $lK5pR = parcelRequire("lK5pR");

var $1O6nN = parcelRequire("1O6nN");

var $5VMi0 = parcelRequire("5VMi0");

var $15aBT = parcelRequire("15aBT");

var $1rxrS = parcelRequire("1rxrS");
const $4f8d7018fec2d385$export$6336b55f7613eff7 = (props)=>{
    const { data: data, isRowHeader: isRowHeader } = props;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _zulpu2gc",
            isRowHeader && "_bozg1ul9"
        ]),
        children: [
            data.check && !isRowHeader && /*#__PURE__*/ (0, $loA2J.jsx)((0, $15aBT.Checkmark), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    data.check && "_1q5171o5"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1rxrS.TextContent), {
                    data: data.value
                })
            }),
            data.lozenge && /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5VMi0.Lozenge), {
                    text: data.lozenge
                })
            })
        ]
    });
};
const $4f8d7018fec2d385$export$2ff19a9fa1e2bf3d = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $15aBT.Checkmark), {});
};
const $4f8d7018fec2d385$export$9df6260913c83267 = (props)=>{
    const { data: data } = props;
    const label = data.lozenge ? /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
        children: [
            data.label,
            " ",
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5VMi0.Lozenge), {
                text: data.lozenge
            })
        ]
    }) : data.label;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lK5pR.Expand), {
        label: label,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1rxrS.TextContent), {
            data: data.body
        })
    });
};
const $4f8d7018fec2d385$export$baed7aa80eb77f27 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1O6nN.Link // id={rowDescId} // todo
    ), {
        text: props.data.label,
        href: props.data.href,
        type: "primary",
        className: (0, $esG4f.default)([
            "_1wybdlk8 _ahbq1y44"
        ])
    });
};
const $4f8d7018fec2d385$export$70b9bce915221e55 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        children: props.data.render()
    });
};

});
parcelRegister("15aBT", function(module, exports) {

$parcel$export(module.exports, "Checkmark", function () { return $5e87c96e85adaac2$export$4f481e0a96cfbed6; });
/* checkmark.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $5e87c96e85adaac2$export$4f481e0a96cfbed6 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "data-testid": "checkmark",
        className: (0, $esG4f.default)([
            "_bfhkl30o _2rko1ssb _syazcd5j _1e0c1o8l _1o9zidpf _k48p8n31 _vwz41tcg _y3gn1h6o _4t3i1tcg _1bsb1tcg"
        ]),
        style: {
            "--_1x006p6": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.lime700")),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Icon), {
            name: "featurecheckmark",
            size: "xs",
            color: (0, $5ohHq.wacToken)("color.neutral.light0")
        })
    });
};
const $5e87c96e85adaac2$var$containerInnerCss = null;

});

parcelRegister("1rxrS", function(module, exports) {

$parcel$export(module.exports, "TextContent", function () { return $f667198e6312b233$export$1b51c6466e79404f; });
/* text-content.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $8lB1y = parcelRequire("8lB1y");
const $f667198e6312b233$export$1b51c6466e79404f = (props)=>{
    const { data: data } = props;
    if (data.type === "plaintext") return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        className: (0, $esG4f.default)([
            "_y3gnv2br _1wybdlk8 _q7gqdlk8"
        ]),
        children: data.value
    });
    if (data.type === "richtext") return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        className: (0, $esG4f.default)([
            "_y3gnv2br _1wybdlk8 _q7gqdlk8"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            text: data.value
        })
    });
    throw new Error(`unknown text-content type: ${data.type}`);
};
const $f667198e6312b233$var$textCss = null;

});


parcelRegister("laObo", function(module, exports) {

});




parcelRegister("54y9B", function(module, exports) {

$parcel$export(module.exports, "Header", function () { return $31cae16aca6a1b1d$export$8b251419efc915eb; });
/* header.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("bwop0");
var $52o7a = parcelRequire("52o7a");
const $31cae16aca6a1b1d$export$8b251419efc915eb = (props)=>{
    const { titles: titles, stickyOffset: stickyOffset } = props;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $52o7a.Head), {
        stickyOffset: stickyOffset,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $52o7a.HeadRow), {
            children: titles.map((heading, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $52o7a.HeadCell), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _2lx21bp4 _zulpftgi _4cvr1y6m"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_syaz1hlo _k48p1fw0"
                            ]),
                            style: {
                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                            },
                            children: heading
                        })
                    })
                }, index))
        })
    });
};
const $31cae16aca6a1b1d$var$headCellDivCss = null;
const $31cae16aca6a1b1d$var$headCellSpanCss = null;

});

parcelRegister("Hw7na", function(module, exports) {

$parcel$export(module.exports, "SectionHeader", function () { return $b00a391f8c4429d7$export$8adb256d999cd5a0; });
/* section-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("bwop0");
var $jF79E = parcelRequire("jF79E");
const $b00a391f8c4429d7$export$8adb256d999cd5a0 = (props)=>{
    const { sectionTitle: sectionTitle, totalColumnCount: totalColumnCount } = props;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jF79E.SectionHeader), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jF79E.SectionHeaderCell), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    className: (0, $esG4f.default)([
                        "_syaz1hlo _1bsb1osq _k48p8n31 _4t3i1wug _1e0c1ule _1i4q1hna"
                    ]),
                    style: {
                        "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                    },
                    children: sectionTitle
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
                children: Array(totalColumnCount - 1).fill("").map((_, idx)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $jF79E.SectionHeaderCell), {}, idx))
            })
        ]
    });
};
const $b00a391f8c4429d7$var$sectionHeaderSpanCss = null;

});

parcelRegister("2NR3S", function(module, exports) {

$parcel$export(module.exports, "getColumnCount", function () { return $36febbb52c955bef$export$813bef8f01765aa1; });
function $36febbb52c955bef$export$813bef8f01765aa1(sections) {
    return $36febbb52c955bef$var$getColumnCountOfRowsOfSections(sections);
}
function $36febbb52c955bef$var$getColumnCountOfRowsOfSections(sections) {
    if (sections.length === 0) throw new Error("sections count should be > 0");
    let columnCount;
    sections.forEach((section, index)=>{
        try {
            const columnCountOfRows = $36febbb52c955bef$var$getColumnCountOfRows(section.rows);
            if (columnCount === undefined) columnCount = columnCountOfRows;
            else {
                if (columnCount !== columnCountOfRows) throw new Error(`inconsistent number of columns: section at index ${index} contains ${columnCountOfRows} columns; expected ${columnCount} columns based on previous section(s)`);
            }
        } catch (error) {
            // @ts-ignore
            throw new Error(`error at table section index ${index}`, {
                cause: error
            });
        }
    });
    if (columnCount === undefined) throw new Error("column count is undefined");
    return columnCount;
}
function $36febbb52c955bef$var$getColumnCountOfRows(rows) {
    if (rows.length === 0) throw new Error("rows count should be > 0");
    let columnCount;
    rows.forEach((row, index)=>{
        if (columnCount === undefined) columnCount = row.length;
        else {
            if (row.length !== columnCount) throw new Error(`inconsistent number of columns: row at index ${index} contains ${row.length} columns; expected ${columnCount} columns based on previous row(s)`);
        }
    });
    if (columnCount === undefined) throw new Error("column count is undefined");
    if (columnCount === 0) throw new Error("columnCount should not be 0");
    return columnCount;
}

});



parcelRegister("lQMRe", function(module, exports) {

$parcel$export(module.exports, "transformContentfulDataToTableData", function () { return $c16941b57a376563$export$d095b9a7d993b440; });
const $c16941b57a376563$export$e28b7b712925a1 = (featureGroup)=>{
    const { fields: fields } = featureGroup;
    return fields.featureGroupTitleExternal;
};
const $c16941b57a376563$export$74a00f18b9031fa7 = (featureFields)=>{
    return featureFields.featureNameExternal || "";
};
const $c16941b57a376563$export$c2c44121b33af1d6 = (featureFields, planTitles)=>{
    // @ts-ignore
    return planTitles.map((planTitle, i)=>{
        var _featureFields_relevantPlan, // @ts-ignore
        _featureFields_featureAdditionalInformation_find, _featureFields_featureAdditionalInformation;
        const isRelevant = (_featureFields_relevantPlan = featureFields.relevantPlan) === null || _featureFields_relevantPlan === void 0 ? void 0 : _featureFields_relevantPlan.some((plan)=>{
            var _plan_fields;
            return ((_plan_fields = plan.fields) === null || _plan_fields === void 0 ? void 0 : _plan_fields.planTitleExternal) === planTitle;
        });
        const additionalInfo = featureFields === null || featureFields === void 0 ? void 0 : (_featureFields_featureAdditionalInformation = featureFields.featureAdditionalInformation) === null || _featureFields_featureAdditionalInformation === void 0 ? void 0 : (_featureFields_featureAdditionalInformation_find = _featureFields_featureAdditionalInformation.find(// @ts-ignore
        (info)=>{
            var _info_fields_relevantPlan, _info_fields;
            return !!((_info_fields = info.fields) === null || _info_fields === void 0 ? void 0 : (_info_fields_relevantPlan = _info_fields.relevantPlan) === null || _info_fields_relevantPlan === void 0 ? void 0 : _info_fields_relevantPlan.some((plan)=>{
                var _plan_fields;
                return ((_plan_fields = plan.fields) === null || _plan_fields === void 0 ? void 0 : _plan_fields.planTitleExternal) === planTitle;
            }));
        })) === null || _featureFields_featureAdditionalInformation_find === void 0 ? void 0 : _featureFields_featureAdditionalInformation_find.fields.featureAdditionalInformation;
        // 1. if there is featureAdditionalInformation, use that as type rich text (links, etc.)
        if (additionalInfo) return {
            type: "text",
            check: additionalInfo && isRelevant,
            value: {
                type: "richtext",
                value: additionalInfo
            }
        };
        // 2. if isRelevant, use type check with empty value
        if (isRelevant) return {
            type: "check"
        };
        // 3. otherwise, use type text with empty value
        return {
            type: "text",
            value: {
                type: "plaintext",
                value: ""
            }
        };
    });
};
const $c16941b57a376563$export$4de3ae5ff94aba4 = (featureFields, featureName, descriptionText)=>{
    if (featureFields.relevantUrl) return {
        type: "hyperlink",
        label: featureName,
        href: featureFields.relevantUrl
    };
    if (descriptionText) return {
        type: "expander",
        label: featureName,
        lozenge: featureFields.callOut,
        body: {
            type: "richtext",
            value: descriptionText || featureName
        }
    };
    return {
        type: "text",
        value: {
            type: "plaintext",
            value: featureName
        },
        lozenge: featureFields.callOut,
        check: false
    };
};
const $c16941b57a376563$export$6fa65ac9a366ed09 = (feature, planTitles)=>{
    const featureFields = feature.fields;
    // left side column link or label
    const featureName = $c16941b57a376563$export$74a00f18b9031fa7(featureFields);
    // individual cells
    const planCells = $c16941b57a376563$export$c2c44121b33af1d6(featureFields, planTitles);
    // left side column
    const featureCell = $c16941b57a376563$export$4de3ae5ff94aba4(featureFields, featureName, featureFields.description);
    return [
        featureCell,
        ...planCells
    ];
};
const $c16941b57a376563$export$11afdf5edf7de08e = (featureGroup, planTitles)=>{
    var _featureGroup_fields_features;
    const sectionTitle = $c16941b57a376563$export$e28b7b712925a1(featureGroup);
    const rows = ((_featureGroup_fields_features = featureGroup.fields.features) === null || _featureGroup_fields_features === void 0 ? void 0 : _featureGroup_fields_features.map((feature)=>$c16941b57a376563$export$6fa65ac9a366ed09(feature, planTitles))) || [];
    return {
        title: sectionTitle,
        rows: rows
    };
};
const $c16941b57a376563$export$d095b9a7d993b440 = (contentfulData, planTitles)=>{
    return contentfulData.map((featureGroup)=>$c16941b57a376563$export$11afdf5edf7de08e(featureGroup, planTitles));
};

});



parcelRegister("cceBl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f0ddae1c4249f8b$export$2e2bcd8739ae039; });

var $kIHPB = parcelRequire("kIHPB");
var $1f0ddae1c4249f8b$export$2e2bcd8739ae039 = (0, $kIHPB.default);

});
parcelRegister("kIHPB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a207c7df7bd4bbe$export$2e2bcd8739ae039; });
/* product-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");
const $0a207c7df7bd4bbe$export$fef9b561ff2e7cb1 = ({ id: id, name: name, description: description, href: href, className: className, imgSrc: imgSrc, imgAlt: imgAlt, type: type = "secondary" })=>{
    const localizedHref = (0, $3FBn4.useLocalizedHref)(href !== null && href !== void 0 ? href : "");
    if (typeof href === "undefined") return null;
    const formattedHref = (0, $3FBn4.isLocalizableHref)(href) ? localizedHref : href;
    const iconSize = type === "primary" ? 44 : 32;
    let normalizedId;
    if (id === "jira-software") normalizedId = "jira";
    else if (id === "atlassian-access") normalizedId = "guard";
    else if (id) // The id for some products in Contentful have "-" in between (ex. jira-service-management), so we need to remove it to match data-product-key values in the global nav
    normalizedId = id.replace(/-/g, "");
    else normalizedId = name.replace(/ /g, "").toLowerCase();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _1mouu2gc _b27r17la",
            className
        ]),
        "data-testid": "wae-product-card",
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
            href: formattedHref,
            target: (0, $3FBn4.isLocalizableHref)(href) ? "" : "_blank",
            rel: (0, $3FBn4.isLocalizableHref)(href) ? "" : "noreferrer",
            "aria-label": name,
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "customerStories",
            "data-product-key": normalizedId,
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1aax1e5h _12l2utpp _4cvr1h6o _1bah1h6o _4t3i1ady _1bsb1ady _1wpz1q9y"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: {
                            src: imgSrc !== null && imgSrc !== void 0 ? imgSrc : "https://dam-cdn.atl.orangelogic.com/AssetLink/5sd7w3j2d7rdm7354yi413c5s1eo6s10.webp",
                            alt: imgAlt !== null && imgAlt !== void 0 ? imgAlt : "",
                            width: iconSize,
                            height: iconSize
                        }
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _zulpv77o _1q51v77o _1tke1ady",
                        "_1b2mvd4q _gp0igktf",
                        !description && "_1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: "h6",
                            children: name
                        }),
                        description && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: "body-sm",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
};
const $0a207c7df7bd4bbe$var$cardStyle = null;
const $0a207c7df7bd4bbe$var$iconStyle = null;
const $0a207c7df7bd4bbe$var$textContainerStyle = null;
const $0a207c7df7bd4bbe$var$noDescriptionStyle = null;
const $0a207c7df7bd4bbe$var$overrideTextStyling = null;
var $0a207c7df7bd4bbe$export$2e2bcd8739ae039 = $0a207c7df7bd4bbe$export$fef9b561ff2e7cb1;

});


parcelRegister("eLOkc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("9WCsH")).default; });

var $9WCsH = parcelRequire("9WCsH");

});
parcelRegister("9WCsH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d8765be0cf8182d$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $40KoW = parcelRequire("40KoW");

var $dti0I = parcelRequire("dti0I");

var $8lB1y = parcelRequire("8lB1y");

var $3FBn4 = parcelRequire("3FBn4");
const $2d8765be0cf8182d$export$228b49acf1bf4a77 = (props)=>{
    var _props_linkHref, _props_buttonHref;
    var _props_linkHref_path;
    const localizedLinkHref = (0, $3FBn4.useLocalizedHref)((_props_linkHref_path = (_props_linkHref = props.linkHref) === null || _props_linkHref === void 0 ? void 0 : _props_linkHref.path) !== null && _props_linkHref_path !== void 0 ? _props_linkHref_path : "");
    var _props_buttonHref_path;
    const localizedButtonHref = (0, $3FBn4.useLocalizedHref)((_props_buttonHref_path = (_props_buttonHref = props.buttonHref) === null || _props_buttonHref === void 0 ? void 0 : _props_buttonHref.path) !== null && _props_buttonHref_path !== void 0 ? _props_buttonHref_path : "");
    const callToActionProps = $2d8765be0cf8182d$var$transformCtaProps((0, $6iHNw._)((0, $7Knp0._)({}, props), {
        linkHref: props.linkHref ? {
            path: localizedLinkHref
        } : undefined,
        buttonHref: props.buttonHref ? {
            path: localizedButtonHref
        } : undefined
    }));
    var _props_imageAlt, _props_iconAlt;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dti0I.ProductCardBlock), {
        title: props.title,
        text: props.richText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            text: props.richText
        }) : !(0, $40KoW.isRichTextValueConsideredEmpty)(props.uniformRichText) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            uniformParameter: "uniformRichText"
        }) : props.text,
        titleAs: props.titleAs,
        logo: props.logo,
        eyebrow: props.eyebrow,
        alignment: props.alignment,
        callToActionProps: callToActionProps,
        pictureProps: props.imageUrl ? {
            image: {
                src: props.imageUrl,
                alt: (_props_imageAlt = props.imageAlt) !== null && _props_imageAlt !== void 0 ? _props_imageAlt : ""
            }
        } : undefined,
        spotIllustrationUrl: props.spotIllustrationUrl,
        icon: props.iconUrl ? {
            linkedIcon: {
                url: props.iconUrl,
                size: props.iconSize,
                alt: (_props_iconAlt = props.iconAlt) !== null && _props_iconAlt !== void 0 ? _props_iconAlt : ""
            }
        } : undefined,
        orientation: props.orientation,
        columns: props.columns,
        backgroundColor: props.backgroundColor
    });
};
function $2d8765be0cf8182d$var$transformCtaProps({ buttonHref: buttonHref, buttonLabel: buttonLabel, buttonVariant: buttonVariant, linkHref: linkHref, linkText: linkText, linkType: linkType }) {
    const isButton = !!(buttonHref === null || buttonHref === void 0 ? void 0 : buttonHref.path) && !!buttonLabel;
    const isLink = !!(linkHref === null || linkHref === void 0 ? void 0 : linkHref.path) && !!linkText;
    if (isButton || isLink) {
        const ctaProps = {
            button: isButton ? {
                href: buttonHref.path
            } : undefined,
            buttonText: buttonLabel !== null && buttonLabel !== void 0 ? buttonLabel : undefined,
            buttonVariant: buttonVariant !== null && buttonVariant !== void 0 ? buttonVariant : undefined,
            link: isLink ? {
                href: linkHref.path,
                text: linkText,
                type: linkType
            } : undefined
        };
        return ctaProps;
    }
    return undefined;
}
var $2d8765be0cf8182d$export$2e2bcd8739ae039 = $2d8765be0cf8182d$export$228b49acf1bf4a77;

});
parcelRegister("dti0I", function(module, exports) {

$parcel$export(module.exports, "ProductCardBlock", function () { return $f49b0f19250ac2d1$export$c17e706797abe921; });
/* product-card-block.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $lbVpk = parcelRequire("lbVpk");

var $c4STr = parcelRequire("c4STr");

var $1O6nN = parcelRequire("1O6nN");
const $f49b0f19250ac2d1$export$9bc3333acc9b342f = {
    jira: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1m4xip711l01021jmk8k33gj82grm078.svg",
        height: 32,
        alt: "Jira logo"
    },
    jiraProductDiscovery: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/lnuk8307fp65406pfvj4radajgkw48c5.svg",
        height: 32,
        alt: "Jira Product Discovery logo"
    },
    jiraServiceManagement: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1x20y6tg7hdjl45x6l8a4iy22n3vhff2.svg",
        height: 32,
        alt: "Jira Service Management logo"
    },
    statuspage: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/r237roxi4i14gj1i4t362kw1g06h63tv.svg",
        height: 32,
        alt: "Statuspage logo"
    },
    confluence: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ou687o50873egmj4l236et86h6178ylm.svg",
        height: 32,
        alt: "Confluence logo"
    },
    trello: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/gf3q277c3idu533i28bg3855yp2mwrlg.svg",
        height: 32,
        alt: "Trello logo"
    },
    loom: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5ncpek557ni2al3s7s5v0dmkcs4ogt05.svg",
        height: 32,
        alt: "Loom logo"
    },
    bitbucket: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/xqweg4il0228mpa8ega4i5hi78p0k16v.svg",
        height: 32,
        alt: "Bitbucket logo"
    },
    rovoDev: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/d888ipg7v6w1c6x4xfb578gfiw5238d0.svg",
        height: 32,
        alt: "Rovo Dev logo"
    },
    sourcetree: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/01u3w2aypa025m62s70p8uo6u21qg3i2.svg",
        height: 32,
        alt: "Sourcetree logo"
    },
    compass: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/yiu46gin8eoxy7f57m1g76a6b22uuf1b.svg",
        height: 32,
        alt: "Compass logo"
    },
    guard: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7085415d2l112j5j545y8nv6ir6t262w.svg",
        height: 32,
        alt: "Guard logo"
    },
    teamworkCollection: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/78ylq28783ef6w7c21vu5y84ngku10fx.svg",
        height: 32,
        alt: "Teamwork Collection logo"
    },
    strategyCollection: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/h5mj8675hs2i21g7687jagjoax1uy14n.svg",
        height: 32,
        alt: "Strategy Collection logo"
    },
    serviceCollection: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/f481qls2e2g883b2us2ek546yg4c44g1.svg",
        height: 32,
        alt: "Service Collection logo"
    },
    softwareCollection: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1j5jdr1kj625ayo48v421j3o05hg8nkg.svg",
        height: 32,
        alt: "Software Collection logo"
    },
    focus: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/q2h38a2vw336a1m16nstqc8s7w50t820.svg",
        height: 32,
        alt: "Focus logo"
    },
    talent: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/241h1u1khig63kccl1fe3hisqom3q007/fl_keep_metadata/Apps-Talent.svg",
        height: 32,
        alt: "Talent logo"
    },
    rovo: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/v878apvhek0q57kko33jlhu74xk3hvnx.svg",
        height: 32,
        alt: "Rovo logo"
    },
    jiraAlign: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/wt00m6668k5546116m0mii0b24q5iv2j/fl_keep_metadata/Apps-light_Jira-Align_Logo_brand_RGB.svg",
        height: 32,
        alt: "Jira Align logo"
    },
    pipelines: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ph5f4g2e315835kmw365b8210i128f6o.svg",
        height: 32,
        alt: "Pipelines logo"
    },
    dx: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/17q1f1j46us1tot0q6y7h67p44ih4548.svg",
        height: 32,
        alt: "DX logo"
    },
    assets: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/kb7rbd47j72qq3p7a02s87hcv743h5p6.svg",
        height: 32,
        alt: "Assets logo"
    },
    customerServiceManagement: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/fhyy25ehhmv4u3mibqncq66x00s65l6t.svg",
        height: 32,
        alt: "Customer Service Management logo"
    },
    bamboo: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5cisniv00mcsj58818l5045tbqo7hfpp.svg",
        height: 32,
        alt: "Bamboo logo"
    },
    crowd: {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/itn2206el7o5j3h62x6bi628p40vcjpe.svg",
        height: 32,
        alt: "Crowd logo"
    }
};
const $f49b0f19250ac2d1$var$imageStyle = null;
const $f49b0f19250ac2d1$var$zeroMarginCss = null;
const $f49b0f19250ac2d1$var$hyphenStyles = null;
const $f49b0f19250ac2d1$var$iconSizes = {
    "x-small": 24,
    "small": 32,
    "medium": 48,
    "large": 64
};
const $f49b0f19250ac2d1$var$contentColumnsLayout = {
    10: {
        assetSpan: 3,
        contentStart: 2
    },
    // 10 columns content block means 3 columns for asset, 7 for text
    12: {
        assetSpan: 4,
        contentStart: 1
    } // Add more mappings as needed in the future, ex:
};
const $f49b0f19250ac2d1$var$renderCta = ({ ctaProps: ctaProps, buttonSize: buttonSize, alignment: alignment, backgroundColor: backgroundColor, titleId: titleId, callToActionId: callToActionId })=>{
    var _ctaProps_buttonVariant;
    if ("button" in ctaProps && ctaProps.button !== undefined) return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _1n261g80 _zulpv47k _4cvr1h6o _1bahmqo6 _e8gh6xil _msuptoro"
        ]),
        style: {
            "--_1n7hwam": (0, $43MIc.default)(typeof alignment === "string" ? alignment : alignment.mobile),
            "--_1szc1oo": (0, $43MIc.default)(typeof alignment === "string" ? alignment : alignment.tablet),
            "--_1gtp2l2": (0, $43MIc.default)(typeof alignment === "string" ? alignment : alignment.desktop)
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $lbVpk.Button), (0, $6iHNw._)((0, $7Knp0._)({}, ctaProps.button), {
                size: buttonSize,
                variant: backgroundColor && backgroundColor === "#1868DB" && (ctaProps.buttonVariant === "primary" || !ctaProps.buttonVariant) ? "secondary" : (_ctaProps_buttonVariant = ctaProps.buttonVariant) !== null && _ctaProps_buttonVariant !== void 0 ? _ctaProps_buttonVariant : "primary",
                colorAgainst: backgroundColor === "#1868DB" ? "other" : "white",
                className: (0, $esG4f.default)([
                    "_i0dl1ris"
                ]),
                children: ctaProps.buttonText
            })),
            ctaProps.link && // eslint-disable-next-line @atlassian/a11y/anchor-has-content -- Link component renders text content via the text prop from ctaProps.link
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1O6nN.Link), (0, $7Knp0._)({
                id: callToActionId,
                ariaLabelledby: `${callToActionId} ${titleId}`,
                type: "primary",
                bgColor: $f49b0f19250ac2d1$var$isDarkBackgroundColor(backgroundColor) ? "bgBlackBlue" : "bgWhite"
            }, ctaProps.link))
        ]
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1O6nN.Link), (0, $7Knp0._)({
            id: callToActionId,
            ariaLabelledby: `${callToActionId} ${titleId}`,
            "aria-label": `${callToActionId} ${titleId}`,
            type: "primary",
            bgColor: $f49b0f19250ac2d1$var$isDarkBackgroundColor(backgroundColor) ? "bgBlackBlue" : "bgWhite"
        }, ctaProps.link))
    });
};
const $f49b0f19250ac2d1$var$renderIcon = (icon)=>{
    if (icon === null || icon === void 0 ? void 0 : icon.linkedIcon) {
        var _icon_linkedIcon;
        const linkedIconSize = (icon === null || icon === void 0 ? void 0 : (_icon_linkedIcon = icon.linkedIcon) === null || _icon_linkedIcon === void 0 ? void 0 : _icon_linkedIcon.size) ? $f49b0f19250ac2d1$var$iconSizes[icon.linkedIcon.size] : $f49b0f19250ac2d1$var$iconSizes["medium"];
        var _icon_linkedIcon_alt;
        return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                image: {
                    src: icon.linkedIcon.url,
                    alt: (_icon_linkedIcon_alt = icon.linkedIcon.alt) !== null && _icon_linkedIcon_alt !== void 0 ? _icon_linkedIcon_alt : "",
                    width: linkedIconSize,
                    height: linkedIconSize
                }
            })
        });
    }
    if (icon === null || icon === void 0 ? void 0 : icon.iconComponent) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: icon.iconComponent
    });
    return null;
};
const $f49b0f19250ac2d1$var$isDarkBackgroundColor = (color)=>{
    return color ? [
        "#1868DB",
        "#101214"
    ].includes(color) : false;
};
const $f49b0f19250ac2d1$export$c17e706797abe921 = (_param)=>{
    var { logo: logo, eyebrow: eyebrow, title: title, text: text, pictureProps: pictureProps, spotIllustrationUrl: spotIllustrationUrl, icon: icon, callToActionProps: callToActionProps, alignment: alignment = "start", orientation: orientation = "vertical", columns: columns = 10, backgroundColor: backgroundColor } = _param, props = (0, $akGnX._)(_param, [
        "logo",
        "eyebrow",
        "title",
        "text",
        "pictureProps",
        "spotIllustrationUrl",
        "icon",
        "callToActionProps",
        "alignment",
        "orientation",
        "columns",
        "backgroundColor"
    ]);
    // hedge against the value being passed in as a string (the options in uniform can only be string values)
    // which would subsequently fail a string vs number check ie 10 === "10" is false
    const numColumns = Number(columns);
    const { titleAs: TitleComponent = "h3" } = props;
    const isSmallDetailStyling = [
        "h4"
    ].includes(TitleComponent);
    const isLargeTextStyling = TitleComponent === "h2";
    const buttonSize = isSmallDetailStyling ? "small" : "large";
    const uniqueId = (0, $iSvIT.useId)();
    const titleId = (title ? title.replace(/\s+/g, "") : "title") + `-${uniqueId}`;
    const callToActionId = ((callToActionProps === null || callToActionProps === void 0 ? void 0 : callToActionProps.link) ? callToActionProps.link.text.replace(/\s+/g, "") : "call-to-action") + `-${uniqueId}`;
    const lightTextStyles = null;
    const textElement = typeof text === "string" ? /*#__PURE__*/ (0, $loA2J.jsx)("p", {
        className: (0, $esG4f.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            $f49b0f19250ac2d1$var$isDarkBackgroundColor(backgroundColor) && "_125xcd5j _9wqlcd5j _1loecd5j _cg41cd5j _qliycd5j _1rhqcd5j",
            isLargeTextStyling ? "body-lg" : "body-md"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: text
    }) : text;
    const bgColorStyle = null;
    const textContent = /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp1ejb _1q511z08 _1bah1yb4 _1b1q1cw5 _4t3i1osq",
            $f49b0f19250ac2d1$var$isDarkBackgroundColor(backgroundColor) && "_125xcd5j _9wqlcd5j _1loecd5j _cg41cd5j _qliycd5j _1rhqcd5j"
        ]),
        style: {
            "--_jsl571": (0, $43MIc.default)(orientation === "horizontal" ? "var(--ds-space-100, 8px)" : undefined),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _zulp1ejb"
                ]),
                children: [
                    logo && /*#__PURE__*/ (0, $loA2J.jsx)((0, $c4STr.Image), {
                        src: $f49b0f19250ac2d1$export$9bc3333acc9b342f[logo].src,
                        alt: $f49b0f19250ac2d1$export$9bc3333acc9b342f[logo].alt,
                        height: $f49b0f19250ac2d1$export$9bc3333acc9b342f[logo].height,
                        style: {
                            objectPosition: "left top",
                            objectFit: "contain"
                        }
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _2lx21bp4 _zulpu2gc",
                            "product-card-block-text-content"
                        ]),
                        children: [
                            eyebrow && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                className: (0, $esG4f.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    isSmallDetailStyling ? "eyebrow-sm" : "eyebrow-md"
                                ]),
                                children: eyebrow
                            }),
                            title && /*#__PURE__*/ (0, $loA2J.jsx)(TitleComponent, {
                                id: titleId,
                                className: (0, $esG4f.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "_ct361wug"
                                ]),
                                children: title
                            }),
                            text && textElement
                        ]
                    })
                ]
            }),
            callToActionProps && $f49b0f19250ac2d1$var$renderCta({
                ctaProps: callToActionProps,
                buttonSize: buttonSize,
                alignment: alignment,
                backgroundColor: backgroundColor,
                titleId: titleId,
                callToActionId: callToActionId
            })
        ]
    });
    const assetStyles = null;
    const horizontalSpotIllustrationStyles = null;
    const assetContent = pictureProps ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1b1q7d4p"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), (0, $6iHNw._)((0, $7Knp0._)({}, pictureProps), {
            className: (0, $esG4f.default)([
                "_18zxcq2i _mezj1osq _bna71wug _1jpx1f51"
            ])
        }))
    }) : spotIllustrationUrl ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1b1q7d4p",
            "_181n1txw _q8t51h6o _e8gh1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
            image: {
                src: spotIllustrationUrl,
                alt: "",
                width: 236,
                height: 236
            }
        })
    }) : icon ? $f49b0f19250ac2d1$var$renderIcon(icon) : null;
    const gapBetweenIconAndText = null;
    const productCardPadding = null;
    if (orientation === "vertical") return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e1faxbu",
            "_1yt41ejb",
            "_y3gnmqo6 _uj6k6xil _10hltoro _1e0c1txw _2lx21bp4 _zulp1ejb _11q79r5u _4cvr1fhb _1bah1fhb _4t3i1osq",
            icon && "_zulppxbi",
            "_2rkovwyg _19ityzqy"
        ]),
        style: {
            "--_1ly4823": (0, $43MIc.default)(backgroundColor),
            "--_1n7hwam": (0, $43MIc.default)(typeof alignment === "string" ? alignment : alignment.mobile),
            "--_1szc1oo": (0, $43MIc.default)(typeof alignment === "string" ? alignment : alignment.tablet),
            "--_1gtp2l2": (0, $43MIc.default)(typeof alignment === "string" ? alignment : alignment.desktop),
            "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
        },
        children: [
            assetContent,
            textContent
        ]
    });
    const fullWidthGridStyles = null;
    const horizontalProductCard = /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1yt41ejb",
            "_195g1wug _p12f1osq _1bsb1osq _13ltwklj _1j8bcx6w _1vsw1vi7 _10jxzqdx _1e0c11p5 _vchhusvi _zulp14hz _1dsl1tcg",
            "_1e1faxbu",
            "_kqswh2mm _1pbykb7n _1v6z18hw _1oyhxrvy",
            !backgroundColor && "_2rkovwyg _19ityzqy"
        ]),
        style: {
            "--_1ly4823": (0, $43MIc.default)(backgroundColor),
            "--_vimf9d": (0, $43MIc.default)(orientation === "horizontal-reverse" ? $f49b0f19250ac2d1$var$contentColumnsLayout[numColumns]["contentStart"] : $f49b0f19250ac2d1$var$contentColumnsLayout[numColumns]["contentStart"] + $f49b0f19250ac2d1$var$contentColumnsLayout[numColumns]["assetSpan"]),
            "--_1seowu7": (0, $43MIc.default)(numColumns - $f49b0f19250ac2d1$var$contentColumnsLayout[numColumns]["assetSpan"]),
            "--_tnqi0k": (0, $43MIc.default)(orientation === "horizontal" ? $f49b0f19250ac2d1$var$contentColumnsLayout[numColumns]["contentStart"] : $f49b0f19250ac2d1$var$contentColumnsLayout[numColumns]["contentStart"] + numColumns - $f49b0f19250ac2d1$var$contentColumnsLayout[numColumns]["assetSpan"]),
            "--_1u7gek8": (0, $43MIc.default)($f49b0f19250ac2d1$var$contentColumnsLayout[numColumns]["assetSpan"]),
            "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
        },
        children: [
            orientation === "horizontal" ? assetContent : null,
            textContent,
            orientation === "horizontal-reverse" ? assetContent : null
        ]
    });
    switch(numColumns){
        case 10:
        case 12:
            if (backgroundColor) return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e1faxbu",
                    "_2rkovwyg _19ityzqy",
                    "_1bsb1osq _kqswh2mm"
                ]),
                style: {
                    "--_1ly4823": (0, $43MIc.default)(backgroundColor),
                    "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
                    "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_kqswstnw _1bsbauwl _14b5zqdx _b8yq87gh _4t3i1osq _1e021ssb _t9eczr6s _11q79r5u _2rkovwyg"
                        ]),
                        style: {
                            "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card"))
                        }
                    }),
                    horizontalProductCard
                ]
            });
            return horizontalProductCard;
    }
};
const $f49b0f19250ac2d1$var$borderRadiusStyle = null;

});



parcelRegister("7D1nQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba308be7eb70f97b$export$2e2bcd8739ae039; });

var $1UUq1 = parcelRequire("1UUq1");
var $ba308be7eb70f97b$export$2e2bcd8739ae039 = (0, $1UUq1.PullQuote);

});

parcelRegister("jp1CX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("gUjud")).default; });

var $gUjud = parcelRequire("gUjud");

});
parcelRegister("gUjud", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c2d46bc1df90e68$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $jvT3O = parcelRequire("jvT3O");
const $6c2d46bc1df90e68$var$UniformRovoChatBox = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jvT3O.RovoChatBoxContainer), {});
};
var $6c2d46bc1df90e68$export$2e2bcd8739ae039 = $6c2d46bc1df90e68$var$UniformRovoChatBox;

});
parcelRegister("jvT3O", function(module, exports) {

$parcel$export(module.exports, "ChatHeader", function () { return $0efc7724e3b86a9c$export$1263ff8fe28ec69f; });
$parcel$export(module.exports, "RovoChatBoxContainer", function () { return $0efc7724e3b86a9c$export$acbe8b1c07595f91; });
/* chat.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $hWh1T = parcelRequire("hWh1T");

var $jgJpJ = parcelRequire("jgJpJ");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $gAJUc = parcelRequire("gAJUc");

var $5wOn9 = parcelRequire("5wOn9");

var $dsYmM = parcelRequire("dsYmM");

var $beXkr = parcelRequire("beXkr");

var $i1mZk = parcelRequire("i1mZk");

var $2ohR1 = parcelRequire("2ohR1");
const $0efc7724e3b86a9c$var$sectionStyles = null;
const $0efc7724e3b86a9c$var$chatHeaderContainerStyles = null;
const $0efc7724e3b86a9c$var$rovoIconStyles = null;
const $0efc7724e3b86a9c$var$h1Styles = null;
const $0efc7724e3b86a9c$var$textfieldContainerStyles = null;
const $0efc7724e3b86a9c$var$ctaButtonStyles = null;
const $0efc7724e3b86a9c$var$disabledInteractionCss = null;
const $0efc7724e3b86a9c$var$RovoPillButton = ({ isDisabled: isDisabled, onClick: onClick })=>{
    const intl = (0, $f6qj2.default)();
    const askRovoLabel = intl.formatMessage({
        id: "RovoChat.askRovo",
        defaultMessage: "Ask Rovo"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
        variant: "primary",
        size: "small",
        onClick: isDisabled ? undefined : onClick,
        className: (0, $esG4f.default)([
            "_1tke1ylp",
            isDisabled && "_lcxvglyw _80om73ad"
        ]),
        children: askRovoLabel
    });
};
const $0efc7724e3b86a9c$var$inputStyles = null;
const $0efc7724e3b86a9c$var$chatBoxContainerStyles = null;
const $0efc7724e3b86a9c$var$getNamedHeader = (firstName)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "RovoChat.greeting",
        defaultMessage: "Hey {name},{br}let's get to work",
        values: {
            name: (0, $jgJpJ.getFirstName)(firstName),
            br: /*#__PURE__*/ (0, $loA2J.jsx)("br", {})
        }
    });
};
const $0efc7724e3b86a9c$export$1263ff8fe28ec69f = ()=>{
    const { isUserLoggedIn: isUserLoggedIn, name: name } = (0, $5wOn9.useLoggedInUser)();
    const firstName = (0, $jgJpJ.getFirstName)(name !== null && name !== void 0 ? name : ""); // If 'gwp-9000-new-rovo-video-hero' is enabled, <h1> shows the video; else, Rovo Chat Header uses <h1>.
    // Check feature flag at render time to allow tests to mock it properly
    const isNewRovoVideoHeroEnabled = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp9000NewRovoVideoHero);
    const getMessage = ()=>{
        if (isUserLoggedIn && firstName) return $0efc7724e3b86a9c$var$getNamedHeader(firstName);
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "RovoChat.greeting",
            defaultMessage: "Hey there,{br}ready to get to work?",
            values: {
                br: /*#__PURE__*/ (0, $loA2J.jsx)("br", {})
            }
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_p12fbxu3 _1bsb1osq _y3gn1h6o _1e0c1txw _2lx21bp4 _4cvr1h6o _zulp7vkz _6rth1tcg"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dsYmM.RovoIcon), {
                className: (0, $esG4f.default)([
                    "_1bsb14no _4t3i14no"
                ])
            }),
            isNewRovoVideoHeroEnabled ? /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _vwz48vuz _1wybckbl _k48p9y44"
                ]),
                children: getMessage()
            }) : /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _vwz48vuz _1wybckbl _k48p9y44"
                ]),
                children: getMessage()
            })
        ]
    });
};
const $0efc7724e3b86a9c$export$e7a1e4b67bd87c97 = ({ textareaRef: externalRef, value: externalValue, onValueChange: onValueChange })=>{
    const intl = (0, $f6qj2.default)();
    const placeholder = intl.formatMessage({
        id: "RovoChat.placeholder",
        defaultMessage: "Find something, plan something, or make something"
    });
    const internalRef = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useRef(null);
    const textareaRef = externalRef || internalRef;
    const MAX_HEIGHT = 140; // keep in sync with inputStyles.maxHeight
    const resizeToContent = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useCallback(()=>{
        const el = textareaRef.current;
        if (!el) return;
        el.style.height = "auto";
        const next = Math.min(el.scrollHeight, MAX_HEIGHT);
        el.style.height = `${next}px`;
    }, [
        textareaRef,
        MAX_HEIGHT
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useEffect(()=>{
        resizeToContent();
    }, [
        resizeToContent
    ]);
    const handleChange = ()=>{
        resizeToContent();
    };
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useState("");
    const displayValue = externalValue !== null && externalValue !== void 0 ? externalValue : value;
    const handleClick = ()=>{
        const prompt = displayValue.trim();
        if (!prompt) return;
        const chatUrl = new URL("https://home.atlassian.com/chat");
        chatUrl.searchParams.set("rovoChatPathway", "chat");
        chatUrl.searchParams.set("rovoChatPrompt", prompt);
        const loginUrl = `https://id.atlassian.com/login?continue=${encodeURIComponent(chatUrl.toString())}`;
        console.log("generated URL: ", loginUrl);
        window.location.assign(loginUrl);
    }; // Determine which button to show based on feature gate
    const usePillButton = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp8979RovoOnWacButton);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bsb1xup _2lx21bp4 _4cvr1fhb _zulputpp _vchhusvi _2rko1crf _19it1k0a _11q71j9a _16qs1cd0 _1yt41s3g _1jj0utpp _14b5cv93 _1reo15vq _18m915vq"
        ]),
        style: {
            "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("textarea", {
                ref: textareaRef,
                placeholder: placeholder,
                maxLength: 1000,
                value: displayValue,
                onChange: (e)=>{
                    setValue(e.target.value);
                    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(e.target.value);
                    handleChange(e);
                },
                className: (0, $esG4f.default)([
                    "_1bsb1osq _1tkegktf _c71l11ux _18m91wug _19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1wyb7vkz _ect41kw7 _vwz4bs82 _slp31hna _1i4q1hna _o5721jtm _14zgglyw _nt751r31 _49pcglyw _1hvw1o36"
                ])
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx2vrvc _1bahesu3 _1bsb1osq _zulpu2gc"
                ]),
                children: usePillButton ? /*#__PURE__*/ (0, $loA2J.jsx)($0efc7724e3b86a9c$var$RovoPillButton, {
                    isDisabled: !displayValue.trim(),
                    onClick: handleClick
                }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $2ohR1.RovoIconButton), {
                    isDisabled: !displayValue.trim(),
                    onClick: handleClick,
                    icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hWh1T))), {
                        label: "Send message"
                    }),
                    ariaLabel: "Send message"
                })
            })
        ]
    });
};
const $0efc7724e3b86a9c$export$acbe8b1c07595f91 = ()=>{
    const [chatValue, setChatValue] = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useState("");
    const textareaRef = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useRef(null);
    const handleColdStartButtonClick = (prompt)=>{
        setChatValue(prompt);
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _p12fcv93 _1bsb1osq _zulpftgi"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($0efc7724e3b86a9c$export$e7a1e4b67bd87c97, {
                textareaRef: textareaRef,
                value: chatValue,
                onValueChange: setChatValue
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $i1mZk.ColdStartButtonsRow), {
                onButtonClick: handleColdStartButtonClick
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $beXkr.AIFooter), {})
        ]
    });
}; /**
    * RovoChat component displays a welcoming header for the Rovo chat experience - will add other components of the chat box in future PRs
    */ 
const $0efc7724e3b86a9c$export$9b4d0c63c2bc86a3 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($0efc7724e3b86a9c$export$1263ff8fe28ec69f, {}),
            /*#__PURE__*/ (0, $loA2J.jsx)($0efc7724e3b86a9c$export$acbe8b1c07595f91, {})
        ]
    });
};

});
parcelRegister("beXkr", function(module, exports) {

$parcel$export(module.exports, "AIFooter", function () { return $a71d6644f276acce$export$b209bc813a85fb1d; });
/* ai-footer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");

var $1lZ6p = parcelRequire("1lZ6p");
const $a71d6644f276acce$var$footerStyles = null;
const $a71d6644f276acce$var$contentStyles = null;
const $a71d6644f276acce$var$iconStyles = null;
const $a71d6644f276acce$var$textStyles = null;
const $a71d6644f276acce$export$b209bc813a85fb1d = ({ href: href = "https://www.atlassian.com/trust/atlassian-intelligence" })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bsb1osq _vchhusvi"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
            href: href,
            target: "_blank",
            rel: "noopener noreferrer",
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o _zulp1y44 _ca0qftgi _u5f3idpf _n3tdftgi _19bvidpf _1bsb1osq _4bfu1r31 _1hmsglyw _ajmmnqa1 _80omtlke"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1bah1h6o _4cvr1h6o _syaz1oju"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1lZ6p))), {
                        label: "Information",
                        size: "small"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    className: (0, $esG4f.default)([
                        "_ect41gqc _k48pi7a9 _1wyb1crf _vwz47vkz _syaz131l _1iqs1rm4 _zg8l4jg8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "RovoChat.usesAI",
                        defaultMessage: "Uses AI. Verify results."
                    })
                })
            ]
        })
    });
};

});

parcelRegister("i1mZk", function(module, exports) {

$parcel$export(module.exports, "ColdStartButtonsRow", function () { return $f8726c14cdc04776$export$f8e46ea9cdd11698; });
/* cold-starts-buttons.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $fdTrW = parcelRequire("fdTrW");

var $foKoE = parcelRequire("foKoE");

var $509Ny = parcelRequire("509Ny");

var $5ohHq = parcelRequire("5ohHq");
const $f8726c14cdc04776$var$buttonStyles = null;
const $f8726c14cdc04776$var$iconStyles = null;
const $f8726c14cdc04776$var$textStyles = null;
const $f8726c14cdc04776$var$buttonsContainerStyles = null;
const $f8726c14cdc04776$var$COLD_START_BUTTONS = [
    {
        icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fdTrW))), {
            label: "Chart trend up"
        }),
        labelMessageId: "RovoChat.coldStart.stayUpToDate",
        labelDefaultMessage: "Stay up to date",
        promptMessageId: "RovoChat.coldStart.stayUpToDatePrompt",
        promptDefaultMessage: "Stay up to date"
    },
    {
        icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($509Ny))), {
            label: "Search"
        }),
        labelMessageId: "RovoChat.coldStart.findInformation",
        labelDefaultMessage: "Find information",
        promptMessageId: "RovoChat.coldStart.findInformationPrompt",
        promptDefaultMessage: "What Confluence pages have I contributed to recently?"
    },
    {
        icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($foKoE))), {
            label: "Lightbulb"
        }),
        labelMessageId: "RovoChat.coldStart.brainstormIdeas",
        labelDefaultMessage: "Brainstorm ideas",
        promptMessageId: "RovoChat.coldStart.brainstormIdeasPrompt",
        promptDefaultMessage: "We're running a brainstorming session on topic/problem/goal. Generate a diverse list of creative ideas, solutions, and/or approaches."
    }
];
const $f8726c14cdc04776$export$b99f19cc0647223e = ({ icon: icon, buttonText: buttonText, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("button", {
        onClick: onClick,
        type: "button",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o _zulpi2wt _1yt4h8dc _2rko1y44 _19itzgxb _11q7m7j4 _80omtlke _v5641gvb _1tkezwfg _19lc15ej _4cvx7jlr _j6xtip91 _q4zt7jlr"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o"
                ]),
                children: icon
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_ect4zeyy _k48p1nn1 _1wybdlk8 _vwz41yan _y3gn1h6o _syaz1yg0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _o5721q9c"
                ]),
                style: {
                    "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
                },
                children: buttonText
            })
        ]
    });
}; /**
    * ColdStartButtonsRow displays a row of pre-filled action buttons for the Rovo Chat
    */ 
const $f8726c14cdc04776$export$f8e46ea9cdd11698 = ({ onButtonClick: onButtonClick })=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx2vrvc _zulpftgi _ca0q7vkz _u5f31crf _n3td7vkz _19bv1crf _1bsb1osq _1bah1h6o _1n261g80"
        ]),
        children: $f8726c14cdc04776$var$COLD_START_BUTTONS.map((button)=>{
            const label = intl.formatMessage({
                id: button.labelMessageId,
                defaultMessage: button.labelDefaultMessage
            });
            const prompt = intl.formatMessage({
                id: button.promptMessageId,
                defaultMessage: button.promptDefaultMessage
            });
            return /*#__PURE__*/ (0, $loA2J.jsx)($f8726c14cdc04776$export$b99f19cc0647223e, {
                icon: button.icon,
                buttonText: label,
                onClick: ()=>onButtonClick === null || onButtonClick === void 0 ? void 0 : onButtonClick(prompt)
            }, button.labelMessageId);
        })
    });
};

});

parcelRegister("2ohR1", function(module, exports) {

$parcel$export(module.exports, "RovoIconButton", function () { return $2bd9de82757a7d85$export$654fb6c640da31b4; });
/* rovo-icon-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $5ohHq = parcelRequire("5ohHq");
const $2bd9de82757a7d85$var$iconStyles = null; // Disabled state styles
const $2bd9de82757a7d85$var$disabledStyles = null; // Enabled state styles
const $2bd9de82757a7d85$var$enabledStyles = null;
const $2bd9de82757a7d85$export$654fb6c640da31b4 = ({ isDisabled: isDisabled = true, onClick: onClick, icon: icon, ariaLabel: ariaLabel = "Submit" })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
        onClick: isDisabled ? undefined : onClick,
        disabled: isDisabled,
        "aria-label": ariaLabel,
        className: (0, $esG4f.default)([
            "_1e0c116y _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg _2rko1ssb _19itglyw _80omtlke _v5642hjt _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1o9zidpf _1ygb8djs _1ah31y44",
            isDisabled ? "_bfhkm7j4 _syaz11tk _80om13gf _irr3m7j4 _30l311tk" : "_bfhk17la _syaz15cr _irr31tj6 _1di61ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1tgiy09": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue900")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: icon
    });
};

});




parcelRegister("k4P0o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("8Pgz8")).default; });

var $8Pgz8 = parcelRequire("8Pgz8");

});
parcelRegister("8Pgz8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffccd0066ce51573$export$2e2bcd8739ae039; });
/* rovo-chat-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $aiugz = parcelRequire("aiugz");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
const $ffccd0066ce51573$var$uniformSlotContainerCss = null;
const $ffccd0066ce51573$var$UniformRovoChatContainer = ()=>{
    const contentContainerRef = (0, $iSvIT.useRef)(null);
    const [interacting, setInteracting] = (0, $iSvIT.useState)(false);
    const interactingRef = (0, $iSvIT.useRef)(interacting);
    (0, $iSvIT.useEffect)(()=>{
        interactingRef.current = interacting;
    }, [
        interacting
    ]); // On-load
    (0, $iSvIT.useEffect)(()=>{
        let hasRun = false;
        let observer = null;
        let wheelTimeout = null;
        let keyTimeout = null;
        const container = contentContainerRef.current;
        function runEffectLogic() {
            if (hasRun) return;
            hasRun = true;
            const handleFirstInteraction = ()=>{
                if (!interactingRef.current) setInteracting(true);
            };
            const handleFirstClick = ()=>{
                handleFirstInteraction();
                enableScrollEvents();
            }; // Scroll blocking
            function preventDefault(e) {
                e.preventDefault();
                handleFirstInteraction();
            }
            function onWheel(e) {
                preventDefault(e);
                if (wheelTimeout) clearTimeout(wheelTimeout);
                wheelTimeout = setTimeout(enableScrollEvents, 20);
            }
            function onKeyDown(e) {
                preventDefault(e);
                if (keyTimeout) clearTimeout(keyTimeout);
                keyTimeout = setTimeout(enableScrollEvents, 20);
            }
            function onTouchMove(e) {
                preventDefault(e);
            }
            function onTouchEnd() {
                enableScrollEvents();
            }
            function blockScrollEvents() {
                window.addEventListener("wheel", onWheel, {
                    passive: false
                });
                window.addEventListener("touchmove", onTouchMove, {
                    passive: false
                });
                window.addEventListener("touchend", onTouchEnd, {
                    passive: false
                });
                window.addEventListener("touchcancel", onTouchEnd, {
                    passive: false
                });
                window.addEventListener("keydown", onKeyDown, {
                    passive: false
                });
            }
            function enableScrollEvents() {
                window.removeEventListener("wheel", onWheel);
                window.removeEventListener("touchmove", onTouchMove);
                window.removeEventListener("touchend", onTouchEnd);
                window.removeEventListener("touchcancel", onTouchEnd);
                window.removeEventListener("keydown", onKeyDown);
                if (wheelTimeout) clearTimeout(wheelTimeout);
                if (keyTimeout) clearTimeout(keyTimeout);
            }
            blockScrollEvents(); // Content container click interactions
            if (container) container.addEventListener("click", handleFirstClick, {
                once: true
            });
             // Also listen for global clicks as fallback
            const handleGlobalClick = ()=>{
                handleFirstInteraction();
                window.removeEventListener("click", handleGlobalClick);
            };
            window.addEventListener("click", handleGlobalClick); // Cleanup
            return ()=>{
                enableScrollEvents();
                if (container) container.removeEventListener("click", handleFirstClick);
                window.removeEventListener("click", handleGlobalClick);
            };
        }
        // Intersection Observer setup
        observer = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry && entry.isIntersecting) {
                runEffectLogic();
                observer === null || observer === void 0 ? void 0 : observer.disconnect();
            }
        }, {
            threshold: 0.1
        });
        if (container) observer.observe(container);
         // Cleanup
        return ()=>{
            if (observer && contentContainerRef.current) observer.unobserve(contentContainerRef.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1reo15vq _18m915vq _kqswh2mm _bfhk1rga"
        ]),
        style: {
            "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _1e023bav _1bsb2faw _4t3i1wug _1reo15vq _18m915vq _3zmjv4q2",
                    "_t9eccvni"
                ]),
                style: {
                    "--_182sf68": (0, $43MIc.default)(interacting ? "translateX(-120px)" : "translateX(0)")
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ih4h04rnm06355wnp2arca3f4gkg0258.webp",
                    alt: "",
                    style: $ffccd0066ce51573$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _rjxp3bav _1bsb2faw _4t3i1wug _1reo15vq _18m915vq _1fbdv4q2",
                    "_t9eccfs3"
                ]),
                style: {
                    "--_1tebple": (0, $43MIc.default)(interacting ? "translateX(120px)" : "translateX(0)")
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3qji3u3j76e5i63yjsj7pnko2npm30n4.webp",
                    alt: "",
                    style: $ffccd0066ce51573$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                ref: contentContainerRef,
                className: (0, $esG4f.default)([
                    "_4t3i1uqg _tnrumjdz"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                    name: "chatContent"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_181nglyw"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6ts3bd426400kq6ds07w1208q7a038r0.webp",
                    alt: "",
                    style: $ffccd0066ce51573$var$imageStyles,
                    className: (0, $esG4f.default)([
                        "_181nglyw"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_dm25glyw _sugaglyw"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6325jfp76jcjym74os216mopusw7m420.webp",
                    alt: "",
                    style: $ffccd0066ce51573$var$imageStyles
                })
            })
        ]
    });
};
var $ffccd0066ce51573$export$2e2bcd8739ae039 = $ffccd0066ce51573$var$UniformRovoChatContainer;
const $ffccd0066ce51573$var$desktopAssetStyle = {
    width: "787px"
};
const $ffccd0066ce51573$var$desktopLeftAssetCss = null;
const $ffccd0066ce51573$var$desktopRightAssetCss = null;
const $ffccd0066ce51573$var$desktopCss = null;
const $ffccd0066ce51573$var$tabletCss = null;
const $ffccd0066ce51573$var$mobileCss = null;
const $ffccd0066ce51573$var$imageStyles = {
    width: "100%",
    height: "100%",
    display: "block"
};
const $ffccd0066ce51573$var$sectionCss = null;

});


parcelRegister("ebG1P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("kklDD")).default; });

var $kklDD = parcelRequire("kklDD");

});
parcelRegister("kklDD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $829c8d4745755f8b$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $jvT3O = parcelRequire("jvT3O");
const $829c8d4745755f8b$var$UniformRovoChatHeader = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jvT3O.ChatHeader), {});
};
var $829c8d4745755f8b$export$2e2bcd8739ae039 = $829c8d4745755f8b$var$UniformRovoChatHeader;

});


parcelRegister("gcnH1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("4d1KE")).default; });

var $4d1KE = parcelRequire("4d1KE");

});
parcelRegister("4d1KE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c51c6f21ea637a9d$export$2e2bcd8739ae039; });
/* rovo-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $2bAHw = parcelRequire("2bAHw");

var $f6qj2 = parcelRequire("f6qj2");

var $gF60T = parcelRequire("gF60T");

var $7ShLR = parcelRequire("7ShLR");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("haYnf");
var $gVN7C = parcelRequire("gVN7C");
// eslint-disable-next-line complexity
const $c51c6f21ea637a9d$var$UniformRovoHero = ({ defaultHeading: defaultHeading, defaultSubheading: defaultSubheading, videoCarousel: videoCarousel, primaryCtaLabel: primaryCtaLabel, primaryCtaHref: primaryCtaHref, headingTag: headingTag = "h1", flattenData: flattenData = true })=>{
    const videoCarouselData = flattenData ? (0, $2bAHw.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    videoCarousel) : videoCarousel;
    const videoRefs = (0, $iSvIT.useRef)([]);
    const videoContainerRef = (0, $iSvIT.useRef)(null);
    const [current, setCurrent] = (0, $iSvIT.useState)(-1);
    const currentRef = (0, $iSvIT.useRef)(current);
    const [playing, setPlaying] = (0, $iSvIT.useState)(true);
    const [durations, setDurations] = (0, $iSvIT.useState)(Array(videoCarouselData.length).fill(0));
    const [fillBarResetKey, setFillBarResetKey] = (0, $iSvIT.useState)(0); // @ts-ignore
    const prevViewportWidth = (0, $iSvIT.useRef)(typeof window !== "undefined" ? window.innerWidth : 0);
    const [viewportWidth, setViewportWidth] = (0, $iSvIT.useState)(typeof window !== "undefined" ? window.innerWidth : 0);
    (0, $iSvIT.useEffect)(()=>{
        currentRef.current = current;
    }, [
        current
    ]); // On-load
    (0, $iSvIT.useEffect)(()=>{
        let hasRun = false;
        let observer = null;
        let wheelTimeout = null;
        let keyTimeout = null;
        function runEffectLogic() {
            if (hasRun) return;
            hasRun = true;
            const handleFirstInteraction = ()=>{
                if (currentRef.current === -1) setCurrent(0);
            };
            const handleFirstClick = ()=>{
                handleFirstInteraction();
                enableScrollEvents();
            }; // Scroll blocking
            function preventDefault(e) {
                e.preventDefault();
                handleFirstInteraction();
            }
            function onWheel(e) {
                preventDefault(e);
                if (wheelTimeout) clearTimeout(wheelTimeout);
                wheelTimeout = setTimeout(enableScrollEvents, 20);
            }
            function onKeyDown(e) {
                preventDefault(e);
                if (keyTimeout) clearTimeout(keyTimeout);
                keyTimeout = setTimeout(enableScrollEvents, 20);
            }
            function onTouchMove(e) {
                preventDefault(e);
            }
            function onTouchEnd() {
                enableScrollEvents();
            }
            function blockScrollEvents() {
                window.addEventListener("wheel", onWheel, {
                    passive: false
                });
                window.addEventListener("touchmove", onTouchMove, {
                    passive: false
                });
                window.addEventListener("touchend", onTouchEnd, {
                    passive: false
                });
                window.addEventListener("touchcancel", onTouchEnd, {
                    passive: false
                });
                window.addEventListener("keydown", onKeyDown, {
                    passive: false
                });
            }
            function enableScrollEvents() {
                window.removeEventListener("wheel", onWheel);
                window.removeEventListener("touchmove", onTouchMove);
                window.removeEventListener("touchend", onTouchEnd);
                window.removeEventListener("touchcancel", onTouchEnd);
                window.removeEventListener("keydown", onKeyDown);
                if (wheelTimeout) clearTimeout(wheelTimeout);
                if (keyTimeout) clearTimeout(keyTimeout);
            }
            blockScrollEvents(); // Video container click interactions
            const container = videoContainerRef.current;
            if (container) container.addEventListener("pointerdown", handleFirstClick, {
                once: true
            });
             // Video durations
            videoCarouselData.forEach((_, idx)=>{
                const video = videoRefs.current[idx];
                if (!video) return;
                if (video.readyState >= 1) setDurations((durs)=>{
                    const copy = [
                        ...durs
                    ];
                    copy[idx] = video.duration;
                    return copy;
                });
                else video.onloadedmetadata = ()=>{
                    setDurations((durs)=>{
                        const copy = [
                            ...durs
                        ];
                        copy[idx] = video.duration;
                        return copy;
                    });
                };
            }); // Cleanup
            return ()=>{
                enableScrollEvents();
                if (container) {
                    container.removeEventListener("pointerdown", handleFirstInteraction);
                    container.removeEventListener("keydown", handleFirstInteraction);
                }
            };
        }
        // Intersection Observer setup
        observer = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry && entry.isIntersecting) {
                runEffectLogic();
                observer === null || observer === void 0 ? void 0 : observer.disconnect();
            }
        }, {
            threshold: 0.1
        });
        if (videoContainerRef.current) observer.observe(videoContainerRef.current);
         // Cleanup
        return ()=>{
            if (observer && videoContainerRef.current) observer.unobserve(videoContainerRef.current);
        };
    }, []);
    // Play next video on end, looping
    const handleEnded = ()=>{
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        setCurrent((prev)=>(prev + 1) % videoCarouselData.length);
    }; // Pause/play current video
    (0, $iSvIT.useEffect)(()=>{
        if (current === -1) return;
        const video = videoRefs.current[current];
        if (video) {
            if (playing) {
                if (video.ended) video.currentTime = 0;
                 // eslint-disable-next-line @typescript-eslint/no-empty-function
                video.play().catch(()=>{});
            } else video.pause();
        }
    }, [
        playing,
        current
    ]); // Pause/play toggle
    const togglePlay = ()=>{
        setPlaying((p)=>!p);
    }; // Jump to a specific video and start from beginning
    const handleTeamClick = (idx)=>{
        if (idx === current) return;
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        setCurrent(idx);
        setPlaying(true);
    };
    const currentDuration = durations[current] || 10; // Responsive asset type
    (0, $iSvIT.useEffect)(()=>{
        let resizeTimeout;
        const breakpoints = [
            768,
            1024
        ]; // Store previous width outside the handler so it persists
        const prevViewportWidth = {
            current: window.innerWidth
        };
        function crossedBreakpoint(prev, curr) {
            return breakpoints.some((bp)=>prev < bp && curr >= bp || prev >= bp && curr < bp);
        }
        const handleResizeEnd = ()=>{
            const currWidth = window.innerWidth;
            if (crossedBreakpoint(prevViewportWidth.current, currWidth)) setFillBarResetKey((k)=>k + 1);
            prevViewportWidth.current = currWidth;
        };
        const handleResize = ()=>{
            setViewportWidth(window.innerWidth);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
            resizeTimeout = window.setTimeout(handleResizeEnd, 300);
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
        };
    }, []);
    const assetType = viewportWidth >= 1024 ? "desktop" : viewportWidth >= 768 ? "tablet" : "mobile";
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1reo15vq _18m915vq _kqswh2mm _bfhk1rga"
        ]),
        style: {
            "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _1e023bav _3zmjv4q2",
                    "_t9ec1qbm"
                ]),
                style: {
                    "--_12q5zt9": (0, $43MIc.default)(current !== -1 ? "translateX(-120px)" : "translateX(0)")
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ih4h04rnm06355wnp2arca3f4gkg0258.webp",
                    alt: "",
                    style: $c51c6f21ea637a9d$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _rjxp3bav _1fbdv4q2",
                    "_t9ecc5kj"
                ]),
                style: {
                    "--_1ylu95p": (0, $43MIc.default)(current !== -1 ? "translateX(120px)" : "translateX(0)")
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3qji3u3j76e5i63yjsj7pnko2npm30n4.webp",
                    alt: "",
                    style: $c51c6f21ea637a9d$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1reo15vq _1rjcxncg _133i1ejb"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $gVN7C.UniformColumnLayout), {
                        layout: "8",
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_y3gn1h6o"
                            ]),
                            children: [
                                defaultSubheading && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_16mf1pz4 _12n91k8s _179m1k92 _1k84oxwj",
                                        "body-lg subheading"
                                    ]),
                                    style: {
                                        "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                                    },
                                    children: defaultSubheading
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_4cvr1h6o _1pfhpxbi"
                                    ]),
                                    children: headingTag === "h1" ? /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                                        className: (0, $esG4f.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _a13e10xh"
                                        ]),
                                        children: defaultHeading
                                    }) : /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                        className: (0, $esG4f.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _a13e10xh"
                                        ]),
                                        children: defaultHeading
                                    })
                                }),
                                primaryCtaLabel && primaryCtaHref && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1e0c1txw _1n261g80 _zulputpp _1bah1h6o _1mou1ejb _urukpxbi"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
                                        href: primaryCtaHref,
                                        className: (0, $esG4f.default)([
                                            "_3fcw1q9c _1cqs1j6v _1bys1k92 _1jw8bfng"
                                        ]),
                                        children: primaryCtaLabel
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        ref: videoContainerRef,
                        className: (0, $esG4f.default)([
                            "_kqswh2mm _1e021ssb _t9eczr6s",
                            "_1bsb17gh _4t3ieo28 _12rr13bv _1vkh124j _1rfmixjv _tnru1jje"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1bsb1osq _4t3i1osq _1e0c1ule _y3gn1h6o _kqswh2mm _1reo15vq _18m915vq"
                            ]),
                            children: videoCarouselData.map(({ team: team, mobileVideoSrc: mobileVideoSrc, tabletVideoSrc: tabletVideoSrc, desktopVideoSrc: desktopVideoSrc, mobilePoster: mobilePoster, tabletPoster: tabletPoster, desktopPoster: desktopPoster, ariaLabel: ariaLabel }, idx)=>/*#__PURE__*/ {
                                var _ref;
                                return (0, $loA2J.jsx)("video", {
                                    ref: (el)=>videoRefs.current[idx] = el,
                                    src: assetType === "desktop" ? desktopVideoSrc : assetType === "tablet" ? tabletVideoSrc : mobileVideoSrc,
                                    muted: true,
                                    playsInline: true,
                                    onEnded: handleEnded,
                                    autoPlay: idx === current && playing,
                                    controls: false,
                                    "aria-label": ariaLabel,
                                    preload: "auto",
                                    poster: (_ref = assetType === "desktop" ? desktopPoster : assetType === "tablet" ? tabletPoster : mobilePoster) !== null && _ref !== void 0 ? _ref : undefined,
                                    className: (0, $esG4f.default)([
                                        "_1bsb17gh _4t3ieo28 _12rr13bv _1vkh124j _1rfmixjv _tnru1jje",
                                        "_3um01ppy _4t3io5ou"
                                    ]),
                                    style: {
                                        "--_1wpk543": (0, $43MIc.default)(idx === current || idx === 0 && current === -1 ? "visible" : "hidden"),
                                        "--_1b1vnti": (0, $43MIc.default)(idx === current || idx === 0 && current === -1 ? "100%" : 0)
                                    }
                                }, team);
                            })
                        })
                    }),
                    current !== -1 && /*#__PURE__*/ (0, $loA2J.jsx)((0, $gVN7C.UniformColumnLayout), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1pfhoahv _195g1wug _1bsb1osq _p12fbxu3 _zulputpp _y44v1dy3 _1e0c11p5 _yv0e1qft _476dutpp _19d71wug _zzszh9n0"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                    onClick: togglePlay,
                                    className: (0, $esG4f.default)([
                                        "_4t3i1ady _1bsb1ady _19pkyjp0 _2hwxyjp0 _otyryjp0 _18u0yjp0 _bfhk1j28 _19itglyw _2rko1osq _1ii7kb7n _yyhycs5v _d0altlke _1tzgkb7n _1acakb7n"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_4t3izwfg _1bsbzwfg _bfhk1aeo _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31s03 _1tjq1s1x"
                                        ]),
                                        style: {
                                            "--_44ufl2": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark1000")),
                                            "--_1mbq9ci": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark800")),
                                            "--_1jncskl": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark300"))
                                        },
                                        children: playing ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gF60T))), {
                                            label: intl.formatMessage({
                                                id: "rovo-hero.pause",
                                                defaultMessage: "Pause"
                                            })
                                        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7ShLR))), {
                                            label: intl.formatMessage({
                                                id: "rovo-hero.play",
                                                defaultMessage: "Play"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1e0c1txw _4cvr1y6m _zulputpp _1bsb1osq"
                                    ]),
                                    children: videoCarouselData.map(({ team: team }, idx)=>/*#__PURE__*/ (0, $loA2J.jsxs)("button", {
                                            onClick: ()=>handleTeamClick(idx),
                                            className: (0, $esG4f.default)([
                                                "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _ect41pz4 _1wyb1j6v _k48p1fw0 _vwz41k8s",
                                                "_syazxvv5 _d0al18ta"
                                            ]),
                                            style: {
                                                "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display")),
                                                "--_145xjfw": (0, $43MIc.default)(idx === current ? (0, $5ohHq.wacToken)("color.primary.blue") : (0, $5ohHq.wacToken)("color.neutral.light800")),
                                                "--_1sd2kd4": (0, $43MIc.default)(idx === current ? "auto" : "pointer")
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                    className: (0, $esG4f.default)([
                                                        "_4t3iftgi _1bsb1osq _kqswh2mm _1reo15vq _18m915vq _bfhku4vp _1mou1ilp",
                                                        idx === 0 && "_2rkonggr",
                                                        idx === videoCarouselData.length - 1 && "_2rkof82g"
                                                    ]),
                                                    style: {
                                                        "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
                                                    },
                                                    children: idx === current && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                        className: (0, $esG4f.default)([
                                                            "_4t3i1osq _1bsb1osq _bfhk17la _kqswstnw _1e02idpf _152tidpf",
                                                            "_y44v1gj6 _1y0c1j4f",
                                                            "fillBar"
                                                        ]),
                                                        style: {
                                                            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                                                            "--_1fmqpqp": (0, $43MIc.default)(currentDuration, "s"),
                                                            "--_snrfvu": (0, $43MIc.default)(playing ? "running" : "paused")
                                                        }
                                                    }, fillBarResetKey)
                                                }),
                                                team
                                            ]
                                        }, team))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_181nglyw"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6ts3bd426400kq6ds07w1208q7a038r0.webp",
                    alt: "",
                    style: $c51c6f21ea637a9d$var$imageStyles,
                    className: (0, $esG4f.default)([
                        "_181nglyw"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_dm25glyw _sugaglyw"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6325jfp76jcjym74os216mopusw7m420.webp",
                    alt: "",
                    style: $c51c6f21ea637a9d$var$imageStyles
                })
            })
        ]
    });
};
var $c51c6f21ea637a9d$export$2e2bcd8739ae039 = $c51c6f21ea637a9d$var$UniformRovoHero;
const $c51c6f21ea637a9d$var$desktopAssetStyle = {
    width: "787px"
};
const $c51c6f21ea637a9d$var$desktopLeftAssetCss = null;
const $c51c6f21ea637a9d$var$desktopRightAssetCss = null;
const $c51c6f21ea637a9d$var$desktopCss = null;
const $c51c6f21ea637a9d$var$tabletCss = null;
const $c51c6f21ea637a9d$var$mobileCss = null;
const $c51c6f21ea637a9d$var$imageStyles = {
    width: "100%",
    height: "100%",
    display: "block"
};
const $c51c6f21ea637a9d$var$sectionCss = null;
const $c51c6f21ea637a9d$var$containerCss = null;
const $c51c6f21ea637a9d$var$subheadingCss = null;
const $c51c6f21ea637a9d$var$headingContainerCss = null;
const $c51c6f21ea637a9d$var$headingCss = null;
const $c51c6f21ea637a9d$var$mainHeadingCss = null;
const $c51c6f21ea637a9d$var$ctaContainerCss = null;
const $c51c6f21ea637a9d$var$ctaCss = null;
const $c51c6f21ea637a9d$var$videoContainerCss = null;
const $c51c6f21ea637a9d$var$videoDimensionsCss = null;
const $c51c6f21ea637a9d$var$videoCss = null;
const $c51c6f21ea637a9d$var$fadeIn = null;
const $c51c6f21ea637a9d$var$controlContainerCss = null;
const $c51c6f21ea637a9d$var$barContainerCss = null;
const $c51c6f21ea637a9d$var$buttonCss = null;
const $c51c6f21ea637a9d$var$buttonCirlceCss = null;
const $c51c6f21ea637a9d$var$firstBarCss = null;
const $c51c6f21ea637a9d$var$lastBarCss = null;
const $c51c6f21ea637a9d$var$barbuttonCss = null;
const $c51c6f21ea637a9d$var$barCss = null;
const $c51c6f21ea637a9d$var$fillBarCss = null;
const $c51c6f21ea637a9d$var$fill = null;

});


parcelRegister("dj3LQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("1BNhI")).default; });

var $1BNhI = parcelRequire("1BNhI");

});
parcelRegister("1BNhI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afe748f793dea70b$export$2e2bcd8739ae039; });
/* scrollable-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $7d77Q = parcelRequire("7d77Q");

var $1UUq1 = parcelRequire("1UUq1");

var $5VMi0 = parcelRequire("5VMi0");

var $5ohHq = parcelRequire("5ohHq");
const $afe748f793dea70b$var$UniformScrollableHeroCards = (props)=>{
    const { flattenData: flattenData = true } = props;
    let { scrollableCard: scrollableCard } = props;
    if (flattenData) {
        const flattened = (0, $7d77Q.flattenScrollableCardProps)(props);
        scrollableCard = flattened.scrollableCard;
    }
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_11q71ybm _1rjcpxbi _18zr1jfw _1bhl1ejb"
        ]),
        style: {
            "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1bsb1s9t _p12f1osq _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _9nneu2gc _1yt4u2gc _zulp1ejb _85i51ejb _1reo1wug _rjfvx6dd _1fjgurpi _a5o91kbs _15peu2gc _1v6m1rga _gce7u2gc _aayn1q9v _155au2gc _1w1e15zi _2osnpxbi"
            ]),
            style: {
                "--_o8nmkh": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue500")),
                "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
            },
            children: scrollableCard === null || scrollableCard === void 0 ? void 0 : scrollableCard.map((card, index)=>{
                var _card_scrollableCardUrl;
                const cardContent = /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5VMi0.Lozenge), {
                            appearance: card.scrollableCardLozengeColor || "neutral",
                            text: card.scrollableCardLozengeText
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            className: (0, $esG4f.default)([
                                "_18s86fpf _1yt414kv _th3simiu _lrmn10nf",
                                "scrollable-card-title"
                            ]),
                            children: card.scrollableCardTitle
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                            src: card.scrollableCardImage,
                            alt: card.scrollableCardTitle
                        })
                    ]
                });
                return ((_card_scrollableCardUrl = card.scrollableCardUrl) === null || _card_scrollableCardUrl === void 0 ? void 0 : _card_scrollableCardUrl.path) ? /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                    href: card.scrollableCardUrl.path,
                    "aria-label": card.scrollableCardUrl.alt || card.scrollableCardTitle,
                    className: (0, $esG4f.default)([
                        "_1hu1v2br _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _4cvr1y6m _1bsbeq5r _1ul9eq5r _zulp1b66 _11q7cd5j _2rkovwyg _16qszucj _1yt418tt _mezj1osq _bna7sb0t _1jpx1dfr _1j3s1nty _1cr61wug _1hlxidpf _1874idpf _10ewidpf",
                        "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazn7od _80omtlke _v564iooc _1llwjtcz _1dbz1cd0 _y2mv1mie"
                    ]),
                    style: {
                        "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                        "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
                        "--_o8nmkh": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue500"))
                    },
                    children: cardContent
                }, index) : /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1hu1v2br _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _4cvr1y6m _1bsbeq5r _1ul9eq5r _zulp1b66 _11q7cd5j _2rkovwyg _16qszucj _1yt418tt _mezj1osq _bna7sb0t _1jpx1dfr _1j3s1nty _1cr61wug _1hlxidpf _1874idpf _10ewidpf"
                    ]),
                    style: {
                        "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                        "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card"))
                    },
                    children: cardContent
                }, index);
            })
        })
    });
};
const $afe748f793dea70b$var$containerStyles = null;
const $afe748f793dea70b$var$scrollableContainer = null;
const $afe748f793dea70b$var$titleStyles = null;
const $afe748f793dea70b$var$cardWrapper = null;
const $afe748f793dea70b$var$clickableCardStyles = null;
var $afe748f793dea70b$export$2e2bcd8739ae039 = $afe748f793dea70b$var$UniformScrollableHeroCards;

});
parcelRegister("7d77Q", function(module, exports) {

$parcel$export(module.exports, "flattenScrollableCardProps", function () { return $65ca9603bccee51b$export$f91448e13674e82b; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $2bAHw = parcelRequire("2bAHw");
const $65ca9603bccee51b$export$f91448e13674e82b = (props)=>{
    return (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        scrollableCard: (0, $2bAHw.flattenValues)(props.scrollableCard)
    });
};

});



parcelRegister("f7sBJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8e0a5eedd482562$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("dMM9X");
var $5STdK = parcelRequire("5STdK");

var $9EEyI = parcelRequire("9EEyI");
const $a8e0a5eedd482562$var$UniformSideNav = ({ component: component })=>{
    var _component_slots, _component_parameters_title, _component_parameters;
    var _component_slots_sideNavItems;
    const slotItems = (_component_slots_sideNavItems = (_component_slots = component.slots) === null || _component_slots === void 0 ? void 0 : _component_slots["sideNavItems"]) !== null && _component_slots_sideNavItems !== void 0 ? _component_slots_sideNavItems : null;
    if (!slotItems) return;
    const sideNavItems = (0, $9EEyI.transformNavItemData)(slotItems);
    const props = {
        title: (_component_parameters = component.parameters) === null || _component_parameters === void 0 ? void 0 : (_component_parameters_title = _component_parameters["title"]) === null || _component_parameters_title === void 0 ? void 0 : _component_parameters_title.value,
        sideNavItems: sideNavItems
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5STdK.SideNav), (0, $7Knp0._)({}, props));
};
var $a8e0a5eedd482562$export$2e2bcd8739ae039 = $a8e0a5eedd482562$var$UniformSideNav;

});
parcelRegister("9EEyI", function(module, exports) {

$parcel$export(module.exports, "transformNavItemData", function () { return $a929b7ce54326c3f$export$bbcc1b49937dee22; });
const $a929b7ce54326c3f$export$bbcc1b49937dee22 = (slots)=>{
    return slots.map((childComponent)=>{
        var _childProps_collectionName, _childComponent_slots;
        var _childComponent_parameters;
        const childProps = (_childComponent_parameters = childComponent.parameters) !== null && _childComponent_parameters !== void 0 ? _childComponent_parameters : {};
        if (childComponent.type === "sideNavLink") {
            var _childProps_anchors, _childProps_text, _childProps_href;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const anchors = (_childProps_anchors = childProps["anchors"]) === null || _childProps_anchors === void 0 ? void 0 : _childProps_anchors.value;
            return {
                type: "link",
                text: (_childProps_text = childProps["text"]) === null || _childProps_text === void 0 ? void 0 : _childProps_text.value,
                href: (_childProps_href = childProps["href"]) === null || _childProps_href === void 0 ? void 0 : _childProps_href.value,
                anchors: anchors ? anchors.map((anchor)=>anchor.fields.text.value) : null,
                dataEventProps: {
                    "data-product-key": "uniform",
                    "data-event-component": "linkButton",
                    "data-event-container": "sideNav",
                    "data-event": "clicked"
                }
            };
        }
        if (childComponent.type === "sideNavCollection") return {
            type: "collection",
            collectionName: (_childProps_collectionName = childProps["collectionName"]) === null || _childProps_collectionName === void 0 ? void 0 : _childProps_collectionName.value,
            sideNavItems: $a929b7ce54326c3f$export$bbcc1b49937dee22((_childComponent_slots = childComponent.slots) === null || _childComponent_slots === void 0 ? void 0 : _childComponent_slots["sideNavItems"])
        };
        return;
    });
};

});


parcelRegister("borry", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("impgo")).default; });

var $impgo = parcelRequire("impgo");

});
parcelRegister("impgo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $579d7e0176dcd680$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $1UUq1 = parcelRequire("1UUq1");

var $9EEyI = parcelRequire("9EEyI");
const $579d7e0176dcd680$var$UniformSideNavCollection = ({ component: component })=>{
    var _component_slots, _component_parameters_collectionName, _component_parameters;
    var _component_slots_sideNavItems;
    const slotItems = (_component_slots_sideNavItems = (_component_slots = component.slots) === null || _component_slots === void 0 ? void 0 : _component_slots["sideNavItems"]) !== null && _component_slots_sideNavItems !== void 0 ? _component_slots_sideNavItems : null;
    if (!slotItems) return;
    const sideNavItems = (0, $9EEyI.transformNavItemData)(slotItems);
    const props = {
        type: "collection",
        collectionName: (_component_parameters = component.parameters) === null || _component_parameters === void 0 ? void 0 : (_component_parameters_collectionName = _component_parameters["collectionName"]) === null || _component_parameters_collectionName === void 0 ? void 0 : _component_parameters_collectionName.value,
        sideNavItems: sideNavItems
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.SideNavCollection), (0, $7Knp0._)({}, props));
};
var $579d7e0176dcd680$export$2e2bcd8739ae039 = $579d7e0176dcd680$var$UniformSideNavCollection;

});


parcelRegister("5yXyq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("aogEX")).default; });

var $aogEX = parcelRequire("aogEX");

});
parcelRegister("aogEX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c268a96f0311a1f2$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $1UUq1 = parcelRequire("1UUq1");
const $c268a96f0311a1f2$var$UniformSideNavLink = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.SideNavLink), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        dataEventProps: {
            "data-product-key": "uniform",
            "data-event-component": "linkButton",
            "data-event-container": "sideNav",
            "data-event": "clicked"
        }
    }));
};
var $c268a96f0311a1f2$export$2e2bcd8739ae039 = $c268a96f0311a1f2$var$UniformSideNavLink;

});


parcelRegister("enK00", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("iDXPJ")).default; });

var $iDXPJ = parcelRequire("iDXPJ");

});
parcelRegister("iDXPJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f5fa523d60d66d8$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $axg8K = parcelRequire("axg8K");
const $0f5fa523d60d66d8$export$143e70f94b3fb702 = (providerList)=>{
    return providerList.reduce((previous, key)=>(0, $6iHNw._)((0, $7Knp0._)({}, previous), {
            [key.toLowerCase()]: key
        }), {});
};
const $0f5fa523d60d66d8$var$UniformSignUpForm = ({ socialProviders: socialProviders })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {
        Login: null,
        Social: (socialProviders === null || socialProviders === void 0 ? void 0 : socialProviders.length) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.Social), {
            providers: $0f5fa523d60d66d8$export$143e70f94b3fb702(socialProviders)
        }) : undefined
    });
};
var $0f5fa523d60d66d8$export$2e2bcd8739ae039 = $0f5fa523d60d66d8$var$UniformSignUpForm;

});


parcelRegister("adl56", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("koVMZ")).default; });

var $koVMZ = parcelRequire("koVMZ");

});
parcelRegister("koVMZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73e8cc6d4da7295e$export$2e2bcd8739ae039; });
/* single-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $aiugz = parcelRequire("aiugz");
// eslint-disable-next-line complexity
const $73e8cc6d4da7295e$var$UniformSingleTab = (props)=>{
    const { orientation: orientation = {
        mobile: "vertical"
    }, gap: gap = {
        mobile: "0"
    } } = props;
    var _gap_mobile, _gap_tablet, _ref, _gap_desktop, _ref1, _ref2;
    const gapObject = {
        mobile: (_gap_mobile = gap.mobile) !== null && _gap_mobile !== void 0 ? _gap_mobile : "0",
        // @ts-ignore
        tablet: (_ref = (_gap_tablet = gap === null || gap === void 0 ? void 0 : gap.tablet) !== null && _gap_tablet !== void 0 ? _gap_tablet : gap.mobile) !== null && _ref !== void 0 ? _ref : "0",
        // @ts-ignore
        desktop: (_ref2 = (_ref1 = (_gap_desktop = gap === null || gap === void 0 ? void 0 : gap.desktop) !== null && _gap_desktop !== void 0 ? _gap_desktop : gap === null || gap === void 0 ? void 0 : gap.tablet) !== null && _ref1 !== void 0 ? _ref1 : gap.mobile) !== null && _ref2 !== void 0 ? _ref2 : "0"
    };
    const styles = null;
    const orientationObject = {
        mobile: orientation.mobile || "vertical",
        // @ts-ignore
        tablet: orientation.tablet || orientation.mobile || "vertical",
        desktop: // @ts-ignore
        orientation.desktop || // @ts-ignore
        orientation.tablet || orientation.mobile || "vertical"
    };
    const orientationStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _4t3i1wug _1e0c1txw _zulp1a6y _19wggsi3 _pdlmxbqd",
            "_1e0c1txw _2lx22h65 _1lp71tnc _1inip4d6"
        ]),
        style: {
            "--_rkv8x9": (0, $43MIc.default)("var(--ds-space-" + gapObject.mobile + ")"),
            "--_9wptik": (0, $43MIc.default)("var(--ds-space-" + gapObject.tablet + ")"),
            "--_3wdyhk": (0, $43MIc.default)("var(--ds-space-" + gapObject.desktop + ")"),
            "--_pv2ypa": (0, $43MIc.default)(orientationObject.mobile === "horizontal" ? "row" : "column"),
            "--_dek1s0": (0, $43MIc.default)(orientationObject.tablet === "horizontal" ? "row" : "column"),
            "--_1ng513r": (0, $43MIc.default)(orientationObject.desktop === "horizontal" ? "row" : "column")
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "tabContents"
        })
    });
};
var $73e8cc6d4da7295e$export$2e2bcd8739ae039 = $73e8cc6d4da7295e$var$UniformSingleTab;

});


parcelRegister("5znlu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("gmi9U")).default; });

var $gmi9U = parcelRequire("gmi9U");

});
parcelRegister("gmi9U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e77a1f912177c1d$export$2e2bcd8739ae039; });
/* split-color-background-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");
const $0e77a1f912177c1d$var$UniformSplitColorBackgroundContainer = ({ topColor: topColor, bottomColor: bottomColor, sectionDivider: sectionDivider, extendBackgroundColor: extendBackgroundColor })=>{
    const baseStyle = null;
    const horizontalStyle = null;
    const highLeft = null;
    const highRight = null;
    const coverStyles = null;
    const sectionDividerComponent = /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswstnw _4t3iq9zu _1bsb1osq _11q7jj3k _152t1ssb _t9ec1i34 _1kt9b3bt _cfu11ule _kfgt1osq _1mp41osq _1cs8stnw _iajmidpf _1rus1utj",
            bottomColor === "transparent" && sectionDivider === "high-left" && "_mkrz7yzi",
            bottomColor === "transparent" && sectionDivider === "high-right" && "_mkrz1swj",
            sectionDivider === "high-left" && "_tgsmte2m",
            sectionDivider === "high-right" && "_tgsmrjfx"
        ]),
        style: {
            "--_nlw01g": (0, $43MIc.default)(topColor),
            "--_130a3qa": (0, $43MIc.default)(bottomColor)
        }
    });
    const extendedBackgroundColorComponent = /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswstnw _1bsbauwl _4t3i1osq _14b5zqdx _b8yq87gh _1e021ssb _t9eczr6s",
            sectionDivider && "_1kt9b3bt _cfu11ule _1mp41osq _1cs8stnw _iajmidpf _1rusjj3k _kfgt2ts6 _aetrb3bt _1ywu1ule _z0ai1osq _18postnw _1bqq1mrw _1gufidpf _1hfk1utj _1qdg2ts6",
            !sectionDivider && "_11q7eqnl"
        ]),
        style: {
            "--_nlw01g": (0, $43MIc.default)(topColor),
            "--_130a3qa": (0, $43MIc.default)(bottomColor)
        },
        children: sectionDivider && sectionDividerComponent
    });
    const slotWrapper = ({ items: items })=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_kqswh2mm"
            ]),
            children: items
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _9luy1wqb _ce5au29b _wfa7llbu",
            !extendBackgroundColor && sectionDivider && "_1kt9b3bt _cfu11ule _1mp41osq _1cs8stnw _iajmidpf _1rusjj3k _kfgt2ts6 _aetrb3bt _1ywu1ule _z0ai1osq _18postnw _1bqq1mrw _1gufidpf _1hfk1utj _1qdg2ts6",
            !extendBackgroundColor && !sectionDivider && "_11q7eqnl"
        ]),
        style: {
            "--_nlw01g": (0, $43MIc.default)(topColor),
            "--_130a3qa": (0, $43MIc.default)(bottomColor)
        },
        children: [
            sectionDivider && !extendBackgroundColor && sectionDividerComponent,
            extendBackgroundColor && extendedBackgroundColorComponent,
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                name: "component",
                wrapperComponent: sectionDivider ? slotWrapper : undefined
            })
        ]
    });
};
var $0e77a1f912177c1d$export$2e2bcd8739ae039 = $0e77a1f912177c1d$var$UniformSplitColorBackgroundContainer;

});


parcelRegister("a1e48", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5740366ed819cf5d$export$2e2bcd8739ae039; });

var $3uNzn = parcelRequire("3uNzn");
var $5740366ed819cf5d$export$2e2bcd8739ae039 = (0, $3uNzn.UniformStatsSection);

});
parcelRegister("3uNzn", function(module, exports) {

$parcel$export(module.exports, "UniformStatsSection", function () { return $6533a8d6d9a59ddf$export$a5aec67e611930b9; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $5ohHq = parcelRequire("5ohHq");

var $2p5f0 = parcelRequire("2p5f0");
const $6533a8d6d9a59ddf$export$a5aec67e611930b9 = (props)=>{
    const statsProps = {
        headerText: props.title,
        bigStat: {
            stat: props.primaryStatNumber,
            statText: props.primaryStatDescription,
            statColor: (0, $5ohHq.wacToken)("color.primary.blue"),
            statSymbol: {
                symbolCharacter: props.primaryStatSymbolCharacter,
                symbolCharacterColor: (0, $5ohHq.wacToken)("color.primary.blue")
            }
        },
        littleStats: [
            {
                stat: props.secondaryStatNumber,
                statText: props.secondaryStatDescription,
                statColor: (0, $5ohHq.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: props.secondaryStatSymbolCharacter,
                    symbolCharacterColor: (0, $5ohHq.wacToken)("color.primary.blue")
                }
            },
            {
                stat: props.tertiaryStatNumber,
                statText: props.tertiaryStatDescription,
                statColor: (0, $5ohHq.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: props.tertiaryStatSymbolCharacter,
                    symbolCharacterColor: (0, $5ohHq.wacToken)("color.primary.blue")
                }
            }
        ]
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $2p5f0.Stats), (0, $7Knp0._)({}, statsProps));
};

});


parcelRegister("qpVJw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("cn8o7")).default; });

var $cn8o7 = parcelRequire("cn8o7");

});
parcelRegister("cn8o7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cfeffa8e46137d1$export$2e2bcd8739ae039; });
/* sub-product.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");
const $6cfeffa8e46137d1$var$lightTextStyles = null;
const $6cfeffa8e46137d1$var$isDarkBackgroundColor = (color)=>{
    return color ? [
        "#1868DB",
        "#101214"
    ].includes(color) : false;
};
const $6cfeffa8e46137d1$var$UniformsubProduct = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp1b66 _1ul91l27 _1yt41giy"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_19pkrdoj _2hwxrdoj _otyrrdoj _18u0rdoj _4t3igktf _1bsbgktf"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: {
                            src: props.imageUrl,
                            alt: props.imageAlt
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_y3gn1h6o _ect4bzd7 _1wybsm30 _zg8l4jg8 _k48p1nn1 _vwz41crf",
                    $6cfeffa8e46137d1$var$isDarkBackgroundColor(props.backgroundColor) && "_syazcd5j"
                ]),
                style: {
                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: props.title
            })
        ]
    });
};
var $6cfeffa8e46137d1$export$2e2bcd8739ae039 = $6cfeffa8e46137d1$var$UniformsubProduct;

});


parcelRegister("2UtIB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("5QIwB")).default; });

var $5QIwB = parcelRequire("5QIwB");

});
parcelRegister("5QIwB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67c6a84774d31eaa$export$2e2bcd8739ae039; });
/* tabs-12-col.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");

var $asiio = parcelRequire("asiio");
parcelRequire("62VZK");
var $7CBQh = parcelRequire("7CBQh");

var $8yGg3 = parcelRequire("8yGg3");
const $67c6a84774d31eaa$var$uniformTabsContainerStyles = null;
const $67c6a84774d31eaa$var$UniformTabs12Col = ({ headerText: headerText, subHeaderText: subHeaderText, bgColor: bgColor = "bgWhite", enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false })=>{
    const renderTabs = (0, $iSvIT.useCallback)(({ items: items })=>{
        const tabsData = items.map((item, index)=>{
            var // @ts-ignore
            _item_props_children_props_data, _item_props_children_props, _item_props_children, _item_props, _params_title, _params_iconUrl;
            const params = (_item_props = item.props) === null || _item_props === void 0 ? void 0 : (_item_props_children = _item_props.children) === null || _item_props_children === void 0 ? void 0 : (_item_props_children_props = _item_props_children.props) === null || _item_props_children_props === void 0 ? void 0 : (_item_props_children_props_data = _item_props_children_props.data) === null || _item_props_children_props_data === void 0 ? void 0 : _item_props_children_props_data.parameters;
            return {
                id: `tab-${index}`,
                title: params === null || params === void 0 ? void 0 : (_params_title = params.title) === null || _params_title === void 0 ? void 0 : _params_title.value,
                iconUrl: params === null || params === void 0 ? void 0 : (_params_iconUrl = params.iconUrl) === null || _params_iconUrl === void 0 ? void 0 : _params_iconUrl.value,
                tabComponent: item
            };
        });
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7CBQh.TabsSection), {
            alignment: "center",
            tabsData: tabsData,
            tabSize: "large",
            bgColor: bgColor,
            enableRovoBorder: enableRovoBorder,
            enableResponsiveTabSize: enableResponsiveTabSize
        });
    }, [
        bgColor,
        enableRovoBorder,
        enableResponsiveTabSize
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp1jfw _1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: [
            (headerText || subHeaderText) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $8yGg3.Row), {
                layout: "8",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $asiio.ContentBlock), {
                    title: headerText,
                    text: subHeaderText,
                    titleAs: "h2",
                    alignment: "center"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                name: "tabs",
                wrapperComponent: renderTabs
            })
        ]
    });
};
var $67c6a84774d31eaa$export$2e2bcd8739ae039 = $67c6a84774d31eaa$var$UniformTabs12Col;

});


parcelRegister("1kxv4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("gRQBn")).default; });

var $gRQBn = parcelRequire("gRQBn");

});
parcelRegister("gRQBn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2efe52b47d57fc66$export$2e2bcd8739ae039; });
/* tabs-8-col.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");

var $asiio = parcelRequire("asiio");
parcelRequire("62VZK");
var $7CBQh = parcelRequire("7CBQh");
const $2efe52b47d57fc66$var$uniformTabsContainerStyles = null;
const $2efe52b47d57fc66$var$UniformTabs8Col = ({ headerText: headerText, subHeaderText: subHeaderText, bgColor: bgColor = "bgWhite" })=>{
    const renderTabs = ({ items: items })=>{
        const tabsData = items.map((item, index)=>{
            var _item_props_children_props_data_parameters_title, _item_props_children_props_data_parameters, _item_props_children_props_data, _item_props_children_props, _item_props_children, _item_props;
            return {
                id: `tab-${index}`,
                // @ts-ignore
                title: (_item_props = item.props) === null || _item_props === void 0 ? void 0 : (_item_props_children = _item_props.children) === null || _item_props_children === void 0 ? void 0 : (_item_props_children_props = _item_props_children.props) === null || _item_props_children_props === void 0 ? void 0 : (_item_props_children_props_data = _item_props_children_props.data) === null || _item_props_children_props_data === void 0 ? void 0 : (_item_props_children_props_data_parameters = _item_props_children_props_data.parameters) === null || _item_props_children_props_data_parameters === void 0 ? void 0 : (_item_props_children_props_data_parameters_title = _item_props_children_props_data_parameters.title) === null || _item_props_children_props_data_parameters_title === void 0 ? void 0 : _item_props_children_props_data_parameters_title.value,
                tabComponent: item
            };
        });
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7CBQh.TabsSection), {
            alignment: "start",
            tabsData: tabsData,
            tabSize: "small",
            bgColor: bgColor
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp1jfw _1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: [
            (headerText || subHeaderText) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $asiio.ContentBlock), {
                title: headerText,
                titleAs: "h2",
                alignment: "start",
                text: subHeaderText
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
                name: "tabs",
                wrapperComponent: renderTabs
            })
        ]
    });
};
var $2efe52b47d57fc66$export$2e2bcd8739ae039 = $2efe52b47d57fc66$var$UniformTabs8Col;

});


parcelRegister("5wZPk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("k6qJQ")).default; });

var $k6qJQ = parcelRequire("k6qJQ");

});
parcelRegister("k6qJQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1d8ed81ddc31042$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iWo90 = parcelRequire("iWo90");
const $d1d8ed81ddc31042$var$UniformTemplateCta = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iWo90.TemplateCta), (0, $7Knp0._)({}, props));
};
var $d1d8ed81ddc31042$export$2e2bcd8739ae039 = $d1d8ed81ddc31042$var$UniformTemplateCta;

});


parcelRegister("diZQT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("h3wk5")).default; });

var $h3wk5 = parcelRequire("h3wk5");

});
parcelRegister("h3wk5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9034dfb6d5e5a2d2$export$2e2bcd8739ae039; });
// @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $gPr7r = parcelRequire("gPr7r");

var $gkV6l = parcelRequire("gkV6l");

var $cX9ng = parcelRequire("cX9ng");

var $knAj5 = parcelRequire("knAj5");

var $lbVpk = parcelRequire("lbVpk");

var $3FBn4 = parcelRequire("3FBn4");
const $9034dfb6d5e5a2d2$var$UniformTemplateModalButton = (props)=>{
    const { text: text, productKey: productKey, templateName: templateName, pluginModuleKey: pluginModuleKey, href: href } = props;
    const { openModalForTemplate: openModalForTemplate } = (0, $gkV6l.useSiteSelectorContext)();
    const { setTemplate: setTemplate } = (0, $gPr7r.useProductTemplateContext)();
    // AIS = Atlassian Identity Service - provides user's existing Atlassian sites
    const aisSites = (0, $knAj5.useSitesWithCurrentProduct)();
    const locale = (0, $3FBn4.useLocale)();
    const localizedSignupHref = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup");
    const [buttonProps, setButtonProps] = (0, $iSvIT.useState)({
        href: $9034dfb6d5e5a2d2$var$getDefaultHref({
            productKey: productKey,
            locale: locale
        })
    });
    const fullStargateProductKey = productKey === "jira-service-management" ? "jira-servicedesk.ondemand" : `${productKey}.ondemand`;
    (0, $iSvIT.useEffect)(()=>{
        if (pluginModuleKey && productKey) {
            const templateData = {
                templateId: pluginModuleKey,
                templateName: templateName,
                productKey: fullStargateProductKey
            };
            setTemplate(templateData);
            var _aisSites_map;
            // Get site URLs for the current product
            const siteUrls = (_aisSites_map = aisSites === null || aisSites === void 0 ? void 0 : aisSites.map((site)=>site.url)) !== null && _aisSites_map !== void 0 ? _aisSites_map : [];
            // Determine action based on user's sites
            const action = (0, $cX9ng.getTemplateAction)({
                templateData: templateData,
                siteUrls: siteUrls,
                localizedSignupHref: localizedSignupHref
            });
            if (action.type === "modal") setButtonProps({
                onClick: (event)=>{
                    event.stopPropagation();
                    event.preventDefault();
                    openModalForTemplate(templateData);
                }
            });
            else setButtonProps({
                href: action.href
            });
        } else if (href) setButtonProps({
            href: (0, $3FBn4.getLocalizedHref)({
                href: href,
                locale: locale
            })
        });
        return ()=>{
            setTemplate(null);
        };
    }, [
        openModalForTemplate,
        templateName,
        pluginModuleKey,
        fullStargateProductKey,
        href,
        productKey,
        locale,
        aisSites,
        localizedSignupHref,
        setTemplate
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lbVpk.Button), (0, $6iHNw._)((0, $7Knp0._)({}, buttonProps), {
        children: text
    }));
};
function $9034dfb6d5e5a2d2$var$getDefaultHref(args) {
    const { locale: locale, productKey: productKey } = args;
    if (productKey === "jira-software") return (0, $3FBn4.getLocalizedHref)({
        href: "/try/cloud/signup?bundle=jira&edition=free",
        locale: locale
    });
    if (productKey === "confluence") return (0, $3FBn4.getLocalizedHref)({
        href: "/try/cloud/signup?bundle=confluence&edition=free",
        locale: locale
    });
    if (productKey === "jira-service-management") return (0, $3FBn4.getLocalizedHref)({
        href: "/try/cloud/signup?bundle=jira-service-management&edition=free",
        locale: locale
    });
    return "";
}
var $9034dfb6d5e5a2d2$export$2e2bcd8739ae039 = $9034dfb6d5e5a2d2$var$UniformTemplateModalButton;

});
parcelRegister("cX9ng", function(module, exports) {

$parcel$export(module.exports, "getTemplateAction", function () { return $9286df2b38d515c7$export$4935503ffd4d8306; });

var $i8kxh = parcelRequire("i8kxh");

var $hG0Y6 = parcelRequire("hG0Y6");
const $9286df2b38d515c7$export$4935503ffd4d8306 = (params)=>{
    const { templateData: templateData, siteUrls: siteUrls, redirectToIdentity: redirectToIdentity, internalLinkAfterIdentity: internalLinkAfterIdentity, localizedSignupHref: localizedSignupHref } = params;
    // If user has existing sites, show modal
    if (siteUrls.length > 0) return {
        type: "modal",
        templateData: templateData
    };
    // Otherwise, redirect directly
    const href = $9286df2b38d515c7$var$getRedirectHref({
        templateData: templateData,
        redirectToIdentity: redirectToIdentity,
        internalLinkAfterIdentity: internalLinkAfterIdentity,
        localizedSignupHref: localizedSignupHref
    });
    return {
        type: "redirect",
        href: href
    };
};
const $9286df2b38d515c7$var$getRedirectHref = (params)=>{
    const { templateData: templateData, redirectToIdentity: redirectToIdentity, internalLinkAfterIdentity: internalLinkAfterIdentity, localizedSignupHref: localizedSignupHref } = params;
    const { templateId: templateId, templateName: templateName } = templateData;
    if (redirectToIdentity && internalLinkAfterIdentity) return $9286df2b38d515c7$var$getIdentityUrl(templateId, templateName, internalLinkAfterIdentity);
    return $9286df2b38d515c7$var$getCloudSignupUrl(templateData, localizedSignupHref, internalLinkAfterIdentity);
};
const $9286df2b38d515c7$var$isJiraProduct = (productKey)=>{
    return [
        (0, $i8kxh.ProductKeys).JIRA_CORE,
        (0, $i8kxh.ProductKeys).JIRA_SERVICE_DESK,
        (0, $i8kxh.ProductKeys).JIRA_SOFTWARE,
        (0, $i8kxh.ProductKeys).JIRA_PRODUCT_DISCOVERY
    ].includes(productKey);
};
const $9286df2b38d515c7$var$getCloudSignupUrl = (templateData, localizedSignupHref, internalLinkAfterIdentity)=>{
    const { templateId: templateId, templateName: templateName, productKey: productKey } = templateData;
    let url = `${localizedSignupHref}?product=${productKey}&templateId=${templateId}&edition=free`;
    if ($9286df2b38d515c7$var$isJiraProduct(productKey)) {
        const urlParams = new URLSearchParams(location.search);
        if (!urlParams.has("p")) urlParams.append("templateModal", templateId);
        url += `&continue=${encodeURIComponent(`${location.href}?${urlParams.toString()}`)}`;
    } else if (productKey === (0, $i8kxh.ProductKeys).CONFLUENCE) {
        const continueUrl = `${(0, $hG0Y6.getWacIntegrationUrl)()}${internalLinkAfterIdentity !== null && internalLinkAfterIdentity !== void 0 ? internalLinkAfterIdentity : ""}?templateId=${templateId + encodeURIComponent("&templateName=" + encodeURIComponent(templateName))}`;
        url = `${url}&continue=${encodeURIComponent(continueUrl)}`;
    }
    return url;
};
const $9286df2b38d515c7$var$getIdentityUrl = (templateId, templateName, internalLinkAfterIdentity)=>{
    const loginUrl = `${(0, $hG0Y6.getIdentityBaseUrl)()}/login?`;
    const continueUrl = `${(0, $hG0Y6.getWacIntegrationUrl)()}${internalLinkAfterIdentity}?templateName=${encodeURIComponent(templateName)}&templateId=${templateId}`;
    return `${loginUrl}&continue=${encodeURIComponent(continueUrl)}`;
};

});



parcelRegister("5hZGW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("c7WmW")).default; });

var $c7WmW = parcelRequire("c7WmW");

});
parcelRegister("c7WmW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c9e25ac92daa05c$export$2e2bcd8739ae039; });
/* template-preview.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $4VhzM = parcelRequire("4VhzM");

var $5T6ho = parcelRequire("5T6ho");
const $5c9e25ac92daa05c$var$UniformTemplatePreview = ({ templatePreview: templatePreview, templateType: templateType })=>{
    if (!templatePreview) return null;
    var _templatePreview_file_url, _templatePreview_description;
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_y3gn1h6o _kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5T6ho.UniformTemplatePreviewWindow), {
            url: (_templatePreview_file_url = templatePreview.file.url) !== null && _templatePreview_file_url !== void 0 ? _templatePreview_file_url : "",
            alt: (_templatePreview_description = templatePreview.description) !== null && _templatePreview_description !== void 0 ? _templatePreview_description : "",
            templateType: templateType || (0, $4VhzM.TemplateType).Page
        })
    });
};
const $5c9e25ac92daa05c$var$templatePreviewSection = null;
var $5c9e25ac92daa05c$export$2e2bcd8739ae039 = $5c9e25ac92daa05c$var$UniformTemplatePreview;

});
parcelRegister("5T6ho", function(module, exports) {

$parcel$export(module.exports, "UniformTemplatePreviewWindow", function () { return $02ee184ca6f63762$export$7796399069f4fd6e; });
/* template-preview-window.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $lHjhp = parcelRequire("lHjhp");

var $4VhzM = parcelRequire("4VhzM");

var $5ohHq = parcelRequire("5ohHq");

var $kqt8V = parcelRequire("kqt8V");

var $ik2oV = parcelRequire("ik2oV");
const $02ee184ca6f63762$var$previewTopBar = null;
const $02ee184ca6f63762$var$previewBarDot = null;
const $02ee184ca6f63762$var$previewImage = null;
const $02ee184ca6f63762$export$7796399069f4fd6e = ({ url: url, alt: alt, templateType: templateType })=>{
    const templatePreview = null;
    const previewScreenshot = null;
    const whiteboardPreviewWrapper = null;
    const zoomControls = null;
    const zoomControl = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_p12f1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug"
        ]),
        children: templateType === (0, $4VhzM.TemplateType).Whiteboard ? /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1yt41ano _4t3ipxbi _vchhusvi _1s1g1b66 _5fbc1b66 _bfhkvejh"
                    ]),
                    style: {
                        "--_nl5by5": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue1000"))
                    },
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_4t3i1gwv _18m91wug _bfhkcd5j _1yxn1b66 _1ein1b66 _19it1k0a _11qbbn52 _12fm15vq",
                        "_80om1qgj _ou2u1osq"
                    ]),
                    style: {
                        "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                        "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lHjhp.TransformWrapper), {
                        children: ({ zoomIn: zoomIn, zoomOut: zoomOut })=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $lHjhp.TransformComponent), {
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                                            src: url,
                                            alt: alt,
                                            className: (0, $esG4f.default)([
                                                "_1bsb1osq _p12f1osq"
                                            ])
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c1txw _zulpu2gc _kqswstnw _u7copxbi _rjxppxbi"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                                onClick: ()=>zoomIn(),
                                                "aria-label": "Zoom In",
                                                className: (0, $esG4f.default)([
                                                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _11q7glyw _80omtlke"
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kqt8V.ZoomIn), {
                                                    size: "16"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                                onClick: ()=>zoomOut(),
                                                "aria-label": "Zoom Out",
                                                className: (0, $esG4f.default)([
                                                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _11q7glyw _80omtlke"
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ik2oV.ZoomOut), {
                                                    size: "16"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1yt41ano _4t3ipxbi _vchhusvi _1s1g1b66 _5fbc1b66 _bfhkvejh"
                    ]),
                    style: {
                        "--_nl5by5": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue1000"))
                    },
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_12l21b66 _1bsb14y2 _4t3i14y2 _bfhkcd5j _2rko1ssb"
                            ]),
                            style: {
                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_4t3i1gwv _18m91wug _bfhkcd5j _1yxn1b66 _1ein1b66 _19it1k0a _11qbbn52 _12fm15vq"
                    ]),
                    style: {
                        "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                        "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                        src: url,
                        alt: alt,
                        className: (0, $esG4f.default)([
                            "_1bsb1osq _p12f1osq"
                        ])
                    })
                })
            ]
        })
    });
};

});



parcelRegister("6NpvY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("1GDqm")).default; });

var $1GDqm = parcelRequire("1GDqm");

});
parcelRegister("1GDqm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23620155247a97b9$export$2e2bcd8739ae039; });
/* text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $4XrxY = parcelRequire("4XrxY");

var $4jHZw = parcelRequire("4jHZw");
const $23620155247a97b9$var$UniformText = ({ text: text, style: style = "body-lg", alignment: alignment = "left", headingLevel: headingLevel })=>{
    const [textRef, textColor] = (0, $4jHZw.useStylePropertyVariableValueFromParent)("--dxp-container-text-color");
    const alignmentStyle = null;
    const boldStyling = null;
    const resetMargin = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
            ref: textRef,
            className: (0, $esG4f.default)([
                style.includes("bold") && "_3dt51fw0",
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                "_y3gnoues",
                style
            ]),
            role: headingLevel ? `heading` : undefined,
            "aria-level": headingLevel,
            style: (0, $6iHNw._)((0, $7Knp0._)({}, textColor ? {
                color: textColor
            } : undefined), {
                "--_1v0xqnb": (0, $43MIc.default)(alignment)
            }),
            children: text
        })
    });
};
var $23620155247a97b9$export$2e2bcd8739ae039 = $23620155247a97b9$var$UniformText;

});


parcelRegister("85qcB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("9SZQE")).default; });

var $9SZQE = parcelRequire("9SZQE");

});
parcelRegister("9SZQE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b10d693545bcf6f$export$2e2bcd8739ae039; });
/* text-with-icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("6NpvY");
var $1GDqm = parcelRequire("1GDqm");

var $734nn = parcelRequire("734nn");
const $6b10d693545bcf6f$export$69f8fbc89c62ee2a = "body-md";
const $6b10d693545bcf6f$export$8cea64591eaafc6 = (props)=>{
    const { text: text, style: style = $6b10d693545bcf6f$export$69f8fbc89c62ee2a, icon: icon } = props;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _zulpftgi"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    "data-testid": "TextWithIcon-icon",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $734nn.Icon), {
                        name: icon,
                        size: style === "body-sm" ? "small" : "medium"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    className: (0, $esG4f.default)([
                        style === "body-sm" && "_1pfht94y",
                        style === "body-md" && "_1pfh1l7b"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1GDqm.default), {
                        text: text,
                        style: style
                    })
                })
            ]
        })
    });
};
const $6b10d693545bcf6f$var$wrapperCss = null;
const $6b10d693545bcf6f$var$smTextCss = null;
const $6b10d693545bcf6f$var$mdTextCss = null;
var $6b10d693545bcf6f$export$2e2bcd8739ae039 = $6b10d693545bcf6f$export$8cea64591eaafc6;

});
parcelRegister("734nn", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $ec5ba767a2e09822$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $1QA99 = parcelRequire("1QA99");
const $ec5ba767a2e09822$export$f04a61298a47a40f = (props)=>{
    const { name: name, size: size } = props;
    if (!name) return /*#__PURE__*/ (0, $loA2J.jsx)($ec5ba767a2e09822$var$GlyphIcon, {
        size: size,
        name: "TaskInProgressIcon"
    });
    // @ts-ignore
    const { version: version } = (0, $1QA99.iconMapping)[name];
    if (version === "glyph") return /*#__PURE__*/ (0, $loA2J.jsx)($ec5ba767a2e09822$var$GlyphIcon, (0, $7Knp0._)({}, props));
    return /*#__PURE__*/ (0, $loA2J.jsx)($ec5ba767a2e09822$var$CoreIcon, (0, $7Knp0._)({}, props));
};
const $ec5ba767a2e09822$var$iconWrapperSmallCss = null;
const $ec5ba767a2e09822$var$iconWrapperMediumCss = null;
const $ec5ba767a2e09822$var$CoreIcon = (props)=>{
    const { name: name, size: size } = props; // @ts-ignore
    const BaseIcon = (0, $1QA99.iconMapping)[name].component;
    return /*#__PURE__*/ (0, $loA2J.jsx)("span" // @ts-ignore
    , {
        className: (0, $esG4f.default)([
            size === "small" && "_1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o",
            size === "medium" && "_1bsbzwfg _4t3izwfg _1e0c1txw _1bah1h6o _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)(BaseIcon, {
            icon: name
        })
    });
};
const $ec5ba767a2e09822$var$GlyphIcon = (props)=>{
    const { name: name, size: size } = props; // @ts-ignore
    const BaseGlyphIcon = (0, $1QA99.iconMapping)[name].component;
    return /*#__PURE__*/ (0, $loA2J.jsx)("span" // @ts-ignore
    , {
        className: (0, $esG4f.default)([
            size === "small" && "_1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o",
            size === "small" && "_17521o4j",
            size === "medium" && "_1bsbzwfg _4t3izwfg _1e0c1txw _1bah1h6o _4cvr1h6o",
            size === "medium" && "_1q511lya _17521txs"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)(BaseGlyphIcon, {
            icon: name,
            size: size
        })
    });
};
const $ec5ba767a2e09822$var$glyphIconWrapperSmallCss = null;
const $ec5ba767a2e09822$var$glyphIconWrapperMediumCss = null;

});
parcelRegister("1QA99", function(module, exports) {

$parcel$export(module.exports, "iconMapping", function () { return $ee9cc442b3519108$export$82f701de2810d5a7; });

var $4mM75 = parcelRequire("4mM75");

var $gg1Wi = parcelRequire("gg1Wi");

var $dpNdQ = parcelRequire("dpNdQ");

var $7DwKW = parcelRequire("7DwKW");

var $7fq8b = parcelRequire("7fq8b");

var $lPup9 = parcelRequire("lPup9");

var $kqqsh = parcelRequire("kqqsh");

var $fgomw = parcelRequire("fgomw");

var $5Rv2O = parcelRequire("5Rv2O");

var $4TbFb = parcelRequire("4TbFb");

var $7M1uQ = parcelRequire("7M1uQ");

var $3Xdhp = parcelRequire("3Xdhp");

var $jUWXi = parcelRequire("jUWXi");

var $6Whls = parcelRequire("6Whls");

var $74nrU = parcelRequire("74nrU");

var $7lagR = parcelRequire("7lagR");

var $2RsRU = parcelRequire("2RsRU");

var $hlDQ4 = parcelRequire("hlDQ4");

var $c8hkI = parcelRequire("c8hkI");

var $ctYD4 = parcelRequire("ctYD4");

var $jcATf = parcelRequire("jcATf");

var $20L2t = parcelRequire("20L2t");

var $aRydc = parcelRequire("aRydc");

var $j25Ho = parcelRequire("j25Ho");

var $cm6I6 = parcelRequire("cm6I6");

var $llWxg = parcelRequire("llWxg");

var $jwsof = parcelRequire("jwsof");

var $wQpQg = parcelRequire("wQpQg");

var $iocYh = parcelRequire("iocYh");

var $3SkcQ = parcelRequire("3SkcQ");

var $fI3Vg = parcelRequire("fI3Vg");

var $89oGH = parcelRequire("89oGH");

var $267hL = parcelRequire("267hL");

var $bNqWX = parcelRequire("bNqWX");

var $3UpUT = parcelRequire("3UpUT");

var $hieSB = parcelRequire("hieSB");

var $fJ5Su = parcelRequire("fJ5Su");

var $bRs7t = parcelRequire("bRs7t");

var $iy4Sr = parcelRequire("iy4Sr");

var $e5LHD = parcelRequire("e5LHD");

var $aLqNf = parcelRequire("aLqNf");

var $7Zpdo = parcelRequire("7Zpdo");

var $ft8Zd = parcelRequire("ft8Zd");

var $g0xEi = parcelRequire("g0xEi");

var $1BHq9 = parcelRequire("1BHq9");

var $fkwrS = parcelRequire("fkwrS");

var $gbUnT = parcelRequire("gbUnT");

var $jDXvh = parcelRequire("jDXvh");

var $ko7jr = parcelRequire("ko7jr");

var $30lzE = parcelRequire("30lzE");

var $lWAak = parcelRequire("lWAak");

var $509Ny = parcelRequire("509Ny");

var $8P0uP = parcelRequire("8P0uP");

var $cDp2C = parcelRequire("cDp2C");

var $g8hkf = parcelRequire("g8hkf");

var $9PjA9 = parcelRequire("9PjA9");

var $ggvlr = parcelRequire("ggvlr");

var $eH5ui = parcelRequire("eH5ui");

var $guk0p = parcelRequire("guk0p");

var $6PLjX = parcelRequire("6PLjX");

var $7ZFBY = parcelRequire("7ZFBY");

var $elfku = parcelRequire("elfku");

var $iSfb0 = parcelRequire("iSfb0");

var $4w8Rb = parcelRequire("4w8Rb");

var $kuew8 = parcelRequire("kuew8");
const $ee9cc442b3519108$export$82f701de2810d5a7 = {
    TimelineIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($guk0p))),
        version: "core"
    },
    CalendarIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7M1uQ))),
        version: "core"
    },
    WarningIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7ZFBY))),
        version: "core"
    },
    TeamsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($eH5ui))),
        version: "core"
    },
    ChangesIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3Xdhp))),
        version: "core"
    },
    ChartBarIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($jUWXi))),
        version: "core"
    },
    BriefcaseIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($5Rv2O))),
        version: "core"
    },
    AutomationIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7DwKW))),
        version: "core"
    },
    BugIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($4TbFb))),
        version: "core"
    },
    DepartmentIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($20L2t))),
        version: "core"
    },
    EyeOpenIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($cm6I6))),
        version: "core"
    },
    BranchIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fgomw))),
        version: "core"
    },
    PhoneIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fkwrS))),
        version: "core"
    },
    CommentIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ctYD4))),
        version: "core"
    },
    Page: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($aLqNf))),
        version: "core"
    },
    PersonAddIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($g0xEi))),
        version: "core"
    },
    PersonAddedIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($1BHq9))),
        version: "core"
    },
    LobbyBellIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($bNqWX))),
        version: "core"
    },
    InformationIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fI3Vg))),
        version: "core"
    },
    PriorityMajorIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($jDXvh))),
        version: "core"
    },
    OfficeBuildingIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($iy4Sr))),
        version: "core"
    },
    ChartTrendIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7lagR))),
        version: "core"
    },
    CheckboxCheckedIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($c8hkI))),
        version: "core"
    },
    GoalIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3SkcQ))),
        version: "core"
    },
    ScreenIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($lWAak))),
        version: "core"
    },
    BookWithBookmarkIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($kqqsh))),
        version: "core"
    },
    PagesIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7Zpdo))),
        version: "core"
    },
    ChartMatrixIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($74nrU))),
        version: "core"
    },
    RoadmapIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($30lzE))),
        version: "core"
    },
    ShowMoreVerticalIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($8P0uP))),
        version: "core"
    },
    TagIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($9PjA9))),
        version: "core"
    },
    MarketplaceIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($hieSB))),
        version: "core"
    },
    AngleBracketsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gg1Wi))),
        version: "core"
    },
    ProjectIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ko7jr))),
        version: "core"
    },
    BoardIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($lPup9))),
        version: "core"
    },
    MegaphoneIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fJ5Su))),
        version: "core"
    },
    TransitionIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6PLjX))),
        version: "core"
    },
    StarStarredIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($g8hkf))),
        version: "core"
    },
    EmojiIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($j25Ho))),
        version: "core"
    },
    TaskInProgressIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ggvlr))),
        version: "core"
    },
    FormsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($iocYh))),
        version: "core"
    },
    FilesIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($wQpQg))),
        version: "core"
    },
    FileIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($jwsof))),
        version: "core"
    },
    ListBulletedIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($89oGH))),
        version: "core"
    },
    SmartLinkListIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($cDp2C))),
        version: "core"
    },
    MagicWandIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3UpUT))),
        version: "core"
    },
    OperationsIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($e5LHD))),
        version: "core"
    },
    DecisionIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($jcATf))),
        version: "core"
    },
    FeedbackIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($llWxg))),
        version: "core"
    },
    ObjectiveIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($bRs7t))),
        version: "core"
    },
    PresenterModeIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gbUnT))),
        version: "core"
    },
    BacklogIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7fq8b))),
        version: "core"
    },
    SearchIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($509Ny))),
        version: "core"
    },
    EditIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($aRydc))),
        version: "core"
    },
    CheckMarkIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($hlDQ4))),
        version: "core"
    },
    CheckCircleIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($2RsRU))),
        version: "core"
    },
    ListChecklistIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($267hL))),
        version: "core"
    },
    ArchiveBoxIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($dpNdQ))),
        version: "core"
    },
    AlertIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($4mM75))),
        version: "core"
    },
    RoadmapsPlanIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($4w8Rb))),
        version: "core"
    },
    PeopleGroupIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ft8Zd))),
        version: "core"
    },
    BrowserExtensionIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($elfku))),
        version: "core"
    },
    SyncIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($kuew8))),
        version: "core"
    },
    NotepadIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($iSfb0))),
        version: "core"
    },
    ChartBubbleIcon: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($6Whls))),
        version: "core"
    }
};

});
parcelRegister("gg1Wi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd5fa50b89111176$var$_react = $bd5fa50b89111176$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $bd5fa50b89111176$var$_baseNew = $bd5fa50b89111176$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $bd5fa50b89111176$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bd5fa50b89111176$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $bd5fa50b89111176$var$_react.default.createElement($bd5fa50b89111176$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$bd5fa50b89111176$var$AngleBracketsIcon.displayName = "AngleBracketsIcon";
var $bd5fa50b89111176$var$_default = module.exports.default = $bd5fa50b89111176$var$AngleBracketsIcon;

});

parcelRegister("dpNdQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53af402aec64299fbaefa11fd3d04c88>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c43caaf2d5893de$var$_react = $9c43caaf2d5893de$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $9c43caaf2d5893de$var$_baseNew = $9c43caaf2d5893de$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $9c43caaf2d5893de$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArchiveBox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: archiving pages, storage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c43caaf2d5893de$var$ArchiveBoxIcon = (props)=>/*#__PURE__*/ $9c43caaf2d5893de$var$_react.default.createElement($9c43caaf2d5893de$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v5h-1v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6H1zm2.5 5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V6zm10-1.5h-11v-2h11zm-3 4.5h-5V7.5h5z" clip-rule="evenodd"/>`
    }, props));
$9c43caaf2d5893de$var$ArchiveBoxIcon.displayName = "ArchiveBoxIcon";
var $9c43caaf2d5893de$var$_default = module.exports.default = $9c43caaf2d5893de$var$ArchiveBoxIcon;

});

parcelRegister("fgomw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1cb3f795038bad9$var$_react = $b1cb3f795038bad9$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b1cb3f795038bad9$var$_baseNew = $b1cb3f795038bad9$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b1cb3f795038bad9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b1cb3f795038bad9$var$BranchIcon = (props)=>/*#__PURE__*/ $b1cb3f795038bad9$var$_react.default.createElement($b1cb3f795038bad9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$b1cb3f795038bad9$var$BranchIcon.displayName = "BranchIcon";
var $b1cb3f795038bad9$var$_default = module.exports.default = $b1cb3f795038bad9$var$BranchIcon;

});

parcelRegister("5Rv2O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e2b10cb2fb36d0ad7bfa02e0b0408651>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4449fbbad119e5d2$var$_react = $4449fbbad119e5d2$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $4449fbbad119e5d2$var$_baseNew = $4449fbbad119e5d2$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $4449fbbad119e5d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Briefcase".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Job title in Atlas, Operations in JSM.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4449fbbad119e5d2$var$BriefcaseIcon = (props)=>/*#__PURE__*/ $4449fbbad119e5d2$var$_react.default.createElement($4449fbbad119e5d2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 2.5a.5.5 0 0 0-.5.5v1h5V3a.5.5 0 0 0-.5-.5zM12 4V3a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v1H3a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 5.5a.5.5 0 0 0-.5.5v2h11V6a.5.5 0 0 0-.5-.5zm10.5 4H8.75V11h-1.5V9.5H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$4449fbbad119e5d2$var$BriefcaseIcon.displayName = "BriefcaseIcon";
var $4449fbbad119e5d2$var$_default = module.exports.default = $4449fbbad119e5d2$var$BriefcaseIcon;

});

parcelRegister("74nrU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d0119e14b14178352097aaf532e33e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $525b189de5fa6099$var$_react = $525b189de5fa6099$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $525b189de5fa6099$var$_baseNew = $525b189de5fa6099$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $525b189de5fa6099$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartMatrix".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Matrix view in in JPD, and other matrix charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $525b189de5fa6099$var$ChartMatrixIcon = (props)=>/*#__PURE__*/ $525b189de5fa6099$var$_react.default.createElement($525b189de5fa6099$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8 4.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M13.25 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-5.5 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2m5.5-9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m8 3.5a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5M10.5 8A1.75 1.75 0 1 1 14 8a1.75 1.75 0 0 1-3.5 0m-5 2.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$525b189de5fa6099$var$ChartMatrixIcon.displayName = "ChartMatrixIcon";
var $525b189de5fa6099$var$_default = module.exports.default = $525b189de5fa6099$var$ChartMatrixIcon;

});

parcelRegister("iocYh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6cd595d4ec67af9dd83acc02e35c9f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d63487b8d7103f43$var$_react = $d63487b8d7103f43$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $d63487b8d7103f43$var$_baseNew = $d63487b8d7103f43$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $d63487b8d7103f43$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Form".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Represents forms across Atlassian products, including Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d63487b8d7103f43$var$FormIcon = (props)=>/*#__PURE__*/ $d63487b8d7103f43$var$_react.default.createElement($d63487b8d7103f43$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 1.5H1V0h6zM1 3.875c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75C15 6.385 14.384 7 13.625 7H2.375C1.615 7 1 6.384 1 5.625zM2.5 4v1.5h11V4zM7 10.5H1V9h6zm-6 2.375c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75c0 .76-.616 1.375-1.375 1.375H2.375C1.615 16 1 15.384 1 14.625zM2.5 13v1.5h11V13z" clip-rule="evenodd"/>`
    }, props));
$d63487b8d7103f43$var$FormIcon.displayName = "FormIcon";
var $d63487b8d7103f43$var$_default = module.exports.default = $d63487b8d7103f43$var$FormIcon;

});

parcelRegister("fI3Vg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d43a7428702b82788297fb999fe29f0a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6fe0201439438b3$var$_react = $b6fe0201439438b3$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b6fe0201439438b3$var$_baseNew = $b6fe0201439438b3$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b6fe0201439438b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b6fe0201439438b3$var$InformationIcon = (props)=>/*#__PURE__*/ $b6fe0201439438b3$var$_react.default.createElement($b6fe0201439438b3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$b6fe0201439438b3$var$InformationIcon.displayName = "InformationIcon";
var $b6fe0201439438b3$var$_default = module.exports.default = $b6fe0201439438b3$var$InformationIcon;

});

parcelRegister("267hL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::481d1ea8ad85e9d7b0bddff8ba9b16d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1871cb1583e370a3$var$_react = $1871cb1583e370a3$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $1871cb1583e370a3$var$_baseNew = $1871cb1583e370a3$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $1871cb1583e370a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListChecklist".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: Checklist, 'Requirement' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1871cb1583e370a3$var$ListChecklistIcon = (props)=>/*#__PURE__*/ $1871cb1583e370a3$var$_react.default.createElement($1871cb1583e370a3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.59 9.97-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07-1.37-2.12 1.26-.81.81 1.25 2.33-2.95zm0-7.5-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07L.01 4.04l1.26-.81.81 1.25 2.33-2.95zM16 11v1.5H7V11zm0-7.5V5H7V3.5z"/>`
    }, props));
$1871cb1583e370a3$var$ListChecklistIcon.displayName = "ListChecklistIcon";
var $1871cb1583e370a3$var$_default = module.exports.default = $1871cb1583e370a3$var$ListChecklistIcon;

});

parcelRegister("3UpUT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b57d69a7e6f53846886bde82f36883e5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2d8ab48e24800f67$var$_react = $2d8ab48e24800f67$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $2d8ab48e24800f67$var$_baseNew = $2d8ab48e24800f67$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $2d8ab48e24800f67$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "MagicWand".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2d8ab48e24800f67$var$MagicWandIcon = (props)=>/*#__PURE__*/ $2d8ab48e24800f67$var$_react.default.createElement($2d8ab48e24800f67$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9.027 3.911a1.376 1.376 0 0 1 1.841-.094l.105.094 1.116 1.116a1.376 1.376 0 0 1 0 1.946l-8.616 8.616a1.376 1.376 0 0 1-1.946 0L.411 14.473a1.376 1.376 0 0 1 0-1.946zM1.561 13.5l.939.94L7.938 9 7 8.061zm13.431-4.067-1.06 1.06-1.415-1.414 1.061-1.06zM8.061 7l.938.938L10.939 6l-.94-.94zM16 5v1.5h-2V5zM7.982 2.422l-1.06 1.06-1.414-1.414 1.06-1.06zm7.01-.354-1.414 1.414-1.06-1.06 1.414-1.414zM11 0v2H9.5V0z"/>`
    }, props));
$2d8ab48e24800f67$var$MagicWandIcon.displayName = "MagicWandIcon";
var $2d8ab48e24800f67$var$_default = module.exports.default = $2d8ab48e24800f67$var$MagicWandIcon;

});

parcelRegister("hieSB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ed07350d21c7e2ad94ff4198361d506>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c96fa8ea1d90bb95$var$_react = $c96fa8ea1d90bb95$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $c96fa8ea1d90bb95$var$_baseNew = $c96fa8ea1d90bb95$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $c96fa8ea1d90bb95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Marketplace".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Marketplace.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c96fa8ea1d90bb95$var$MarketplaceIcon = (props)=>/*#__PURE__*/ $c96fa8ea1d90bb95$var$_react.default.createElement($c96fa8ea1d90bb95$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.789 1.513A.75.75 0 0 1 2.5 1h11a.75.75 0 0 1 .711.513l1.502 4.5a.8.8 0 0 1 .038.237A3.08 3.08 0 0 1 14 9.032V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.031A3.08 3.08 0 0 1 .25 6.25q0-.12.038-.237zM3.5 9.329V13a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9.33a3.08 3.08 0 0 1-2.166-1.064A3.08 3.08 0 0 1 8 9.334a3.08 3.08 0 0 1-2.334-1.068A3.08 3.08 0 0 1 3.5 9.329M4.916 6.25v.03a1.584 1.584 0 0 1-3.163.08l.037-.11zm1.5.038.005-.038h3.158l.004.038a1.584 1.584 0 0 1-3.166 0M9.413 4.75H6.588l.25-2.25h2.324zm1.672 1.5a1.584 1.584 0 0 0 3.164.11l-.037-.11zm2.626-1.5h-2.788l-.25-2.25h2.288zM5.33 2.5l-.25 2.25H2.29l.75-2.25z" clip-rule="evenodd"/>`
    }, props));
$c96fa8ea1d90bb95$var$MarketplaceIcon.displayName = "MarketplaceIcon";
var $c96fa8ea1d90bb95$var$_default = module.exports.default = $c96fa8ea1d90bb95$var$MarketplaceIcon;

});

parcelRegister("bRs7t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6209776ef69c56f26af2970fd840a919>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a2a74e45c0701ee$var$_react = $8a2a74e45c0701ee$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $8a2a74e45c0701ee$var$_baseNew = $8a2a74e45c0701ee$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $8a2a74e45c0701ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Objective".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for objectives.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a2a74e45c0701ee$var$ObjectiveIcon = (props)=>/*#__PURE__*/ $8a2a74e45c0701ee$var$_react.default.createElement($8a2a74e45c0701ee$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.422.02a.75.75 0 0 1 .54.493l.38 1.144 1.145.381a.75.75 0 0 1 .293 1.242l-2 2a.75.75 0 0 1-.53.22h-1.69L8.03 9.03 6.97 7.97l3.53-3.53V2.75a.75.75 0 0 1 .22-.53l2-2a.75.75 0 0 1 .702-.2M12 4h.94l.922-.922-.35-.116a.75.75 0 0 1-.473-.475l-.117-.349-.922.923zM8 1.5A6.5 6.5 0 1 0 14.5 8H16a8 8 0 1 1-8-8zM8 5a3 3 0 1 0 3 3h1.5A4.5 4.5 0 1 1 8 3.5z" clip-rule="evenodd"/>`
    }, props));
$8a2a74e45c0701ee$var$ObjectiveIcon.displayName = "ObjectiveIcon";
var $8a2a74e45c0701ee$var$_default = module.exports.default = $8a2a74e45c0701ee$var$ObjectiveIcon;

});

parcelRegister("e5LHD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30e149500cf1a05a183dbc43511b361c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a426891697dd54be$var$_react = $a426891697dd54be$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $a426891697dd54be$var$_baseNew = $a426891697dd54be$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $a426891697dd54be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Operations".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for IT Operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a426891697dd54be$var$OperationsIcon = (props)=>/*#__PURE__*/ $a426891697dd54be$var$_react.default.createElement($a426891697dd54be$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.036 2.904A6.501 6.501 0 1 0 8 14.5V16a8 8 0 1 1 5.657-13.657l.53.53L8.28 8.78 7.22 7.72l2.304-2.305A3.001 3.001 0 1 0 8 11v1.5a4.5 4.5 0 1 1 2.608-8.168z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M14.58 4.862a.75.75 0 0 1 .959.454l.008.025a.75.75 0 1 1-1.414.499l-.007-.02a.75.75 0 0 1 .454-.958m-2.798 2.573a.75.75 0 0 1 .713.786l-.001.015-.001.014a.75.75 0 1 1-1.498-.083v-.01l.001-.01a.75.75 0 0 1 .786-.712m3.497.184a.75.75 0 0 1 .71.787v.026a.75.75 0 1 1-1.498-.081V8.33a.75.75 0 0 1 .788-.711m-4.205 2.656a.75.75 0 0 1-.052 1.06l-.022.019a.75.75 0 1 1-1-1.118l.015-.013a.75.75 0 0 1 1.059.052m3.799.16a.75.75 0 0 1 .355.999l-.011.023a.75.75 0 0 1-1.353-.649l.01-.019a.75.75 0 0 1 .999-.355m-1.457 2.442a.75.75 0 0 1-.053 1.06l-.02.017a.75.75 0 0 1-1.001-1.117l.015-.014a.75.75 0 0 1 1.06.054m-2.278 1.703a.75.75 0 0 1-.454.959l-.025.008a.75.75 0 0 1-.499-1.414l.02-.007a.75.75 0 0 1 .958.454" clip-rule="evenodd"/>`
    }, props));
$a426891697dd54be$var$OperationsIcon.displayName = "OperationsIcon";
var $a426891697dd54be$var$_default = module.exports.default = $a426891697dd54be$var$OperationsIcon;

});

parcelRegister("gbUnT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::975f3556f302c98e53e9a5c512ff1020>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc996930445c07e8$var$_react = $bc996930445c07e8$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $bc996930445c07e8$var$_baseNew = $bc996930445c07e8$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $bc996930445c07e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PresenterMode".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for presenter mode in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc996930445c07e8$var$PresenterModeIcon = (props)=>/*#__PURE__*/ $bc996930445c07e8$var$_react.default.createElement($bc996930445c07e8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.909 2.5a2.409 2.409 0 0 0-1.054 4.576l-.657 1.348a3.909 3.909 0 1 1 5.226-5.226l-1.348.657A2.41 2.41 0 0 0 4.909 2.5m-.19 2.22a.75.75 0 0 1 .786-.175l9 3.25a.75.75 0 0 1 .02 1.403l-3.822 1.505-1.505 3.822a.75.75 0 0 1-1.403-.02l-3.25-9a.75.75 0 0 1 .175-.785M6.5 6.498l2.032 5.628.896-2.276a.75.75 0 0 1 .423-.423l2.276-.896z" clip-rule="evenodd"/>`
    }, props));
$bc996930445c07e8$var$PresenterModeIcon.displayName = "PresenterModeIcon";
var $bc996930445c07e8$var$_default = module.exports.default = $bc996930445c07e8$var$PresenterModeIcon;

});

parcelRegister("jDXvh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff5f3689a11c3468e5139786a8e64251>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e4cfd1038e117e57$var$_react = $e4cfd1038e117e57$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $e4cfd1038e117e57$var$_baseNew = $e4cfd1038e117e57$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $e4cfd1038e117e57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityMajor".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for major work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e4cfd1038e117e57$var$PriorityMajorIcon = (props)=>/*#__PURE__*/ $e4cfd1038e117e57$var$_react.default.createElement($e4cfd1038e117e57$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.913 4.75-5.5-3.625a.75.75 0 0 0-.826 0l-5.5 3.625L2.913 6 8 2.65 13.087 6zm0 4.5-5.5-3.625a.75.75 0 0 0-.826 0l-5.5 3.625.826 1.252L8 7.149l5.087 3.353zm0 4.5-5.5-3.626a.75.75 0 0 0-.826 0l-5.5 3.625.826 1.252L8 11.65l5.087 3.353z"/>`
    }, props));
$e4cfd1038e117e57$var$PriorityMajorIcon.displayName = "PriorityMajorIcon";
var $e4cfd1038e117e57$var$_default = module.exports.default = $e4cfd1038e117e57$var$PriorityMajorIcon;

});

parcelRegister("lWAak", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1698552166bfef93121ec02f2fff1081>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff9b1182de1c9206$var$_react = $ff9b1182de1c9206$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $ff9b1182de1c9206$var$_baseNew = $ff9b1182de1c9206$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $ff9b1182de1c9206$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Screen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ff9b1182de1c9206$var$ScreenIcon = (props)=>/*#__PURE__*/ $ff9b1182de1c9206$var$_react.default.createElement($ff9b1182de1c9206$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.75v1.5H12V15H4v-1.5h3.25V12H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$ff9b1182de1c9206$var$ScreenIcon.displayName = "ScreenIcon";
var $ff9b1182de1c9206$var$_default = module.exports.default = $ff9b1182de1c9206$var$ScreenIcon;

});

parcelRegister("8P0uP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::02df73cd5dddff20d82e48f58fe7ce92>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66c378ab0381dd7f$var$_react = $66c378ab0381dd7f$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $66c378ab0381dd7f$var$_baseNew = $66c378ab0381dd7f$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $66c378ab0381dd7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus, traditionally on mobile.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66c378ab0381dd7f$var$ShowMoreVerticalIcon = (props)=>/*#__PURE__*/ $66c378ab0381dd7f$var$_react.default.createElement($66c378ab0381dd7f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.5 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$66c378ab0381dd7f$var$ShowMoreVerticalIcon.displayName = "ShowMoreVerticalIcon";
var $66c378ab0381dd7f$var$_default = module.exports.default = $66c378ab0381dd7f$var$ShowMoreVerticalIcon;

});

parcelRegister("cDp2C", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d0cf5658da3b79d5f876ad9c272a691a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $932c8d3be2b6f2b7$var$_react = $932c8d3be2b6f2b7$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $932c8d3be2b6f2b7$var$_baseNew = $932c8d3be2b6f2b7$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $932c8d3be2b6f2b7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkList".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing Smart link embedded link lists.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $932c8d3be2b6f2b7$var$SmartLinkListIcon = (props)=>/*#__PURE__*/ $932c8d3be2b6f2b7$var$_react.default.createElement($932c8d3be2b6f2b7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm2.5 3H4V4h1.5zm6.5 0H7V4h5zM5.5 8.75H4v-1.5h1.5zm6.5 0H7v-1.5h5zM5.5 12H4v-1.5h1.5zm6.5 0H7v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$932c8d3be2b6f2b7$var$SmartLinkListIcon.displayName = "SmartLinkListIcon";
var $932c8d3be2b6f2b7$var$_default = module.exports.default = $932c8d3be2b6f2b7$var$SmartLinkListIcon;

});

parcelRegister("9PjA9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::338651941b03ec38a528c6808ae2ffcd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $727811146868953b$var$_react = $727811146868953b$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $727811146868953b$var$_baseNew = $727811146868953b$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $727811146868953b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tag".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $727811146868953b$var$TagIcon = (props)=>/*#__PURE__*/ $727811146868953b$var$_react.default.createElement($727811146868953b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/><path fill="currentcolor" fill-rule="evenodd" d="M9.286 1a3.25 3.25 0 0 0-2.299.952L1.604 7.336a2 2 0 0 0 0 2.828l4.232 4.232a2 2 0 0 0 2.828 0l5.384-5.383A3.25 3.25 0 0 0 15 6.714V3a2 2 0 0 0-2-2zM8.048 3.013A1.75 1.75 0 0 1 9.286 2.5H13a.5.5 0 0 1 .5.5v3.714c0 .465-.184.91-.513 1.238l-5.383 5.384a.5.5 0 0 1-.708 0L2.664 9.104a.5.5 0 0 1 0-.708z" clip-rule="evenodd"/>`
    }, props));
$727811146868953b$var$TagIcon.displayName = "TagIcon";
var $727811146868953b$var$_default = module.exports.default = $727811146868953b$var$TagIcon;

});

parcelRegister("ggvlr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::350d68f25c9b4e9b7a6f8128f373fbcc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd767466e2ef74ca$var$_react = $bd767466e2ef74ca$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $bd767466e2ef74ca$var$_baseNew = $bd767466e2ef74ca$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $bd767466e2ef74ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TaskInProgress".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for in progress task status. Used in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bd767466e2ef74ca$var$TaskInProgressIcon = (props)=>/*#__PURE__*/ $bd767466e2ef74ca$var$_react.default.createElement($bd767466e2ef74ca$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.543 7.25h7.646L6.97 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H1.542a6.501 6.501 0 1 0 0-1.5M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8" clip-rule="evenodd"/>`
    }, props));
$bd767466e2ef74ca$var$TaskInProgressIcon.displayName = "TaskInProgressIcon";
var $bd767466e2ef74ca$var$_default = module.exports.default = $bd767466e2ef74ca$var$TaskInProgressIcon;

});

parcelRegister("6PLjX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b20915105f9f06f3ef89ee9497af0ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f9c367122dee778$var$_react = $4f9c367122dee778$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $4f9c367122dee778$var$_baseNew = $4f9c367122dee778$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $4f9c367122dee778$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Transition".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for transitions in Analytics.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4f9c367122dee778$var$TransitionIcon = (props)=>/*#__PURE__*/ $4f9c367122dee778$var$_react.default.createElement($4f9c367122dee778$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.75 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.122 0a2.251 2.251 0 1 1 0 1.5h-.816c-.586 0-1.062.476-1.062 1.063v5.875A2.563 2.563 0 0 1 6.188 13.5h-.816a2.25 2.25 0 1 1 0-1.5h.816c.586 0 1.062-.476 1.062-1.062V5.062A2.56 2.56 0 0 1 9.813 2.5zM3.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$4f9c367122dee778$var$TransitionIcon.displayName = "TransitionIcon";
var $4f9c367122dee778$var$_default = module.exports.default = $4f9c367122dee778$var$TransitionIcon;

});





parcelRegister("lOAhp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce01dca626f76d5f$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $h2e6B = parcelRequire("h2e6B");

var $hZiVF = parcelRequire("hZiVF");
const $ce01dca626f76d5f$export$d9468344d3651243 = (body)=>{
    if (!body) return {
        title: null,
        details: null,
        asset: null,
        embedLink: null
    };
    const { topicintroduction: topicintroduction } = body;
    function getRichText(richText) {
        if (typeof richText === "string") return richText;
        return (0, $h2e6B.documentToHtmlString)(richText);
    }
    var _topicintroduction_topicIntroductionTitleExternal, _getRichText, _topicintroduction_embedLink;
    const formattedBody = {
        title: (_topicintroduction_topicIntroductionTitleExternal = topicintroduction === null || topicintroduction === void 0 ? void 0 : topicintroduction.topicIntroductionTitleExternal) !== null && _topicintroduction_topicIntroductionTitleExternal !== void 0 ? _topicintroduction_topicIntroductionTitleExternal : null,
        details: (_getRichText = getRichText(topicintroduction === null || topicintroduction === void 0 ? void 0 : topicintroduction.topicIntroductionDetails)) !== null && _getRichText !== void 0 ? _getRichText : null,
        asset: (()=>{
            var _topicintroduction_topicIntroductionAsset;
            const formattedAsset = $ce01dca626f76d5f$var$formatAsset(topicintroduction === null || topicintroduction === void 0 ? void 0 : (_topicintroduction_topicIntroductionAsset = topicintroduction.topicIntroductionAsset) === null || _topicintroduction_topicIntroductionAsset === void 0 ? void 0 : _topicintroduction_topicIntroductionAsset[0]);
            return formattedAsset ? [
                formattedAsset
            ] : null;
        })(),
        embedLink: (_topicintroduction_embedLink = topicintroduction === null || topicintroduction === void 0 ? void 0 : topicintroduction.embedLink) !== null && _topicintroduction_embedLink !== void 0 ? _topicintroduction_embedLink : null
    };
    return formattedBody;
};
// eslint-disable-next-line complexity
const $ce01dca626f76d5f$var$formatAsset = (asset)=>{
    var _fields_file_details, _fields_file, _fields_file1, _fields_file_image, _fields_file2, _fields_image, _fields_file3, _fields_file4;
    if (!(asset === null || asset === void 0 ? void 0 : asset.fields)) return undefined;
    const { fields: fields } = asset;
    var _fields_file_fileName, _fields_file_image_height, _fields_image_width, _fields_description, _fields_file_contentType;
    return {
        name: fields.title,
        size: (_fields_file = fields.file) === null || _fields_file === void 0 ? void 0 : (_fields_file_details = _fields_file.details) === null || _fields_file_details === void 0 ? void 0 : _fields_file_details.size,
        fileName: (_fields_file_fileName = (_fields_file1 = fields.file) === null || _fields_file1 === void 0 ? void 0 : _fields_file1.fileName) !== null && _fields_file_fileName !== void 0 ? _fields_file_fileName : null,
        height: (_fields_file_image_height = (_fields_file2 = fields.file) === null || _fields_file2 === void 0 ? void 0 : (_fields_file_image = _fields_file2.image) === null || _fields_file_image === void 0 ? void 0 : _fields_file_image.height) !== null && _fields_file_image_height !== void 0 ? _fields_file_image_height : null,
        width: (_fields_image_width = (_fields_image = fields.image) === null || _fields_image === void 0 ? void 0 : _fields_image.width) !== null && _fields_image_width !== void 0 ? _fields_image_width : null,
        url: (_fields_file3 = fields.file) === null || _fields_file3 === void 0 ? void 0 : _fields_file3.url,
        description: (_fields_description = fields.description) !== null && _fields_description !== void 0 ? _fields_description : null,
        contentType: (_fields_file_contentType = (_fields_file4 = fields.file) === null || _fields_file4 === void 0 ? void 0 : _fields_file4.contentType) !== null && _fields_file_contentType !== void 0 ? _fields_file_contentType : null
    };
};
const $ce01dca626f76d5f$var$UniformTopicIntroductionContent = (props)=>{
    const topicIntroduction = (0, $iSvIT.useMemo)(()=>$ce01dca626f76d5f$export$d9468344d3651243(props), [
        props
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hZiVF.TopicIntroductionContent), {
        topicIntroduction: topicIntroduction
    });
};
var $ce01dca626f76d5f$export$2e2bcd8739ae039 = $ce01dca626f76d5f$var$UniformTopicIntroductionContent;

});
parcelRegister("hZiVF", function(module, exports) {

$parcel$export(module.exports, "TopicIntroductionContent", function () { return $ec014be53000938a$export$c79bf2a9fdb4b5c2; });
/* topic-introduction-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $h2e6B = parcelRequire("h2e6B");

var $6O6jV = parcelRequire("6O6jV");

var $krNyQ = parcelRequire("krNyQ");
function $ec014be53000938a$var$getRichText(richText) {
    if (typeof richText === "string") return richText;
    return (0, $h2e6B.documentToHtmlString)(richText);
}
const $ec014be53000938a$export$c79bf2a9fdb4b5c2 = ({ topicIntroduction: topicIntroduction })=>{
    var _topicIntroduction_asset;
    var _topicIntroduction_title, _topicIntroduction_details, _topicIntroduction_embedLink, _topicIntroduction_title1, _topicIntroduction_asset_;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "agile-hub-introduction-content",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulpv47k"
        ]),
        children: [
            (topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.title) && /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_6rthze3t"
                ]),
                children: topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.title
            }),
            (topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.details) && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rthv47k"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                    name: (_topicIntroduction_title = topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.title) !== null && _topicIntroduction_title !== void 0 ? _topicIntroduction_title : "",
                    text: $ec014be53000938a$var$getRichText((_topicIntroduction_details = topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.details) !== null && _topicIntroduction_details !== void 0 ? _topicIntroduction_details : "")
                })
            }),
            (topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.embedLink) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $6O6jV.AgileVideo), {
                embedLink: (_topicIntroduction_embedLink = topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.embedLink) !== null && _topicIntroduction_embedLink !== void 0 ? _topicIntroduction_embedLink : "",
                title: (_topicIntroduction_title1 = topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.title) !== null && _topicIntroduction_title1 !== void 0 ? _topicIntroduction_title1 : "",
                thumbnail: (_topicIntroduction_asset_ = topicIntroduction === null || topicIntroduction === void 0 ? void 0 : (_topicIntroduction_asset = topicIntroduction.asset) === null || _topicIntroduction_asset === void 0 ? void 0 : _topicIntroduction_asset[0]) !== null && _topicIntroduction_asset_ !== void 0 ? _topicIntroduction_asset_ : null
            })
        ]
    });
};

});


parcelRegister("aDVDR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b437973572e74d97$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $h2e6B = parcelRequire("h2e6B");

var $kEwPg = parcelRequire("kEwPg");
const $b437973572e74d97$export$d9468344d3651243 = (body)=>{
    if (!body) return {
        tutorialIntroductionName: null,
        tutorialIntroductionDetails: null,
        tutorialIntroductionAsset: null,
        embedLink: null
    };
    const { tutorialintroduction: tutorialintroduction } = body;
    function getRichText(richText) {
        if (typeof richText === "string") return richText;
        return (0, $h2e6B.documentToHtmlString)(richText);
    }
    var _tutorialintroduction_tutorialIntroductionTitleExternal, _getRichText, _formatAsset, _tutorialintroduction_embedLink;
    const formattedBody = {
        tutorialIntroductionName: (_tutorialintroduction_tutorialIntroductionTitleExternal = tutorialintroduction === null || tutorialintroduction === void 0 ? void 0 : tutorialintroduction.tutorialIntroductionTitleExternal) !== null && _tutorialintroduction_tutorialIntroductionTitleExternal !== void 0 ? _tutorialintroduction_tutorialIntroductionTitleExternal : null,
        tutorialIntroductionDetails: (_getRichText = getRichText(tutorialintroduction === null || tutorialintroduction === void 0 ? void 0 : tutorialintroduction.tutorialIntroductionDetails)) !== null && _getRichText !== void 0 ? _getRichText : null,
        tutorialIntroductionAsset: (_formatAsset = $b437973572e74d97$var$formatAsset(tutorialintroduction === null || tutorialintroduction === void 0 ? void 0 : tutorialintroduction.tutorialIntroductionAsset)) !== null && _formatAsset !== void 0 ? _formatAsset : null,
        embedLink: (_tutorialintroduction_embedLink = tutorialintroduction === null || tutorialintroduction === void 0 ? void 0 : tutorialintroduction.embedLink) !== null && _tutorialintroduction_embedLink !== void 0 ? _tutorialintroduction_embedLink : null
    };
    return formattedBody;
};
// eslint-disable-next-line complexity
const $b437973572e74d97$var$formatAsset = (asset)=>{
    var _fields_file_details, _fields_file, _fields_file1, _fields_file_image, _fields_file2, _fields_image, _fields_file3, _fields_file4;
    if (!(asset === null || asset === void 0 ? void 0 : asset.fields)) return undefined;
    const { fields: fields } = asset;
    var _fields_file_fileName, _fields_file_image_height, _fields_image_width, _fields_description, _fields_file_contentType;
    return {
        name: fields.title,
        size: (_fields_file = fields.file) === null || _fields_file === void 0 ? void 0 : (_fields_file_details = _fields_file.details) === null || _fields_file_details === void 0 ? void 0 : _fields_file_details.size,
        fileName: (_fields_file_fileName = (_fields_file1 = fields.file) === null || _fields_file1 === void 0 ? void 0 : _fields_file1.fileName) !== null && _fields_file_fileName !== void 0 ? _fields_file_fileName : null,
        height: (_fields_file_image_height = (_fields_file2 = fields.file) === null || _fields_file2 === void 0 ? void 0 : (_fields_file_image = _fields_file2.image) === null || _fields_file_image === void 0 ? void 0 : _fields_file_image.height) !== null && _fields_file_image_height !== void 0 ? _fields_file_image_height : null,
        width: (_fields_image_width = (_fields_image = fields.image) === null || _fields_image === void 0 ? void 0 : _fields_image.width) !== null && _fields_image_width !== void 0 ? _fields_image_width : null,
        url: (_fields_file3 = fields.file) === null || _fields_file3 === void 0 ? void 0 : _fields_file3.url,
        description: (_fields_description = fields.description) !== null && _fields_description !== void 0 ? _fields_description : null,
        contentType: (_fields_file_contentType = (_fields_file4 = fields.file) === null || _fields_file4 === void 0 ? void 0 : _fields_file4.contentType) !== null && _fields_file_contentType !== void 0 ? _fields_file_contentType : null
    };
};
const $b437973572e74d97$var$UniformTutorialIntroductionContent = (props)=>{
    const tutorialIntroduction = (0, $iSvIT.useMemo)(()=>$b437973572e74d97$export$d9468344d3651243(props), [
        props
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $kEwPg.TutorialIntroductionContent), {
        tutorialIntroduction: tutorialIntroduction
    });
};
var $b437973572e74d97$export$2e2bcd8739ae039 = $b437973572e74d97$var$UniformTutorialIntroductionContent;

});
parcelRegister("kEwPg", function(module, exports) {

$parcel$export(module.exports, "TutorialIntroductionContent", function () { return $4bcc864d3cf1b6b7$export$8d53a13d50897e0d; });
/* tutorial-introduction-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $h2e6B = parcelRequire("h2e6B");

var $6O6jV = parcelRequire("6O6jV");

var $krNyQ = parcelRequire("krNyQ");
function $4bcc864d3cf1b6b7$var$getRichText(richText) {
    if (typeof richText === "string") return richText;
    return (0, $h2e6B.documentToHtmlString)(richText);
}
const $4bcc864d3cf1b6b7$export$8d53a13d50897e0d = ({ tutorialIntroduction: tutorialIntroduction })=>{
    var _tutorialIntroduction_tutorialIntroductionName, _tutorialIntroduction_tutorialIntroductionDetails, _tutorialIntroduction_embedLink, _tutorialIntroduction_tutorialIntroductionName1;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "agile-hub-introduction-content",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulpv47k"
        ]),
        children: [
            (tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.tutorialIntroductionName) && /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_6rthze3t"
                ]),
                children: tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.tutorialIntroductionName
            }),
            (tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.tutorialIntroductionDetails) && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rthv47k"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                    name: (_tutorialIntroduction_tutorialIntroductionName = tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.tutorialIntroductionName) !== null && _tutorialIntroduction_tutorialIntroductionName !== void 0 ? _tutorialIntroduction_tutorialIntroductionName : "",
                    text: $4bcc864d3cf1b6b7$var$getRichText((_tutorialIntroduction_tutorialIntroductionDetails = tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.tutorialIntroductionDetails) !== null && _tutorialIntroduction_tutorialIntroductionDetails !== void 0 ? _tutorialIntroduction_tutorialIntroductionDetails : "")
                })
            }),
            (tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.embedLink) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $6O6jV.AgileVideo), {
                embedLink: (_tutorialIntroduction_embedLink = tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.embedLink) !== null && _tutorialIntroduction_embedLink !== void 0 ? _tutorialIntroduction_embedLink : "",
                title: (_tutorialIntroduction_tutorialIntroductionName1 = tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.tutorialIntroductionName) !== null && _tutorialIntroduction_tutorialIntroductionName1 !== void 0 ? _tutorialIntroduction_tutorialIntroductionName1 : "",
                thumbnail: tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.tutorialIntroductionAsset
            })
        ]
    });
};

});


parcelRegister("jzDAp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("4d4f5")).default; });

var $4d4f5 = parcelRequire("4d4f5");
 // export type { UniformVariantProps } from "./src/variant";

});
parcelRegister("4d4f5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e222d054d5504f7$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");
const $1e222d054d5504f7$var$UniformVariant = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: "content"
    });
};
var $1e222d054d5504f7$export$2e2bcd8739ae039 = $1e222d054d5504f7$var$UniformVariant;

});


parcelRegister("3Z0Az", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("bR2Mn")).default; });

var $bR2Mn = parcelRequire("bR2Mn");

});
parcelRegister("bR2Mn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50c82a39185e8ede$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");
const $50c82a39185e8ede$var$UniformVariantContainer = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: "content"
    });
var $50c82a39185e8ede$export$2e2bcd8739ae039 = $50c82a39185e8ede$var$UniformVariantContainer;

});


parcelRegister("d6DCu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("3gOU8")).default; });

var $3gOU8 = parcelRequire("3gOU8");

});
parcelRegister("3gOU8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fd90b3956d2a9be$export$2e2bcd8739ae039; });
/* video.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $gF60T = parcelRequire("gF60T");

var $7ShLR = parcelRequire("7ShLR");

var $5ohHq = parcelRequire("5ohHq");
const $9fd90b3956d2a9be$var$UniformVideo = ({ src: src, alt: alt = "", poster: poster, desktopHeight: desktopHeight, tabletHeight: tabletHeight, mobileHeight: mobileHeight, disableAutoplay: disableAutoplay = false, showVideoControls: showVideoControls = false })=>{
    const videoRef = (0, $iSvIT.useRef)(null);
    const [isPlaying, setIsPlaying] = (0, $iSvIT.useState)(false);
    const [hasError, setHasError] = (0, $iSvIT.useState)(false); // Play from beginning when in viewport, pause when out
    (0, $iSvIT.useEffect)(()=>{
        const video = videoRef.current;
        if (!video || disableAutoplay) return;
        const observer = new IntersectionObserver(([entry])=>{
            if (entry && entry.isIntersecting && !hasError) {
                video.currentTime = 0; // Always start from beginning
                video.play().catch(()=>{
                // Ignore error likely due to autoplay restrictions or browser power saving
                });
            } else video.pause();
        }, {
            threshold: 0.5
        });
        observer.observe(video);
        return ()=>{
            observer.disconnect();
        };
    }, [
        hasError,
        disableAutoplay
    ]);
    const togglePlay = ()=>{
        if (videoRef.current && !hasError) {
            if (isPlaying) {
                videoRef.current.pause();
                setIsPlaying(false);
            } else videoRef.current.play().then(()=>{
                setIsPlaying(true);
            }).catch(()=>{
                // Ignore error likely due to autoplay restrictions or browser power saving
                setIsPlaying(false);
            });
        }
    };
    const heightCss = null;
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("video", {
                ref: videoRef,
                playsInline: true,
                muted: !disableAutoplay && !showVideoControls,
                preload: "auto",
                poster: poster,
                controls: showVideoControls,
                "aria-label": alt,
                "aria-hidden": alt === "",
                onPlay: ()=>setIsPlaying(true),
                onPause: ()=>setIsPlaying(false),
                onEnded: ()=>setIsPlaying(false),
                onError: ()=>setHasError(true),
                onLoadStart: ()=>setHasError(false),
                className: (0, $esG4f.default)([
                    "_165tbekw _1vkha7f3 _tnruirba"
                ]),
                style: {
                    maxWidth: "100%",
                    "--_1frmj6s": (0, $43MIc.default)(desktopHeight ? desktopHeight : "auto"),
                    "--_1cta8t7": (0, $43MIc.default)(tabletHeight ? tabletHeight : "auto"),
                    "--_k89wwe": (0, $43MIc.default)(mobileHeight ? mobileHeight : "auto")
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                        src: src,
                        type: "video/mp4"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("track", {
                        kind: "captions"
                    }),
                    "Video not supported."
                ]
            }),
            !hasError && !showVideoControls && /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                onClick: togglePlay,
                className: (0, $esG4f.default)([
                    "_kqswstnw _u7cou2gc _rjxpu2gc _1yt412x7 _4t3i1ady _1bsb1ady _bfhk1j28 _19itglyw _2rko1osq _d0altlke"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_4t3izwfg _1bsbzwfg _bfhkxv17 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr3mmjq _1tjq121t"
                    ]),
                    style: {
                        "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400")),
                        "--_1ayut75": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light500")),
                        "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                    },
                    children: isPlaying ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gF60T))), {
                        label: intl.formatMessage({
                            id: "uniform-video.pause",
                            defaultMessage: "Pause"
                        })
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7ShLR))), {
                        label: intl.formatMessage({
                            id: "uniform-video.play",
                            defaultMessage: "Play"
                        })
                    })
                })
            })
        ]
    });
};
const $9fd90b3956d2a9be$var$controlButtonCss = null;
const $9fd90b3956d2a9be$var$buttonCircleCss = null;
var $9fd90b3956d2a9be$export$2e2bcd8739ae039 = $9fd90b3956d2a9be$var$UniformVideo;

});


parcelRegister("fWJHK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("ci6CH")).default; });

var $ci6CH = parcelRequire("ci6CH");

});
parcelRegister("ci6CH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d68eb2ecbe345d06$export$2e2bcd8739ae039; });
/* video-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $2bAHw = parcelRequire("2bAHw");

var $f6qj2 = parcelRequire("f6qj2");

var $gF60T = parcelRequire("gF60T");

var $7ShLR = parcelRequire("7ShLR");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("haYnf");
var $gVN7C = parcelRequire("gVN7C");
const $d68eb2ecbe345d06$var$UniformVideoCarousel = ({ videoCarousel: videoCarousel, flattenData: flattenData = true })=>{
    const videoCarouselData = flattenData ? (0, $2bAHw.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    videoCarousel) : videoCarousel;
    const videoRefs = (0, $iSvIT.useRef)([]);
    const videoContainerRef = (0, $iSvIT.useRef)(null);
    const [current, setCurrent] = (0, $iSvIT.useState)(-1);
    const currentRef = (0, $iSvIT.useRef)(current);
    const [playing, setPlaying] = (0, $iSvIT.useState)(true);
    const [durations, setDurations] = (0, $iSvIT.useState)(Array(videoCarouselData.length).fill(0));
    const [fillBarResetKey, setFillBarResetKey] = (0, $iSvIT.useState)(0); // @ts-ignore
    const prevViewportWidth = (0, $iSvIT.useRef)(typeof window !== "undefined" ? window.innerWidth : 0);
    const [viewportWidth, setViewportWidth] = (0, $iSvIT.useState)(typeof window !== "undefined" ? window.innerWidth : 0);
    (0, $iSvIT.useEffect)(()=>{
        currentRef.current = current;
    }, [
        current
    ]); // On-load
    (0, $iSvIT.useEffect)(()=>{
        let hasRun = false;
        let observer = null;
        let wheelTimeout = null;
        let keyTimeout = null;
        const containerRefValue = videoContainerRef.current;
        function runEffectLogic() {
            if (hasRun) return;
            hasRun = true;
            const handleFirstInteraction = ()=>{
                if (currentRef.current === -1) setCurrent(0);
            };
            const handleFirstClick = ()=>{
                handleFirstInteraction();
                enableScrollEvents();
            }; // Scroll blocking
            function preventDefault(e) {
                e.preventDefault();
                handleFirstInteraction();
            }
            function onWheel(e) {
                preventDefault(e);
                if (wheelTimeout) clearTimeout(wheelTimeout);
                wheelTimeout = setTimeout(enableScrollEvents, 20);
            }
            function onKeyDown(e) {
                preventDefault(e);
                if (keyTimeout) clearTimeout(keyTimeout);
                keyTimeout = setTimeout(enableScrollEvents, 20);
            }
            function onTouchMove(e) {
                preventDefault(e);
            }
            function onTouchEnd() {
                enableScrollEvents();
            }
            function blockScrollEvents() {
                window.addEventListener("wheel", onWheel, {
                    passive: false
                });
                window.addEventListener("touchmove", onTouchMove, {
                    passive: false
                });
                window.addEventListener("touchend", onTouchEnd, {
                    passive: false
                });
                window.addEventListener("touchcancel", onTouchEnd, {
                    passive: false
                });
                window.addEventListener("keydown", onKeyDown, {
                    passive: false
                });
            }
            function enableScrollEvents() {
                window.removeEventListener("wheel", onWheel);
                window.removeEventListener("touchmove", onTouchMove);
                window.removeEventListener("touchend", onTouchEnd);
                window.removeEventListener("touchcancel", onTouchEnd);
                window.removeEventListener("keydown", onKeyDown);
                if (wheelTimeout) clearTimeout(wheelTimeout);
                if (keyTimeout) clearTimeout(keyTimeout);
            }
            blockScrollEvents(); // Video container click interactions
            const container = videoContainerRef.current;
            if (container) container.addEventListener("pointerdown", handleFirstClick, {
                once: true
            });
             // Video durations
            videoCarouselData.forEach((_, idx)=>{
                const video = videoRefs.current[idx];
                if (!video) return;
                if (video.readyState >= 1) setDurations((durs)=>{
                    const copy = [
                        ...durs
                    ];
                    copy[idx] = video.duration;
                    return copy;
                });
                else video.onloadedmetadata = ()=>{
                    setDurations((durs)=>{
                        const copy = [
                            ...durs
                        ];
                        copy[idx] = video.duration;
                        return copy;
                    });
                };
            }); // Cleanup
            return ()=>{
                enableScrollEvents();
                if (container) {
                    container.removeEventListener("pointerdown", handleFirstInteraction);
                    container.removeEventListener("keydown", handleFirstInteraction);
                }
            };
        }
        // Intersection Observer setup
        observer = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry && entry.isIntersecting) {
                runEffectLogic();
                observer === null || observer === void 0 ? void 0 : observer.disconnect();
            }
        }, {
            threshold: 0.1
        });
        if (containerRefValue) observer.observe(containerRefValue);
         // Cleanup
        return ()=>{
            if (observer && containerRefValue) observer.unobserve(containerRefValue);
        };
    }, [
        videoCarouselData
    ]);
    // Play next video on end, looping
    const handleEnded = ()=>{
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        setCurrent((prev)=>(prev + 1) % videoCarouselData.length);
    }; // Pause/play current video
    (0, $iSvIT.useEffect)(()=>{
        if (current === -1) return;
        const video = videoRefs.current[current];
        if (video) {
            if (playing) {
                if (video.ended) video.currentTime = 0;
                 // eslint-disable-next-line @typescript-eslint/no-empty-function
                video.play().catch(()=>{});
            } else video.pause();
        }
    }, [
        playing,
        current
    ]); // Pause/play toggle
    const togglePlay = ()=>{
        setPlaying((p)=>!p);
    }; // Jump to a specific video and start from beginning
    const handleTeamClick = (idx)=>{
        if (idx === current) return;
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        setCurrent(idx);
        setPlaying(true);
    };
    const currentDuration = durations[current] || 10; // Responsive asset type
    (0, $iSvIT.useEffect)(()=>{
        let resizeTimeout;
        const breakpoints = [
            768,
            1024
        ]; // Store previous width outside the handler so it persists
        const prevViewportWidth = {
            current: window.innerWidth
        };
        function crossedBreakpoint(prev, curr) {
            return breakpoints.some((bp)=>prev < bp && curr >= bp || prev >= bp && curr < bp);
        }
        const handleResizeEnd = ()=>{
            const currWidth = window.innerWidth;
            if (crossedBreakpoint(prevViewportWidth.current, currWidth)) setFillBarResetKey((k)=>k + 1);
            prevViewportWidth.current = currWidth;
        };
        const handleResize = ()=>{
            setViewportWidth(window.innerWidth);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
            resizeTimeout = window.setTimeout(handleResizeEnd, 300);
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
        };
    }, []);
    const assetType = viewportWidth >= 1024 ? "desktop" : viewportWidth >= 768 ? "tablet" : "mobile";
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1reo15vq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                ref: videoContainerRef,
                className: (0, $esG4f.default)([
                    "_kqswh2mm _1e021ssb _t9eczr6s",
                    "_1bsb1osq _4t3ieo28 _1vkh124j _tnru1jje"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1bsb1osq _4t3i1osq _1e0c1ule _y3gn1h6o _kqswh2mm _1reo15vq _18m915vq"
                    ]),
                    children: videoCarouselData.map(({ team: team, mobileVideoSrc: mobileVideoSrc, tabletVideoSrc: tabletVideoSrc, desktopVideoSrc: desktopVideoSrc, mobilePoster: mobilePoster, tabletPoster: tabletPoster, desktopPoster: desktopPoster, ariaLabel: ariaLabel }, idx)=>/*#__PURE__*/ {
                        var _ref;
                        return (0, $loA2J.jsx)("video", {
                            ref: (el)=>videoRefs.current[idx] = el,
                            src: assetType === "desktop" ? desktopVideoSrc : assetType === "tablet" ? tabletVideoSrc : mobileVideoSrc,
                            muted: true,
                            playsInline: true,
                            onEnded: handleEnded,
                            autoPlay: idx === current && playing,
                            controls: false,
                            "aria-label": ariaLabel,
                            preload: "auto",
                            poster: (_ref = assetType === "desktop" ? desktopPoster : assetType === "tablet" ? tabletPoster : mobilePoster) !== null && _ref !== void 0 ? _ref : undefined,
                            className: (0, $esG4f.default)([
                                "_1bsb1osq _4t3ieo28 _1vkh124j _tnru1jje",
                                "_1e0c1ule _3um01ppy _4t3io5ou _5ral1dfr"
                            ]),
                            style: {
                                "--_1wpk543": (0, $43MIc.default)(idx === current || idx === 0 && current === -1 ? "visible" : "hidden"),
                                "--_1b1vnti": (0, $43MIc.default)(idx === current || idx === 0 && current === -1 ? "100%" : 0)
                            }
                        }, team);
                    })
                })
            }),
            current !== -1 && /*#__PURE__*/ (0, $loA2J.jsx)((0, $gVN7C.UniformColumnLayout), {
                layout: "12",
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1pfhoahv _195g1wug _1bsb1osq _p12fbxu3 _zulputpp _y44v1dy3 _1e0c11p5 _yv0e15eh _1ul9idpf _476dutpp _19d71wug _zzszh9n0"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                            onClick: togglePlay,
                            className: (0, $esG4f.default)([
                                "_4t3i1ady _1bsb1ady _19pkyjp0 _2hwxyjp0 _otyryjp0 _18u0yjp0 _bfhk1j28 _19itglyw _2rko1osq _1ii7kb7n _yyhycs5v _d0altlke _1tzgkb7n _1acakb7n"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_4t3izwfg _1bsbzwfg _bfhk1aeo _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31s03 _1tjq1s1x"
                                ]),
                                style: {
                                    "--_44ufl2": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark1000")),
                                    "--_1mbq9ci": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark800")),
                                    "--_1jncskl": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark300"))
                                },
                                children: playing ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gF60T))), {
                                    label: intl.formatMessage({
                                        id: "rovo-hero.pause",
                                        defaultMessage: "Pause"
                                    })
                                }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7ShLR))), {
                                    label: intl.formatMessage({
                                        id: "rovo-hero.play",
                                        defaultMessage: "Play"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _4cvr1y6m _zulputpp _1bsb1osq _1ul9idpf _1reo15vq _18m915vq"
                            ]),
                            children: videoCarouselData.map(({ team: team }, idx)=>/*#__PURE__*/ (0, $loA2J.jsxs)("button", {
                                    onClick: ()=>handleTeamClick(idx),
                                    className: (0, $esG4f.default)([
                                        "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _1ul9idpf _1o9zkb7n _ect41pz4 _1wyb1j6v _k48p1fw0 _vwz41k8s _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
                                        "_syazxvv5 _d0al18ta"
                                    ]),
                                    style: {
                                        "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display")),
                                        "--_145xjfw": (0, $43MIc.default)(idx === current ? (0, $5ohHq.wacToken)("color.primary.blue") : (0, $5ohHq.wacToken)("color.neutral.light800")),
                                        "--_1sd2kd4": (0, $43MIc.default)(idx === current ? "auto" : "pointer")
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_4t3iftgi _1bsb1osq _kqswh2mm _1reo15vq _18m915vq _bfhku4vp _1mou1ilp",
                                                idx === 0 && "_2rkonggr",
                                                idx === videoCarouselData.length - 1 && "_2rkof82g"
                                            ]),
                                            style: {
                                                "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
                                            },
                                            children: idx === current && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_4t3i1osq _1bsb1osq _bfhk17la _kqswstnw _1e02idpf _152tidpf",
                                                    "_y44v1gj6 _1y0c1j4f",
                                                    "fillBar"
                                                ]),
                                                style: {
                                                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                                                    "--_1fmqpqp": (0, $43MIc.default)(currentDuration, "s"),
                                                    "--_snrfvu": (0, $43MIc.default)(playing ? "running" : "paused")
                                                }
                                            }, fillBarResetKey)
                                        }),
                                        team
                                    ]
                                }, team))
                        })
                    ]
                })
            })
        ]
    });
};
var $d68eb2ecbe345d06$export$2e2bcd8739ae039 = $d68eb2ecbe345d06$var$UniformVideoCarousel;
const $d68eb2ecbe345d06$var$containerCss = null;
const $d68eb2ecbe345d06$var$videoContainerCss = null;
const $d68eb2ecbe345d06$var$videoDimensionsCss = null;
const $d68eb2ecbe345d06$var$videoCss = null;
const $d68eb2ecbe345d06$var$fadeIn = null;
const $d68eb2ecbe345d06$var$controlContainerCss = null;
const $d68eb2ecbe345d06$var$barContainerCss = null;
const $d68eb2ecbe345d06$var$buttonCss = null;
const $d68eb2ecbe345d06$var$buttonCirlceCss = null;
const $d68eb2ecbe345d06$var$firstBarCss = null;
const $d68eb2ecbe345d06$var$lastBarCss = null;
const $d68eb2ecbe345d06$var$barbuttonCss = null;
const $d68eb2ecbe345d06$var$barCss = null;
const $d68eb2ecbe345d06$var$fillBarCss = null;
const $d68eb2ecbe345d06$var$fill = null;

});



parcelRegister("4sbR8", function(module, exports) {

$parcel$export(module.exports, "UniformMissingComponent", function () { return $bf3a6afbcc6e7c21$export$ec79654869ecfe2e; });
/* uniform-missing-component.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $bf3a6afbcc6e7c21$export$ec79654869ecfe2e = ({ componentName: componentName })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        id: `UNIFORM-MISSING-COMPONENT-${componentName}`,
        "data-nosnippet": true,
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            "_1e0cglyw"
        ])
    });
};

});



//# sourceMappingURL=index.3c30ef11.js.map
